(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7118"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7118"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("24QL2", function(module, exports) {
"use strict";
module.exports = "3.24.2";

});

parcelRegister("eNIDJ", function(module, exports) {
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ var $ac6844d50e9b1d65$var$Hogan = {};
(function(Hogan) {
    Hogan.Template = function(codeObj, text, compiler, options) {
        codeObj = codeObj || {};
        this.r = codeObj.code || this.r;
        this.c = compiler;
        this.options = options || {};
        this.text = text || "";
        this.partials = codeObj.partials || {};
        this.subs = codeObj.subs || {};
        this.buf = "";
    };
    Hogan.Template.prototype = {
        // render: replaced by generated code.
        r: function(context, partials, indent) {
            return "";
        },
        // variable escaping
        v: hoganEscape,
        // triple stache
        t: coerceToString,
        render: function render(context, partials, indent) {
            return this.ri([
                context
            ], partials || {}, indent);
        },
        // render internal -- a hook for overrides that catches partials too
        ri: function(context, partials, indent) {
            return this.r(context, partials, indent);
        },
        // ensurePartial
        ep: function(symbol, partials) {
            var partial = this.partials[symbol];
            // check to see that if we've instantiated this partial before
            var template = partials[partial.name];
            if (partial.instance && partial.base == template) return partial.instance;
            if (typeof template == "string") {
                if (!this.c) throw new Error("No compiler available.");
                template = this.c.compile(template, this.options);
            }
            if (!template) return null;
            // We use this to check whether the partials dictionary has changed
            this.partials[symbol].base = template;
            if (partial.subs) {
                // Make sure we consider parent template now
                if (!partials.stackText) partials.stackText = {};
                for(key in partial.subs)if (!partials.stackText[key]) partials.stackText[key] = this.activeSub !== undefined && partials.stackText[this.activeSub] ? partials.stackText[this.activeSub] : this.text;
                template = createSpecializedPartial(template, partial.subs, partial.partials, this.stackSubs, this.stackPartials, partials.stackText);
            }
            this.partials[symbol].instance = template;
            return template;
        },
        // tries to find a partial in the current scope and render it
        rp: function(symbol, context, partials, indent) {
            var partial = this.ep(symbol, partials);
            if (!partial) return "";
            return partial.ri(context, partials, indent);
        },
        // render a section
        rs: function(context, partials, section) {
            var tail = context[context.length - 1];
            if (!isArray(tail)) {
                section(context, partials, this);
                return;
            }
            for(var i = 0; i < tail.length; i++){
                context.push(tail[i]);
                section(context, partials, this);
                context.pop();
            }
        },
        // maybe start a section
        s: function(val, ctx, partials, inverted, start, end, tags) {
            var pass;
            if (isArray(val) && val.length === 0) return false;
            if (typeof val == "function") val = this.ms(val, ctx, partials, inverted, start, end, tags);
            pass = !!val;
            if (!inverted && pass && ctx) ctx.push(typeof val == "object" ? val : ctx[ctx.length - 1]);
            return pass;
        },
        // find values with dotted names
        d: function(key1, ctx, partials, returnFound) {
            var found, names = key1.split("."), val = this.f(names[0], ctx, partials, returnFound), doModelGet = this.options.modelGet, cx = null;
            if (key1 === "." && isArray(ctx[ctx.length - 2])) val = ctx[ctx.length - 1];
            else for(var i = 1; i < names.length; i++){
                found = findInScope(names[i], val, doModelGet);
                if (found !== undefined) {
                    cx = val;
                    val = found;
                } else val = "";
            }
            if (returnFound && !val) return false;
            if (!returnFound && typeof val == "function") {
                ctx.push(cx);
                val = this.mv(val, ctx, partials);
                ctx.pop();
            }
            return val;
        },
        // find values with normal names
        f: function(key1, ctx, partials, returnFound) {
            var val = false, v = null, found = false, doModelGet = this.options.modelGet;
            for(var i = ctx.length - 1; i >= 0; i--){
                v = ctx[i];
                val = findInScope(key1, v, doModelGet);
                if (val !== undefined) {
                    found = true;
                    break;
                }
            }
            if (!found) return returnFound ? false : "";
            if (!returnFound && typeof val == "function") val = this.mv(val, ctx, partials);
            return val;
        },
        // higher order templates
        ls: function(func, cx, partials, text, tags) {
            var oldTags = this.options.delimiters;
            this.options.delimiters = tags;
            this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
            this.options.delimiters = oldTags;
            return false;
        },
        // compile text
        ct: function(text, cx, partials) {
            if (this.options.disableLambda) throw new Error("Lambda features disabled.");
            return this.c.compile(text, this.options).render(cx, partials);
        },
        // template result buffering
        b: function(s) {
            this.buf += s;
        },
        fl: function() {
            var r = this.buf;
            this.buf = "";
            return r;
        },
        // method replace section
        ms: function(func, ctx, partials, inverted, start, end, tags) {
            var textSource, cx = ctx[ctx.length - 1], result = func.call(cx);
            if (typeof result == "function") {
                if (inverted) return true;
                else {
                    textSource = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text;
                    return this.ls(result, cx, partials, textSource.substring(start, end), tags);
                }
            }
            return result;
        },
        // method replace variable
        mv: function(func, ctx, partials) {
            var cx = ctx[ctx.length - 1];
            var result = func.call(cx);
            if (typeof result == "function") return this.ct(coerceToString(result.call(cx)), cx, partials);
            return result;
        },
        sub: function(name, context, partials, indent) {
            var f = this.subs[name];
            if (f) {
                this.activeSub = name;
                f(context, partials, this, indent);
                this.activeSub = false;
            }
        }
    };
    //Find a key in an object
    function findInScope(key1, scope, doModelGet) {
        var val;
        if (scope && typeof scope == "object") {
            if (scope[key1] !== undefined) val = scope[key1];
            else if (doModelGet && scope.get && typeof scope.get == "function") val = scope.get(key1);
        }
        return val;
    }
    function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
        function PartialTemplate() {}
        PartialTemplate.prototype = instance;
        function Substitutions() {}
        Substitutions.prototype = instance.subs;
        var key1;
        var partial = new PartialTemplate();
        partial.subs = new Substitutions();
        partial.subsText = {}; //hehe. substext.
        partial.buf = "";
        stackSubs = stackSubs || {};
        partial.stackSubs = stackSubs;
        partial.subsText = stackText;
        for(key1 in subs)if (!stackSubs[key1]) stackSubs[key1] = subs[key1];
        for(key1 in stackSubs)partial.subs[key1] = stackSubs[key1];
        stackPartials = stackPartials || {};
        partial.stackPartials = stackPartials;
        for(key1 in partials)if (!stackPartials[key1]) stackPartials[key1] = partials[key1];
        for(key1 in stackPartials)partial.partials[key1] = stackPartials[key1];
        return partial;
    }
    var rAmp = /&/g, rLt = /</g, rGt = />/g, rApos = /\'/g, rQuot = /\"/g, hChars = /[&<>\"\']/;
    function coerceToString(val) {
        return String(val === null || val === undefined ? "" : val);
    }
    function hoganEscape(str) {
        str = coerceToString(str);
        return hChars.test(str) ? str.replace(rAmp, "&amp;").replace(rLt, "&lt;").replace(rGt, "&gt;").replace(rApos, "&#39;").replace(rQuot, "&quot;") : str;
    }
    var isArray = Array.isArray || function(a) {
        return Object.prototype.toString.call(a) === "[object Array]";
    };
})(module.exports);

});

// bump
var $5db76c8220343c1b$exports = {};

$parcel$export($5db76c8220343c1b$exports, "apiClientVersion", () => $5db76c8220343c1b$export$ad1dfbed11feb646);
$parcel$export($5db76c8220343c1b$exports, "abtestingClient", () => $5db76c8220343c1b$export$c1558718601bb704);
// builds/browser.ts
function $5be27e2d7f7d1009$export$2b053666affad54a() {
    function r(t) {
        return new Promise((s)=>{
            let e = new XMLHttpRequest;
            e.open(t.method, t.url, !0), Object.keys(t.headers).forEach((n)=>e.setRequestHeader(n, t.headers[n]));
            let i = (n, a)=>setTimeout(()=>{
                    e.abort(), s({
                        status: 0,
                        content: a,
                        isTimedOut: !0
                    });
                }, n), u = i(t.connectTimeout, "Connection timeout"), o;
            e.onreadystatechange = ()=>{
                e.readyState > e.OPENED && o === void 0 && (clearTimeout(u), o = i(t.responseTimeout, "Socket timeout"));
            }, e.onerror = ()=>{
                e.status === 0 && (clearTimeout(u), clearTimeout(o), s({
                    content: e.responseText || "Network request failed",
                    status: e.status,
                    isTimedOut: !1
                }));
            }, e.onload = ()=>{
                clearTimeout(u), clearTimeout(o), s({
                    content: e.responseText,
                    status: e.status,
                    isTimedOut: !1
                });
            }, e.send(t.data);
        });
    }
    return {
        send: r
    };
}


// src/cache/createBrowserLocalStorageCache.ts
function $5e9921bee1f5cd3c$export$ca8cae1c5b20815a(options) {
    let storage;
    const namespaceKey = `algolia-client-js-${options.key}`;
    function getStorage() {
        if (storage === void 0) storage = options.localStorage || window.localStorage;
        return storage;
    }
    function getNamespace() {
        return JSON.parse(getStorage().getItem(namespaceKey) || "{}");
    }
    function setNamespace(namespace) {
        getStorage().setItem(namespaceKey, JSON.stringify(namespace));
    }
    function removeOutdatedCacheItems() {
        const timeToLive = options.timeToLive ? options.timeToLive * 1e3 : null;
        const namespace = getNamespace();
        const filteredNamespaceWithoutOldFormattedCacheItems = Object.fromEntries(Object.entries(namespace).filter(([, cacheItem])=>{
            return cacheItem.timestamp !== void 0;
        }));
        setNamespace(filteredNamespaceWithoutOldFormattedCacheItems);
        if (!timeToLive) return;
        const filteredNamespaceWithoutExpiredItems = Object.fromEntries(Object.entries(filteredNamespaceWithoutOldFormattedCacheItems).filter(([, cacheItem])=>{
            const currentTimestamp = /* @__PURE__ */ new Date().getTime();
            const isExpired = cacheItem.timestamp + timeToLive < currentTimestamp;
            return !isExpired;
        }));
        setNamespace(filteredNamespaceWithoutExpiredItems);
    }
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return Promise.resolve().then(()=>{
                removeOutdatedCacheItems();
                return getNamespace()[JSON.stringify(key)];
            }).then((value)=>{
                return Promise.all([
                    value ? value.value : defaultValue(),
                    value !== void 0
                ]);
            }).then(([value, exists])=>{
                return Promise.all([
                    value,
                    exists || events.miss(value)
                ]);
            }).then(([value])=>value);
        },
        set (key, value) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                namespace[JSON.stringify(key)] = {
                    timestamp: /* @__PURE__ */ new Date().getTime(),
                    value: value
                };
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
                return value;
            });
        },
        delete (key) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                delete namespace[JSON.stringify(key)];
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
            });
        },
        clear () {
            return Promise.resolve().then(()=>{
                getStorage().removeItem(namespaceKey);
            });
        }
    };
}
// src/cache/createNullCache.ts
function $5e9921bee1f5cd3c$export$2774a8bf79d531b() {
    return {
        get (_key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const value = defaultValue();
            return value.then((result)=>Promise.all([
                    result,
                    events.miss(result)
                ])).then(([result])=>result);
        },
        set (_key, value) {
            return Promise.resolve(value);
        },
        delete (_key) {
            return Promise.resolve();
        },
        clear () {
            return Promise.resolve();
        }
    };
}
// src/cache/createFallbackableCache.ts
function $5e9921bee1f5cd3c$export$8637a0800116df9b(options) {
    const caches = [
        ...options.caches
    ];
    const current = caches.shift();
    if (current === void 0) return $5e9921bee1f5cd3c$export$2774a8bf79d531b();
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return current.get(key, defaultValue, events).catch(()=>{
                return $5e9921bee1f5cd3c$export$8637a0800116df9b({
                    caches: caches
                }).get(key, defaultValue, events);
            });
        },
        set (key, value) {
            return current.set(key, value).catch(()=>{
                return $5e9921bee1f5cd3c$export$8637a0800116df9b({
                    caches: caches
                }).set(key, value);
            });
        },
        delete (key) {
            return current.delete(key).catch(()=>{
                return $5e9921bee1f5cd3c$export$8637a0800116df9b({
                    caches: caches
                }).delete(key);
            });
        },
        clear () {
            return current.clear().catch(()=>{
                return $5e9921bee1f5cd3c$export$8637a0800116df9b({
                    caches: caches
                }).clear();
            });
        }
    };
}
// src/cache/createMemoryCache.ts
function $5e9921bee1f5cd3c$export$b1fc9484ccfcd328(options = {
    serializable: true
}) {
    let cache = {};
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const keyAsString = JSON.stringify(key);
            if (keyAsString in cache) return Promise.resolve(options.serializable ? JSON.parse(cache[keyAsString]) : cache[keyAsString]);
            const promise = defaultValue();
            return promise.then((value)=>events.miss(value)).then(()=>promise);
        },
        set (key, value) {
            cache[JSON.stringify(key)] = options.serializable ? JSON.stringify(value) : value;
            return Promise.resolve(value);
        },
        delete (key) {
            delete cache[JSON.stringify(key)];
            return Promise.resolve();
        },
        clear () {
            cache = {};
            return Promise.resolve();
        }
    };
}
// src/constants.ts
var $5e9921bee1f5cd3c$export$1c9d677a000d9c75 = 1e3;
var $5e9921bee1f5cd3c$export$cc6130e78d57e416 = 2e3;
var $5e9921bee1f5cd3c$export$a36d433dda13154c = 3e4;
var $5e9921bee1f5cd3c$export$3d443caeeeeb0358 = 2e3;
var $5e9921bee1f5cd3c$export$da73fde44cbc636a = 5e3;
var $5e9921bee1f5cd3c$export$fdad022791f75c95 = 3e4;
// src/createAlgoliaAgent.ts
function $5e9921bee1f5cd3c$export$f3ef4b722067ac71(version) {
    const algoliaAgent = {
        value: `Algolia for JavaScript (${version})`,
        add (options) {
            const addedAlgoliaAgent = `; ${options.segment}${options.version !== void 0 ? ` (${options.version})` : ""}`;
            if (algoliaAgent.value.indexOf(addedAlgoliaAgent) === -1) algoliaAgent.value = `${algoliaAgent.value}${addedAlgoliaAgent}`;
            return algoliaAgent;
        }
    };
    return algoliaAgent;
}
// src/createAuth.ts
function $5e9921bee1f5cd3c$export$5f096e4c9da248bb(appId, apiKey, authMode = "WithinHeaders") {
    const credentials = {
        "x-algolia-api-key": apiKey,
        "x-algolia-application-id": appId
    };
    return {
        headers () {
            return authMode === "WithinHeaders" ? credentials : {};
        },
        queryParameters () {
            return authMode === "WithinQueryParameters" ? credentials : {};
        }
    };
}
// src/createIterablePromise.ts
function $5e9921bee1f5cd3c$export$d96db6d38a87ffce({ func: func, validate: validate, aggregator: aggregator, error: error, timeout: timeout = ()=>0 }) {
    const retry = (previousResponse)=>{
        return new Promise((resolve, reject)=>{
            func(previousResponse).then(async (response)=>{
                if (aggregator) await aggregator(response);
                if (await validate(response)) return resolve(response);
                if (error && await error.validate(response)) return reject(new Error(await error.message(response)));
                return setTimeout(()=>{
                    retry(response).then(resolve).catch(reject);
                }, await timeout());
            }).catch((err)=>{
                reject(err);
            });
        });
    };
    return retry();
}
// src/getAlgoliaAgent.ts
function $5e9921bee1f5cd3c$export$dc28410830ce888d({ algoliaAgents: algoliaAgents, client: client, version: version }) {
    const defaultAlgoliaAgent = $5e9921bee1f5cd3c$export$f3ef4b722067ac71(version).add({
        segment: client,
        version: version
    });
    algoliaAgents.forEach((algoliaAgent)=>defaultAlgoliaAgent.add(algoliaAgent));
    return defaultAlgoliaAgent;
}
// src/logger/createNullLogger.ts
function $5e9921bee1f5cd3c$export$6d3f4ca34494bf2d() {
    return {
        debug (_message, _args) {
            return Promise.resolve();
        },
        info (_message, _args) {
            return Promise.resolve();
        },
        error (_message, _args) {
            return Promise.resolve();
        }
    };
}
// src/transporter/createStatefulHost.ts
var $5e9921bee1f5cd3c$var$EXPIRATION_DELAY = 120000;
function $5e9921bee1f5cd3c$export$3fb3dda619608b7(host, status = "up") {
    const lastUpdate = Date.now();
    function isUp() {
        return status === "up" || Date.now() - lastUpdate > $5e9921bee1f5cd3c$var$EXPIRATION_DELAY;
    }
    function isTimedOut() {
        return status === "timed out" && Date.now() - lastUpdate <= $5e9921bee1f5cd3c$var$EXPIRATION_DELAY;
    }
    return {
        ...host,
        status: status,
        lastUpdate: lastUpdate,
        isUp: isUp,
        isTimedOut: isTimedOut
    };
}
// src/transporter/errors.ts
var $5e9921bee1f5cd3c$export$94fb2163d3563f9d = class extends Error {
    name = "AlgoliaError";
    constructor(message, name){
        super(message);
        if (name) this.name = name;
    }
};
var $5e9921bee1f5cd3c$export$2fd7939d0c81cd0c = class extends $5e9921bee1f5cd3c$export$94fb2163d3563f9d {
    stackTrace;
    constructor(message, stackTrace, name){
        super(message, name);
        this.stackTrace = stackTrace;
    }
};
var $5e9921bee1f5cd3c$export$aa6cf8a4f695f0ee = class extends $5e9921bee1f5cd3c$export$2fd7939d0c81cd0c {
    constructor(stackTrace){
        super("Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support.", stackTrace, "RetryError");
    }
};
var $5e9921bee1f5cd3c$export$f2e832acab1bdd79 = class extends $5e9921bee1f5cd3c$export$2fd7939d0c81cd0c {
    status;
    constructor(message, status, stackTrace, name = "ApiError"){
        super(message, stackTrace, name);
        this.status = status;
    }
};
var $5e9921bee1f5cd3c$export$e711248598da7854 = class extends $5e9921bee1f5cd3c$export$94fb2163d3563f9d {
    response;
    constructor(message, response){
        super(message, "DeserializationError");
        this.response = response;
    }
};
var $5e9921bee1f5cd3c$export$5f44dadb2efd3cfb = class extends $5e9921bee1f5cd3c$export$f2e832acab1bdd79 {
    error;
    constructor(message, status, error, stackTrace){
        super(message, status, stackTrace, "DetailedApiError");
        this.error = error;
    }
};
// src/transporter/helpers.ts
function $5e9921bee1f5cd3c$export$448332262467e042(array) {
    const shuffledArray = array;
    for(let c = array.length - 1; c > 0; c--){
        const b = Math.floor(Math.random() * (c + 1));
        const a = array[c];
        shuffledArray[c] = array[b];
        shuffledArray[b] = a;
    }
    return shuffledArray;
}
function $5e9921bee1f5cd3c$export$102dee260a456972(host, path, queryParameters) {
    const queryParametersAsString = $5e9921bee1f5cd3c$export$b3f68c1f6e4b3e22(queryParameters);
    let url = `${host.protocol}://${host.url}${host.port ? `:${host.port}` : ""}/${path.charAt(0) === "/" ? path.substring(1) : path}`;
    if (queryParametersAsString.length) url += `?${queryParametersAsString}`;
    return url;
}
function $5e9921bee1f5cd3c$export$b3f68c1f6e4b3e22(parameters) {
    return Object.keys(parameters).filter((key)=>parameters[key] !== void 0).sort().map((key)=>`${key}=${encodeURIComponent(Object.prototype.toString.call(parameters[key]) === "[object Array]" ? parameters[key].join(",") : parameters[key]).replace(/\+/g, "%20")}`).join("&");
}
function $5e9921bee1f5cd3c$export$b2290ffa247cf0a7(request, requestOptions) {
    if (request.method === "GET" || request.data === void 0 && requestOptions.data === void 0) return void 0;
    const data = Array.isArray(request.data) ? request.data : {
        ...request.data,
        ...requestOptions.data
    };
    return JSON.stringify(data);
}
function $5e9921bee1f5cd3c$export$dfd5dd9013041417(baseHeaders, requestHeaders, requestOptionsHeaders) {
    const headers = {
        Accept: "application/json",
        ...baseHeaders,
        ...requestHeaders,
        ...requestOptionsHeaders
    };
    const serializedHeaders = {};
    Object.keys(headers).forEach((header)=>{
        const value = headers[header];
        serializedHeaders[header.toLowerCase()] = value;
    });
    return serializedHeaders;
}
function $5e9921bee1f5cd3c$export$699210646009f15c(response) {
    try {
        return JSON.parse(response.content);
    } catch (e) {
        throw new $5e9921bee1f5cd3c$export$e711248598da7854(e.message, response);
    }
}
function $5e9921bee1f5cd3c$export$36794b0ec2a5c1b1({ content: content, status: status }, stackFrame) {
    try {
        const parsed = JSON.parse(content);
        if ("error" in parsed) return new $5e9921bee1f5cd3c$export$5f44dadb2efd3cfb(parsed.message, status, parsed.error, stackFrame);
        return new $5e9921bee1f5cd3c$export$f2e832acab1bdd79(parsed.message, status, stackFrame);
    } catch  {}
    return new $5e9921bee1f5cd3c$export$f2e832acab1bdd79(content, status, stackFrame);
}
// src/transporter/responses.ts
function $5e9921bee1f5cd3c$export$476aa014e2fd89d5({ isTimedOut: isTimedOut, status: status }) {
    return !isTimedOut && ~~status === 0;
}
function $5e9921bee1f5cd3c$export$f146c102d7613638({ isTimedOut: isTimedOut, status: status }) {
    return isTimedOut || $5e9921bee1f5cd3c$export$476aa014e2fd89d5({
        isTimedOut: isTimedOut,
        status: status
    }) || ~~(status / 100) !== 2 && ~~(status / 100) !== 4;
}
function $5e9921bee1f5cd3c$export$b0ac3e614a309be3({ status: status }) {
    return ~~(status / 100) === 2;
}
// src/transporter/stackTrace.ts
function $5e9921bee1f5cd3c$export$719a2b5349a98bb0(stackTrace) {
    return stackTrace.map((stackFrame)=>$5e9921bee1f5cd3c$export$e8a46da9420defe9(stackFrame));
}
function $5e9921bee1f5cd3c$export$e8a46da9420defe9(stackFrame) {
    const modifiedHeaders = stackFrame.request.headers["x-algolia-api-key"] ? {
        "x-algolia-api-key": "*****"
    } : {};
    return {
        ...stackFrame,
        request: {
            ...stackFrame.request,
            headers: {
                ...stackFrame.request.headers,
                ...modifiedHeaders
            }
        }
    };
}
// src/transporter/createTransporter.ts
function $5e9921bee1f5cd3c$export$9f379e42258ad245({ hosts: hosts, hostsCache: hostsCache, baseHeaders: baseHeaders, logger: logger, baseQueryParameters: baseQueryParameters, algoliaAgent: algoliaAgent, timeouts: timeouts, requester: requester, requestsCache: requestsCache, responsesCache: responsesCache }) {
    async function createRetryableOptions(compatibleHosts) {
        const statefulHosts = await Promise.all(compatibleHosts.map((compatibleHost)=>{
            return hostsCache.get(compatibleHost, ()=>{
                return Promise.resolve($5e9921bee1f5cd3c$export$3fb3dda619608b7(compatibleHost));
            });
        }));
        const hostsUp = statefulHosts.filter((host)=>host.isUp());
        const hostsTimedOut = statefulHosts.filter((host)=>host.isTimedOut());
        const hostsAvailable = [
            ...hostsUp,
            ...hostsTimedOut
        ];
        const compatibleHostsAvailable = hostsAvailable.length > 0 ? hostsAvailable : compatibleHosts;
        return {
            hosts: compatibleHostsAvailable,
            getTimeout (timeoutsCount, baseTimeout) {
                const timeoutMultiplier = hostsTimedOut.length === 0 && timeoutsCount === 0 ? 1 : hostsTimedOut.length + 3 + timeoutsCount;
                return timeoutMultiplier * baseTimeout;
            }
        };
    }
    async function retryableRequest(request, requestOptions, isRead = true) {
        const stackTrace = [];
        const data = $5e9921bee1f5cd3c$export$b2290ffa247cf0a7(request, requestOptions);
        const headers = $5e9921bee1f5cd3c$export$dfd5dd9013041417(baseHeaders, request.headers, requestOptions.headers);
        const dataQueryParameters = request.method === "GET" ? {
            ...request.data,
            ...requestOptions.data
        } : {};
        const queryParameters = {
            ...baseQueryParameters,
            ...request.queryParameters,
            ...dataQueryParameters
        };
        if (algoliaAgent.value) queryParameters["x-algolia-agent"] = algoliaAgent.value;
        if (requestOptions && requestOptions.queryParameters) {
            for (const key of Object.keys(requestOptions.queryParameters))if (!requestOptions.queryParameters[key] || Object.prototype.toString.call(requestOptions.queryParameters[key]) === "[object Object]") queryParameters[key] = requestOptions.queryParameters[key];
            else queryParameters[key] = requestOptions.queryParameters[key].toString();
        }
        let timeoutsCount = 0;
        const retry = async (retryableHosts, getTimeout)=>{
            const host = retryableHosts.pop();
            if (host === void 0) throw new $5e9921bee1f5cd3c$export$aa6cf8a4f695f0ee($5e9921bee1f5cd3c$export$719a2b5349a98bb0(stackTrace));
            const timeout = {
                ...timeouts,
                ...requestOptions.timeouts
            };
            const payload = {
                data: data,
                headers: headers,
                method: request.method,
                url: $5e9921bee1f5cd3c$export$102dee260a456972(host, request.path, queryParameters),
                connectTimeout: getTimeout(timeoutsCount, timeout.connect),
                responseTimeout: getTimeout(timeoutsCount, isRead ? timeout.read : timeout.write)
            };
            const pushToStackTrace = (response2)=>{
                const stackFrame = {
                    request: payload,
                    response: response2,
                    host: host,
                    triesLeft: retryableHosts.length
                };
                stackTrace.push(stackFrame);
                return stackFrame;
            };
            const response = await requester.send(payload);
            if ($5e9921bee1f5cd3c$export$f146c102d7613638(response)) {
                const stackFrame = pushToStackTrace(response);
                if (response.isTimedOut) timeoutsCount++;
                logger.info("Retryable failure", $5e9921bee1f5cd3c$export$e8a46da9420defe9(stackFrame));
                await hostsCache.set(host, $5e9921bee1f5cd3c$export$3fb3dda619608b7(host, response.isTimedOut ? "timed out" : "down"));
                return retry(retryableHosts, getTimeout);
            }
            if ($5e9921bee1f5cd3c$export$b0ac3e614a309be3(response)) return $5e9921bee1f5cd3c$export$699210646009f15c(response);
            pushToStackTrace(response);
            throw $5e9921bee1f5cd3c$export$36794b0ec2a5c1b1(response, stackTrace);
        };
        const compatibleHosts = hosts.filter((host)=>host.accept === "readWrite" || (isRead ? host.accept === "read" : host.accept === "write"));
        const options = await createRetryableOptions(compatibleHosts);
        return retry([
            ...options.hosts
        ].reverse(), options.getTimeout);
    }
    function createRequest(request, requestOptions = {}) {
        const isRead = request.useReadTransporter || request.method === "GET";
        if (!isRead) return retryableRequest(request, requestOptions, isRead);
        const createRetryableRequest = ()=>{
            return retryableRequest(request, requestOptions);
        };
        const cacheable = requestOptions.cacheable || request.cacheable;
        if (cacheable !== true) return createRetryableRequest();
        const key = {
            request: request,
            requestOptions: requestOptions,
            transporter: {
                queryParameters: baseQueryParameters,
                headers: baseHeaders
            }
        };
        return responsesCache.get(key, ()=>{
            return requestsCache.get(key, ()=>/**
             * Finally, if there is no request in progress with the same key,
             * this `createRetryableRequest()` will actually trigger the
             * retryable request.
             */ requestsCache.set(key, createRetryableRequest()).then((response)=>Promise.all([
                        requestsCache.delete(key),
                        response
                    ]), (err)=>Promise.all([
                        requestsCache.delete(key),
                        Promise.reject(err)
                    ])).then(([_, response])=>response));
        }, {
            /**
         * Of course, once we get this response back from the server, we
         * tell response cache to actually store the received response
         * to be used later.
         */ miss: (response)=>responsesCache.set(key, response)
        });
    }
    return {
        hostsCache: hostsCache,
        requester: requester,
        timeouts: timeouts,
        logger: logger,
        algoliaAgent: algoliaAgent,
        baseHeaders: baseHeaders,
        baseQueryParameters: baseQueryParameters,
        hosts: hosts,
        request: createRequest,
        requestsCache: requestsCache,
        responsesCache: responsesCache
    };
}
// src/types/logger.ts
var $5e9921bee1f5cd3c$export$d65602050420b80d = {
    Debug: 1,
    Info: 2,
    Error: 3
};


var $5db76c8220343c1b$export$ad1dfbed11feb646 = "5.21.0";
var $5db76c8220343c1b$var$REGIONS = [
    "de",
    "us"
];
function $5db76c8220343c1b$var$getDefaultHosts(region) {
    const url = !region ? "analytics.algolia.com" : "analytics.{region}.algolia.com".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $5db76c8220343c1b$var$createAbtestingClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $5e9921bee1f5cd3c$export$5f096e4c9da248bb)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $5e9921bee1f5cd3c$export$9f379e42258ad245)({
        hosts: $5db76c8220343c1b$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $5e9921bee1f5cd3c$export$dc28410830ce888d)({
            algoliaAgents: algoliaAgents,
            client: "Abtesting",
            version: $5db76c8220343c1b$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Creates a new A/B test.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param addABTestsRequest - The addABTestsRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ addABTests (addABTestsRequest, requestOptions) {
            if (!addABTestsRequest) throw new Error("Parameter `addABTestsRequest` is required when calling `addABTests`.");
            if (!addABTestsRequest.name) throw new Error("Parameter `addABTestsRequest.name` is required when calling `addABTests`.");
            if (!addABTestsRequest.variants) throw new Error("Parameter `addABTestsRequest.variants` is required when calling `addABTests`.");
            if (!addABTestsRequest.endAt) throw new Error("Parameter `addABTestsRequest.endAt` is required when calling `addABTests`.");
            const requestPath = "/2/abtests";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: addABTestsRequest
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteABTest - The deleteABTest object.
     * @param deleteABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteABTest ({ id: id }, requestOptions) {
            if (!id) throw new Error("Parameter `id` is required when calling `deleteABTest`.");
            const requestPath = "/2/abtests/{id}".replace("{id}", encodeURIComponent(id));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Given the traffic percentage and the expected effect size, this endpoint estimates the sample size and duration of an A/B test based on historical traffic.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param estimateABTestRequest - The estimateABTestRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ estimateABTest (estimateABTestRequest, requestOptions) {
            if (!estimateABTestRequest) throw new Error("Parameter `estimateABTestRequest` is required when calling `estimateABTest`.");
            if (!estimateABTestRequest.configuration) throw new Error("Parameter `estimateABTestRequest.configuration` is required when calling `estimateABTest`.");
            if (!estimateABTestRequest.variants) throw new Error("Parameter `estimateABTestRequest.variants` is required when calling `estimateABTest`.");
            const requestPath = "/2/abtests/estimate";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: estimateABTestRequest
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the details for an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getABTest - The getABTest object.
     * @param getABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getABTest ({ id: id }, requestOptions) {
            if (!id) throw new Error("Parameter `id` is required when calling `getABTest`.");
            const requestPath = "/2/abtests/{id}".replace("{id}", encodeURIComponent(id));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists all A/B tests you configured for this application.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param listABTests - The listABTests object.
     * @param listABTests.offset - Position of the first item to return.
     * @param listABTests.limit - Number of items to return.
     * @param listABTests.indexPrefix - Index name prefix. Only A/B tests for indices starting with this string are included in the response.
     * @param listABTests.indexSuffix - Index name suffix. Only A/B tests for indices ending with this string are included in the response.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listABTests ({ offset: offset, limit: limit, indexPrefix: indexPrefix, indexSuffix: indexSuffix } = {}, requestOptions) {
            const requestPath = "/2/abtests";
            const headers = {};
            const queryParameters = {};
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (indexPrefix !== void 0) queryParameters["indexPrefix"] = indexPrefix.toString();
            if (indexSuffix !== void 0) queryParameters["indexSuffix"] = indexSuffix.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Schedule an A/B test to be started at a later time.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param scheduleABTestsRequest - The scheduleABTestsRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ scheduleABTest (scheduleABTestsRequest, requestOptions) {
            if (!scheduleABTestsRequest) throw new Error("Parameter `scheduleABTestsRequest` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.name) throw new Error("Parameter `scheduleABTestsRequest.name` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.variants) throw new Error("Parameter `scheduleABTestsRequest.variants` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.scheduledAt) throw new Error("Parameter `scheduleABTestsRequest.scheduledAt` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.endAt) throw new Error("Parameter `scheduleABTestsRequest.endAt` is required when calling `scheduleABTest`.");
            const requestPath = "/2/abtests/schedule";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: scheduleABTestsRequest
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Stops an A/B test by its ID.  You can\'t restart stopped A/B tests.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param stopABTest - The stopABTest object.
     * @param stopABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ stopABTest ({ id: id }, requestOptions) {
            if (!id) throw new Error("Parameter `id` is required when calling `stopABTest`.");
            const requestPath = "/2/abtests/{id}/stop".replace("{id}", encodeURIComponent(id));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $5db76c8220343c1b$export$c1558718601bb704(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (region && (typeof region !== "string" || !$5db76c8220343c1b$var$REGIONS.includes(region))) throw new Error(`\`region\` must be one of the following: ${$5db76c8220343c1b$var$REGIONS.join(", ")}`);
    return $5db76c8220343c1b$var$createAbtestingClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $5e9921bee1f5cd3c$export$6d3f4ca34494bf2d)(),
        requester: (0, $5be27e2d7f7d1009$export$2b053666affad54a)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)(),
        requestsCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)({
            serializable: false
        }),
        hostsCache: (0, $5e9921bee1f5cd3c$export$8637a0800116df9b)({
            caches: [
                (0, $5e9921bee1f5cd3c$export$ca8cae1c5b20815a)({
                    key: `${$5db76c8220343c1b$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)()
            ]
        }),
        ...options
    });
}


var $66b4a85c6ea664d7$exports = {};

$parcel$export($66b4a85c6ea664d7$exports, "apiClientVersion", () => $66b4a85c6ea664d7$export$ad1dfbed11feb646);
$parcel$export($66b4a85c6ea664d7$exports, "analyticsClient", () => $66b4a85c6ea664d7$export$f1caacacb426dc27);
// builds/browser.ts


var $66b4a85c6ea664d7$export$ad1dfbed11feb646 = "5.21.0";
var $66b4a85c6ea664d7$var$REGIONS = [
    "de",
    "us"
];
function $66b4a85c6ea664d7$var$getDefaultHosts(region) {
    const url = !region ? "analytics.algolia.com" : "analytics.{region}.algolia.com".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $66b4a85c6ea664d7$var$createAnalyticsClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $5e9921bee1f5cd3c$export$5f096e4c9da248bb)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $5e9921bee1f5cd3c$export$9f379e42258ad245)({
        hosts: $66b4a85c6ea664d7$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $5e9921bee1f5cd3c$export$dc28410830ce888d)({
            algoliaAgents: algoliaAgents,
            client: "Analytics",
            version: $66b4a85c6ea664d7$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the add-to-cart rate for all your searches with at least one add-to-cart event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  The rate is the number of add-to-cart conversion events divided by the number of tracked searches. A search is tracked if it returns a queryID (`clickAnalytics` is `true`). This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`.  **There\'s a difference between a 0 and null add-to-cart rate when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the add-to-cart rate is null. - **0** mean there _were_ queries but no [add-to-cart events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getAddToCartRate - The getAddToCartRate object.
     * @param getAddToCartRate.index - Index name.
     * @param getAddToCartRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAddToCartRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAddToCartRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getAddToCartRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getAddToCartRate`.");
            const requestPath = "/2/conversions/addToCartRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the average click position of your search results, including a daily breakdown.  The average click position is the average of all clicked search result positions. For example, if users only ever click on the first result for any search, the average click position is 1. By default, the analyzed period includes the last eight days including the current day.  An average of `null` when `clickAnalytics` is enabled means Algolia didn\'t receive any [click events](https://www.algolia.com/doc/guides/sending-events/getting-started/) for the queries. The average is `null` until Algolia receives at least one click event.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getAverageClickPosition - The getAverageClickPosition object.
     * @param getAverageClickPosition.index - Index name.
     * @param getAverageClickPosition.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAverageClickPosition.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAverageClickPosition.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getAverageClickPosition ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getAverageClickPosition`.");
            const requestPath = "/2/clicks/averageClickPosition";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the positions in the search results and their associated number of clicks.  This lets you check how many clicks the first, second, or tenth search results receive.  An average of `0` when `clickAnalytics` is enabled means Algolia didn\'t receive any [click events](https://www.algolia.com/doc/guides/sending-events/getting-started/) for the queries.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getClickPositions - The getClickPositions object.
     * @param getClickPositions.index - Index name.
     * @param getClickPositions.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickPositions.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickPositions.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getClickPositions ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getClickPositions`.");
            const requestPath = "/2/clicks/positions";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the click-through rate (CTR) for all your searches with at least one click event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  **There\'s a difference between a 0 and null CTR when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, CTR is null. - **0** mean there _were_ queries but no [click events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getClickThroughRate - The getClickThroughRate object.
     * @param getClickThroughRate.index - Index name.
     * @param getClickThroughRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickThroughRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickThroughRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getClickThroughRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getClickThroughRate`.");
            const requestPath = "/2/clicks/clickThroughRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the conversion rate (CR) for all your searches with at least one conversion event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  **There\'s a difference between a 0 and null CR when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, CR is null. - **0** mean there _were_ queries but no [conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getConversionRate - The getConversionRate object.
     * @param getConversionRate.index - Index name.
     * @param getConversionRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getConversionRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getConversionRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getConversionRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getConversionRate`.");
            const requestPath = "/2/conversions/conversionRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the fraction of searches that didn\'t lead to any click within a time range, including a daily breakdown. It also returns the number of tracked searches and tracked searches without clicks.  By default, the analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getNoClickRate - The getNoClickRate object.
     * @param getNoClickRate.index - Index name.
     * @param getNoClickRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoClickRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoClickRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getNoClickRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getNoClickRate`.");
            const requestPath = "/2/searches/noClickRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the fraction of searches that didn\'t return any results within a time range, including a daily breakdown. It also returns the count of searches and searches without results used to compute the rates.  By default, the analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getNoResultsRate - The getNoResultsRate object.
     * @param getNoResultsRate.index - Index name.
     * @param getNoResultsRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoResultsRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoResultsRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getNoResultsRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getNoResultsRate`.");
            const requestPath = "/2/searches/noResultRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the purchase rate for all your searches with at least one purchase event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  The rate is the number of purchase conversion events divided by the number of tracked searches. A search is tracked if it returns a query ID (`clickAnalytics` is `true`). This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`.  **There\'s a difference between a 0 and null purchase rate when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the purchase rate is null. - **0** mean there _were_ queries but no [purchase conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getPurchaseRate - The getPurchaseRate object.
     * @param getPurchaseRate.index - Index name.
     * @param getPurchaseRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getPurchaseRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getPurchaseRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getPurchaseRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getPurchaseRate`.");
            const requestPath = "/2/conversions/purchaseRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves revenue-related metrics, such as the total revenue or the average order value.  To retrieve revenue-related metrics, send purchase events. By default, the analyzed period includes the last eight days including the current day.  Revenue is based on purchase conversion events (a conversion event with an `eventSubtype` attribute of `purchase`). The revenue is the `price` attribute multiplied by the `quantity` attribute for each object in the event\'s `objectData` array.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getRevenue - The getRevenue object.
     * @param getRevenue.index - Index name.
     * @param getRevenue.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getRevenue.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getRevenue.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRevenue ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getRevenue`.");
            const requestPath = "/2/conversions/revenue";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the number of searches within a time range, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getSearchesCount - The getSearchesCount object.
     * @param getSearchesCount.index - Index name.
     * @param getSearchesCount.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesCount.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesCount.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSearchesCount ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getSearchesCount`.");
            const requestPath = "/2/searches/count";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the most popular searches that didn\'t lead to any clicks, from the 1,000 most frequent searches.  For each search, it also returns the number of displayed search results that remained unclicked.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getSearchesNoClicks - The getSearchesNoClicks object.
     * @param getSearchesNoClicks.index - Index name.
     * @param getSearchesNoClicks.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoClicks.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoClicks.limit - Number of items to return.
     * @param getSearchesNoClicks.offset - Position of the first item to return.
     * @param getSearchesNoClicks.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSearchesNoClicks ({ index: index, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getSearchesNoClicks`.");
            const requestPath = "/2/searches/noClicks";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the 1,000 most frequent searches that produced zero results.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getSearchesNoResults - The getSearchesNoResults object.
     * @param getSearchesNoResults.index - Index name.
     * @param getSearchesNoResults.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoResults.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoResults.limit - Number of items to return.
     * @param getSearchesNoResults.offset - Position of the first item to return.
     * @param getSearchesNoResults.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSearchesNoResults ({ index: index, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getSearchesNoResults`.");
            const requestPath = "/2/searches/noResults";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the time when the Analytics data for the specified index was last updated.  If the index has been recently created or no search has been performed yet the updated time is `null`.  The Analytics data is updated every 5&nbsp;minutes.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getStatus - The getStatus object.
     * @param getStatus.index - Index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getStatus ({ index: index }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getStatus`.");
            const requestPath = "/2/status";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the countries with the most searches in your index.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopCountries - The getTopCountries object.
     * @param getTopCountries.index - Index name.
     * @param getTopCountries.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopCountries.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopCountries.limit - Number of items to return.
     * @param getTopCountries.offset - Position of the first item to return.
     * @param getTopCountries.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopCountries ({ index: index, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getTopCountries`.");
            const requestPath = "/2/countries";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the 1,000 most frequently used filter attributes.  These are attributes of your records that you included in the `attributesForFaceting` setting.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopFilterAttributes - The getTopFilterAttributes object.
     * @param getTopFilterAttributes.index - Index name.
     * @param getTopFilterAttributes.search - Search query.
     * @param getTopFilterAttributes.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterAttributes.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterAttributes.limit - Number of items to return.
     * @param getTopFilterAttributes.offset - Position of the first item to return.
     * @param getTopFilterAttributes.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopFilterAttributes ({ index: index, search: search, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getTopFilterAttributes`.");
            const requestPath = "/2/filters";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (search !== void 0) queryParameters["search"] = search.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the 1,000 most frequent filter (facet) values for a filter attribute.  These are attributes of your records that you included in the `attributesForFaceting` setting.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopFilterForAttribute - The getTopFilterForAttribute object.
     * @param getTopFilterForAttribute.attribute - Attribute name.
     * @param getTopFilterForAttribute.index - Index name.
     * @param getTopFilterForAttribute.search - Search query.
     * @param getTopFilterForAttribute.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterForAttribute.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterForAttribute.limit - Number of items to return.
     * @param getTopFilterForAttribute.offset - Position of the first item to return.
     * @param getTopFilterForAttribute.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopFilterForAttribute ({ attribute: attribute, index: index, search: search, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!attribute) throw new Error("Parameter `attribute` is required when calling `getTopFilterForAttribute`.");
            if (!index) throw new Error("Parameter `index` is required when calling `getTopFilterForAttribute`.");
            const requestPath = "/2/filters/{attribute}".replace("{attribute}", encodeURIComponent(attribute));
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (search !== void 0) queryParameters["search"] = search.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the 1,000 most frequently used filters for a search that didn\'t return any results.  To get the most frequent searches without results, use the [Retrieve searches without results](#tag/search/operation/getSearchesNoResults) operation.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopFiltersNoResults - The getTopFiltersNoResults object.
     * @param getTopFiltersNoResults.index - Index name.
     * @param getTopFiltersNoResults.search - Search query.
     * @param getTopFiltersNoResults.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFiltersNoResults.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFiltersNoResults.limit - Number of items to return.
     * @param getTopFiltersNoResults.offset - Position of the first item to return.
     * @param getTopFiltersNoResults.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopFiltersNoResults ({ index: index, search: search, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getTopFiltersNoResults`.");
            const requestPath = "/2/filters/noResults";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (search !== void 0) queryParameters["search"] = search.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the object IDs of the 1,000 most frequent search results.  If you set the `clickAnalytics` query parameter to true, the response also includes:  - Tracked searches count. Tracked searches are Search API requests with the `clickAnalytics` parameter set to `true`. This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`. - Click count - Click-through rate (CTR) - Conversion count - Conversion rate (CR) - Average click position  If you set the `revenueAnalytics` parameter to `true`, the response also includes:  - Add-to-cart count - Add-to-cart rate (ATCR) - Purchase count - Purchase rate - Revenue details for each currency  **There\'s a difference between 0% rates and null rates:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the rates (CTR, CR, ATCR, purchase rate) are null. - **0% rates** mean there _were_ queries but no [click or conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopHits - The getTopHits object.
     * @param getTopHits.index - Index name.
     * @param getTopHits.search - Search query.
     * @param getTopHits.clickAnalytics - Whether to include metrics related to click and conversion events in the response.
     * @param getTopHits.revenueAnalytics - Whether to include metrics related to revenue events in the response.
     * @param getTopHits.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopHits.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopHits.limit - Number of items to return.
     * @param getTopHits.offset - Position of the first item to return.
     * @param getTopHits.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopHits ({ index: index, search: search, clickAnalytics: clickAnalytics, revenueAnalytics: revenueAnalytics, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getTopHits`.");
            const requestPath = "/2/hits";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (search !== void 0) queryParameters["search"] = search.toString();
            if (clickAnalytics !== void 0) queryParameters["clickAnalytics"] = clickAnalytics.toString();
            if (revenueAnalytics !== void 0) queryParameters["revenueAnalytics"] = revenueAnalytics.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Returns the most popular searches. For each search, it also includes the average number of hits.  If you set the `clickAnalytics` query parameter to `true`, the response also includes  - Tracked searches count. Tracked searches are Search API requests with the `clickAnalytics` parameter set to `true`. This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`. - Click count - Click-through rate (CTR) - Conversion count - Conversion rate (CR) - Average click position  If you set the `revenueAnalytics` query parameter to `true`, the response also includes:  - Add-to-cart count - Add-to-cart rate (ATCR) - Purchase count - Purchase rate - Revenue details for each currency  **There\'s a difference between 0% rates and null rates:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the rates (CTR, CR, ATCR, purchase rate) are null. - **0% rates** mean there _were_ queries but no [click or conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopSearches - The getTopSearches object.
     * @param getTopSearches.index - Index name.
     * @param getTopSearches.clickAnalytics - Whether to include metrics related to click and conversion events in the response.
     * @param getTopSearches.revenueAnalytics - Whether to include metrics related to revenue events in the response.
     * @param getTopSearches.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopSearches.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopSearches.orderBy - Attribute by which to order the response items.  If the `clickAnalytics` parameter is false, only `searchCount` is available.
     * @param getTopSearches.direction - Sorting direction of the results: ascending or descending.
     * @param getTopSearches.limit - Number of items to return.
     * @param getTopSearches.offset - Position of the first item to return.
     * @param getTopSearches.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopSearches ({ index: index, clickAnalytics: clickAnalytics, revenueAnalytics: revenueAnalytics, startDate: startDate, endDate: endDate, orderBy: orderBy, direction: direction, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getTopSearches`.");
            const requestPath = "/2/searches";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (clickAnalytics !== void 0) queryParameters["clickAnalytics"] = clickAnalytics.toString();
            if (revenueAnalytics !== void 0) queryParameters["revenueAnalytics"] = revenueAnalytics.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (orderBy !== void 0) queryParameters["orderBy"] = orderBy.toString();
            if (direction !== void 0) queryParameters["direction"] = direction.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the number of unique users within a time range, including a daily breakdown.  Since it returns the number of unique users, the sum of the daily values might be different from the total number.  By default:  - Algolia distinguishes search users by their IP address, _unless_ you include a pseudonymous user identifier in your search requests with the `userToken` API parameter or `x-algolia-usertoken` request header. - The analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getUsersCount - The getUsersCount object.
     * @param getUsersCount.index - Index name.
     * @param getUsersCount.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getUsersCount.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getUsersCount.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getUsersCount ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getUsersCount`.");
            const requestPath = "/2/users/count";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $66b4a85c6ea664d7$export$f1caacacb426dc27(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (region && (typeof region !== "string" || !$66b4a85c6ea664d7$var$REGIONS.includes(region))) throw new Error(`\`region\` must be one of the following: ${$66b4a85c6ea664d7$var$REGIONS.join(", ")}`);
    return $66b4a85c6ea664d7$var$createAnalyticsClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $5e9921bee1f5cd3c$export$6d3f4ca34494bf2d)(),
        requester: (0, $5be27e2d7f7d1009$export$2b053666affad54a)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)(),
        requestsCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)({
            serializable: false
        }),
        hostsCache: (0, $5e9921bee1f5cd3c$export$8637a0800116df9b)({
            caches: [
                (0, $5e9921bee1f5cd3c$export$ca8cae1c5b20815a)({
                    key: `${$66b4a85c6ea664d7$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)()
            ]
        }),
        ...options
    });
}


var $9edd69ad60151739$exports = {};

$parcel$export($9edd69ad60151739$exports, "apiClientVersion", () => $9edd69ad60151739$export$ad1dfbed11feb646);
$parcel$export($9edd69ad60151739$exports, "insightsClient", () => $9edd69ad60151739$export$856f93a58939b342);
// builds/browser.ts


var $9edd69ad60151739$export$ad1dfbed11feb646 = "5.21.0";
var $9edd69ad60151739$var$REGIONS = [
    "de",
    "us"
];
function $9edd69ad60151739$var$getDefaultHosts(region) {
    const url = !region ? "insights.algolia.io" : "insights.{region}.algolia.io".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $9edd69ad60151739$var$createInsightsClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $5e9921bee1f5cd3c$export$5f096e4c9da248bb)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $5e9921bee1f5cd3c$export$9f379e42258ad245)({
        hosts: $9edd69ad60151739$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $5e9921bee1f5cd3c$export$dc28410830ce888d)({
            algoliaAgents: algoliaAgents,
            client: "Insights",
            version: $9edd69ad60151739$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes all events related to the specified user token from events metrics and analytics. The deletion is asynchronous, and processed within 48 hours. To delete a personalization user profile, see `Delete a user profile` in the Personalization API.
     * @param deleteUserToken - The deleteUserToken object.
     * @param deleteUserToken.userToken - User token for which to delete all associated events.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteUserToken ({ userToken: userToken }, requestOptions) {
            if (!userToken) throw new Error("Parameter `userToken` is required when calling `deleteUserToken`.");
            const requestPath = "/1/usertokens/{userToken}".replace("{userToken}", encodeURIComponent(userToken));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Sends a list of events to the Insights API.  You can include up to 1,000 events in a single request, but the request body must be smaller than 2&nbsp;MB.
     * @param insightsEvents - The insightsEvents object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ pushEvents (insightsEvents, requestOptions) {
            if (!insightsEvents) throw new Error("Parameter `insightsEvents` is required when calling `pushEvents`.");
            if (!insightsEvents.events) throw new Error("Parameter `insightsEvents.events` is required when calling `pushEvents`.");
            const requestPath = "/1/events";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: insightsEvents
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $9edd69ad60151739$export$856f93a58939b342(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (region && (typeof region !== "string" || !$9edd69ad60151739$var$REGIONS.includes(region))) throw new Error(`\`region\` must be one of the following: ${$9edd69ad60151739$var$REGIONS.join(", ")}`);
    return $9edd69ad60151739$var$createInsightsClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $5e9921bee1f5cd3c$export$6d3f4ca34494bf2d)(),
        requester: (0, $5be27e2d7f7d1009$export$2b053666affad54a)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)(),
        requestsCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)({
            serializable: false
        }),
        hostsCache: (0, $5e9921bee1f5cd3c$export$8637a0800116df9b)({
            caches: [
                (0, $5e9921bee1f5cd3c$export$ca8cae1c5b20815a)({
                    key: `${$9edd69ad60151739$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)()
            ]
        }),
        ...options
    });
}


var $e3771acb5eb9ca00$exports = {};

$parcel$export($e3771acb5eb9ca00$exports, "apiClientVersion", () => $e3771acb5eb9ca00$export$ad1dfbed11feb646);
$parcel$export($e3771acb5eb9ca00$exports, "personalizationClient", () => $e3771acb5eb9ca00$export$56412180a9807a64);
// builds/browser.ts


var $e3771acb5eb9ca00$export$ad1dfbed11feb646 = "5.21.0";
var $e3771acb5eb9ca00$var$REGIONS = [
    "eu",
    "us"
];
function $e3771acb5eb9ca00$var$getDefaultHosts(region) {
    const url = "personalization.{region}.algolia.com".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $e3771acb5eb9ca00$var$createPersonalizationClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $5e9921bee1f5cd3c$export$5f096e4c9da248bb)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $5e9921bee1f5cd3c$export$9f379e42258ad245)({
        hosts: $e3771acb5eb9ca00$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $5e9921bee1f5cd3c$export$dc28410830ce888d)({
            algoliaAgents: algoliaAgents,
            client: "Personalization",
            version: $e3771acb5eb9ca00$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a user profile.  The response includes a date and time when the user profile can safely be considered deleted.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param deleteUserProfile - The deleteUserProfile object.
     * @param deleteUserProfile.userToken - Unique identifier representing a user for which to fetch the personalization profile.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteUserProfile ({ userToken: userToken }, requestOptions) {
            if (!userToken) throw new Error("Parameter `userToken` is required when calling `deleteUserProfile`.");
            const requestPath = "/1/profiles/{userToken}".replace("{userToken}", encodeURIComponent(userToken));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the current personalization strategy.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getPersonalizationStrategy (requestOptions) {
            const requestPath = "/1/strategies/personalization";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a user profile and their affinities for different facets.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param getUserTokenProfile - The getUserTokenProfile object.
     * @param getUserTokenProfile.userToken - Unique identifier representing a user for which to fetch the personalization profile.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getUserTokenProfile ({ userToken: userToken }, requestOptions) {
            if (!userToken) throw new Error("Parameter `userToken` is required when calling `getUserTokenProfile`.");
            const requestPath = "/1/profiles/personalization/{userToken}".replace("{userToken}", encodeURIComponent(userToken));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new personalization strategy.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param personalizationStrategyParams - The personalizationStrategyParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ setPersonalizationStrategy (personalizationStrategyParams, requestOptions) {
            if (!personalizationStrategyParams) throw new Error("Parameter `personalizationStrategyParams` is required when calling `setPersonalizationStrategy`.");
            if (!personalizationStrategyParams.eventsScoring) throw new Error("Parameter `personalizationStrategyParams.eventsScoring` is required when calling `setPersonalizationStrategy`.");
            if (!personalizationStrategyParams.facetsScoring) throw new Error("Parameter `personalizationStrategyParams.facetsScoring` is required when calling `setPersonalizationStrategy`.");
            if (!personalizationStrategyParams.personalizationImpact) throw new Error("Parameter `personalizationStrategyParams.personalizationImpact` is required when calling `setPersonalizationStrategy`.");
            const requestPath = "/1/strategies/personalization";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: personalizationStrategyParams
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $e3771acb5eb9ca00$export$56412180a9807a64(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (!region || region && (typeof region !== "string" || !$e3771acb5eb9ca00$var$REGIONS.includes(region))) throw new Error(`\`region\` is required and must be one of the following: ${$e3771acb5eb9ca00$var$REGIONS.join(", ")}`);
    return $e3771acb5eb9ca00$var$createPersonalizationClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $5e9921bee1f5cd3c$export$6d3f4ca34494bf2d)(),
        requester: (0, $5be27e2d7f7d1009$export$2b053666affad54a)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)(),
        requestsCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)({
            serializable: false
        }),
        hostsCache: (0, $5e9921bee1f5cd3c$export$8637a0800116df9b)({
            caches: [
                (0, $5e9921bee1f5cd3c$export$ca8cae1c5b20815a)({
                    key: `${$e3771acb5eb9ca00$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)()
            ]
        }),
        ...options
    });
}


var $337b9d60b8bfb816$exports = {};

$parcel$export($337b9d60b8bfb816$exports, "apiClientVersion", () => $337b9d60b8bfb816$export$ad1dfbed11feb646);
$parcel$export($337b9d60b8bfb816$exports, "querySuggestionsClient", () => $337b9d60b8bfb816$export$1efe5b59a2a2df14);
// builds/browser.ts


var $337b9d60b8bfb816$export$ad1dfbed11feb646 = "5.21.0";
var $337b9d60b8bfb816$var$REGIONS = [
    "eu",
    "us"
];
function $337b9d60b8bfb816$var$getDefaultHosts(region) {
    const url = "query-suggestions.{region}.algolia.com".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $337b9d60b8bfb816$var$createQuerySuggestionsClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $5e9921bee1f5cd3c$export$5f096e4c9da248bb)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $5e9921bee1f5cd3c$export$9f379e42258ad245)({
        hosts: $337b9d60b8bfb816$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $5e9921bee1f5cd3c$export$dc28410830ce888d)({
            algoliaAgents: algoliaAgents,
            client: "QuerySuggestions",
            version: $337b9d60b8bfb816$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Creates a new Query Suggestions configuration.  You can have up to 100 configurations per Algolia application.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param configurationWithIndex - The configurationWithIndex object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createConfig (configurationWithIndex, requestOptions) {
            if (!configurationWithIndex) throw new Error("Parameter `configurationWithIndex` is required when calling `createConfig`.");
            const requestPath = "/1/configs";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: configurationWithIndex
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a Query Suggestions configuration.  Deleting only removes the configuration and stops updates to the Query Suggestions index. To delete the Query Suggestions index itself, use the Search API and the `Delete an index` operation.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteConfig - The deleteConfig object.
     * @param deleteConfig.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteConfig ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteConfig`.");
            const requestPath = "/1/configs/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves all Query Suggestions configurations of your Algolia application.
     *
     * Required API Key ACLs:
     *  - settings
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getAllConfigs (requestOptions) {
            const requestPath = "/1/configs";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a single Query Suggestions configuration by its index name.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getConfig - The getConfig object.
     * @param getConfig.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getConfig ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getConfig`.");
            const requestPath = "/1/configs/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Reports the status of a Query Suggestions index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getConfigStatus - The getConfigStatus object.
     * @param getConfigStatus.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getConfigStatus ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getConfigStatus`.");
            const requestPath = "/1/configs/{indexName}/status".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the logs for a single Query Suggestions index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getLogFile - The getLogFile object.
     * @param getLogFile.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getLogFile ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getLogFile`.");
            const requestPath = "/1/logs/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates a QuerySuggestions configuration.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param updateConfig - The updateConfig object.
     * @param updateConfig.indexName - Query Suggestions index name.
     * @param updateConfig.configuration - The configuration object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateConfig ({ indexName: indexName, configuration: configuration }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `updateConfig`.");
            if (!configuration) throw new Error("Parameter `configuration` is required when calling `updateConfig`.");
            if (!configuration.sourceIndices) throw new Error("Parameter `configuration.sourceIndices` is required when calling `updateConfig`.");
            const requestPath = "/1/configs/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: configuration
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $337b9d60b8bfb816$export$1efe5b59a2a2df14(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (!region || region && (typeof region !== "string" || !$337b9d60b8bfb816$var$REGIONS.includes(region))) throw new Error(`\`region\` is required and must be one of the following: ${$337b9d60b8bfb816$var$REGIONS.join(", ")}`);
    return $337b9d60b8bfb816$var$createQuerySuggestionsClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $5e9921bee1f5cd3c$export$6d3f4ca34494bf2d)(),
        requester: (0, $5be27e2d7f7d1009$export$2b053666affad54a)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)(),
        requestsCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)({
            serializable: false
        }),
        hostsCache: (0, $5e9921bee1f5cd3c$export$8637a0800116df9b)({
            caches: [
                (0, $5e9921bee1f5cd3c$export$ca8cae1c5b20815a)({
                    key: `${$337b9d60b8bfb816$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)()
            ]
        }),
        ...options
    });
}


var $49a95dde5dda3eeb$exports = {};

$parcel$export($49a95dde5dda3eeb$exports, "apiClientVersion", () => $49a95dde5dda3eeb$export$ad1dfbed11feb646);
$parcel$export($49a95dde5dda3eeb$exports, "searchClient", () => $49a95dde5dda3eeb$export$b72856d058786d12);
// builds/browser.ts


var $49a95dde5dda3eeb$export$ad1dfbed11feb646 = "5.21.0";
function $49a95dde5dda3eeb$var$getDefaultHosts(appId) {
    return [
        {
            url: `${appId}-dsn.algolia.net`,
            accept: "read",
            protocol: "https"
        },
        {
            url: `${appId}.algolia.net`,
            accept: "write",
            protocol: "https"
        }
    ].concat((0, $5e9921bee1f5cd3c$export$448332262467e042)([
        {
            url: `${appId}-1.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-2.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-3.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        }
    ]));
}
function $49a95dde5dda3eeb$var$createSearchClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, ...options }) {
    const auth = (0, $5e9921bee1f5cd3c$export$5f096e4c9da248bb)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $5e9921bee1f5cd3c$export$9f379e42258ad245)({
        hosts: $49a95dde5dda3eeb$var$getDefaultHosts(appIdOption),
        ...options,
        algoliaAgent: (0, $5e9921bee1f5cd3c$export$dc28410830ce888d)({
            algoliaAgents: algoliaAgents,
            client: "Search",
            version: $49a95dde5dda3eeb$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Helper: Wait for a task to be published (completed) for a given `indexName` and `taskID`.
     *
     * @summary Helper method that waits for a task to be published (completed).
     * @param waitForTaskOptions - The `waitForTaskOptions` object.
     * @param waitForTaskOptions.indexName - The `indexName` where the operation was performed.
     * @param waitForTaskOptions.taskID - The `taskID` returned in the method response.
     * @param waitForTaskOptions.maxRetries - The maximum number of retries. 50 by default.
     * @param waitForTaskOptions.timeout - The function to decide how long to wait between retries.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */ waitForTask ({ indexName: indexName, taskID: taskID, maxRetries: maxRetries = 50, timeout: timeout = (retryCount)=>Math.min(retryCount * 200, 5e3) }, requestOptions) {
            let retryCount = 0;
            return (0, $5e9921bee1f5cd3c$export$d96db6d38a87ffce)({
                func: ()=>this.getTask({
                        indexName: indexName,
                        taskID: taskID
                    }, requestOptions),
                validate: (response)=>response.status === "published",
                aggregator: ()=>retryCount += 1,
                error: {
                    validate: ()=>retryCount >= maxRetries,
                    message: ()=>`The maximum number of retries exceeded. (${retryCount}/${maxRetries})`
                },
                timeout: ()=>timeout(retryCount)
            });
        },
        /**
     * Helper: Wait for an application-level task to complete for a given `taskID`.
     *
     * @summary Helper method that waits for a task to be published (completed).
     * @param waitForAppTaskOptions - The `waitForTaskOptions` object.
     * @param waitForAppTaskOptions.taskID - The `taskID` returned in the method response.
     * @param waitForAppTaskOptions.maxRetries - The maximum number of retries. 50 by default.
     * @param waitForAppTaskOptions.timeout - The function to decide how long to wait between retries.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */ waitForAppTask ({ taskID: taskID, maxRetries: maxRetries = 50, timeout: timeout = (retryCount)=>Math.min(retryCount * 200, 5e3) }, requestOptions) {
            let retryCount = 0;
            return (0, $5e9921bee1f5cd3c$export$d96db6d38a87ffce)({
                func: ()=>this.getAppTask({
                        taskID: taskID
                    }, requestOptions),
                validate: (response)=>response.status === "published",
                aggregator: ()=>retryCount += 1,
                error: {
                    validate: ()=>retryCount >= maxRetries,
                    message: ()=>`The maximum number of retries exceeded. (${retryCount}/${maxRetries})`
                },
                timeout: ()=>timeout(retryCount)
            });
        },
        /**
     * Helper: Wait for an API key to be added, updated or deleted based on a given `operation`.
     *
     * @summary Helper method that waits for an API key task to be processed.
     * @param waitForApiKeyOptions - The `waitForApiKeyOptions` object.
     * @param waitForApiKeyOptions.operation - The `operation` that was done on a `key`.
     * @param waitForApiKeyOptions.key - The `key` that has been added, deleted or updated.
     * @param waitForApiKeyOptions.apiKey - Necessary to know if an `update` operation has been processed, compare fields of the response with it.
     * @param waitForApiKeyOptions.maxRetries - The maximum number of retries. 50 by default.
     * @param waitForApiKeyOptions.timeout - The function to decide how long to wait between retries.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getApikey` method and merged with the transporter requestOptions.
     */ waitForApiKey ({ operation: operation, key: key, apiKey: apiKey, maxRetries: maxRetries = 50, timeout: timeout = (retryCount)=>Math.min(retryCount * 200, 5e3) }, requestOptions) {
            let retryCount = 0;
            const baseIteratorOptions = {
                aggregator: ()=>retryCount += 1,
                error: {
                    validate: ()=>retryCount >= maxRetries,
                    message: ()=>`The maximum number of retries exceeded. (${retryCount}/${maxRetries})`
                },
                timeout: ()=>timeout(retryCount)
            };
            if (operation === "update") {
                if (!apiKey) throw new Error("`apiKey` is required when waiting for an `update` operation.");
                return (0, $5e9921bee1f5cd3c$export$d96db6d38a87ffce)({
                    ...baseIteratorOptions,
                    func: ()=>this.getApiKey({
                            key: key
                        }, requestOptions),
                    validate: (response)=>{
                        for (const field of Object.keys(apiKey)){
                            const value = apiKey[field];
                            const resValue = response[field];
                            if (Array.isArray(value) && Array.isArray(resValue)) {
                                if (value.length !== resValue.length || value.some((v, index)=>v !== resValue[index])) return false;
                            } else if (value !== resValue) return false;
                        }
                        return true;
                    }
                });
            }
            return (0, $5e9921bee1f5cd3c$export$d96db6d38a87ffce)({
                ...baseIteratorOptions,
                func: ()=>this.getApiKey({
                        key: key
                    }, requestOptions).catch((error)=>{
                        if (error.status === 404) return void 0;
                        throw error;
                    }),
                validate: (response)=>operation === "add" ? response !== void 0 : response === void 0
            });
        },
        /**
     * Helper: Iterate on the `browse` method of the client to allow aggregating objects of an index.
     *
     * @summary Helper method that iterates on the `browse` method.
     * @param browseObjects - The `browseObjects` object.
     * @param browseObjects.indexName - The index in which to perform the request.
     * @param browseObjects.browseParams - The `browse` parameters.
     * @param browseObjects.validate - The validator function. It receive the resolved return of the API call. By default, stops when there is no `cursor` in the response.
     * @param browseObjects.aggregator - The function that runs right after the API call has been resolved, allows you to do anything with the response before `validate`.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `browse` method and merged with the transporter requestOptions.
     */ browseObjects ({ indexName: indexName, browseParams: browseParams, ...browseObjectsOptions }, requestOptions) {
            return (0, $5e9921bee1f5cd3c$export$d96db6d38a87ffce)({
                func: (previousResponse)=>{
                    return this.browse({
                        indexName: indexName,
                        browseParams: {
                            cursor: previousResponse ? previousResponse.cursor : void 0,
                            hitsPerPage: 1e3,
                            ...browseParams
                        }
                    }, requestOptions);
                },
                validate: (response)=>response.cursor === void 0,
                ...browseObjectsOptions
            });
        },
        /**
     * Helper: Iterate on the `searchRules` method of the client to allow aggregating rules of an index.
     *
     * @summary Helper method that iterates on the `searchRules` method.
     * @param browseRules - The `browseRules` object.
     * @param browseRules.indexName - The index in which to perform the request.
     * @param browseRules.searchRulesParams - The `searchRules` method parameters.
     * @param browseRules.validate - The validator function. It receive the resolved return of the API call. By default, stops when there is less hits returned than the number of maximum hits (1000).
     * @param browseRules.aggregator - The function that runs right after the API call has been resolved, allows you to do anything with the response before `validate`.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `searchRules` method and merged with the transporter requestOptions.
     */ browseRules ({ indexName: indexName, searchRulesParams: searchRulesParams, ...browseRulesOptions }, requestOptions) {
            const params = {
                hitsPerPage: 1e3,
                ...searchRulesParams
            };
            return (0, $5e9921bee1f5cd3c$export$d96db6d38a87ffce)({
                func: (previousResponse)=>{
                    return this.searchRules({
                        indexName: indexName,
                        searchRulesParams: {
                            ...params,
                            page: previousResponse ? previousResponse.page + 1 : params.page || 0
                        }
                    }, requestOptions);
                },
                validate: (response)=>response.hits.length < params.hitsPerPage,
                ...browseRulesOptions
            });
        },
        /**
     * Helper: Iterate on the `searchSynonyms` method of the client to allow aggregating rules of an index.
     *
     * @summary Helper method that iterates on the `searchSynonyms` method.
     * @param browseSynonyms - The `browseSynonyms` object.
     * @param browseSynonyms.indexName - The index in which to perform the request.
     * @param browseSynonyms.validate - The validator function. It receive the resolved return of the API call. By default, stops when there is less hits returned than the number of maximum hits (1000).
     * @param browseSynonyms.aggregator - The function that runs right after the API call has been resolved, allows you to do anything with the response before `validate`.
     * @param browseSynonyms.searchSynonymsParams - The `searchSynonyms` method parameters.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `searchSynonyms` method and merged with the transporter requestOptions.
     */ browseSynonyms ({ indexName: indexName, searchSynonymsParams: searchSynonymsParams, ...browseSynonymsOptions }, requestOptions) {
            const params = {
                page: 0,
                ...searchSynonymsParams,
                hitsPerPage: 1e3
            };
            return (0, $5e9921bee1f5cd3c$export$d96db6d38a87ffce)({
                func: (_)=>{
                    const resp = this.searchSynonyms({
                        indexName: indexName,
                        searchSynonymsParams: {
                            ...params,
                            page: params.page
                        }
                    }, requestOptions);
                    params.page += 1;
                    return resp;
                },
                validate: (response)=>response.hits.length < params.hitsPerPage,
                ...browseSynonymsOptions
            });
        },
        /**
     * Helper: Chunks the given `objects` list in subset of 1000 elements max in order to make it fit in `batch` requests.
     *
     * @summary Helper: Chunks the given `objects` list in subset of 1000 elements max in order to make it fit in `batch` requests.
     * @param chunkedBatch - The `chunkedBatch` object.
     * @param chunkedBatch.indexName - The `indexName` to replace `objects` in.
     * @param chunkedBatch.objects - The array of `objects` to store in the given Algolia `indexName`.
     * @param chunkedBatch.action - The `batch` `action` to perform on the given array of `objects`, defaults to `addObject`.
     * @param chunkedBatch.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param chunkedBatch.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */ async chunkedBatch ({ indexName: indexName, objects: objects, action: action = "addObject", waitForTasks: waitForTasks, batchSize: batchSize = 1e3 }, requestOptions) {
            let requests = [];
            const responses = [];
            const objectEntries = objects.entries();
            for (const [i, obj] of objectEntries){
                requests.push({
                    action: action,
                    body: obj
                });
                if (requests.length === batchSize || i === objects.length - 1) {
                    responses.push(await this.batch({
                        indexName: indexName,
                        batchWriteParams: {
                            requests: requests
                        }
                    }, requestOptions));
                    requests = [];
                }
            }
            if (waitForTasks) for (const resp of responses)await this.waitForTask({
                indexName: indexName,
                taskID: resp.taskID
            });
            return responses;
        },
        /**
     * Helper: Saves the given array of objects in the given index. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     *
     * @summary Helper: Saves the given array of objects in the given index. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     * @param saveObjects - The `saveObjects` object.
     * @param saveObjects.indexName - The `indexName` to save `objects` in.
     * @param saveObjects.objects - The array of `objects` to store in the given Algolia `indexName`.
     * @param chunkedBatch.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param saveObjects.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `batch` method and merged with the transporter requestOptions.
     */ async saveObjects ({ indexName: indexName, objects: objects, waitForTasks: waitForTasks, batchSize: batchSize }, requestOptions) {
            return await this.chunkedBatch({
                indexName: indexName,
                objects: objects,
                action: "addObject",
                waitForTasks: waitForTasks,
                batchSize: batchSize
            }, requestOptions);
        },
        /**
     * Helper: Deletes every records for the given objectIDs. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objectIDs in it.
     *
     * @summary Helper: Deletes every records for the given objectIDs. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objectIDs in it.
     * @param deleteObjects - The `deleteObjects` object.
     * @param deleteObjects.indexName - The `indexName` to delete `objectIDs` from.
     * @param deleteObjects.objectIDs - The objectIDs to delete.
     * @param chunkedBatch.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param deleteObjects.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `batch` method and merged with the transporter requestOptions.
     */ async deleteObjects ({ indexName: indexName, objectIDs: objectIDs, waitForTasks: waitForTasks, batchSize: batchSize }, requestOptions) {
            return await this.chunkedBatch({
                indexName: indexName,
                objects: objectIDs.map((objectID)=>({
                        objectID: objectID
                    })),
                action: "deleteObject",
                waitForTasks: waitForTasks,
                batchSize: batchSize
            }, requestOptions);
        },
        /**
     * Helper: Replaces object content of all the given objects according to their respective `objectID` field. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     *
     * @summary Helper: Replaces object content of all the given objects according to their respective `objectID` field. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     * @param partialUpdateObjects - The `partialUpdateObjects` object.
     * @param partialUpdateObjects.indexName - The `indexName` to update `objects` in.
     * @param partialUpdateObjects.objects - The array of `objects` to update in the given Algolia `indexName`.
     * @param partialUpdateObjects.createIfNotExists - To be provided if non-existing objects are passed, otherwise, the call will fail..
     * @param chunkedBatch.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param partialUpdateObjects.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */ async partialUpdateObjects ({ indexName: indexName, objects: objects, createIfNotExists: createIfNotExists, waitForTasks: waitForTasks, batchSize: batchSize }, requestOptions) {
            return await this.chunkedBatch({
                indexName: indexName,
                objects: objects,
                action: createIfNotExists ? "partialUpdateObject" : "partialUpdateObjectNoCreate",
                batchSize: batchSize,
                waitForTasks: waitForTasks
            }, requestOptions);
        },
        /**
     * Helper: Replaces all objects (records) in the given `index_name` with the given `objects`. A temporary index is created during this process in order to backup your data.
     * See https://api-clients-automation.netlify.app/docs/add-new-api-client#5-helpers for implementation details.
     *
     * @summary Helper: Replaces all objects (records) in the given `index_name` with the given `objects`. A temporary index is created during this process in order to backup your data.
     * @param replaceAllObjects - The `replaceAllObjects` object.
     * @param replaceAllObjects.indexName - The `indexName` to replace `objects` in.
     * @param replaceAllObjects.objects - The array of `objects` to store in the given Algolia `indexName`.
     * @param replaceAllObjects.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `objects.length / batchSize`. Defaults to 1000.
     * @param replaceAllObjects.scopes - The `scopes` to keep from the index. Defaults to ['settings', 'rules', 'synonyms'].
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `batch`, `operationIndex` and `getTask` method and merged with the transporter requestOptions.
     */ async replaceAllObjects ({ indexName: indexName, objects: objects, batchSize: batchSize, scopes: scopes }, requestOptions) {
            const randomSuffix = Math.floor(Math.random() * 1e6) + 1e5;
            const tmpIndexName = `${indexName}_tmp_${randomSuffix}`;
            if (scopes === void 0) scopes = [
                "settings",
                "rules",
                "synonyms"
            ];
            try {
                let copyOperationResponse = await this.operationIndex({
                    indexName: indexName,
                    operationIndexParams: {
                        operation: "copy",
                        destination: tmpIndexName,
                        scope: scopes
                    }
                }, requestOptions);
                const batchResponses = await this.chunkedBatch({
                    indexName: tmpIndexName,
                    objects: objects,
                    waitForTasks: true,
                    batchSize: batchSize
                }, requestOptions);
                await this.waitForTask({
                    indexName: tmpIndexName,
                    taskID: copyOperationResponse.taskID
                });
                copyOperationResponse = await this.operationIndex({
                    indexName: indexName,
                    operationIndexParams: {
                        operation: "copy",
                        destination: tmpIndexName,
                        scope: scopes
                    }
                }, requestOptions);
                await this.waitForTask({
                    indexName: tmpIndexName,
                    taskID: copyOperationResponse.taskID
                });
                const moveOperationResponse = await this.operationIndex({
                    indexName: tmpIndexName,
                    operationIndexParams: {
                        operation: "move",
                        destination: indexName
                    }
                }, requestOptions);
                await this.waitForTask({
                    indexName: tmpIndexName,
                    taskID: moveOperationResponse.taskID
                });
                return {
                    copyOperationResponse: copyOperationResponse,
                    batchResponses: batchResponses,
                    moveOperationResponse: moveOperationResponse
                };
            } catch (error) {
                await this.deleteIndex({
                    indexName: tmpIndexName
                });
                throw error;
            }
        },
        async indexExists ({ indexName: indexName }) {
            try {
                await this.getSettings({
                    indexName: indexName
                });
            } catch (error) {
                if (error instanceof (0, $5e9921bee1f5cd3c$export$f2e832acab1bdd79) && error.status === 404) return false;
                throw error;
            }
            return true;
        },
        /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia records (hits) and not facets.
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `hits` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `hits`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchForHits (searchMethodParams, requestOptions) {
            return this.search(searchMethodParams, requestOptions);
        },
        /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia facets and not records (hits).
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `facets` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `facets`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchForFacets (searchMethodParams, requestOptions) {
            return this.search(searchMethodParams, requestOptions);
        },
        /**
     * Creates a new API key with specific permissions and restrictions.
     *
     * Required API Key ACLs:
     *  - admin
     * @param apiKey - The apiKey object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ addApiKey (apiKey, requestOptions) {
            if (!apiKey) throw new Error("Parameter `apiKey` is required when calling `addApiKey`.");
            if (!apiKey.acl) throw new Error("Parameter `apiKey.acl` is required when calling `addApiKey`.");
            const requestPath = "/1/keys";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: apiKey
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * If a record with the specified object ID exists, the existing record is replaced. Otherwise, a new record is added to the index.  If you want to use auto-generated object IDs, use the [`saveObject` operation](#tag/Records/operation/saveObject). To update _some_ attributes of an existing record, use the [`partial` operation](#tag/Records/operation/partialUpdateObject) instead. To add, update, or replace multiple records, use the [`batch` operation](#tag/Records/operation/batch).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param addOrUpdateObject - The addOrUpdateObject object.
     * @param addOrUpdateObject.indexName - Name of the index on which to perform the operation.
     * @param addOrUpdateObject.objectID - Unique record identifier.
     * @param addOrUpdateObject.body - The record. A schemaless object with attributes that are useful in the context of search and discovery.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ addOrUpdateObject ({ indexName: indexName, objectID: objectID, body: body }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `addOrUpdateObject`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `addOrUpdateObject`.");
            if (!body) throw new Error("Parameter `body` is required when calling `addOrUpdateObject`.");
            const requestPath = "/1/indexes/{indexName}/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds a source to the list of allowed sources.
     *
     * Required API Key ACLs:
     *  - admin
     * @param source - Source to add.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ appendSource (source, requestOptions) {
            if (!source) throw new Error("Parameter `source` is required when calling `appendSource`.");
            if (!source.source) throw new Error("Parameter `source.source` is required when calling `appendSource`.");
            const requestPath = "/1/security/sources/append";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: source
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Assigns or moves a user ID to a cluster.  The time it takes to move a user is proportional to the amount of data linked to the user ID.
     *
     * Required API Key ACLs:
     *  - admin
     * @param assignUserId - The assignUserId object.
     * @param assignUserId.xAlgoliaUserID - Unique identifier of the user who makes the search request.
     * @param assignUserId.assignUserIdParams - The assignUserIdParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ assignUserId ({ xAlgoliaUserID: xAlgoliaUserID, assignUserIdParams: assignUserIdParams }, requestOptions) {
            if (!xAlgoliaUserID) throw new Error("Parameter `xAlgoliaUserID` is required when calling `assignUserId`.");
            if (!assignUserIdParams) throw new Error("Parameter `assignUserIdParams` is required when calling `assignUserId`.");
            if (!assignUserIdParams.cluster) throw new Error("Parameter `assignUserIdParams.cluster` is required when calling `assignUserId`.");
            const requestPath = "/1/clusters/mapping";
            const headers = {};
            const queryParameters = {};
            if (xAlgoliaUserID !== void 0) headers["X-Algolia-User-ID"] = xAlgoliaUserID.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: assignUserIdParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds, updates, or deletes records in one index with a single API request.  Batching index updates reduces latency and increases data integrity.  - Actions are applied in the order they\'re specified. - Actions are equivalent to the individual API requests of the same name.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     * @param batch - The batch object.
     * @param batch.indexName - Name of the index on which to perform the operation.
     * @param batch.batchWriteParams - The batchWriteParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ batch ({ indexName: indexName, batchWriteParams: batchWriteParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `batch`.");
            if (!batchWriteParams) throw new Error("Parameter `batchWriteParams` is required when calling `batch`.");
            if (!batchWriteParams.requests) throw new Error("Parameter `batchWriteParams.requests` is required when calling `batch`.");
            const requestPath = "/1/indexes/{indexName}/batch".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: batchWriteParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Assigns multiple user IDs to a cluster.  **You can\'t move users with this operation**.
     *
     * Required API Key ACLs:
     *  - admin
     * @param batchAssignUserIds - The batchAssignUserIds object.
     * @param batchAssignUserIds.xAlgoliaUserID - Unique identifier of the user who makes the search request.
     * @param batchAssignUserIds.batchAssignUserIdsParams - The batchAssignUserIdsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ batchAssignUserIds ({ xAlgoliaUserID: xAlgoliaUserID, batchAssignUserIdsParams: batchAssignUserIdsParams }, requestOptions) {
            if (!xAlgoliaUserID) throw new Error("Parameter `xAlgoliaUserID` is required when calling `batchAssignUserIds`.");
            if (!batchAssignUserIdsParams) throw new Error("Parameter `batchAssignUserIdsParams` is required when calling `batchAssignUserIds`.");
            if (!batchAssignUserIdsParams.cluster) throw new Error("Parameter `batchAssignUserIdsParams.cluster` is required when calling `batchAssignUserIds`.");
            if (!batchAssignUserIdsParams.users) throw new Error("Parameter `batchAssignUserIdsParams.users` is required when calling `batchAssignUserIds`.");
            const requestPath = "/1/clusters/mapping/batch";
            const headers = {};
            const queryParameters = {};
            if (xAlgoliaUserID !== void 0) headers["X-Algolia-User-ID"] = xAlgoliaUserID.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: batchAssignUserIdsParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds or deletes multiple entries from your plurals, segmentation, or stop word dictionaries.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param batchDictionaryEntries - The batchDictionaryEntries object.
     * @param batchDictionaryEntries.dictionaryName - Dictionary type in which to search.
     * @param batchDictionaryEntries.batchDictionaryEntriesParams - The batchDictionaryEntriesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ batchDictionaryEntries ({ dictionaryName: dictionaryName, batchDictionaryEntriesParams: batchDictionaryEntriesParams }, requestOptions) {
            if (!dictionaryName) throw new Error("Parameter `dictionaryName` is required when calling `batchDictionaryEntries`.");
            if (!batchDictionaryEntriesParams) throw new Error("Parameter `batchDictionaryEntriesParams` is required when calling `batchDictionaryEntries`.");
            if (!batchDictionaryEntriesParams.requests) throw new Error("Parameter `batchDictionaryEntriesParams.requests` is required when calling `batchDictionaryEntries`.");
            const requestPath = "/1/dictionaries/{dictionaryName}/batch".replace("{dictionaryName}", encodeURIComponent(dictionaryName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: batchDictionaryEntriesParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves records from an index, up to 1,000 per request.  While searching retrieves _hits_ (records augmented with attributes for highlighting and ranking details), browsing _just_ returns matching records. This can be useful if you want to export your indices.  - The Analytics API doesn\'t collect data when using `browse`. - Records are ranked by attributes and custom ranking. - There\'s no ranking for: typo-tolerance, number of matched words, proximity, geo distance.  Browse requests automatically apply these settings:  - `advancedSyntax`: `false` - `attributesToHighlight`: `[]` - `attributesToSnippet`: `[]` - `distinct`: `false` - `enablePersonalization`: `false` - `enableRules`: `false` - `facets`: `[]` - `getRankingInfo`: `false` - `ignorePlurals`: `false` - `optionalFilters`: `[]` - `typoTolerance`: `true` or `false` (`min` and `strict` evaluate to `true`)  If you send these parameters with your browse requests, they\'ll be ignored.
     *
     * Required API Key ACLs:
     *  - browse
     * @param browse - The browse object.
     * @param browse.indexName - Name of the index on which to perform the operation.
     * @param browse.browseParams - The browseParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ browse ({ indexName: indexName, browseParams: browseParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `browse`.");
            const requestPath = "/1/indexes/{indexName}/browse".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: browseParams ? browseParams : {},
                useReadTransporter: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes only the records from an index while keeping settings, synonyms, and rules. This operation is resource-intensive and subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - deleteIndex
     * @param clearObjects - The clearObjects object.
     * @param clearObjects.indexName - Name of the index on which to perform the operation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ clearObjects ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `clearObjects`.");
            const requestPath = "/1/indexes/{indexName}/clear".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes all rules from the index.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param clearRules - The clearRules object.
     * @param clearRules.indexName - Name of the index on which to perform the operation.
     * @param clearRules.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ clearRules ({ indexName: indexName, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `clearRules`.");
            const requestPath = "/1/indexes/{indexName}/rules/clear".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes all synonyms from the index.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param clearSynonyms - The clearSynonyms object.
     * @param clearSynonyms.indexName - Name of the index on which to perform the operation.
     * @param clearSynonyms.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ clearSynonyms ({ indexName: indexName, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `clearSynonyms`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/clear".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes the API key.
     *
     * Required API Key ACLs:
     *  - admin
     * @param deleteApiKey - The deleteApiKey object.
     * @param deleteApiKey.key - API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteApiKey ({ key: key }, requestOptions) {
            if (!key) throw new Error("Parameter `key` is required when calling `deleteApiKey`.");
            const requestPath = "/1/keys/{key}".replace("{key}", encodeURIComponent(key));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This operation doesn\'t accept empty filters.  This operation is resource-intensive. You should only use it if you can\'t get the object IDs of the records you want to delete. It\'s more efficient to get a list of object IDs with the [`browse` operation](#tag/Search/operation/browse), and then delete the records using the [`batch` operation](#tag/Records/operation/batch).  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - deleteIndex
     * @param deleteBy - The deleteBy object.
     * @param deleteBy.indexName - Name of the index on which to perform the operation.
     * @param deleteBy.deleteByParams - The deleteByParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteBy ({ indexName: indexName, deleteByParams: deleteByParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteBy`.");
            if (!deleteByParams) throw new Error("Parameter `deleteByParams` is required when calling `deleteBy`.");
            const requestPath = "/1/indexes/{indexName}/deleteByQuery".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: deleteByParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes an index and all its settings.  - Deleting an index doesn\'t delete its analytics data. - If you try to delete a non-existing index, the operation is ignored without warning. - If the index you want to delete has replica indices, the replicas become independent indices. - If the index you want to delete is a replica index, you must first unlink it from its primary index before you can delete it.   For more information, see [Delete replica indices](https://www.algolia.com/doc/guides/managing-results/refine-results/sorting/how-to/deleting-replicas/).
     *
     * Required API Key ACLs:
     *  - deleteIndex
     * @param deleteIndex - The deleteIndex object.
     * @param deleteIndex.indexName - Name of the index on which to perform the operation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteIndex ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteIndex`.");
            const requestPath = "/1/indexes/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a record by its object ID.  To delete more than one record, use the [`batch` operation](#tag/Records/operation/batch). To delete records matching a query, use the [`deleteByQuery` operation](#tag/Records/operation/deleteBy).
     *
     * Required API Key ACLs:
     *  - deleteObject
     * @param deleteObject - The deleteObject object.
     * @param deleteObject.indexName - Name of the index on which to perform the operation.
     * @param deleteObject.objectID - Unique record identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteObject ({ indexName: indexName, objectID: objectID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteObject`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `deleteObject`.");
            const requestPath = "/1/indexes/{indexName}/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a rule by its ID. To find the object ID for rules, use the [`search` operation](#tag/Rules/operation/searchRules).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteRule - The deleteRule object.
     * @param deleteRule.indexName - Name of the index on which to perform the operation.
     * @param deleteRule.objectID - Unique identifier of a rule object.
     * @param deleteRule.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteRule ({ indexName: indexName, objectID: objectID, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteRule`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `deleteRule`.");
            const requestPath = "/1/indexes/{indexName}/rules/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a source from the list of allowed sources.
     *
     * Required API Key ACLs:
     *  - admin
     * @param deleteSource - The deleteSource object.
     * @param deleteSource.source - IP address range of the source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteSource ({ source: source }, requestOptions) {
            if (!source) throw new Error("Parameter `source` is required when calling `deleteSource`.");
            const requestPath = "/1/security/sources/{source}".replace("{source}", encodeURIComponent(source));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a synonym by its ID. To find the object IDs of your synonyms, use the [`search` operation](#tag/Synonyms/operation/searchSynonyms).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteSynonym - The deleteSynonym object.
     * @param deleteSynonym.indexName - Name of the index on which to perform the operation.
     * @param deleteSynonym.objectID - Unique identifier of a synonym object.
     * @param deleteSynonym.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteSynonym ({ indexName: indexName, objectID: objectID, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteSynonym`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `deleteSynonym`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Gets the permissions and restrictions of an API key.  When authenticating with the admin API key, you can request information for any of your application\'s keys. When authenticating with other API keys, you can only retrieve information for that key, with the description replaced by `<redacted>`.
     * @param getApiKey - The getApiKey object.
     * @param getApiKey.key - API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getApiKey ({ key: key }, requestOptions) {
            if (!key) throw new Error("Parameter `key` is required when calling `getApiKey`.");
            const requestPath = "/1/keys/{key}".replace("{key}", encodeURIComponent(key));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Checks the status of a given application task.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param getAppTask - The getAppTask object.
     * @param getAppTask.taskID - Unique task identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getAppTask ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `getAppTask`.");
            const requestPath = "/1/task/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists supported languages with their supported dictionary types and number of custom entries.
     *
     * Required API Key ACLs:
     *  - settings
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getDictionaryLanguages (requestOptions) {
            const requestPath = "/1/dictionaries/*/languages";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the languages for which standard dictionary entries are turned off.
     *
     * Required API Key ACLs:
     *  - settings
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getDictionarySettings (requestOptions) {
            const requestPath = "/1/dictionaries/*/settings";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * The request must be authenticated by an API key with the [`logs` ACL](https://www.algolia.com/doc/guides/security/api-keys/#access-control-list-acl).  - Logs are held for the last seven days. - Up to 1,000 API requests per server are logged. - This request counts towards your [operations quota](https://support.algolia.com/hc/en-us/articles/4406981829777-How-does-Algolia-count-records-and-operations-) but doesn\'t appear in the logs itself.
     *
     * Required API Key ACLs:
     *  - logs
     * @param getLogs - The getLogs object.
     * @param getLogs.offset - First log entry to retrieve. The most recent entries are listed first.
     * @param getLogs.length - Maximum number of entries to retrieve.
     * @param getLogs.indexName - Index for which to retrieve log entries. By default, log entries are retrieved for all indices.
     * @param getLogs.type - Type of log entries to retrieve. By default, all log entries are retrieved.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getLogs ({ offset: offset, length: length, indexName: indexName, type: type } = {}, requestOptions) {
            const requestPath = "/1/logs";
            const headers = {};
            const queryParameters = {};
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (length !== void 0) queryParameters["length"] = length.toString();
            if (indexName !== void 0) queryParameters["indexName"] = indexName.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves one record by its object ID.  To retrieve more than one record, use the [`objects` operation](#tag/Records/operation/getObjects).
     *
     * Required API Key ACLs:
     *  - search
     * @param getObject - The getObject object.
     * @param getObject.indexName - Name of the index on which to perform the operation.
     * @param getObject.objectID - Unique record identifier.
     * @param getObject.attributesToRetrieve - Attributes to include with the records in the response. This is useful to reduce the size of the API response. By default, all retrievable attributes are returned.  `objectID` is always retrieved.  Attributes included in `unretrievableAttributes` won\'t be retrieved unless the request is authenticated with the admin API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getObject ({ indexName: indexName, objectID: objectID, attributesToRetrieve: attributesToRetrieve }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getObject`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `getObject`.");
            const requestPath = "/1/indexes/{indexName}/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (attributesToRetrieve !== void 0) queryParameters["attributesToRetrieve"] = attributesToRetrieve.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves one or more records, potentially from different indices.  Records are returned in the same order as the requests.
     *
     * Required API Key ACLs:
     *  - search
     * @param getObjectsParams - Request object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getObjects (getObjectsParams, requestOptions) {
            if (!getObjectsParams) throw new Error("Parameter `getObjectsParams` is required when calling `getObjects`.");
            if (!getObjectsParams.requests) throw new Error("Parameter `getObjectsParams.requests` is required when calling `getObjects`.");
            const requestPath = "/1/indexes/*/objects";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: getObjectsParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a rule by its ID. To find the object ID of rules, use the [`search` operation](#tag/Rules/operation/searchRules).
     *
     * Required API Key ACLs:
     *  - settings
     * @param getRule - The getRule object.
     * @param getRule.indexName - Name of the index on which to perform the operation.
     * @param getRule.objectID - Unique identifier of a rule object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRule ({ indexName: indexName, objectID: objectID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getRule`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `getRule`.");
            const requestPath = "/1/indexes/{indexName}/rules/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves an object with non-null index settings.
     *
     * Required API Key ACLs:
     *  - search
     * @param getSettings - The getSettings object.
     * @param getSettings.indexName - Name of the index on which to perform the operation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSettings ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getSettings`.");
            const requestPath = "/1/indexes/{indexName}/settings".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves all allowed IP addresses with access to your application.
     *
     * Required API Key ACLs:
     *  - admin
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSources (requestOptions) {
            const requestPath = "/1/security/sources";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a synonym by its ID. To find the object IDs for your synonyms, use the [`search` operation](#tag/Synonyms/operation/searchSynonyms).
     *
     * Required API Key ACLs:
     *  - settings
     * @param getSynonym - The getSynonym object.
     * @param getSynonym.indexName - Name of the index on which to perform the operation.
     * @param getSynonym.objectID - Unique identifier of a synonym object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSynonym ({ indexName: indexName, objectID: objectID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getSynonym`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `getSynonym`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Checks the status of a given task.  Indexing tasks are asynchronous. When you add, update, or delete records or indices, a task is created on a queue and completed depending on the load on the server.  The indexing tasks\' responses include a task ID that you can use to check the status.
     *
     * Required API Key ACLs:
     *  - addObject
     * @param getTask - The getTask object.
     * @param getTask.indexName - Name of the index on which to perform the operation.
     * @param getTask.taskID - Unique task identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTask ({ indexName: indexName, taskID: taskID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getTask`.");
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `getTask`.");
            const requestPath = "/1/indexes/{indexName}/task/{taskID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Get the IDs of the 10 users with the highest number of records per cluster.  Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.
     *
     * Required API Key ACLs:
     *  - admin
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopUserIds (requestOptions) {
            const requestPath = "/1/clusters/mapping/top";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Returns the user ID data stored in the mapping.  Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.
     *
     * Required API Key ACLs:
     *  - admin
     * @param getUserId - The getUserId object.
     * @param getUserId.userID - Unique identifier of the user who makes the search request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getUserId ({ userID: userID }, requestOptions) {
            if (!userID) throw new Error("Parameter `userID` is required when calling `getUserId`.");
            const requestPath = "/1/clusters/mapping/{userID}".replace("{userID}", encodeURIComponent(userID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * To determine when the time-consuming process of creating a large batch of users or migrating users from one cluster to another is complete, this operation retrieves the status of the process.
     *
     * Required API Key ACLs:
     *  - admin
     * @param hasPendingMappings - The hasPendingMappings object.
     * @param hasPendingMappings.getClusters - Whether to include the cluster\'s pending mapping state in the response.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ hasPendingMappings ({ getClusters: getClusters } = {}, requestOptions) {
            const requestPath = "/1/clusters/mapping/pending";
            const headers = {};
            const queryParameters = {};
            if (getClusters !== void 0) queryParameters["getClusters"] = getClusters.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists all API keys associated with your Algolia application, including their permissions and restrictions.
     *
     * Required API Key ACLs:
     *  - admin
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listApiKeys (requestOptions) {
            const requestPath = "/1/keys";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists the available clusters in a multi-cluster setup.
     *
     * Required API Key ACLs:
     *  - admin
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listClusters (requestOptions) {
            const requestPath = "/1/clusters";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists all indices in the current Algolia application.  The request follows any index restrictions of the API key you use to make the request.
     *
     * Required API Key ACLs:
     *  - listIndexes
     * @param listIndices - The listIndices object.
     * @param listIndices.page - Requested page of the API response. If `null`, the API response is not paginated.
     * @param listIndices.hitsPerPage - Number of hits per page.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listIndices ({ page: page, hitsPerPage: hitsPerPage } = {}, requestOptions) {
            const requestPath = "/1/indexes";
            const headers = {};
            const queryParameters = {};
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (hitsPerPage !== void 0) queryParameters["hitsPerPage"] = hitsPerPage.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists the userIDs assigned to a multi-cluster application.  Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.
     *
     * Required API Key ACLs:
     *  - admin
     * @param listUserIds - The listUserIds object.
     * @param listUserIds.page - Requested page of the API response. If `null`, the API response is not paginated.
     * @param listUserIds.hitsPerPage - Number of hits per page.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listUserIds ({ page: page, hitsPerPage: hitsPerPage } = {}, requestOptions) {
            const requestPath = "/1/clusters/mapping";
            const headers = {};
            const queryParameters = {};
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (hitsPerPage !== void 0) queryParameters["hitsPerPage"] = hitsPerPage.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds, updates, or deletes records in multiple indices with a single API request.  - Actions are applied in the order they are specified. - Actions are equivalent to the individual API requests of the same name.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     * @param batchParams - The batchParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ multipleBatch (batchParams, requestOptions) {
            if (!batchParams) throw new Error("Parameter `batchParams` is required when calling `multipleBatch`.");
            if (!batchParams.requests) throw new Error("Parameter `batchParams.requests` is required when calling `multipleBatch`.");
            const requestPath = "/1/indexes/*/batch";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: batchParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Copies or moves (renames) an index within the same Algolia application.  - Existing destination indices are overwritten, except for their analytics data. - If the destination index doesn\'t exist yet, it\'ll be created. - This operation is resource-intensive.  **Copy**  - Copying a source index that doesn\'t exist creates a new index with 0 records and default settings. - The API keys of the source index are merged with the existing keys in the destination index. - You can\'t copy the `enableReRanking`, `mode`, and `replicas` settings. - You can\'t copy to a destination index that already has replicas. - Be aware of the [size limits](https://www.algolia.com/doc/guides/scaling/algolia-service-limits/#application-record-and-index-limits). - Related guide: [Copy indices](https://www.algolia.com/doc/guides/sending-and-managing-data/manage-indices-and-apps/manage-indices/how-to/copy-indices/)  **Move**  - Moving a source index that doesn\'t exist is ignored without returning an error. - When moving an index, the analytics data keeps its original name, and a new set of analytics data is started for the new name.   To access the original analytics in the dashboard, create an index with the original name. - If the destination index has replicas, moving will overwrite the existing index and copy the data to the replica indices. - Related guide: [Move indices](https://www.algolia.com/doc/guides/sending-and-managing-data/manage-indices-and-apps/manage-indices/how-to/move-indices/).  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param operationIndex - The operationIndex object.
     * @param operationIndex.indexName - Name of the index on which to perform the operation.
     * @param operationIndex.operationIndexParams - The operationIndexParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ operationIndex ({ indexName: indexName, operationIndexParams: operationIndexParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `operationIndex`.");
            if (!operationIndexParams) throw new Error("Parameter `operationIndexParams` is required when calling `operationIndex`.");
            if (!operationIndexParams.operation) throw new Error("Parameter `operationIndexParams.operation` is required when calling `operationIndex`.");
            if (!operationIndexParams.destination) throw new Error("Parameter `operationIndexParams.destination` is required when calling `operationIndex`.");
            const requestPath = "/1/indexes/{indexName}/operation".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: operationIndexParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds new attributes to a record, or updates existing ones.  - If a record with the specified object ID doesn\'t exist,   a new record is added to the index **if** `createIfNotExists` is true. - If the index doesn\'t exist yet, this method creates a new index. - You can use any first-level attribute but not nested attributes.   If you specify a nested attribute, this operation replaces its first-level ancestor.  To update an attribute without pushing the entire record, you can use these built-in operations. These operations can be helpful if you don\'t have access to your initial data.  - Increment: increment a numeric attribute - Decrement: decrement a numeric attribute - Add: append a number or string element to an array attribute - Remove: remove all matching number or string elements from an array attribute made of numbers or strings - AddUnique: add a number or string element to an array attribute made of numbers or strings only if it\'s not already present - IncrementFrom: increment a numeric integer attribute only if the provided value matches the current value, and otherwise ignore the whole object update. For example, if you pass an IncrementFrom value of 2 for the version attribute, but the current value of the attribute is 1, the engine ignores the update. If the object doesn\'t exist, the engine only creates it if you pass an IncrementFrom value of 0. - IncrementSet: increment a numeric integer attribute only if the provided value is greater than the current value, and otherwise ignore the whole object update. For example, if you pass an IncrementSet value of 2 for the version attribute, and the current value of the attribute is 1, the engine updates the object. If the object doesn\'t exist yet, the engine only creates it if you pass an IncrementSet value greater than 0.  You can specify an operation by providing an object with the attribute to update as the key and its value being an object with the following properties:  - _operation: the operation to apply on the attribute - value: the right-hand side argument to the operation, for example, increment or decrement step, value to add or remove.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param partialUpdateObject - The partialUpdateObject object.
     * @param partialUpdateObject.indexName - Name of the index on which to perform the operation.
     * @param partialUpdateObject.objectID - Unique record identifier.
     * @param partialUpdateObject.attributesToUpdate - Attributes with their values.
     * @param partialUpdateObject.createIfNotExists - Whether to create a new record if it doesn\'t exist.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ partialUpdateObject ({ indexName: indexName, objectID: objectID, attributesToUpdate: attributesToUpdate, createIfNotExists: createIfNotExists }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `partialUpdateObject`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `partialUpdateObject`.");
            if (!attributesToUpdate) throw new Error("Parameter `attributesToUpdate` is required when calling `partialUpdateObject`.");
            const requestPath = "/1/indexes/{indexName}/{objectID}/partial".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (createIfNotExists !== void 0) queryParameters["createIfNotExists"] = createIfNotExists.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: attributesToUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a user ID and its associated data from the clusters.
     *
     * Required API Key ACLs:
     *  - admin
     * @param removeUserId - The removeUserId object.
     * @param removeUserId.userID - Unique identifier of the user who makes the search request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ removeUserId ({ userID: userID }, requestOptions) {
            if (!userID) throw new Error("Parameter `userID` is required when calling `removeUserId`.");
            const requestPath = "/1/clusters/mapping/{userID}".replace("{userID}", encodeURIComponent(userID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Replaces the list of allowed sources.
     *
     * Required API Key ACLs:
     *  - admin
     * @param replaceSources - The replaceSources object.
     * @param replaceSources.source - Allowed sources.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ replaceSources ({ source: source }, requestOptions) {
            if (!source) throw new Error("Parameter `source` is required when calling `replaceSources`.");
            const requestPath = "/1/security/sources";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: source
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Restores a deleted API key.  Restoring resets the `validity` attribute to `0`.  Algolia stores up to 1,000 API keys per application. If you create more, the oldest API keys are deleted and can\'t be restored.
     *
     * Required API Key ACLs:
     *  - admin
     * @param restoreApiKey - The restoreApiKey object.
     * @param restoreApiKey.key - API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ restoreApiKey ({ key: key }, requestOptions) {
            if (!key) throw new Error("Parameter `key` is required when calling `restoreApiKey`.");
            const requestPath = "/1/keys/{key}/restore".replace("{key}", encodeURIComponent(key));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds a record to an index or replaces it.  - If the record doesn\'t have an object ID, a new record with an auto-generated object ID is added to your index. - If a record with the specified object ID exists, the existing record is replaced. - If a record with the specified object ID doesn\'t exist, a new record is added to your index. - If you add a record to an index that doesn\'t exist yet, a new index is created.  To update _some_ attributes of a record, use the [`partial` operation](#tag/Records/operation/partialUpdateObject). To add, update, or replace multiple records, use the [`batch` operation](#tag/Records/operation/batch).  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param saveObject - The saveObject object.
     * @param saveObject.indexName - Name of the index on which to perform the operation.
     * @param saveObject.body - The record. A schemaless object with attributes that are useful in the context of search and discovery.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ saveObject ({ indexName: indexName, body: body }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `saveObject`.");
            if (!body) throw new Error("Parameter `body` is required when calling `saveObject`.");
            const requestPath = "/1/indexes/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * If a rule with the specified object ID doesn\'t exist, it\'s created. Otherwise, the existing rule is replaced.  To create or update more than one rule, use the [`batch` operation](#tag/Rules/operation/saveRules).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveRule - The saveRule object.
     * @param saveRule.indexName - Name of the index on which to perform the operation.
     * @param saveRule.objectID - Unique identifier of a rule object.
     * @param saveRule.rule - The rule object.
     * @param saveRule.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ saveRule ({ indexName: indexName, objectID: objectID, rule: rule, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `saveRule`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `saveRule`.");
            if (!rule) throw new Error("Parameter `rule` is required when calling `saveRule`.");
            if (!rule.objectID) throw new Error("Parameter `rule.objectID` is required when calling `saveRule`.");
            if (!rule.consequence) throw new Error("Parameter `rule.consequence` is required when calling `saveRule`.");
            const requestPath = "/1/indexes/{indexName}/rules/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: rule
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Create or update multiple rules.  If a rule with the specified object ID doesn\'t exist, Algolia creates a new one. Otherwise, existing rules are replaced.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveRules - The saveRules object.
     * @param saveRules.indexName - Name of the index on which to perform the operation.
     * @param saveRules.rules - The rules object.
     * @param saveRules.forwardToReplicas - Whether changes are applied to replica indices.
     * @param saveRules.clearExistingRules - Whether existing rules should be deleted before adding this batch.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ saveRules ({ indexName: indexName, rules: rules, forwardToReplicas: forwardToReplicas, clearExistingRules: clearExistingRules }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `saveRules`.");
            if (!rules) throw new Error("Parameter `rules` is required when calling `saveRules`.");
            const requestPath = "/1/indexes/{indexName}/rules/batch".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            if (clearExistingRules !== void 0) queryParameters["clearExistingRules"] = clearExistingRules.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: rules
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * If a synonym with the specified object ID doesn\'t exist, Algolia adds a new one. Otherwise, the existing synonym is replaced. To add multiple synonyms in a single API request, use the [`batch` operation](#tag/Synonyms/operation/saveSynonyms).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveSynonym - The saveSynonym object.
     * @param saveSynonym.indexName - Name of the index on which to perform the operation.
     * @param saveSynonym.objectID - Unique identifier of a synonym object.
     * @param saveSynonym.synonymHit - The synonymHit object.
     * @param saveSynonym.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ saveSynonym ({ indexName: indexName, objectID: objectID, synonymHit: synonymHit, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `saveSynonym`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `saveSynonym`.");
            if (!synonymHit) throw new Error("Parameter `synonymHit` is required when calling `saveSynonym`.");
            if (!synonymHit.objectID) throw new Error("Parameter `synonymHit.objectID` is required when calling `saveSynonym`.");
            if (!synonymHit.type) throw new Error("Parameter `synonymHit.type` is required when calling `saveSynonym`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: synonymHit
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * If a synonym with the `objectID` doesn\'t exist, Algolia adds a new one. Otherwise, existing synonyms are replaced.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveSynonyms - The saveSynonyms object.
     * @param saveSynonyms.indexName - Name of the index on which to perform the operation.
     * @param saveSynonyms.synonymHit - The synonymHit object.
     * @param saveSynonyms.forwardToReplicas - Whether changes are applied to replica indices.
     * @param saveSynonyms.replaceExistingSynonyms - Whether to replace all synonyms in the index with the ones sent with this request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ saveSynonyms ({ indexName: indexName, synonymHit: synonymHit, forwardToReplicas: forwardToReplicas, replaceExistingSynonyms: replaceExistingSynonyms }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `saveSynonyms`.");
            if (!synonymHit) throw new Error("Parameter `synonymHit` is required when calling `saveSynonyms`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/batch".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            if (replaceExistingSynonyms !== void 0) queryParameters["replaceExistingSynonyms"] = replaceExistingSynonyms.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: synonymHit
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Sends multiple search requests to one or more indices.  This can be useful in these cases:  - Different indices for different purposes, such as, one index for products, another one for marketing content. - Multiple searches to the same index—for example, with different filters.
     *
     * Required API Key ACLs:
     *  - search
     * @param searchMethodParams - Muli-search request body. Results are returned in the same order as the requests.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ search (searchMethodParams, requestOptions) {
            if (searchMethodParams && Array.isArray(searchMethodParams)) {
                const newSignatureRequest = {
                    requests: searchMethodParams.map(({ params: params, ...legacyRequest })=>{
                        if (legacyRequest.type === "facet") return {
                            ...legacyRequest,
                            ...params,
                            type: "facet"
                        };
                        return {
                            ...legacyRequest,
                            ...params,
                            facet: void 0,
                            maxFacetHits: void 0,
                            facetQuery: void 0
                        };
                    })
                };
                searchMethodParams = newSignatureRequest;
            }
            if (!searchMethodParams) throw new Error("Parameter `searchMethodParams` is required when calling `search`.");
            if (!searchMethodParams.requests) throw new Error("Parameter `searchMethodParams.requests` is required when calling `search`.");
            const requestPath = "/1/indexes/*/queries";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchMethodParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for standard and custom dictionary entries.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchDictionaryEntries - The searchDictionaryEntries object.
     * @param searchDictionaryEntries.dictionaryName - Dictionary type in which to search.
     * @param searchDictionaryEntries.searchDictionaryEntriesParams - The searchDictionaryEntriesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchDictionaryEntries ({ dictionaryName: dictionaryName, searchDictionaryEntriesParams: searchDictionaryEntriesParams }, requestOptions) {
            if (!dictionaryName) throw new Error("Parameter `dictionaryName` is required when calling `searchDictionaryEntries`.");
            if (!searchDictionaryEntriesParams) throw new Error("Parameter `searchDictionaryEntriesParams` is required when calling `searchDictionaryEntries`.");
            if (!searchDictionaryEntriesParams.query) throw new Error("Parameter `searchDictionaryEntriesParams.query` is required when calling `searchDictionaryEntries`.");
            const requestPath = "/1/dictionaries/{dictionaryName}/search".replace("{dictionaryName}", encodeURIComponent(dictionaryName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchDictionaryEntriesParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for values of a specified facet attribute.  - By default, facet values are sorted by decreasing count.   You can adjust this with the `sortFacetValueBy` parameter. - Searching for facet values doesn\'t work if you have **more than 65 searchable facets and searchable attributes combined**.
     *
     * Required API Key ACLs:
     *  - search
     * @param searchForFacetValues - The searchForFacetValues object.
     * @param searchForFacetValues.indexName - Name of the index on which to perform the operation.
     * @param searchForFacetValues.facetName - Facet attribute in which to search for values.  This attribute must be included in the `attributesForFaceting` index setting with the `searchable()` modifier.
     * @param searchForFacetValues.searchForFacetValuesRequest - The searchForFacetValuesRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchForFacetValues ({ indexName: indexName, facetName: facetName, searchForFacetValuesRequest: searchForFacetValuesRequest }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `searchForFacetValues`.");
            if (!facetName) throw new Error("Parameter `facetName` is required when calling `searchForFacetValues`.");
            const requestPath = "/1/indexes/{indexName}/facets/{facetName}/query".replace("{indexName}", encodeURIComponent(indexName)).replace("{facetName}", encodeURIComponent(facetName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchForFacetValuesRequest ? searchForFacetValuesRequest : {},
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for rules in your index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchRules - The searchRules object.
     * @param searchRules.indexName - Name of the index on which to perform the operation.
     * @param searchRules.searchRulesParams - The searchRulesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchRules ({ indexName: indexName, searchRulesParams: searchRulesParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `searchRules`.");
            const requestPath = "/1/indexes/{indexName}/rules/search".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchRulesParams ? searchRulesParams : {},
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches a single index and returns matching search results (_hits_).  This method lets you retrieve up to 1,000 hits. If you need more, use the [`browse` operation](#tag/Search/operation/browse) or increase the `paginatedLimitedTo` index setting.
     *
     * Required API Key ACLs:
     *  - search
     * @param searchSingleIndex - The searchSingleIndex object.
     * @param searchSingleIndex.indexName - Name of the index on which to perform the operation.
     * @param searchSingleIndex.searchParams - The searchParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchSingleIndex ({ indexName: indexName, searchParams: searchParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `searchSingleIndex`.");
            const requestPath = "/1/indexes/{indexName}/query".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchParams ? searchParams : {},
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for synonyms in your index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchSynonyms - The searchSynonyms object.
     * @param searchSynonyms.indexName - Name of the index on which to perform the operation.
     * @param searchSynonyms.searchSynonymsParams - Body of the `searchSynonyms` operation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchSynonyms ({ indexName: indexName, searchSynonymsParams: searchSynonymsParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `searchSynonyms`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/search".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchSynonymsParams ? searchSynonymsParams : {},
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.  To ensure rapid updates, the user IDs index isn\'t built at the same time as the mapping. Instead, it\'s built every 12 hours, at the same time as the update of user ID usage. For example, if you add or move a user ID, the search will show an old value until the next time the mapping is rebuilt (every 12 hours).
     *
     * Required API Key ACLs:
     *  - admin
     * @param searchUserIdsParams - The searchUserIdsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchUserIds (searchUserIdsParams, requestOptions) {
            if (!searchUserIdsParams) throw new Error("Parameter `searchUserIdsParams` is required when calling `searchUserIds`.");
            if (!searchUserIdsParams.query) throw new Error("Parameter `searchUserIdsParams.query` is required when calling `searchUserIds`.");
            const requestPath = "/1/clusters/mapping/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchUserIdsParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Turns standard stop word dictionary entries on or off for a given language.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param dictionarySettingsParams - The dictionarySettingsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ setDictionarySettings (dictionarySettingsParams, requestOptions) {
            if (!dictionarySettingsParams) throw new Error("Parameter `dictionarySettingsParams` is required when calling `setDictionarySettings`.");
            if (!dictionarySettingsParams.disableStandardEntries) throw new Error("Parameter `dictionarySettingsParams.disableStandardEntries` is required when calling `setDictionarySettings`.");
            const requestPath = "/1/dictionaries/*/settings";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: dictionarySettingsParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Update the specified index settings.  Index settings that you don\'t specify are left unchanged. Specify `null` to reset a setting to its default value.  For best performance, update the index settings before you add new records to your index.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param setSettings - The setSettings object.
     * @param setSettings.indexName - Name of the index on which to perform the operation.
     * @param setSettings.indexSettings - The indexSettings object.
     * @param setSettings.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ setSettings ({ indexName: indexName, indexSettings: indexSettings, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `setSettings`.");
            if (!indexSettings) throw new Error("Parameter `indexSettings` is required when calling `setSettings`.");
            const requestPath = "/1/indexes/{indexName}/settings".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: indexSettings
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Replaces the permissions of an existing API key.  Any unspecified attribute resets that attribute to its default value.
     *
     * Required API Key ACLs:
     *  - admin
     * @param updateApiKey - The updateApiKey object.
     * @param updateApiKey.key - API key.
     * @param updateApiKey.apiKey - The apiKey object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateApiKey ({ key: key, apiKey: apiKey }, requestOptions) {
            if (!key) throw new Error("Parameter `key` is required when calling `updateApiKey`.");
            if (!apiKey) throw new Error("Parameter `apiKey` is required when calling `updateApiKey`.");
            if (!apiKey.acl) throw new Error("Parameter `apiKey.acl` is required when calling `updateApiKey`.");
            const requestPath = "/1/keys/{key}".replace("{key}", encodeURIComponent(key));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: apiKey
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $49a95dde5dda3eeb$export$b72856d058786d12(appId, apiKey, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    return $49a95dde5dda3eeb$var$createSearchClient({
        appId: appId,
        apiKey: apiKey,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $5e9921bee1f5cd3c$export$6d3f4ca34494bf2d)(),
        requester: (0, $5be27e2d7f7d1009$export$2b053666affad54a)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)(),
        requestsCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)({
            serializable: false
        }),
        hostsCache: (0, $5e9921bee1f5cd3c$export$8637a0800116df9b)({
            caches: [
                (0, $5e9921bee1f5cd3c$export$ca8cae1c5b20815a)({
                    key: `${$49a95dde5dda3eeb$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)()
            ]
        }),
        ...options
    });
}


var $5c46eaf58ece5c16$exports = {};

$parcel$export($5c46eaf58ece5c16$exports, "apiClientVersion", () => $5c46eaf58ece5c16$export$ad1dfbed11feb646);
$parcel$export($5c46eaf58ece5c16$exports, "isOnDemandTrigger", () => $5c46eaf58ece5c16$export$1d06324d5774046d);
$parcel$export($5c46eaf58ece5c16$exports, "isScheduleTrigger", () => $5c46eaf58ece5c16$export$fe93fab81010f657);
$parcel$export($5c46eaf58ece5c16$exports, "isSubscriptionTrigger", () => $5c46eaf58ece5c16$export$354f27d77e7d8bdc);
$parcel$export($5c46eaf58ece5c16$exports, "ingestionClient", () => $5c46eaf58ece5c16$export$f458e77ddebad4b);
// builds/browser.ts


var $5c46eaf58ece5c16$export$ad1dfbed11feb646 = "1.21.0";
var $5c46eaf58ece5c16$var$REGIONS = [
    "eu",
    "us"
];
function $5c46eaf58ece5c16$var$getDefaultHosts(region) {
    const url = "data.{region}.algolia.com".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $5c46eaf58ece5c16$export$1d06324d5774046d(trigger) {
    return trigger.type === "onDemand";
}
function $5c46eaf58ece5c16$export$fe93fab81010f657(trigger) {
    return trigger.type === "schedule";
}
function $5c46eaf58ece5c16$export$354f27d77e7d8bdc(trigger) {
    return trigger.type === "subscription";
}
function $5c46eaf58ece5c16$var$createIngestionClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $5e9921bee1f5cd3c$export$5f096e4c9da248bb)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $5e9921bee1f5cd3c$export$9f379e42258ad245)({
        hosts: $5c46eaf58ece5c16$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $5e9921bee1f5cd3c$export$dc28410830ce888d)({
            algoliaAgents: algoliaAgents,
            client: "Ingestion",
            version: $5c46eaf58ece5c16$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Creates a new authentication resource.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param authenticationCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createAuthentication (authenticationCreate, requestOptions) {
            if (!authenticationCreate) throw new Error("Parameter `authenticationCreate` is required when calling `createAuthentication`.");
            if (!authenticationCreate.type) throw new Error("Parameter `authenticationCreate.type` is required when calling `createAuthentication`.");
            if (!authenticationCreate.name) throw new Error("Parameter `authenticationCreate.name` is required when calling `createAuthentication`.");
            if (!authenticationCreate.input) throw new Error("Parameter `authenticationCreate.input` is required when calling `createAuthentication`.");
            const requestPath = "/1/authentications";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: authenticationCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new destination.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param destinationCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createDestination (destinationCreate, requestOptions) {
            if (!destinationCreate) throw new Error("Parameter `destinationCreate` is required when calling `createDestination`.");
            if (!destinationCreate.type) throw new Error("Parameter `destinationCreate.type` is required when calling `createDestination`.");
            if (!destinationCreate.name) throw new Error("Parameter `destinationCreate.name` is required when calling `createDestination`.");
            if (!destinationCreate.input) throw new Error("Parameter `destinationCreate.input` is required when calling `createDestination`.");
            const requestPath = "/1/destinations";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: destinationCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new source.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param sourceCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createSource (sourceCreate, requestOptions) {
            if (!sourceCreate) throw new Error("Parameter `sourceCreate` is required when calling `createSource`.");
            if (!sourceCreate.type) throw new Error("Parameter `sourceCreate.type` is required when calling `createSource`.");
            if (!sourceCreate.name) throw new Error("Parameter `sourceCreate.name` is required when calling `createSource`.");
            const requestPath = "/1/sources";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: sourceCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new task.
     * @param taskCreate - Request body for creating a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createTask (taskCreate, requestOptions) {
            if (!taskCreate) throw new Error("Parameter `taskCreate` is required when calling `createTask`.");
            if (!taskCreate.sourceID) throw new Error("Parameter `taskCreate.sourceID` is required when calling `createTask`.");
            if (!taskCreate.destinationID) throw new Error("Parameter `taskCreate.destinationID` is required when calling `createTask`.");
            if (!taskCreate.action) throw new Error("Parameter `taskCreate.action` is required when calling `createTask`.");
            const requestPath = "/2/tasks";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new task using the v1 endpoint, please use `createTask` instead.
     * @param taskCreate - Request body for creating a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createTaskV1 (taskCreate, requestOptions) {
            if (!taskCreate) throw new Error("Parameter `taskCreate` is required when calling `createTaskV1`.");
            if (!taskCreate.sourceID) throw new Error("Parameter `taskCreate.sourceID` is required when calling `createTaskV1`.");
            if (!taskCreate.destinationID) throw new Error("Parameter `taskCreate.destinationID` is required when calling `createTaskV1`.");
            if (!taskCreate.trigger) throw new Error("Parameter `taskCreate.trigger` is required when calling `createTaskV1`.");
            if (!taskCreate.action) throw new Error("Parameter `taskCreate.action` is required when calling `createTaskV1`.");
            const requestPath = "/1/tasks";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new transformation.
     * @param transformationCreate - Request body for creating a transformation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createTransformation (transformationCreate, requestOptions) {
            if (!transformationCreate) throw new Error("Parameter `transformationCreate` is required when calling `createTransformation`.");
            if (!transformationCreate.code) throw new Error("Parameter `transformationCreate.code` is required when calling `createTransformation`.");
            if (!transformationCreate.name) throw new Error("Parameter `transformationCreate.name` is required when calling `createTransformation`.");
            const requestPath = "/1/transformations";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: transformationCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes an authentication resource. You can\'t delete authentication resources that are used by a source or a destination.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param deleteAuthentication - The deleteAuthentication object.
     * @param deleteAuthentication.authenticationID - Unique identifier of an authentication resource.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteAuthentication ({ authenticationID: authenticationID }, requestOptions) {
            if (!authenticationID) throw new Error("Parameter `authenticationID` is required when calling `deleteAuthentication`.");
            const requestPath = "/1/authentications/{authenticationID}".replace("{authenticationID}", encodeURIComponent(authenticationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a destination by its ID. You can\'t delete destinations that are referenced in tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param deleteDestination - The deleteDestination object.
     * @param deleteDestination.destinationID - Unique identifier of a destination.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteDestination ({ destinationID: destinationID }, requestOptions) {
            if (!destinationID) throw new Error("Parameter `destinationID` is required when calling `deleteDestination`.");
            const requestPath = "/1/destinations/{destinationID}".replace("{destinationID}", encodeURIComponent(destinationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a source by its ID. You can\'t delete sources that are referenced in tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param deleteSource - The deleteSource object.
     * @param deleteSource.sourceID - Unique identifier of a source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteSource ({ sourceID: sourceID }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `deleteSource`.");
            const requestPath = "/1/sources/{sourceID}".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a task by its ID.
     * @param deleteTask - The deleteTask object.
     * @param deleteTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteTask ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `deleteTask`.");
            const requestPath = "/2/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a task by its ID using the v1 endpoint, please use `deleteTask` instead.
     * @param deleteTaskV1 - The deleteTaskV1 object.
     * @param deleteTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteTaskV1 ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `deleteTaskV1`.");
            const requestPath = "/1/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a transformation by its ID.
     * @param deleteTransformation - The deleteTransformation object.
     * @param deleteTransformation.transformationID - Unique identifier of a transformation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteTransformation ({ transformationID: transformationID }, requestOptions) {
            if (!transformationID) throw new Error("Parameter `transformationID` is required when calling `deleteTransformation`.");
            const requestPath = "/1/transformations/{transformationID}".replace("{transformationID}", encodeURIComponent(transformationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Disables a task.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param disableTask - The disableTask object.
     * @param disableTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ disableTask ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `disableTask`.");
            const requestPath = "/2/tasks/{taskID}/disable".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Disables a task using the v1 endpoint, please use `disableTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param disableTaskV1 - The disableTaskV1 object.
     * @param disableTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ disableTaskV1 ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `disableTaskV1`.");
            const requestPath = "/1/tasks/{taskID}/disable".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Enables a task.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param enableTask - The enableTask object.
     * @param enableTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ enableTask ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `enableTask`.");
            const requestPath = "/2/tasks/{taskID}/enable".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Enables a task using the v1 endpoint, please use `enableTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param enableTaskV1 - The enableTaskV1 object.
     * @param enableTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ enableTaskV1 ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `enableTaskV1`.");
            const requestPath = "/1/tasks/{taskID}/enable".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves an authentication resource by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getAuthentication - The getAuthentication object.
     * @param getAuthentication.authenticationID - Unique identifier of an authentication resource.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getAuthentication ({ authenticationID: authenticationID }, requestOptions) {
            if (!authenticationID) throw new Error("Parameter `authenticationID` is required when calling `getAuthentication`.");
            const requestPath = "/1/authentications/{authenticationID}".replace("{authenticationID}", encodeURIComponent(authenticationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a destination by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getDestination - The getDestination object.
     * @param getDestination.destinationID - Unique identifier of a destination.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getDestination ({ destinationID: destinationID }, requestOptions) {
            if (!destinationID) throw new Error("Parameter `destinationID` is required when calling `getDestination`.");
            const requestPath = "/1/destinations/{destinationID}".replace("{destinationID}", encodeURIComponent(destinationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a single task run event by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getEvent - The getEvent object.
     * @param getEvent.runID - Unique identifier of a task run.
     * @param getEvent.eventID - Unique identifier of an event.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getEvent ({ runID: runID, eventID: eventID }, requestOptions) {
            if (!runID) throw new Error("Parameter `runID` is required when calling `getEvent`.");
            if (!eventID) throw new Error("Parameter `eventID` is required when calling `getEvent`.");
            const requestPath = "/1/runs/{runID}/events/{eventID}".replace("{runID}", encodeURIComponent(runID)).replace("{eventID}", encodeURIComponent(eventID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieve a single task run by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getRun - The getRun object.
     * @param getRun.runID - Unique identifier of a task run.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRun ({ runID: runID }, requestOptions) {
            if (!runID) throw new Error("Parameter `runID` is required when calling `getRun`.");
            const requestPath = "/1/runs/{runID}".replace("{runID}", encodeURIComponent(runID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieve a source by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getSource - The getSource object.
     * @param getSource.sourceID - Unique identifier of a source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSource ({ sourceID: sourceID }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `getSource`.");
            const requestPath = "/1/sources/{sourceID}".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a task by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getTask - The getTask object.
     * @param getTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTask ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `getTask`.");
            const requestPath = "/2/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a task by its ID using the v1 endpoint, please use `getTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getTaskV1 - The getTaskV1 object.
     * @param getTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTaskV1 ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `getTaskV1`.");
            const requestPath = "/1/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a transformation by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getTransformation - The getTransformation object.
     * @param getTransformation.transformationID - Unique identifier of a transformation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTransformation ({ transformationID: transformationID }, requestOptions) {
            if (!transformationID) throw new Error("Parameter `transformationID` is required when calling `getTransformation`.");
            const requestPath = "/1/transformations/{transformationID}".replace("{transformationID}", encodeURIComponent(transformationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of all authentication resources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listAuthentications - The listAuthentications object.
     * @param listAuthentications.itemsPerPage - Number of items per page.
     * @param listAuthentications.page - Page number of the paginated API response.
     * @param listAuthentications.type - Type of authentication resource to retrieve.
     * @param listAuthentications.platform - Ecommerce platform for which to retrieve authentications.
     * @param listAuthentications.sort - Property by which to sort the list of authentications.
     * @param listAuthentications.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listAuthentications ({ itemsPerPage: itemsPerPage, page: page, type: type, platform: platform, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/1/authentications";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            if (platform !== void 0) queryParameters["platform"] = platform.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of destinations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listDestinations - The listDestinations object.
     * @param listDestinations.itemsPerPage - Number of items per page.
     * @param listDestinations.page - Page number of the paginated API response.
     * @param listDestinations.type - Destination type.
     * @param listDestinations.authenticationID - Authentication ID used by destinations.
     * @param listDestinations.transformationID - Get the list of destinations used by a transformation.
     * @param listDestinations.sort - Property by which to sort the destinations.
     * @param listDestinations.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listDestinations ({ itemsPerPage: itemsPerPage, page: page, type: type, authenticationID: authenticationID, transformationID: transformationID, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/1/destinations";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            if (authenticationID !== void 0) queryParameters["authenticationID"] = authenticationID.toString();
            if (transformationID !== void 0) queryParameters["transformationID"] = transformationID.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of events for a task run, identified by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listEvents - The listEvents object.
     * @param listEvents.runID - Unique identifier of a task run.
     * @param listEvents.itemsPerPage - Number of items per page.
     * @param listEvents.page - Page number of the paginated API response.
     * @param listEvents.status - Event status for filtering the list of task runs.
     * @param listEvents.type - Event type for filtering the list of task runs.
     * @param listEvents.sort - Property by which to sort the list of task run events.
     * @param listEvents.order - Sort order of the response, ascending or descending.
     * @param listEvents.startDate - Date and time in RFC 3339 format for the earliest events to retrieve. By default, the current time minus three hours is used.
     * @param listEvents.endDate - Date and time in RFC 3339 format for the latest events to retrieve. By default, the current time is used.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listEvents ({ runID: runID, itemsPerPage: itemsPerPage, page: page, status: status, type: type, sort: sort, order: order, startDate: startDate, endDate: endDate }, requestOptions) {
            if (!runID) throw new Error("Parameter `runID` is required when calling `listEvents`.");
            const requestPath = "/1/runs/{runID}/events".replace("{runID}", encodeURIComponent(runID));
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (status !== void 0) queryParameters["status"] = status.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieve a list of task runs.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listRuns - The listRuns object.
     * @param listRuns.itemsPerPage - Number of items per page.
     * @param listRuns.page - Page number of the paginated API response.
     * @param listRuns.status - Run status for filtering the list of task runs.
     * @param listRuns.type - Run type for filtering the list of task runs.
     * @param listRuns.taskID - Task ID for filtering the list of task runs.
     * @param listRuns.sort - Property by which to sort the list of task runs.
     * @param listRuns.order - Sort order of the response, ascending or descending.
     * @param listRuns.startDate - Date in RFC 3339 format for the earliest run to retrieve. By default, the current day minus seven days is used.
     * @param listRuns.endDate - Date in RFC 3339 format for the latest run to retrieve. By default, the current day is used.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listRuns ({ itemsPerPage: itemsPerPage, page: page, status: status, type: type, taskID: taskID, sort: sort, order: order, startDate: startDate, endDate: endDate } = {}, requestOptions) {
            const requestPath = "/1/runs";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (status !== void 0) queryParameters["status"] = status.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            if (taskID !== void 0) queryParameters["taskID"] = taskID.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of sources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listSources - The listSources object.
     * @param listSources.itemsPerPage - Number of items per page.
     * @param listSources.page - Page number of the paginated API response.
     * @param listSources.type - Source type. Some sources require authentication.
     * @param listSources.authenticationID - Authentication IDs of the sources to retrieve. \'none\' returns sources that doesn\'t have an authentication.
     * @param listSources.sort - Property by which to sort the list of sources.
     * @param listSources.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listSources ({ itemsPerPage: itemsPerPage, page: page, type: type, authenticationID: authenticationID, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/1/sources";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            if (authenticationID !== void 0) queryParameters["authenticationID"] = authenticationID.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listTasks - The listTasks object.
     * @param listTasks.itemsPerPage - Number of items per page.
     * @param listTasks.page - Page number of the paginated API response.
     * @param listTasks.action - Actions for filtering the list of tasks.
     * @param listTasks.enabled - Whether to filter the list of tasks by the `enabled` status.
     * @param listTasks.sourceID - Source IDs for filtering the list of tasks.
     * @param listTasks.sourceType - Filters the tasks with the specified source type.
     * @param listTasks.destinationID - Destination IDs for filtering the list of tasks.
     * @param listTasks.triggerType - Type of task trigger for filtering the list of tasks.
     * @param listTasks.withEmailNotifications - If specified, the response only includes tasks with notifications.email.enabled set to this value.
     * @param listTasks.sort - Property by which to sort the list of tasks.
     * @param listTasks.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listTasks ({ itemsPerPage: itemsPerPage, page: page, action: action, enabled: enabled, sourceID: sourceID, sourceType: sourceType, destinationID: destinationID, triggerType: triggerType, withEmailNotifications: withEmailNotifications, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/2/tasks";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (action !== void 0) queryParameters["action"] = action.toString();
            if (enabled !== void 0) queryParameters["enabled"] = enabled.toString();
            if (sourceID !== void 0) queryParameters["sourceID"] = sourceID.toString();
            if (sourceType !== void 0) queryParameters["sourceType"] = sourceType.toString();
            if (destinationID !== void 0) queryParameters["destinationID"] = destinationID.toString();
            if (triggerType !== void 0) queryParameters["triggerType"] = triggerType.toString();
            if (withEmailNotifications !== void 0) queryParameters["withEmailNotifications"] = withEmailNotifications.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of tasks using the v1 endpoint, please use `getTasks` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listTasksV1 - The listTasksV1 object.
     * @param listTasksV1.itemsPerPage - Number of items per page.
     * @param listTasksV1.page - Page number of the paginated API response.
     * @param listTasksV1.action - Actions for filtering the list of tasks.
     * @param listTasksV1.enabled - Whether to filter the list of tasks by the `enabled` status.
     * @param listTasksV1.sourceID - Source IDs for filtering the list of tasks.
     * @param listTasksV1.destinationID - Destination IDs for filtering the list of tasks.
     * @param listTasksV1.triggerType - Type of task trigger for filtering the list of tasks.
     * @param listTasksV1.sort - Property by which to sort the list of tasks.
     * @param listTasksV1.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listTasksV1 ({ itemsPerPage: itemsPerPage, page: page, action: action, enabled: enabled, sourceID: sourceID, destinationID: destinationID, triggerType: triggerType, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/1/tasks";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (action !== void 0) queryParameters["action"] = action.toString();
            if (enabled !== void 0) queryParameters["enabled"] = enabled.toString();
            if (sourceID !== void 0) queryParameters["sourceID"] = sourceID.toString();
            if (destinationID !== void 0) queryParameters["destinationID"] = destinationID.toString();
            if (triggerType !== void 0) queryParameters["triggerType"] = triggerType.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of transformations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listTransformations - The listTransformations object.
     * @param listTransformations.itemsPerPage - Number of items per page.
     * @param listTransformations.page - Page number of the paginated API response.
     * @param listTransformations.sort - Property by which to sort the list of transformations.
     * @param listTransformations.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listTransformations ({ itemsPerPage: itemsPerPage, page: page, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/1/transformations";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Push a `batch` request payload through the Pipeline. You can check the status of task pushes with the observability endpoints.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param pushTask - The pushTask object.
     * @param pushTask.taskID - Unique identifier of a task.
     * @param pushTask.pushTaskPayload - Request body of a Search API `batch` request that will be pushed in the Connectors pipeline.
     * @param pushTask.watch - When provided, the push operation will be synchronous and the API will wait for the ingestion to be finished before responding.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ pushTask ({ taskID: taskID, pushTaskPayload: pushTaskPayload, watch: watch }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `pushTask`.");
            if (!pushTaskPayload) throw new Error("Parameter `pushTaskPayload` is required when calling `pushTask`.");
            if (!pushTaskPayload.action) throw new Error("Parameter `pushTaskPayload.action` is required when calling `pushTask`.");
            if (!pushTaskPayload.records) throw new Error("Parameter `pushTaskPayload.records` is required when calling `pushTask`.");
            const requestPath = "/2/tasks/{taskID}/push".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            if (watch !== void 0) queryParameters["watch"] = watch.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: pushTaskPayload
            };
            requestOptions = {
                timeouts: {
                    connect: 18e4,
                    read: 18e4,
                    write: 18e4,
                    ...requestOptions?.timeouts
                }
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Runs all tasks linked to a source, only available for Shopify sources. It will create 1 run per task.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param runSource - The runSource object.
     * @param runSource.sourceID - Unique identifier of a source.
     * @param runSource.runSourcePayload -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ runSource ({ sourceID: sourceID, runSourcePayload: runSourcePayload }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `runSource`.");
            const requestPath = "/1/sources/{sourceID}/run".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: runSourcePayload ? runSourcePayload : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Runs a task. You can check the status of task runs with the observability endpoints.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param runTask - The runTask object.
     * @param runTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ runTask ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `runTask`.");
            const requestPath = "/2/tasks/{taskID}/run".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Runs a task using the v1 endpoint, please use `runTask` instead. You can check the status of task runs with the observability endpoints.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param runTaskV1 - The runTaskV1 object.
     * @param runTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ runTaskV1 ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `runTaskV1`.");
            const requestPath = "/1/tasks/{taskID}/run".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for authentication resources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param authenticationSearch - The authenticationSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchAuthentications (authenticationSearch, requestOptions) {
            if (!authenticationSearch) throw new Error("Parameter `authenticationSearch` is required when calling `searchAuthentications`.");
            if (!authenticationSearch.authenticationIDs) throw new Error("Parameter `authenticationSearch.authenticationIDs` is required when calling `searchAuthentications`.");
            const requestPath = "/1/authentications/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: authenticationSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for destinations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param destinationSearch - The destinationSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchDestinations (destinationSearch, requestOptions) {
            if (!destinationSearch) throw new Error("Parameter `destinationSearch` is required when calling `searchDestinations`.");
            if (!destinationSearch.destinationIDs) throw new Error("Parameter `destinationSearch.destinationIDs` is required when calling `searchDestinations`.");
            const requestPath = "/1/destinations/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: destinationSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for sources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param sourceSearch - The sourceSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchSources (sourceSearch, requestOptions) {
            if (!sourceSearch) throw new Error("Parameter `sourceSearch` is required when calling `searchSources`.");
            if (!sourceSearch.sourceIDs) throw new Error("Parameter `sourceSearch.sourceIDs` is required when calling `searchSources`.");
            const requestPath = "/1/sources/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: sourceSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param taskSearch - The taskSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchTasks (taskSearch, requestOptions) {
            if (!taskSearch) throw new Error("Parameter `taskSearch` is required when calling `searchTasks`.");
            if (!taskSearch.taskIDs) throw new Error("Parameter `taskSearch.taskIDs` is required when calling `searchTasks`.");
            const requestPath = "/2/tasks/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for tasks using the v1 endpoint, please use `searchTasks` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param taskSearch - The taskSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchTasksV1 (taskSearch, requestOptions) {
            if (!taskSearch) throw new Error("Parameter `taskSearch` is required when calling `searchTasksV1`.");
            if (!taskSearch.taskIDs) throw new Error("Parameter `taskSearch.taskIDs` is required when calling `searchTasksV1`.");
            const requestPath = "/1/tasks/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for transformations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param transformationSearch - The transformationSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchTransformations (transformationSearch, requestOptions) {
            if (!transformationSearch) throw new Error("Parameter `transformationSearch` is required when calling `searchTransformations`.");
            if (!transformationSearch.transformationIDs) throw new Error("Parameter `transformationSearch.transformationIDs` is required when calling `searchTransformations`.");
            const requestPath = "/1/transformations/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: transformationSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Triggers a stream-listing request for a source. Triggering stream-listing requests only works with sources with `type: docker` and `imageType: airbyte`.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param triggerDockerSourceDiscover - The triggerDockerSourceDiscover object.
     * @param triggerDockerSourceDiscover.sourceID - Unique identifier of a source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ triggerDockerSourceDiscover ({ sourceID: sourceID }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `triggerDockerSourceDiscover`.");
            const requestPath = "/1/sources/{sourceID}/discover".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            requestOptions = {
                timeouts: {
                    connect: 18e4,
                    read: 18e4,
                    write: 18e4,
                    ...requestOptions?.timeouts
                }
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Try a transformation before creating it.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param transformationTry - The transformationTry object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ tryTransformation (transformationTry, requestOptions) {
            if (!transformationTry) throw new Error("Parameter `transformationTry` is required when calling `tryTransformation`.");
            if (!transformationTry.code) throw new Error("Parameter `transformationTry.code` is required when calling `tryTransformation`.");
            if (!transformationTry.sampleRecord) throw new Error("Parameter `transformationTry.sampleRecord` is required when calling `tryTransformation`.");
            const requestPath = "/1/transformations/try";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: transformationTry
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Try a transformation before updating it.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param tryTransformationBeforeUpdate - The tryTransformationBeforeUpdate object.
     * @param tryTransformationBeforeUpdate.transformationID - Unique identifier of a transformation.
     * @param tryTransformationBeforeUpdate.transformationTry - The transformationTry object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ tryTransformationBeforeUpdate ({ transformationID: transformationID, transformationTry: transformationTry }, requestOptions) {
            if (!transformationID) throw new Error("Parameter `transformationID` is required when calling `tryTransformationBeforeUpdate`.");
            if (!transformationTry) throw new Error("Parameter `transformationTry` is required when calling `tryTransformationBeforeUpdate`.");
            if (!transformationTry.code) throw new Error("Parameter `transformationTry.code` is required when calling `tryTransformationBeforeUpdate`.");
            if (!transformationTry.sampleRecord) throw new Error("Parameter `transformationTry.sampleRecord` is required when calling `tryTransformationBeforeUpdate`.");
            const requestPath = "/1/transformations/{transformationID}/try".replace("{transformationID}", encodeURIComponent(transformationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: transformationTry
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates an authentication resource.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param updateAuthentication - The updateAuthentication object.
     * @param updateAuthentication.authenticationID - Unique identifier of an authentication resource.
     * @param updateAuthentication.authenticationUpdate - The authenticationUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateAuthentication ({ authenticationID: authenticationID, authenticationUpdate: authenticationUpdate }, requestOptions) {
            if (!authenticationID) throw new Error("Parameter `authenticationID` is required when calling `updateAuthentication`.");
            if (!authenticationUpdate) throw new Error("Parameter `authenticationUpdate` is required when calling `updateAuthentication`.");
            const requestPath = "/1/authentications/{authenticationID}".replace("{authenticationID}", encodeURIComponent(authenticationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PATCH",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: authenticationUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates the destination by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param updateDestination - The updateDestination object.
     * @param updateDestination.destinationID - Unique identifier of a destination.
     * @param updateDestination.destinationUpdate - The destinationUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateDestination ({ destinationID: destinationID, destinationUpdate: destinationUpdate }, requestOptions) {
            if (!destinationID) throw new Error("Parameter `destinationID` is required when calling `updateDestination`.");
            if (!destinationUpdate) throw new Error("Parameter `destinationUpdate` is required when calling `updateDestination`.");
            const requestPath = "/1/destinations/{destinationID}".replace("{destinationID}", encodeURIComponent(destinationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PATCH",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: destinationUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates a source by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param updateSource - The updateSource object.
     * @param updateSource.sourceID - Unique identifier of a source.
     * @param updateSource.sourceUpdate - The sourceUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateSource ({ sourceID: sourceID, sourceUpdate: sourceUpdate }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `updateSource`.");
            if (!sourceUpdate) throw new Error("Parameter `sourceUpdate` is required when calling `updateSource`.");
            const requestPath = "/1/sources/{sourceID}".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PATCH",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: sourceUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates a task by its ID.
     * @param updateTask - The updateTask object.
     * @param updateTask.taskID - Unique identifier of a task.
     * @param updateTask.taskUpdate - The taskUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateTask ({ taskID: taskID, taskUpdate: taskUpdate }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `updateTask`.");
            if (!taskUpdate) throw new Error("Parameter `taskUpdate` is required when calling `updateTask`.");
            const requestPath = "/2/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PATCH",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates a task by its ID using the v1 endpoint, please use `updateTask` instead.
     * @param updateTaskV1 - The updateTaskV1 object.
     * @param updateTaskV1.taskID - Unique identifier of a task.
     * @param updateTaskV1.taskUpdate - The taskUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateTaskV1 ({ taskID: taskID, taskUpdate: taskUpdate }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `updateTaskV1`.");
            if (!taskUpdate) throw new Error("Parameter `taskUpdate` is required when calling `updateTaskV1`.");
            const requestPath = "/1/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PATCH",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates a transformation by its ID.
     * @param updateTransformation - The updateTransformation object.
     * @param updateTransformation.transformationID - Unique identifier of a transformation.
     * @param updateTransformation.transformationCreate - The transformationCreate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateTransformation ({ transformationID: transformationID, transformationCreate: transformationCreate }, requestOptions) {
            if (!transformationID) throw new Error("Parameter `transformationID` is required when calling `updateTransformation`.");
            if (!transformationCreate) throw new Error("Parameter `transformationCreate` is required when calling `updateTransformation`.");
            if (!transformationCreate.code) throw new Error("Parameter `transformationCreate.code` is required when calling `updateTransformation`.");
            if (!transformationCreate.name) throw new Error("Parameter `transformationCreate.name` is required when calling `updateTransformation`.");
            const requestPath = "/1/transformations/{transformationID}".replace("{transformationID}", encodeURIComponent(transformationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: transformationCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Validates a source payload to ensure it can be created and that the data source can be reached by Algolia.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param sourceCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ validateSource (sourceCreate, requestOptions) {
            const requestPath = "/1/sources/validate";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: sourceCreate ? sourceCreate : {}
            };
            requestOptions = {
                timeouts: {
                    connect: 18e4,
                    read: 18e4,
                    write: 18e4,
                    ...requestOptions?.timeouts
                }
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Validates an update of a source payload to ensure it can be created and that the data source can be reached by Algolia.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param validateSourceBeforeUpdate - The validateSourceBeforeUpdate object.
     * @param validateSourceBeforeUpdate.sourceID - Unique identifier of a source.
     * @param validateSourceBeforeUpdate.sourceUpdate - The sourceUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ validateSourceBeforeUpdate ({ sourceID: sourceID, sourceUpdate: sourceUpdate }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `validateSourceBeforeUpdate`.");
            if (!sourceUpdate) throw new Error("Parameter `sourceUpdate` is required when calling `validateSourceBeforeUpdate`.");
            const requestPath = "/1/sources/{sourceID}/validate".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: sourceUpdate
            };
            requestOptions = {
                timeouts: {
                    connect: 18e4,
                    read: 18e4,
                    write: 18e4,
                    ...requestOptions?.timeouts
                }
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $5c46eaf58ece5c16$export$f458e77ddebad4b(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (!region || region && (typeof region !== "string" || !$5c46eaf58ece5c16$var$REGIONS.includes(region))) throw new Error(`\`region\` is required and must be one of the following: ${$5c46eaf58ece5c16$var$REGIONS.join(", ")}`);
    return $5c46eaf58ece5c16$var$createIngestionClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 25e3,
            read: 25e3,
            write: 25e3
        },
        logger: (0, $5e9921bee1f5cd3c$export$6d3f4ca34494bf2d)(),
        requester: (0, $5be27e2d7f7d1009$export$2b053666affad54a)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)(),
        requestsCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)({
            serializable: false
        }),
        hostsCache: (0, $5e9921bee1f5cd3c$export$8637a0800116df9b)({
            caches: [
                (0, $5e9921bee1f5cd3c$export$ca8cae1c5b20815a)({
                    key: `${$5c46eaf58ece5c16$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)()
            ]
        }),
        ...options
    });
}


var $9a11671e27776869$exports = {};

$parcel$export($9a11671e27776869$exports, "apiClientVersion", () => $9a11671e27776869$export$ad1dfbed11feb646);
$parcel$export($9a11671e27776869$exports, "monitoringClient", () => $9a11671e27776869$export$4ae4681adb143a8a);
// builds/browser.ts


var $9a11671e27776869$export$ad1dfbed11feb646 = "1.21.0";
function $9a11671e27776869$var$getDefaultHosts() {
    return [
        {
            url: "status.algolia.com",
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $9a11671e27776869$var$createMonitoringClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, ...options }) {
    const auth = (0, $5e9921bee1f5cd3c$export$5f096e4c9da248bb)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $5e9921bee1f5cd3c$export$9f379e42258ad245)({
        hosts: $9a11671e27776869$var$getDefaultHosts(),
        ...options,
        algoliaAgent: (0, $5e9921bee1f5cd3c$export$dc28410830ce888d)({
            algoliaAgents: algoliaAgents,
            client: "Monitoring",
            version: $9a11671e27776869$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves known incidents for the selected clusters.
     * @param getClusterIncidents - The getClusterIncidents object.
     * @param getClusterIncidents.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getClusterIncidents ({ clusters: clusters }, requestOptions) {
            if (!clusters) throw new Error("Parameter `clusters` is required when calling `getClusterIncidents`.");
            const requestPath = "/1/incidents/{clusters}".replace("{clusters}", encodeURIComponent(clusters));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the status of selected clusters.
     * @param getClusterStatus - The getClusterStatus object.
     * @param getClusterStatus.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getClusterStatus ({ clusters: clusters }, requestOptions) {
            if (!clusters) throw new Error("Parameter `clusters` is required when calling `getClusterStatus`.");
            const requestPath = "/1/status/{clusters}".replace("{clusters}", encodeURIComponent(clusters));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves known incidents for all clusters.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getIncidents (requestOptions) {
            const requestPath = "/1/incidents";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves average times for indexing operations for selected clusters.
     * @param getIndexingTime - The getIndexingTime object.
     * @param getIndexingTime.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getIndexingTime ({ clusters: clusters }, requestOptions) {
            if (!clusters) throw new Error("Parameter `clusters` is required when calling `getIndexingTime`.");
            const requestPath = "/1/indexing/{clusters}".replace("{clusters}", encodeURIComponent(clusters));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the average latency for search requests for selected clusters.
     * @param getLatency - The getLatency object.
     * @param getLatency.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getLatency ({ clusters: clusters }, requestOptions) {
            if (!clusters) throw new Error("Parameter `clusters` is required when calling `getLatency`.");
            const requestPath = "/1/latency/{clusters}".replace("{clusters}", encodeURIComponent(clusters));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves metrics related to your Algolia infrastructure, aggregated over a selected time window.  Access to this API is available as part of the [Premium or Elevate plans](https://www.algolia.com/pricing). You must authenticate requests with the `x-algolia-application-id` and `x-algolia-api-key` headers (using the Monitoring API key).
     * @param getMetrics - The getMetrics object.
     * @param getMetrics.metric - Metric to report.  For more information about the individual metrics, see the description of the API response. To include all metrics, use `*`.
     * @param getMetrics.period - Period over which to aggregate the metrics:  - `minute`. Aggregate the last minute. 1 data point per 10 seconds. - `hour`. Aggregate the last hour. 1 data point per minute. - `day`. Aggregate the last day. 1 data point per 10 minutes. - `week`. Aggregate the last week. 1 data point per hour. - `month`. Aggregate the last month. 1 data point per day.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getMetrics ({ metric: metric, period: period }, requestOptions) {
            if (!metric) throw new Error("Parameter `metric` is required when calling `getMetrics`.");
            if (!period) throw new Error("Parameter `period` is required when calling `getMetrics`.");
            const requestPath = "/1/infrastructure/{metric}/period/{period}".replace("{metric}", encodeURIComponent(metric)).replace("{period}", encodeURIComponent(period));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Test whether clusters are reachable or not.
     * @param getReachability - The getReachability object.
     * @param getReachability.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getReachability ({ clusters: clusters }, requestOptions) {
            if (!clusters) throw new Error("Parameter `clusters` is required when calling `getReachability`.");
            const requestPath = "/1/reachability/{clusters}/probes".replace("{clusters}", encodeURIComponent(clusters));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the servers that belong to clusters.  The response depends on whether you authenticate your API request:  - With authentication, the response lists the servers assigned to your Algolia application\'s cluster.  - Without authentication, the response lists the servers for all Algolia clusters.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getServers (requestOptions) {
            const requestPath = "/1/inventory/servers";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the status of all Algolia clusters and instances.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getStatus (requestOptions) {
            const requestPath = "/1/status";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $9a11671e27776869$export$4ae4681adb143a8a(appId, apiKey, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    return $9a11671e27776869$var$createMonitoringClient({
        appId: appId,
        apiKey: apiKey,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $5e9921bee1f5cd3c$export$6d3f4ca34494bf2d)(),
        requester: (0, $5be27e2d7f7d1009$export$2b053666affad54a)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)(),
        requestsCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)({
            serializable: false
        }),
        hostsCache: (0, $5e9921bee1f5cd3c$export$8637a0800116df9b)({
            caches: [
                (0, $5e9921bee1f5cd3c$export$ca8cae1c5b20815a)({
                    key: `${$9a11671e27776869$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)()
            ]
        }),
        ...options
    });
}


var $6a3bc5f765fbfe04$exports = {};

$parcel$export($6a3bc5f765fbfe04$exports, "apiClientVersion", () => $6a3bc5f765fbfe04$export$ad1dfbed11feb646);
$parcel$export($6a3bc5f765fbfe04$exports, "recommendClient", () => $6a3bc5f765fbfe04$export$d4c266a0cfaa4787);
// builds/browser.ts


var $6a3bc5f765fbfe04$export$ad1dfbed11feb646 = "5.21.0";
function $6a3bc5f765fbfe04$var$getDefaultHosts(appId) {
    return [
        {
            url: `${appId}-dsn.algolia.net`,
            accept: "read",
            protocol: "https"
        },
        {
            url: `${appId}.algolia.net`,
            accept: "write",
            protocol: "https"
        }
    ].concat((0, $5e9921bee1f5cd3c$export$448332262467e042)([
        {
            url: `${appId}-1.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-2.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-3.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        }
    ]));
}
function $6a3bc5f765fbfe04$var$createRecommendClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, ...options }) {
    const auth = (0, $5e9921bee1f5cd3c$export$5f096e4c9da248bb)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $5e9921bee1f5cd3c$export$9f379e42258ad245)({
        hosts: $6a3bc5f765fbfe04$var$getDefaultHosts(appIdOption),
        ...options,
        algoliaAgent: (0, $5e9921bee1f5cd3c$export$dc28410830ce888d)({
            algoliaAgents: algoliaAgents,
            client: "Recommend",
            version: $6a3bc5f765fbfe04$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Create or update a batch of Recommend Rules  Each Recommend Rule is created or updated, depending on whether a Recommend Rule with the same `objectID` already exists. You may also specify `true` for `clearExistingRules`, in which case the batch will atomically replace all the existing Recommend Rules.  Recommend Rules are similar to Search Rules, except that the conditions and consequences apply to a [source item](/doc/guides/algolia-recommend/overview/#recommend-models) instead of a query. The main differences are the following: - Conditions `pattern` and `anchoring` are unavailable. - Condition `filters` triggers if the source item matches the specified filters. - Condition `filters` accepts numeric filters. - Consequence `params` only covers filtering parameters. - Consequence `automaticFacetFilters` doesn\'t require a facet value placeholder (it tries to match the data source item\'s attributes instead).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param batchRecommendRules - The batchRecommendRules object.
     * @param batchRecommendRules.indexName - Name of the index on which to perform the operation.
     * @param batchRecommendRules.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param batchRecommendRules.recommendRule - The recommendRule object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ batchRecommendRules ({ indexName: indexName, model: model, recommendRule: recommendRule }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `batchRecommendRules`.");
            if (!model) throw new Error("Parameter `model` is required when calling `batchRecommendRules`.");
            const requestPath = "/1/indexes/{indexName}/{model}/recommend/rules/batch".replace("{indexName}", encodeURIComponent(indexName)).replace("{model}", encodeURIComponent(model));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: recommendRule ? recommendRule : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a Recommend rule from a recommendation scenario.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteRecommendRule - The deleteRecommendRule object.
     * @param deleteRecommendRule.indexName - Name of the index on which to perform the operation.
     * @param deleteRecommendRule.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param deleteRecommendRule.objectID - Unique record identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteRecommendRule ({ indexName: indexName, model: model, objectID: objectID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteRecommendRule`.");
            if (!model) throw new Error("Parameter `model` is required when calling `deleteRecommendRule`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `deleteRecommendRule`.");
            const requestPath = "/1/indexes/{indexName}/{model}/recommend/rules/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{model}", encodeURIComponent(model)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a Recommend rule that you previously created in the Algolia dashboard.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getRecommendRule - The getRecommendRule object.
     * @param getRecommendRule.indexName - Name of the index on which to perform the operation.
     * @param getRecommendRule.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param getRecommendRule.objectID - Unique record identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRecommendRule ({ indexName: indexName, model: model, objectID: objectID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getRecommendRule`.");
            if (!model) throw new Error("Parameter `model` is required when calling `getRecommendRule`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `getRecommendRule`.");
            const requestPath = "/1/indexes/{indexName}/{model}/recommend/rules/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{model}", encodeURIComponent(model)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Checks the status of a given task.  Deleting a Recommend rule is asynchronous. When you delete a rule, a task is created on a queue and completed depending on the load on the server. The API response includes a task ID that you can use to check the status.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param getRecommendStatus - The getRecommendStatus object.
     * @param getRecommendStatus.indexName - Name of the index on which to perform the operation.
     * @param getRecommendStatus.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param getRecommendStatus.taskID - Unique task identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRecommendStatus ({ indexName: indexName, model: model, taskID: taskID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getRecommendStatus`.");
            if (!model) throw new Error("Parameter `model` is required when calling `getRecommendStatus`.");
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `getRecommendStatus`.");
            const requestPath = "/1/indexes/{indexName}/{model}/task/{taskID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{model}", encodeURIComponent(model)).replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves recommendations from selected AI models.
     *
     * Required API Key ACLs:
     *  - search
     * @param getRecommendationsParams - The getRecommendationsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRecommendations (getRecommendationsParams, requestOptions) {
            if (getRecommendationsParams && Array.isArray(getRecommendationsParams)) {
                const newSignatureRequest = {
                    requests: getRecommendationsParams
                };
                getRecommendationsParams = newSignatureRequest;
            }
            if (!getRecommendationsParams) throw new Error("Parameter `getRecommendationsParams` is required when calling `getRecommendations`.");
            if (!getRecommendationsParams.requests) throw new Error("Parameter `getRecommendationsParams.requests` is required when calling `getRecommendations`.");
            const requestPath = "/1/indexes/*/recommendations";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: getRecommendationsParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for Recommend rules.  Use an empty query to list all rules for this recommendation scenario.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchRecommendRules - The searchRecommendRules object.
     * @param searchRecommendRules.indexName - Name of the index on which to perform the operation.
     * @param searchRecommendRules.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param searchRecommendRules.searchRecommendRulesParams - The searchRecommendRulesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchRecommendRules ({ indexName: indexName, model: model, searchRecommendRulesParams: searchRecommendRulesParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `searchRecommendRules`.");
            if (!model) throw new Error("Parameter `model` is required when calling `searchRecommendRules`.");
            const requestPath = "/1/indexes/{indexName}/{model}/recommend/rules/search".replace("{indexName}", encodeURIComponent(indexName)).replace("{model}", encodeURIComponent(model));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchRecommendRulesParams ? searchRecommendRulesParams : {},
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $6a3bc5f765fbfe04$export$d4c266a0cfaa4787(appId, apiKey, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    return $6a3bc5f765fbfe04$var$createRecommendClient({
        appId: appId,
        apiKey: apiKey,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $5e9921bee1f5cd3c$export$6d3f4ca34494bf2d)(),
        requester: (0, $5be27e2d7f7d1009$export$2b053666affad54a)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)(),
        requestsCache: (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)({
            serializable: false
        }),
        hostsCache: (0, $5e9921bee1f5cd3c$export$8637a0800116df9b)({
            caches: [
                (0, $5e9921bee1f5cd3c$export$ca8cae1c5b20815a)({
                    key: `${$6a3bc5f765fbfe04$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $5e9921bee1f5cd3c$export$b1fc9484ccfcd328)()
            ]
        }),
        ...options
    });
}


var $d359e94bac2b9347$var$__defProp = Object.defineProperty;
var $d359e94bac2b9347$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d359e94bac2b9347$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d359e94bac2b9347$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d359e94bac2b9347$var$__export = (target, all)=>{
    for(var name in all)$d359e94bac2b9347$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $d359e94bac2b9347$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $d359e94bac2b9347$var$__getOwnPropNames(from))if (!$d359e94bac2b9347$var$__hasOwnProp.call(to, key) && key !== except) $d359e94bac2b9347$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $d359e94bac2b9347$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $d359e94bac2b9347$var$__reExport = (target, mod, secondTarget)=>($d359e94bac2b9347$var$__copyProps(target, mod, "default"), secondTarget && $d359e94bac2b9347$var$__copyProps(secondTarget, mod, "default"));
// builds/browser.ts
var $d359e94bac2b9347$var$browser_exports = {};
$d359e94bac2b9347$var$__export($d359e94bac2b9347$var$browser_exports, {
    algoliasearch: ()=>$d359e94bac2b9347$export$e63737c6f074d9d7,
    apiClientVersion: ()=>(0, $49a95dde5dda3eeb$export$ad1dfbed11feb646)
});
// builds/models.ts
var $d359e94bac2b9347$var$models_exports = {};
$d359e94bac2b9347$var$__export($d359e94bac2b9347$var$models_exports, {
    apiClientVersion: ()=>(0, $49a95dde5dda3eeb$export$ad1dfbed11feb646)
});
$d359e94bac2b9347$var$__reExport($d359e94bac2b9347$var$models_exports, $5db76c8220343c1b$exports);
$d359e94bac2b9347$var$__reExport($d359e94bac2b9347$var$models_exports, $66b4a85c6ea664d7$exports);
$d359e94bac2b9347$var$__reExport($d359e94bac2b9347$var$models_exports, $9edd69ad60151739$exports);
$d359e94bac2b9347$var$__reExport($d359e94bac2b9347$var$models_exports, $e3771acb5eb9ca00$exports);
$d359e94bac2b9347$var$__reExport($d359e94bac2b9347$var$models_exports, $337b9d60b8bfb816$exports);
$d359e94bac2b9347$var$__reExport($d359e94bac2b9347$var$models_exports, $49a95dde5dda3eeb$exports);
$d359e94bac2b9347$var$__reExport($d359e94bac2b9347$var$models_exports, $5c46eaf58ece5c16$exports);
$d359e94bac2b9347$var$__reExport($d359e94bac2b9347$var$models_exports, $9a11671e27776869$exports);
$d359e94bac2b9347$var$__reExport($d359e94bac2b9347$var$models_exports, $6a3bc5f765fbfe04$exports);
// builds/browser.ts
$d359e94bac2b9347$var$__reExport($d359e94bac2b9347$var$browser_exports, $d359e94bac2b9347$var$models_exports);
function $d359e94bac2b9347$export$e63737c6f074d9d7(appId, apiKey, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    const client = (0, $49a95dde5dda3eeb$export$b72856d058786d12)(appId, apiKey, options);
    return {
        ...client,
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return client.transporter.algoliaAgent.value;
        },
        initAbtesting: (initOptions)=>{
            return (0, $5db76c8220343c1b$export$c1558718601bb704)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initAnalytics: (initOptions)=>{
            return (0, $66b4a85c6ea664d7$export$f1caacacb426dc27)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initIngestion: (initOptions)=>{
            return (0, $5c46eaf58ece5c16$export$f458e77ddebad4b)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initInsights: (initOptions)=>{
            return (0, $9edd69ad60151739$export$856f93a58939b342)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initMonitoring: (initOptions = {})=>{
            return (0, $9a11671e27776869$export$4ae4681adb143a8a)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.options);
        },
        initPersonalization: (initOptions)=>{
            return (0, $e3771acb5eb9ca00$export$56412180a9807a64)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initQuerySuggestions: (initOptions)=>{
            return (0, $337b9d60b8bfb816$export$1efe5b59a2a2df14)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initRecommend: (initOptions = {})=>{
            return (0, $6a3bc5f765fbfe04$export$d4c266a0cfaa4787)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.options);
        }
    };
}


var $fb1e243c72be04b6$var$NAMESPACE = "ais";
var $fb1e243c72be04b6$export$d8556a2a8f973135 = function component(componentName) {
    return function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, descendantName = _ref.descendantName, modifierName = _ref.modifierName;
        var descendent = descendantName ? "-".concat(descendantName) : "";
        var modifier = modifierName ? "--".concat(modifierName) : "";
        return "".concat($fb1e243c72be04b6$var$NAMESPACE, "-").concat(componentName).concat(descendent).concat(modifier);
    };
};


function $df4ef976d5bdb951$export$d14846335956eefa(object, path) {
    var parts = Array.isArray(path) ? path : path.split(".");
    return parts.reduce(function(current, key) {
        return current && current[key];
    }, object);
}

/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/escape.js
 */ // Used to map characters to HTML entities.
var $f3dcbb78d3a0cdcf$var$htmlEntities = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
// Used to match HTML entities and HTML characters.
var $f3dcbb78d3a0cdcf$var$regexUnescapedHtml = /[&<>"']/g;
var $f3dcbb78d3a0cdcf$var$regexHasUnescapedHtml = RegExp($f3dcbb78d3a0cdcf$var$regexUnescapedHtml.source);
function $f3dcbb78d3a0cdcf$export$4e7f196112fea3c5(value) {
    return value && $f3dcbb78d3a0cdcf$var$regexHasUnescapedHtml.test(value) ? value.replace($f3dcbb78d3a0cdcf$var$regexUnescapedHtml, function(character) {
        return $f3dcbb78d3a0cdcf$var$htmlEntities[character];
    }) : value;
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/unescape.js
 */ // Used to map HTML entities to characters.
var $f3dcbb78d3a0cdcf$var$htmlCharacters = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
};
// Used to match HTML entities and HTML characters.
var $f3dcbb78d3a0cdcf$var$regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var $f3dcbb78d3a0cdcf$var$regexHasEscapedHtml = RegExp($f3dcbb78d3a0cdcf$var$regexEscapedHtml.source);
function $f3dcbb78d3a0cdcf$export$e8bacd2802a88316(value) {
    return value && $f3dcbb78d3a0cdcf$var$regexHasEscapedHtml.test(value) ? value.replace($f3dcbb78d3a0cdcf$var$regexEscapedHtml, function(character) {
        return $f3dcbb78d3a0cdcf$var$htmlCharacters[character];
    }) : value;
}


function $98634d9e355ebef6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $98634d9e355ebef6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $98634d9e355ebef6$var$_typeof(o);
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/master/isPlainObject.js
 */ function $98634d9e355ebef6$var$getTag(value) {
    if (value === null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function $98634d9e355ebef6$var$isObjectLike(value) {
    return $98634d9e355ebef6$var$_typeof(value) === "object" && value !== null;
}
function $98634d9e355ebef6$export$53b83ca8eaab0383(value) {
    if (!$98634d9e355ebef6$var$isObjectLike(value) || $98634d9e355ebef6$var$getTag(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    var proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}


function $c3ab0a6931928f0c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c3ab0a6931928f0c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c3ab0a6931928f0c$var$_typeof(o);
}
function $c3ab0a6931928f0c$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $c3ab0a6931928f0c$var$_extends() {
    $c3ab0a6931928f0c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c3ab0a6931928f0c$var$_extends.apply(this, arguments);
}
function $c3ab0a6931928f0c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c3ab0a6931928f0c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c3ab0a6931928f0c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c3ab0a6931928f0c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c3ab0a6931928f0c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c3ab0a6931928f0c$var$_defineProperty(obj, key, value) {
    key = $c3ab0a6931928f0c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c3ab0a6931928f0c$var$_toPropertyKey(t) {
    var i = $c3ab0a6931928f0c$var$_toPrimitive(t, "string");
    return "symbol" == $c3ab0a6931928f0c$var$_typeof(i) ? i : String(i);
}
function $c3ab0a6931928f0c$var$_toPrimitive(t, r) {
    if ("object" != $c3ab0a6931928f0c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c3ab0a6931928f0c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c3ab0a6931928f0c$export$1e7338a8952eaf35 = {
    highlightPreTag: "__ais-highlight__",
    highlightPostTag: "__/ais-highlight__"
};
var $c3ab0a6931928f0c$export$62e796b7905e8e6b = {
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>"
};
// @MAJOR: in the future, this should only escape, not replace
function $c3ab0a6931928f0c$var$replaceTagsAndEscape(value) {
    return (0, $f3dcbb78d3a0cdcf$export$4e7f196112fea3c5)(value).replace(new RegExp($c3ab0a6931928f0c$export$1e7338a8952eaf35.highlightPreTag, "g"), $c3ab0a6931928f0c$export$62e796b7905e8e6b.highlightPreTag).replace(new RegExp($c3ab0a6931928f0c$export$1e7338a8952eaf35.highlightPostTag, "g"), $c3ab0a6931928f0c$export$62e796b7905e8e6b.highlightPostTag);
}
function $c3ab0a6931928f0c$var$recursiveEscape(input) {
    if ((0, $98634d9e355ebef6$export$53b83ca8eaab0383)(input) && typeof input.value !== "string") return Object.keys(input).reduce(function(acc, key) {
        return $c3ab0a6931928f0c$var$_objectSpread($c3ab0a6931928f0c$var$_objectSpread({}, acc), {}, $c3ab0a6931928f0c$var$_defineProperty({}, key, $c3ab0a6931928f0c$var$recursiveEscape(input[key])));
    }, {});
    if (Array.isArray(input)) return input.map($c3ab0a6931928f0c$var$recursiveEscape);
    return $c3ab0a6931928f0c$var$_objectSpread($c3ab0a6931928f0c$var$_objectSpread({}, input), {}, {
        value: $c3ab0a6931928f0c$var$replaceTagsAndEscape(input.value)
    });
}
function $c3ab0a6931928f0c$export$9adb036445aab889(hits) {
    if (hits.__escaped === undefined) {
        // We don't override the value on hit because it will mutate the raw results
        // instead we make a shallow copy and we assign the escaped values on it.
        hits = hits.map(function(_ref) {
            var hit = $c3ab0a6931928f0c$var$_extends({}, ($c3ab0a6931928f0c$var$_objectDestructuringEmpty(_ref), _ref));
            if (hit._highlightResult) hit._highlightResult = $c3ab0a6931928f0c$var$recursiveEscape(hit._highlightResult);
            if (hit._snippetResult) hit._snippetResult = $c3ab0a6931928f0c$var$recursiveEscape(hit._snippetResult);
            return hit;
        });
        hits.__escaped = true;
    }
    return hits;
}
function $c3ab0a6931928f0c$export$9ae2e822836b2e1a(facetHits) {
    return facetHits.map(function(h) {
        return $c3ab0a6931928f0c$var$_objectSpread($c3ab0a6931928f0c$var$_objectSpread({}, h), {}, {
            highlighted: $c3ab0a6931928f0c$var$replaceTagsAndEscape(h.highlighted)
        });
    });
}


var $a04f80f894e77137$var$suit = (0, $fb1e243c72be04b6$export$d8556a2a8f973135)("Highlight");
function $a04f80f894e77137$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $df4ef976d5bdb951$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $a04f80f894e77137$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



function $d437a372f657f877$export$a34fe2fceda1929e(parts) {
    var highlightPreTag = (0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPreTag, highlightPostTag = (0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPostTag;
    return parts.map(function(part) {
        return part.isHighlighted ? highlightPreTag + part.value + highlightPostTag : part.value;
    }).join("");
}


var $69790ef672436aa1$var$hasAlphanumeric = new RegExp(/\w/i);
function $69790ef672436aa1$export$60c97785b669d08a(parts, i) {
    var _parts, _parts2;
    var current = parts[i];
    var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
    var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;
    if (!$69790ef672436aa1$var$hasAlphanumeric.test((0, $f3dcbb78d3a0cdcf$export$e8bacd2802a88316)(current.value)) && isPreviousHighlighted === isNextHighlighted) return isPreviousHighlighted;
    return current.isHighlighted;
}


function $5677f08bfb02b552$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5677f08bfb02b552$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5677f08bfb02b552$var$_typeof(o);
}
function $5677f08bfb02b552$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5677f08bfb02b552$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5677f08bfb02b552$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5677f08bfb02b552$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5677f08bfb02b552$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5677f08bfb02b552$var$_defineProperty(obj, key, value) {
    key = $5677f08bfb02b552$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5677f08bfb02b552$var$_toPropertyKey(t) {
    var i = $5677f08bfb02b552$var$_toPrimitive(t, "string");
    return "symbol" == $5677f08bfb02b552$var$_typeof(i) ? i : String(i);
}
function $5677f08bfb02b552$var$_toPrimitive(t, r) {
    if ("object" != $5677f08bfb02b552$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5677f08bfb02b552$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5677f08bfb02b552$export$8d1202a2cf66e93(parts) {
    if (!parts.some(function(part) {
        return part.isHighlighted;
    })) return parts.map(function(part) {
        return $5677f08bfb02b552$var$_objectSpread($5677f08bfb02b552$var$_objectSpread({}, part), {}, {
            isHighlighted: false
        });
    });
    return parts.map(function(part, i) {
        return $5677f08bfb02b552$var$_objectSpread($5677f08bfb02b552$var$_objectSpread({}, part), {}, {
            isHighlighted: !(0, $69790ef672436aa1$export$60c97785b669d08a)(parts, i)
        });
    });
}


function $5102b5af87290225$export$e04d28e65b830ebf(highlightedValue) {
    // @MAJOR: this should use TAG_PLACEHOLDER
    var highlightPostTag = (0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPostTag, highlightPreTag = (0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPreTag;
    var splitByPreTag = highlightedValue.split(highlightPreTag);
    var firstValue = splitByPreTag.shift();
    var elements = !firstValue ? [] : [
        {
            value: firstValue,
            isHighlighted: false
        }
    ];
    splitByPreTag.forEach(function(split) {
        var splitByPostTag = split.split(highlightPostTag);
        elements.push({
            value: splitByPostTag[0],
            isHighlighted: true
        });
        if (splitByPostTag[1] !== "") elements.push({
            value: splitByPostTag[1],
            isHighlighted: false
        });
    });
    return elements;
}


var $1c0dfaf5220411d2$var$suit = (0, $fb1e243c72be04b6$export$d8556a2a8f973135)("ReverseHighlight");
function $1c0dfaf5220411d2$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $df4ef976d5bdb951$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $1c0dfaf5220411d2$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $d437a372f657f877$export$a34fe2fceda1929e)((0, $5677f08bfb02b552$export$8d1202a2cf66e93)((0, $5102b5af87290225$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $9bab6399914ee67a$var$suit = (0, $fb1e243c72be04b6$export$d8556a2a8f973135)("Snippet");
function $9bab6399914ee67a$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $df4ef976d5bdb951$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $9bab6399914ee67a$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $3f04f3deb6088df4$var$suit = (0, $fb1e243c72be04b6$export$d8556a2a8f973135)("ReverseSnippet");
function $3f04f3deb6088df4$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $df4ef976d5bdb951$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $3f04f3deb6088df4$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $d437a372f657f877$export$a34fe2fceda1929e)((0, $5677f08bfb02b552$export$8d1202a2cf66e93)((0, $5102b5af87290225$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}

function $e554eb5b66e10834$export$44b4521aa38272f2(payload) {
    return btoa(encodeURIComponent(JSON.stringify(payload)));
}
function $e554eb5b66e10834$export$706ea24b0964bee9(serialized) {
    return JSON.parse(decodeURIComponent(atob(serialized)));
}


function $54d2c88a789bd99d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $54d2c88a789bd99d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $54d2c88a789bd99d$var$_typeof(o);
}
function $54d2c88a789bd99d$export$cbcfede36ce7ab2e(domElement) {
    var method = domElement.getAttribute("data-insights-method");
    var serializedPayload = domElement.getAttribute("data-insights-payload");
    if (typeof serializedPayload !== "string") throw new Error("The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.");
    try {
        var payload = (0, $e554eb5b66e10834$export$706ea24b0964bee9)(serializedPayload);
        return {
            method: method,
            payload: payload
        };
    } catch (error) {
        throw new Error("The insights helper was unable to parse `data-insights-payload`.");
    }
}
function $54d2c88a789bd99d$export$a3453cc0ced8b97c(_ref) {
    var method = _ref.method, payload = _ref.payload;
    if ($54d2c88a789bd99d$var$_typeof(payload) !== "object") throw new Error("The insights helper expects the payload to be an object.");
    var serializedPayload;
    try {
        serializedPayload = (0, $e554eb5b66e10834$export$44b4521aa38272f2)(payload);
    } catch (error) {
        throw new Error("Could not JSON serialize the payload object.");
    }
    return 'data-insights-method="'.concat(method, '" data-insights-payload="').concat(serializedPayload, '"');
}
function $54d2c88a789bd99d$export$2e2bcd8739ae039(method, payload) {
    return $54d2c88a789bd99d$export$a3453cc0ced8b97c({
        method: method,
        payload: payload
    });
}


function $48acce04fdc682d2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $48acce04fdc682d2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $48acce04fdc682d2$var$_typeof(o);
}
var $48acce04fdc682d2$export$d900da7fa9a86f36 = "_ALGOLIA";
function $48acce04fdc682d2$var$getCookie(name) {
    if ((typeof document === "undefined" ? "undefined" : $48acce04fdc682d2$var$_typeof(document)) !== "object" || typeof document.cookie !== "string") return undefined;
    var prefix = "".concat(name, "=");
    var cookies = document.cookie.split(";");
    for(var i = 0; i < cookies.length; i++){
        var cookie = cookies[i];
        while(cookie.charAt(0) === " ")cookie = cookie.substring(1);
        if (cookie.indexOf(prefix) === 0) return cookie.substring(prefix.length, cookie.length);
    }
    return undefined;
}
function $48acce04fdc682d2$export$61f1c6e9cd2ed687() {
    return $48acce04fdc682d2$var$getCookie($48acce04fdc682d2$export$d900da7fa9a86f36);
}
function $48acce04fdc682d2$export$2e2bcd8739ae039() {
    return $48acce04fdc682d2$export$61f1c6e9cd2ed687();
}


// eslint-disable-next-line no-restricted-globals
/**
 * Runs code on browser environments safely.
 */ function $7ba35a00e1b6937e$export$39f19eed34acd2f1(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        fallback: function fallback() {
            return undefined;
        }
    }, fallback = _ref.fallback;
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === "undefined") return fallback();
    // eslint-disable-next-line no-restricted-globals
    return callback({
        window: window
    });
}

function $33ae9dc431645103$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $33ae9dc431645103$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($33ae9dc431645103$var$isPrimitive(first) || $33ae9dc431645103$var$isPrimitive(second) || typeof first === "function" || typeof second === "function") return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    // @TODO avoid for..of because of the large polyfill
    // eslint-disable-next-line no-restricted-syntax
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$33ae9dc431645103$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}


var $1d19869c4e5f6004$var$_excluded = [
    "page"
];
function $1d19869c4e5f6004$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1d19869c4e5f6004$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1d19869c4e5f6004$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1d19869c4e5f6004$var$getStateWithoutPage(state) {
    var _ref = state || {}, page = _ref.page, rest = $1d19869c4e5f6004$var$_objectWithoutProperties(_ref, $1d19869c4e5f6004$var$_excluded);
    return rest;
}
function $1d19869c4e5f6004$export$2e2bcd8739ae039() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, key = _ref2.key;
    var KEY = [
        "ais.infiniteHits",
        key
    ].filter(Boolean).join(":");
    return {
        read: function read(_ref3) {
            var state = _ref3.state;
            var sessionStorage = (0, $7ba35a00e1b6937e$export$39f19eed34acd2f1)(function(_ref4) {
                var window = _ref4.window;
                return window.sessionStorage;
            });
            if (!sessionStorage) return null;
            try {
                var cache = JSON.parse(// @ts-expect-error JSON.parse() requires a string, but it actually accepts null, too.
                sessionStorage.getItem(KEY));
                return cache && (0, $33ae9dc431645103$export$248d38f6296296c5)(cache.state, $1d19869c4e5f6004$var$getStateWithoutPage(state)) ? cache.hits : null;
            } catch (error) {
                if (error instanceof SyntaxError) try {
                    sessionStorage.removeItem(KEY);
                } catch (err) {
                // do nothing
                }
                return null;
            }
        },
        write: function write(_ref5) {
            var state = _ref5.state, hits = _ref5.hits;
            var sessionStorage = (0, $7ba35a00e1b6937e$export$39f19eed34acd2f1)(function(_ref6) {
                var window = _ref6.window;
                return window.sessionStorage;
            });
            if (!sessionStorage) return;
            try {
                sessionStorage.setItem(KEY, JSON.stringify({
                    state: $1d19869c4e5f6004$var$getStateWithoutPage(state),
                    hits: hits
                }));
            } catch (error) {
            // do nothing
            }
        }
    };
}


var $a1a5fc99466dfdf0$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $a1a5fc99466dfdf0$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
$a1a5fc99466dfdf0$exports = $a1a5fc99466dfdf0$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$a1a5fc99466dfdf0$var$EventEmitter.prototype._events = undefined;
$a1a5fc99466dfdf0$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$a1a5fc99466dfdf0$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$a1a5fc99466dfdf0$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$a1a5fc99466dfdf0$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
    this._maxListeners = n;
    return this;
};
$a1a5fc99466dfdf0$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === "error") {
        if (!this._events.error || $a1a5fc99466dfdf0$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($a1a5fc99466dfdf0$var$isUndefined(handler)) return false;
    if ($a1a5fc99466dfdf0$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($a1a5fc99466dfdf0$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$a1a5fc99466dfdf0$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$a1a5fc99466dfdf0$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit("newListener", type, $a1a5fc99466dfdf0$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($a1a5fc99466dfdf0$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($a1a5fc99466dfdf0$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$a1a5fc99466dfdf0$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $a1a5fc99466dfdf0$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === "function") // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$a1a5fc99466dfdf0$var$EventEmitter.prototype.on = $a1a5fc99466dfdf0$var$EventEmitter.prototype.addListener;
$a1a5fc99466dfdf0$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$a1a5fc99466dfdf0$var$isFunction(listener)) throw TypeError("listener must be a function");
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$a1a5fc99466dfdf0$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$a1a5fc99466dfdf0$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $a1a5fc99466dfdf0$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    } else if ($a1a5fc99466dfdf0$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    }
    return this;
};
$a1a5fc99466dfdf0$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($a1a5fc99466dfdf0$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$a1a5fc99466dfdf0$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($a1a5fc99466dfdf0$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$a1a5fc99466dfdf0$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($a1a5fc99466dfdf0$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$a1a5fc99466dfdf0$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $a1a5fc99466dfdf0$var$isFunction(arg) {
    return typeof arg === "function";
}
function $a1a5fc99466dfdf0$var$isNumber(arg) {
    return typeof arg === "number";
}
function $a1a5fc99466dfdf0$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $a1a5fc99466dfdf0$var$isUndefined(arg) {
    return arg === void 0;
}


var $0fe43ba187e86394$exports = {};
"use strict";
var $c858381db0ea2708$exports = {};
"use strict";

var $1194216fcff75110$exports = {};
"use strict";

var $eedba569536860d4$exports = {};
"use strict";
function $eedba569536860d4$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
$eedba569536860d4$exports = $eedba569536860d4$var$inherits;


/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state for search
 * @param {function} recommendFn the function to create the derived state for recommendations
 */ function $1194216fcff75110$var$DerivedHelper(mainHelper, fn, recommendFn) {
    this.main = mainHelper;
    this.fn = fn;
    this.recommendFn = recommendFn;
    this.lastResults = null;
    this.lastRecommendResults = null;
}
$eedba569536860d4$exports($1194216fcff75110$var$DerivedHelper, $a1a5fc99466dfdf0$exports);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $1194216fcff75110$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$1194216fcff75110$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$1194216fcff75110$var$DerivedHelper.prototype.getModifiedRecommendState = function(parameters) {
    return this.recommendFn(parameters);
};
$1194216fcff75110$exports = $1194216fcff75110$var$DerivedHelper;


var $e183c98d903fd079$exports = {};
"use strict";
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $e183c98d903fd079$var$escapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return String(value).replace(/^-/, "\\-");
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $e183c98d903fd079$var$unescapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return value.replace(/^\\-/, "-");
}
$e183c98d903fd079$exports = {
    escapeFacetValue: $e183c98d903fd079$var$escapeFacetValue,
    unescapeFacetValue: $e183c98d903fd079$var$unescapeFacetValue
};


var $c858381db0ea2708$require$escapeFacetValue = $e183c98d903fd079$exports.escapeFacetValue;

var $bf12185581c10ca7$exports = {};
"use strict";
function $bf12185581c10ca7$var$clone(value) {
    if (typeof value === "object" && value !== null) return $bf12185581c10ca7$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $bf12185581c10ca7$var$isObjectOrArrayOrFunction(value) {
    return typeof value === "function" || Array.isArray(value) || Object.prototype.toString.call(value) === "[object Object]";
}
function $bf12185581c10ca7$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === "__proto__" || key === "constructor") continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== "undefined" && typeof sourceVal === "undefined") continue;
        if ($bf12185581c10ca7$var$isObjectOrArrayOrFunction(targetVal) && $bf12185581c10ca7$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $bf12185581c10ca7$var$_merge(targetVal, sourceVal);
        else target[key] = $bf12185581c10ca7$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $bf12185581c10ca7$var$merge(target) {
    if (!$bf12185581c10ca7$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($bf12185581c10ca7$var$isObjectOrArrayOrFunction(source)) $bf12185581c10ca7$var$_merge(target, source);
    }
    return target;
}
$bf12185581c10ca7$exports = $bf12185581c10ca7$var$merge;


var $05795f7725cc6c63$exports = {};
"use strict";
function $05795f7725cc6c63$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
$05795f7725cc6c63$exports = $05795f7725cc6c63$var$objectHasKeys;


var $b501b2516ae5f016$exports = {};
"use strict";
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $b501b2516ae5f016$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$b501b2516ae5f016$exports = $b501b2516ae5f016$var$_objectWithoutPropertiesLoose;


var $5bfffc5ced5b4167$exports = {};
"use strict";
/**
 * RecommendParameters is the data structure that contains all the information
 * usable for getting recommendations from the Algolia API. It doesn't do the
 * search itself, nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It
 * will be provided when needed.
 * @constructor
 * @classdesc contains all the parameters for recommendations
 * @param {RecommendParametersOptions} opts the options to create the object
 */ function $5bfffc5ced5b4167$var$RecommendParameters(opts) {
    opts = opts || {};
    this.params = opts.params || [];
}
$5bfffc5ced5b4167$var$RecommendParameters.prototype = {
    constructor: $5bfffc5ced5b4167$var$RecommendParameters,
    addParams: function(params) {
        var newParams = this.params.slice();
        newParams.push(params);
        return new $5bfffc5ced5b4167$var$RecommendParameters({
            params: newParams
        });
    },
    removeParams: function(id) {
        return new $5bfffc5ced5b4167$var$RecommendParameters({
            params: this.params.filter(function(param) {
                return param.$$id !== id;
            })
        });
    },
    addFrequentlyBoughtTogether: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "bought-together"
        }));
    },
    addRelatedProducts: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "related-products"
        }));
    },
    addTrendingItems: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-items"
        }));
    },
    addTrendingFacets: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-facets"
        }));
    },
    addLookingSimilar: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "looking-similar"
        }));
    },
    _buildQueries: function(indexName, cache) {
        return this.params.filter(function(params) {
            return cache[params.$$id] === undefined;
        }).map(function(params) {
            var query = Object.assign({}, params, {
                indexName: indexName,
                // @TODO: remove this if it ever gets handled by the API
                threshold: params.threshold || 0
            });
            delete query.$$id;
            return query;
        });
    }
};
$5bfffc5ced5b4167$exports = $5bfffc5ced5b4167$var$RecommendParameters;


var $7c9bc17e2748123d$exports = {};
"use strict";
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {RecommendParameters} state state that led to the response
 * @param {Record<string,RecommendResultItem>} results the results from algolia client
 **/ function $7c9bc17e2748123d$var$RecommendResults(state, results) {
    this._state = state;
    this._rawResults = {};
    // eslint-disable-next-line consistent-this
    var self = this;
    state.params.forEach(function(param) {
        var id = param.$$id;
        self[id] = results[id];
        self._rawResults[id] = results[id];
    });
}
$7c9bc17e2748123d$var$RecommendResults.prototype = {
    constructor: $7c9bc17e2748123d$var$RecommendResults
};
$7c9bc17e2748123d$exports = $7c9bc17e2748123d$var$RecommendResults;


var $2a224fff5c9ab56a$exports = {};
"use strict";

function $2a224fff5c9ab56a$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $2a224fff5c9ab56a$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $2a224fff5c9ab56a$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $2a224fff5c9ab56a$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $2a224fff5c9ab56a$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(":")[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === "string" && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ":" + parent.value);
                    else if (filteredFacetFilters.length > 0) params.facetFilters = filteredFacetFilters;
                    else delete params.facetFilters;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getCompositionQueries: function getQueries(state) {
        return [
            {
                compositionID: state.index,
                requestBody: {
                    params: $2a224fff5c9ab56a$var$requestBuilder._getCompositionHitsSearchParams(state)
                }
            }
        ];
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($2a224fff5c9ab56a$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $2a224fff5c9ab56a$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $2a224fff5c9ab56a$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $2a224fff5c9ab56a$var$requestBuilder._getTagFilters(state);
        var additionalParams = {};
        if (facets.length > 0) additionalParams.facets = facets.indexOf("*") > -1 ? [
            "*"
        ] : facets;
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $2a224fff5c9ab56a$var$sortObject($bf12185581c10ca7$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getCompositionHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets.map(function(value) {
            return "disjunctive(" + value + ")";
        })).concat($2a224fff5c9ab56a$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $2a224fff5c9ab56a$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $2a224fff5c9ab56a$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $2a224fff5c9ab56a$var$requestBuilder._getTagFilters(state);
        var additionalParams = {};
        if (facets.length > 0) additionalParams.facets = facets.indexOf("*") > -1 ? [
            "*"
        ] : facets;
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        var params = state.getQueryParams();
        delete params.highlightPreTag;
        delete params.highlightPostTag;
        // not a valid search parameter, it is handled in _getCompositionQueries
        delete params.index;
        return $2a224fff5c9ab56a$var$sortObject($bf12185581c10ca7$exports({}, params, additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $2a224fff5c9ab56a$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $2a224fff5c9ab56a$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $2a224fff5c9ab56a$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $2a224fff5c9ab56a$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $2a224fff5c9ab56a$var$sortObject($bf12185581c10ca7$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(",");
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.slice().sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":" + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":-" + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.slice().sort().forEach(function(facetValue) {
                orFilters.push(facetName + ":" + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ":" + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || "";
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === "number") searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $2a224fff5c9ab56a$var$sortObject($bf12185581c10ca7$exports({}, $2a224fff5c9ab56a$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
$2a224fff5c9ab56a$exports = $2a224fff5c9ab56a$var$requestBuilder;


var $db2fbd56732ee621$exports = {};
"use strict";
var $5e6c7f688bd3c75e$exports = {};
"use strict";
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
$5e6c7f688bd3c75e$exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};


var $843c28b11bbb54ba$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#find when we change support
$843c28b11bbb54ba$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};


var $766882b04c94ffe4$exports = {};
"use strict";
function $766882b04c94ffe4$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
$766882b04c94ffe4$exports = $766882b04c94ffe4$var$intersection;





var $513dc471009b3191$exports = {};
"use strict";
function $513dc471009b3191$var$valToNumber(v) {
    if (typeof v === "number") return v;
    else if (typeof v === "string") return parseFloat(v);
    else if (Array.isArray(v)) return v.map($513dc471009b3191$var$valToNumber);
    throw new Error("The value should be a number, a parsable string or an array of those.");
}
$513dc471009b3191$exports = $513dc471009b3191$var$valToNumber;


var $7f0699838448c74d$exports = {};
"use strict";
$7f0699838448c74d$exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};


var $ad4176350ff3bc10$exports = {};
"use strict";



var $ad4176350ff3bc10$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($ad4176350ff3bc10$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = "" + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $5e6c7f688bd3c75e$exports(mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $ad4176350ff3bc10$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = "" + value;
        return $ad4176350ff3bc10$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error("toggleRefinement should be used with a value");
        if ($ad4176350ff3bc10$var$lib.isRefined(refinementList, attribute, value)) return $ad4176350ff3bc10$var$lib.removeRefinement(refinementList, attribute, value);
        return $ad4176350ff3bc10$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$05795f7725cc6c63$exports(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === "string") return $b501b2516ae5f016$exports(refinementList, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = "" + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
$ad4176350ff3bc10$exports = $ad4176350ff3bc10$var$lib;


/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $db2fbd56732ee621$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $db2fbd56732ee621$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $db2fbd56732ee621$var$findArray(array, searchedValue) {
    return $843c28b11bbb54ba$exports(array, function(currentValue) {
        return $db2fbd56732ee621$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $db2fbd56732ee621$var$SearchParameters(newParameters) {
    var params = newParameters ? $db2fbd56732ee621$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$7f0699838448c74d$exports(params.userToken)) // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}");
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $db2fbd56732ee621$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $db2fbd56732ee621$var$SearchParameters.PARAMETERS = Object.keys(new $db2fbd56732ee621$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $db2fbd56732ee621$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $db2fbd56732ee621$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        "aroundPrecision",
        "aroundRadius",
        "getRankingInfo",
        "minWordSizefor2Typos",
        "minWordSizefor1Typo",
        "page",
        "maxValuesPerFacet",
        "distinct",
        "minimumAroundRadius",
        "hitsPerPage",
        "minProximity"
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === "string") {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === "string") return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === "string") return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $bf12185581c10ca7$exports(partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $db2fbd56732ee621$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $db2fbd56732ee621$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $db2fbd56732ee621$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $05795f7725cc6c63$exports(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($05795f7725cc6c63$exports(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$db2fbd56732ee621$var$SearchParameters.prototype = {
    constructor: $db2fbd56732ee621$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $ad4176350ff3bc10$exports.clearRefinement(this.facetsRefinements, attribute, "conjunctiveFacet"),
            facetsExcludes: $ad4176350ff3bc10$exports.clearRefinement(this.facetsExcludes, attribute, "exclude"),
            disjunctiveFacetsRefinements: $ad4176350ff3bc10$exports.clearRefinement(this.disjunctiveFacetsRefinements, attribute, "disjunctiveFacet"),
            hierarchicalFacetsRefinements: $ad4176350ff3bc10$exports.clearRefinement(this.hierarchicalFacetsRefinements, attribute, "hierarchicalFacet")
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $513dc471009b3191$exports(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $bf12185581c10ca7$exports({}, this.numericRefinements);
        mod[attribute] = $bf12185581c10ca7$exports({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $db2fbd56732ee621$var$isEqualNumericRefinement(value.val, $513dc471009b3191$exports(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$05795f7725cc6c63$exports(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === "string") return $b501b2516ae5f016$exports(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, "numeric");
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + hierarchicalFacet.name + "`");
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($ad4176350ff3bc10$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $ad4176350ff3bc10$exports.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($ad4176350ff3bc10$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $ad4176350ff3bc10$exports.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if ($ad4176350ff3bc10$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $ad4176350ff3bc10$exports.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$ad4176350ff3bc10$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $ad4176350ff3bc10$exports.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$ad4176350ff3bc10$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $ad4176350ff3bc10$exports.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if (!$ad4176350ff3bc10$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $ad4176350ff3bc10$exports.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error("Cannot refine the undeclared facet " + facet + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsRefinements: $ad4176350ff3bc10$exports.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsExcludes: $ad4176350ff3bc10$exports.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $ad4176350ff3bc10$exports.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration");
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $5e6c7f688bd3c75e$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + " is already refined.");
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $5e6c7f688bd3c75e$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $5e6c7f688bd3c75e$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $ad4176350ff3bc10$exports.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $ad4176350ff3bc10$exports.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $ad4176350ff3bc10$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $513dc471009b3191$exports(value);
        var isAttributeValueDefined = $db2fbd56732ee621$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $766882b04c94ffe4$exports(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $766882b04c94ffe4$exports(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        "index",
        "facets",
        "disjunctiveFacets",
        "facetsRefinements",
        "hierarchicalFacets",
        "facetsExcludes",
        "disjunctiveFacetsRefinements",
        "numericRefinements",
        "tagRefinements",
        "hierarchicalFacetsRefinements"
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $db2fbd56732ee621$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $db2fbd56732ee621$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $b501b2516ae5f016$exports(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            "isRefined:desc",
            "name:asc"
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || " > ";
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === "boolean") return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $843c28b11bbb54ba$exports(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ $db2fbd56732ee621$exports = $db2fbd56732ee621$var$SearchParameters;


var $e58124aa6c1b8225$exports = {};
"use strict";
var $ea95cc58ba7e28a0$exports = {};
"use strict";
$ea95cc58ba7e28a0$exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};





var $56354a8a1a29dd6b$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#findIndex when we change support
$56354a8a1a29dd6b$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};


var $f0083053ad9b5e92$exports = {};
"use strict";

/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ $f0083053ad9b5e92$exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(":");
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(":");
        var matchingDefault = $843c28b11bbb54ba$exports(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};


var $6d315e6155a5a49b$exports = {};
"use strict";
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order and keep the highest numeric value
function $6d315e6155a5a49b$var$mergeNumericMax() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            var accValue = typeof acc[key] === "number" ? acc[key] : 0;
            var sourceValue = source[key];
            if (sourceValue === undefined) return;
            if (sourceValue >= accValue) {
                if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
                delete acc[key];
                acc[key] = sourceValue;
            }
        });
        return acc;
    }, {});
}
$6d315e6155a5a49b$exports = $6d315e6155a5a49b$var$mergeNumericMax;


var $f8e7b7edeb497298$exports = {};
"use strict";
function $f8e7b7edeb497298$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $f8e7b7edeb497298$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $f8e7b7edeb497298$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === "desc") return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
$f8e7b7edeb497298$exports = $f8e7b7edeb497298$var$orderBy;


var $e58124aa6c1b8225$var$escapeFacetValue = $e183c98d903fd079$exports.escapeFacetValue;
var $e58124aa6c1b8225$var$unescapeFacetValue = $e183c98d903fd079$exports.unescapeFacetValue;
var $8ee30b17e06c2c68$exports = {};
"use strict";
$8ee30b17e06c2c68$exports = $8ee30b17e06c2c68$var$generateTrees;




var $8ee30b17e06c2c68$var$escapeFacetValue = $e183c98d903fd079$exports.escapeFacetValue;
var $8ee30b17e06c2c68$var$unescapeFacetValue = $e183c98d903fd079$exports.unescapeFacetValue;
function $8ee30b17e06c2c68$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || "";
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $f0083053ad9b5e92$exports(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $8ee30b17e06c2c68$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $8ee30b17e06c2c68$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $843c28b11bbb54ba$exports(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $8ee30b17e06c2c68$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $f8e7b7edeb497298$exports(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $8ee30b17e06c2c68$var$format(facetCount, facetValue, hierarchicalSeparator, $8ee30b17e06c2c68$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $8ee30b17e06c2c68$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $8ee30b17e06c2c68$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $8ee30b17e06c2c68$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}


/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $e58124aa6c1b8225$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $e58124aa6c1b8225$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $e58124aa6c1b8225$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $843c28b11bbb54ba$exports(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @param {object} options options to control results content
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $e58124aa6c1b8225$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0] || {};
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    var opts = $5e6c7f688bd3c75e$exports(options, {
        persistHierarchicalRootCount: false
    });
    Object.keys(opts).forEach(function(key) {
        self[key] = opts[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $e58124aa6c1b8225$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $e58124aa6c1b8225$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $e58124aa6c1b8225$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $56354a8a1a29dd6b$exports(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $e58124aa6c1b8225$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $e58124aa6c1b8225$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $ea95cc58ba7e28a0$exports(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $56354a8a1a29dd6b$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $56354a8a1a29dd6b$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = self.persistHierarchicalRootCount ? $6d315e6155a5a49b$exports(self.hierarchicalFacets[position][attributeIndex].data, facetResults) : $5e6c7f688bd3c75e$exports(facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $6d315e6155a5a49b$exports(dataFromMainRequest, facetResults),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $e58124aa6c1b8225$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($e58124aa6c1b8225$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $56354a8a1a29dd6b$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $56354a8a1a29dd6b$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                // @MAJOR: remove this legacy behaviour in next major version
                var defaultData = {};
                if (currentRefinement.length > 0 && !self.persistHierarchicalRootCount) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $5e6c7f688bd3c75e$exports(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($8ee30b17e06c2c68$exports(state));
    /**
   * @type {Array}
   */ this.facets = $ea95cc58ba7e28a0$exports(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $ea95cc58ba7e28a0$exports(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $e58124aa6c1b8225$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $843c28b11bbb54ba$exports(this.facets, predicate) || $843c28b11bbb54ba$exports(this.disjunctiveFacets, predicate) || $843c28b11bbb54ba$exports(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $e58124aa6c1b8225$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $843c28b11bbb54ba$exports(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $e58124aa6c1b8225$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $843c28b11bbb54ba$exports(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $e58124aa6c1b8225$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $843c28b11bbb54ba$exports(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $e58124aa6c1b8225$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || "");
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, "");
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $e58124aa6c1b8225$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $e58124aa6c1b8225$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === (currentRefinement[depth] && currentRefinement[depth].trim());
    if (item.data) item.data.forEach(function(child) {
        $e58124aa6c1b8225$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $e58124aa6c1b8225$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $e58124aa6c1b8225$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $5e6c7f688bd3c75e$exports({
        data: sortedChildren
    }, node);
    return newNode;
}
$e58124aa6c1b8225$var$SearchResults.DEFAULT_SORT = [
    "isRefined:desc",
    "count:desc",
    "name:asc"
];
function $e58124aa6c1b8225$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $e58124aa6c1b8225$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var hide = facetOrdering.hide || [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        var hidden = hide.indexOf(name) > -1;
        if (!hidden && reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else if (!hidden) remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === "hidden") return orderedFacets;
    else if (sortRemainingBy === "alpha") ordering = [
        [
            "path",
            "name"
        ],
        [
            "asc",
            "asc"
        ]
    ];
    else ordering = [
        [
            "count"
        ],
        [
            "desc"
        ]
    ];
    return orderedFacets.concat($f8e7b7edeb497298$exports(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $e58124aa6c1b8225$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $e58124aa6c1b8225$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $e58124aa6c1b8225$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $5e6c7f688bd3c75e$exports(opts, {
        sortBy: $e58124aa6c1b8225$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $e58124aa6c1b8225$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $e58124aa6c1b8225$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $e58124aa6c1b8225$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $f0083053ad9b5e92$exports(options.sortBy, $e58124aa6c1b8225$var$SearchResults.DEFAULT_SORT);
            return $f8e7b7edeb497298$exports(data, order[0], order[1]);
        } else if (typeof options.sortBy === "function") return $e58124aa6c1b8225$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $e58124aa6c1b8225$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $e58124aa6c1b8225$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $e58124aa6c1b8225$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $e58124aa6c1b8225$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $843c28b11bbb54ba$exports(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $e58124aa6c1b8225$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($e58124aa6c1b8225$var$getRefinement(state, "facet", attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($e58124aa6c1b8225$var$getRefinement(state, "exclude", attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($e58124aa6c1b8225$var$getRefinement(state, "disjunctive", attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($e58124aa6c1b8225$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: "numeric",
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: "tag",
            attributeName: "_tags",
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $e58124aa6c1b8225$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $843c28b11bbb54ba$exports(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $e58124aa6c1b8225$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $843c28b11bbb54ba$exports(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $843c28b11bbb54ba$exports(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || "";
    return {
        type: "hierarchical",
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
$e58124aa6c1b8225$exports = $e58124aa6c1b8225$var$SearchResults;


var $e5b298271cc3ad16$exports = {};
"use strict";

var $a243818c7d2f3220$exports = {};
// @MAJOR: remove this function and use Array.prototype.flat
$a243818c7d2f3220$exports = function flat(arr) {
    return arr.reduce(function(acc, val) {
        return acc.concat(val);
    }, []);
};


function $e5b298271cc3ad16$var$getAverageIndices(indexTracker, nrOfObjs) {
    var avgIndices = [];
    Object.keys(indexTracker).forEach(function(key) {
        if (indexTracker[key].count < 2) indexTracker[key].indexSum += 100;
        avgIndices.push({
            objectID: key,
            avgOfIndices: indexTracker[key].indexSum / nrOfObjs
        });
    });
    return avgIndices.sort(function(a, b) {
        return a.avgOfIndices > b.avgOfIndices ? 1 : -1;
    });
}
function $e5b298271cc3ad16$var$sortAndMergeRecommendations(results) {
    var indexTracker = {};
    results.forEach(function(hits) {
        hits.forEach(function(hit, index) {
            if (!indexTracker[hit.objectID]) indexTracker[hit.objectID] = {
                indexSum: index,
                count: 1
            };
            else indexTracker[hit.objectID] = {
                indexSum: indexTracker[hit.objectID].indexSum + index,
                count: indexTracker[hit.objectID].count + 1
            };
        });
    });
    var sortedAverageIndices = $e5b298271cc3ad16$var$getAverageIndices(indexTracker, results.length);
    var finalOrder = sortedAverageIndices.reduce(function(orderedHits, avgIndexRef) {
        var result = $843c28b11bbb54ba$exports($a243818c7d2f3220$exports(results), function(hit) {
            return hit.objectID === avgIndexRef.objectID;
        });
        return result ? orderedHits.concat(result) : orderedHits;
    }, []);
    return finalOrder;
}
$e5b298271cc3ad16$exports = $e5b298271cc3ad16$var$sortAndMergeRecommendations;



var $24QL2 = parcelRequire("24QL2");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 */ function $c858381db0ea2708$var$AlgoliaSearchHelper(client, index, options, searchResultsOptions) {
    if (typeof client.addAlgoliaAgent === "function") client.addAlgoliaAgent("JS Helper (" + $24QL2 + ")");
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $db2fbd56732ee621$exports.make(opts);
    this.recommendState = new $5bfffc5ced5b4167$exports({
        params: opts.recommendState
    });
    this.lastResults = null;
    this.lastRecommendResults = null;
    this._queryId = 0;
    this._recommendQueryId = 0;
    this._lastQueryIdReceived = -1;
    this._lastRecommendQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
    this._currentNbRecommendQueries = 0;
    this._searchResultsOptions = searchResultsOptions;
    this._recommendCache = {};
}
$eedba569536860d4$exports($c858381db0ea2708$var$AlgoliaSearchHelper, $a1a5fc99466dfdf0$exports);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$c858381db0ea2708$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
$c858381db0ea2708$var$AlgoliaSearchHelper.prototype.searchWithComposition = function() {
    this._runComposition({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Sends the recommendation queries set in the state. When the method is
 * called, it triggers a `fetch` event. The results will be available through
 * the `result` event. If an error occurs, an `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires fetch
 * @fires result
 * @fires error
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.recommend = function() {
    this._recommend();
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $2a224fff5c9ab56a$exports._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $2a224fff5c9ab56a$exports._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit("searchOnce", {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(null, new $e58124aa6c1b8225$exports(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        return {
            content: new $e58124aa6c1b8225$exports(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] answers is no longer supported");
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $bf12185581c10ca7$exports({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $b501b2516ae5f016$exports($2a224fff5c9ab56a$exports._getHitsSearchParams(derivedState), [
            "attributesToSnippet",
            "hitsPerPage",
            "restrictSearchableAttributes",
            "snippetEllipsisText"
        ])
    });
    var errorMessage = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if (typeof this.client.initIndex !== "function") throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== "function") throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === "function" && // v5 has a wrong sffv signature
    typeof this.client.searchForFacets !== "function";
    var clientHasInitIndex = typeof this.client.initIndex === "function";
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== "function") throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $2a224fff5c9ab56a$exports.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: "facet",
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit("searchForFacetValues", {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $c858381db0ea2708$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Search for facet values using the Composition API & based on a query and the name of a faceted attribute.
 * This triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.searchForCompositionFacetValues = function(facet, query, maxFacetHits, userState) {
    if (typeof this.client.searchForFacetValues !== "function") throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues");
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    searchForFacetValuesPromise = this.client.searchForFacetValues({
        compositionID: state.index,
        facetName: facet,
        searchForFacetValuesRequest: {
            params: {
                query: query,
                maxFacetHits: maxFacetHits,
                searchQuery: $2a224fff5c9ab56a$exports._getCompositionHitsSearchParams(state)
            }
        }
    });
    this.emit("searchForFacetValues", {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        content = content.results[0];
        content.facetHits.forEach(function(f) {
            f.escapedValue = $c858381db0ea2708$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a "frequently bought together" recommendation query.
 *
 * @param {FrequentlyBoughtTogetherQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addFrequentlyBoughtTogether = function(params) {
    this._recommendChange({
        state: this.recommendState.addFrequentlyBoughtTogether(params)
    });
    return this;
};
/**
 * Adds a "related products" recommendation query.
 *
 * @param {RelatedProductsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addRelatedProducts = function(params) {
    this._recommendChange({
        state: this.recommendState.addRelatedProducts(params)
    });
    return this;
};
/**
 * Adds a "trending items" recommendation query.
 *
 * @param {TrendingItemsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addTrendingItems = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingItems(params)
    });
    return this;
};
/**
 * Adds a "trending facets" recommendation query.
 *
 * @param {TrendingFacetsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addTrendingFacets = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingFacets(params)
    });
    return this;
};
/**
 * Adds a "looking similar" recommendation query.
 *
 * @param {LookingSimilarQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.addLookingSimilar = function(params) {
    this._recommendChange({
        state: this.recommendState.addLookingSimilar(params)
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a "frequently bought together" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeFrequentlyBoughtTogether = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "related products" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeRelatedProducts = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending items" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeTrendingItems = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending facets" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeTrendingFacets = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "looking similar" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.removeLookingSimilar = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $c858381db0ea2708$var$setCurrentPage(page) {
    if (page < 0) throw new Error("Page requested below 0.");
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.setCurrentPage = $c858381db0ea2708$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.setPage = $c858381db0ea2708$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $db2fbd56732ee621$exports.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $db2fbd56732ee621$exports(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($05795f7725cc6c63$exports(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $c858381db0ea2708$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.getCurrentPage = $c858381db0ea2708$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.getPage = $c858381db0ea2708$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "conjunctive"
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "exclude"
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "disjunctive"
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: "numeric"
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $2a224fff5c9ab56a$exports._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit("search", {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $2a224fff5c9ab56a$exports._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit("search", {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return undefined;
};
/**
 * Perform the underlying queries
 * @private
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype._runComposition = function() {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = $2a224fff5c9ab56a$exports._getCompositionQueries(derivedState);
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit("search", {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    if (queries.length > 1) throw new Error("Only one query is allowed when using a composition.");
    var query = queries[0];
    try {
        this.client.search(query).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return undefined;
};
$c858381db0ea2708$var$AlgoliaSearchHelper.prototype._recommend = function() {
    var searchState = this.state;
    var recommendState = this.recommendState;
    var index = this.getIndex();
    var states = [
        {
            state: recommendState,
            index: index,
            helper: this
        }
    ];
    var ids = recommendState.params.map(function(param) {
        return param.$$id;
    });
    this.emit("fetch", {
        recommend: {
            state: recommendState,
            results: this.lastRecommendResults
        }
    });
    var cache = this._recommendCache;
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedIndex = derivedHelper.getModifiedState(searchState).index;
        if (!derivedIndex) return [];
        // Contrary to what is done when deriving the search state, we don't want to
        // provide the current recommend state to the derived helper, as it would
        // inherit unwanted queries. We instead provide an empty recommend state.
        var derivedState = derivedHelper.getModifiedRecommendState(new $5bfffc5ced5b4167$exports());
        states.push({
            state: derivedState,
            index: derivedIndex,
            helper: derivedHelper
        });
        ids = Array.prototype.concat.apply(ids, derivedState.params.map(function(param) {
            return param.$$id;
        }));
        derivedHelper.emit("fetch", {
            recommend: {
                state: derivedState,
                results: derivedHelper.lastRecommendResults
            }
        });
        return derivedState._buildQueries(derivedIndex, cache);
    });
    var queries = Array.prototype.concat.apply(this.recommendState._buildQueries(index, cache), derivedQueries);
    if (queries.length === 0) return;
    if (queries.length > 0 && typeof this.client.getRecommendations === "undefined") {
        // eslint-disable-next-line no-console
        console.warn("Please update algoliasearch/lite to the latest version in order to use recommend widgets.");
        return;
    }
    var queryId = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
        this.client.getRecommendations(queries).then(this._dispatchRecommendResponse.bind(this, queryId, states, ids)).catch(this._dispatchRecommendError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // eslint-disable-next-line consistent-this
    var self = this;
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
    var results = content.results.slice();
    var rawContent = Object.keys(content).reduce(function(value, key) {
        if (key !== "results") value[key] = content[key];
        return value;
    }, {});
    if (Object.keys(rawContent).length <= 0) rawContent = undefined;
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit("result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $e58124aa6c1b8225$exports(state, specificResults, self._searchResultsOptions);
        if (rawContent !== undefined) helper.lastResults._rawContent = rawContent;
        helper.emit("result", {
            results: helper.lastResults,
            state: state
        });
    });
};
$c858381db0ea2708$var$AlgoliaSearchHelper.prototype._dispatchRecommendResponse = function(queryId, states, ids, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
    var cache = this._recommendCache;
    var idsMap = {};
    ids.filter(function(id) {
        return cache[id] === undefined;
    }).forEach(function(id, index) {
        if (!idsMap[id]) idsMap[id] = [];
        idsMap[id].push(index);
    });
    Object.keys(idsMap).forEach(function(id) {
        var indices = idsMap[id];
        var firstResult = content.results[indices[0]];
        if (indices.length === 1) {
            cache[id] = firstResult;
            return;
        }
        cache[id] = Object.assign({}, firstResult, {
            hits: $e5b298271cc3ad16$exports(indices.map(function(idx) {
                return content.results[idx].hits;
            }))
        });
    });
    var results = {};
    ids.forEach(function(id) {
        results[id] = cache[id];
    });
    states.forEach(function(s) {
        var state = s.state;
        var helper = s.helper;
        if (!s.index) {
            // eslint-disable-next-line no-warning-comments
            // TODO: emit "result" event when events for Recommend are implemented
            helper.emit("recommend:result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastRecommendResults = new $7c9bc17e2748123d$exports(state, results);
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "result" event when events for Recommend are implemented
        helper.emit("recommend:result", {
            recommend: {
                results: helper.lastRecommendResults,
                state: state
            }
        });
    });
};
$c858381db0ea2708$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
};
$c858381db0ea2708$var$AlgoliaSearchHelper.prototype._dispatchRecommendError = function(queryId, error) {
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
};
$c858381db0ea2708$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$c858381db0ea2708$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit("change", {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
$c858381db0ea2708$var$AlgoliaSearchHelper.prototype._recommendChange = function(event) {
    var state = event.state;
    if (state !== this.recommendState) {
        this.recommendState = state;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "change" event when events for Recommend are implemented
        this.emit("recommend:change", {
            search: {
                results: this.lastResults,
                state: this.state
            },
            recommend: {
                results: this.lastRecommendResults,
                state: this.recommendState
            }
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === "function") newClient.addAlgoliaAgent("JS Helper (" + $24QL2 + ")");
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @param {function} recommendFn RecommendParameters -> RecommendParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.derive = function(fn, recommendFn) {
    var derivedHelper = new $1194216fcff75110$exports(this, fn, recommendFn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $c858381db0ea2708$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ $c858381db0ea2708$exports = $c858381db0ea2708$var$AlgoliaSearchHelper;






/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $0fe43ba187e86394$var$algoliasearchHelper(client, index, opts, searchResultsOptions) {
    return new $c858381db0ea2708$exports(client, index, opts, searchResultsOptions);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $0fe43ba187e86394$var$algoliasearchHelper.version = (parcelRequire("24QL2"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $0fe43ba187e86394$var$algoliasearchHelper.AlgoliaSearchHelper = $c858381db0ea2708$exports;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $0fe43ba187e86394$var$algoliasearchHelper.SearchParameters = $db2fbd56732ee621$exports;
/**
 * Constructor for the object containing all the parameters for Recommend.
 * @member module:algoliasearchHelper.RecommendParameters
 * @type {RecommendParameters}
 */ $0fe43ba187e86394$var$algoliasearchHelper.RecommendParameters = $5bfffc5ced5b4167$exports;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $0fe43ba187e86394$var$algoliasearchHelper.SearchResults = $e58124aa6c1b8225$exports;
/**
 * Constructor for the object containing the results for Recommend.
 * @member module:algoliasearchHelper.RecommendResults
 * @type {RecommendResults}
 */ $0fe43ba187e86394$var$algoliasearchHelper.RecommendResults = $7c9bc17e2748123d$exports;
$0fe43ba187e86394$exports = $0fe43ba187e86394$var$algoliasearchHelper;



function $8fe091dcd40a4798$export$8793edee2d425525() {}

// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function $e017fe0f86217dc1$export$58f35ab8a1251bc0(searchClient) {
    if (searchClient.appId && searchClient.apiKey) // searchClient v5
    return [
        searchClient.appId,
        searchClient.apiKey
    ];
    else if (searchClient.transporter) {
        // searchClient v4 or v5
        var transporter = searchClient.transporter;
        var headers = transporter.headers || transporter.baseHeaders;
        var queryParameters = transporter.queryParameters || transporter.baseQueryParameters;
        var APP_ID = "x-algolia-application-id";
        var API_KEY = "x-algolia-api-key";
        var appId = headers[APP_ID] || queryParameters[APP_ID];
        var apiKey = headers[API_KEY] || queryParameters[API_KEY];
        return [
            appId,
            apiKey
        ];
    } else // searchClient v3
    return [
        searchClient.applicationID,
        searchClient.apiKey
    ];
}

// We aren't using the native `Array.prototype.find` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `find` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.find` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
function $3a145725faa3321d$export$71aa6c912b956294(items, predicate) {
    var value;
    for(var i = 0; i < items.length; i++){
        value = items[i];
        // inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
        if (predicate(value, i, items)) return value;
    }
    return undefined;
}


/**
 * Create UUID according to
 * https://www.ietf.org/rfc/rfc4122.txt.
 *
 * @returns Generated UUID.
 */ function $96e77c48f8f7b2e8$export$5dbf9a24b655dde4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        /* eslint-disable no-bitwise */ var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        /* eslint-enable */ return v.toString(16);
    });
}


function $ef593e4916349da0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ef593e4916349da0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ef593e4916349da0$var$_typeof(o);
}
function $ef593e4916349da0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef593e4916349da0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef593e4916349da0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ef593e4916349da0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef593e4916349da0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ef593e4916349da0$var$_defineProperty(obj, key, value) {
    key = $ef593e4916349da0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ef593e4916349da0$var$_toPropertyKey(t) {
    var i = $ef593e4916349da0$var$_toPrimitive(t, "string");
    return "symbol" == $ef593e4916349da0$var$_typeof(i) ? i : String(i);
}
function $ef593e4916349da0$var$_toPrimitive(t, r) {
    if ("object" != $ef593e4916349da0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ef593e4916349da0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ef593e4916349da0$var$_slicedToArray(arr, i) {
    return $ef593e4916349da0$var$_arrayWithHoles(arr) || $ef593e4916349da0$var$_iterableToArrayLimit(arr, i) || $ef593e4916349da0$var$_unsupportedIterableToArray(arr, i) || $ef593e4916349da0$var$_nonIterableRest();
}
function $ef593e4916349da0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ef593e4916349da0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ef593e4916349da0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ef593e4916349da0$var$_toConsumableArray(arr) {
    return $ef593e4916349da0$var$_arrayWithoutHoles(arr) || $ef593e4916349da0$var$_iterableToArray(arr) || $ef593e4916349da0$var$_unsupportedIterableToArray(arr) || $ef593e4916349da0$var$_nonIterableSpread();
}
function $ef593e4916349da0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ef593e4916349da0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ef593e4916349da0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ef593e4916349da0$var$_arrayLikeToArray(o, minLen);
}
function $ef593e4916349da0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ef593e4916349da0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ef593e4916349da0$var$_arrayLikeToArray(arr);
}
function $ef593e4916349da0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ef593e4916349da0$var$ALGOLIA_INSIGHTS_VERSION = "2.17.2";
var $ef593e4916349da0$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($ef593e4916349da0$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
function $ef593e4916349da0$export$91e0bf09562e2c44() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _insightsClient = props.insightsClient, insightsInitParams = props.insightsInitParams, onEvent = props.onEvent, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal, _props$$$automatic = props.$$automatic, $$automatic = _props$$$automatic === void 0 ? false : _props$$$automatic;
    var potentialInsightsClient = _insightsClient;
    if (!_insightsClient && _insightsClient !== null) (0, $7ba35a00e1b6937e$export$39f19eed34acd2f1)(function(_ref) {
        var window = _ref.window;
        var pointer = window.AlgoliaAnalyticsObject || "aa";
        if (typeof pointer === "string") potentialInsightsClient = window[pointer];
        if (!potentialInsightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) {
                window[pointer] = function() {
                    if (!window[pointer].queue) window[pointer].queue = [];
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    window[pointer].queue.push(args);
                };
                window[pointer].version = $ef593e4916349da0$var$ALGOLIA_INSIGHTS_VERSION;
                window[pointer].shouldAddScript = true;
            }
            potentialInsightsClient = window[pointer];
        }
    });
    // if still no insightsClient was found, we use a noop
    var insightsClient = potentialInsightsClient || (0, $8fe091dcd40a4798$export$8793edee2d425525);
    return function(_ref2) {
        var instantSearchInstance = _ref2.instantSearchInstance;
        // remove existing default insights middleware
        // user-provided insights middleware takes precedence
        var existingInsightsMiddlewares = instantSearchInstance.middleware.filter(function(m) {
            return m.instance.$$type === "ais.insights" && m.instance.$$internal;
        }).map(function(m) {
            return m.creator;
        });
        instantSearchInstance.unuse.apply(instantSearchInstance, $ef593e4916349da0$var$_toConsumableArray(existingInsightsMiddlewares));
        var _getAppIdAndApiKey = (0, $e017fe0f86217dc1$export$58f35ab8a1251bc0)(instantSearchInstance.client), _getAppIdAndApiKey2 = $ef593e4916349da0$var$_slicedToArray(_getAppIdAndApiKey, 2), appId = _getAppIdAndApiKey2[0], apiKey = _getAppIdAndApiKey2[1];
        var queuedInitParams = undefined;
        var queuedUserToken = undefined;
        var userTokenBeforeInit = undefined;
        var queue = insightsClient.queue;
        if (Array.isArray(queue)) {
            // Context: The umd build of search-insights is asynchronously loaded by the snippet.
            //
            // When user calls `aa('setUserToken', 'my-user-token')` before `search-insights` is loaded,
            // ['setUserToken', 'my-user-token'] gets stored in `aa.queue`.
            // Whenever `search-insights` is finally loaded, it will process the queue.
            //
            // But here's the reason why we handle it here:
            // At this point, even though `search-insights` is not loaded yet,
            // we still want to read the token from the queue.
            // Otherwise, the first search call will be fired without the token.
            var _map = [
                "setUserToken",
                "init"
            ].map(function(key) {
                var _ref3 = (0, $3a145725faa3321d$export$71aa6c912b956294)(queue.slice().reverse(), function(_ref5) {
                    var _ref6 = $ef593e4916349da0$var$_slicedToArray(_ref5, 1), method = _ref6[0];
                    return method === key;
                }) || [], _ref4 = $ef593e4916349da0$var$_slicedToArray(_ref3, 2), value = _ref4[1];
                return value;
            });
            var _map2 = $ef593e4916349da0$var$_slicedToArray(_map, 2);
            queuedUserToken = _map2[0];
            queuedInitParams = _map2[1];
        }
        // If user called `aa('setUserToken')` before creating the Insights middleware,
        // we temporarily store the token and set it later on.
        //
        // Otherwise, the `init` call might override them with anonymous user token.
        insightsClient("getUserToken", null, function(_error, userToken) {
            userTokenBeforeInit = $ef593e4916349da0$var$normalizeUserToken(userToken);
        });
        // Only `init` if the `insightsInitParams` option is passed or
        // if the `insightsClient` version doesn't supports optional `init` calling.
        if (insightsInitParams || !$ef593e4916349da0$var$isModernInsightsClient(insightsClient)) insightsClient("init", $ef593e4916349da0$var$_objectSpread({
            appId: appId,
            apiKey: apiKey,
            partial: true
        }, insightsInitParams));
        var initialParameters;
        var helper;
        return {
            $$type: "ais.insights",
            $$internal: $$internal,
            $$automatic: $$automatic,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                if (!insightsClient.shouldAddScript) return;
                var errorMessage = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
                try {
                    var script = document.createElement("script");
                    script.async = true;
                    script.src = $ef593e4916349da0$var$ALGOLIA_INSIGHTS_SRC;
                    script.onerror = function() {
                        instantSearchInstance.emit("error", new Error(errorMessage));
                    };
                    document.body.appendChild(script);
                    insightsClient.shouldAddScript = false;
                } catch (cause) {
                    insightsClient.shouldAddScript = false;
                    instantSearchInstance.emit("error", new Error(errorMessage));
                }
            },
            started: function started() {
                insightsClient("addAlgoliaAgent", "insights-middleware");
                helper = instantSearchInstance.mainHelper;
                var queueAtStart = insightsClient.queue;
                if (Array.isArray(queueAtStart)) {
                    var _map3 = [
                        "setUserToken",
                        "init"
                    ].map(function(key) {
                        var _ref7 = (0, $3a145725faa3321d$export$71aa6c912b956294)(queueAtStart.slice().reverse(), function(_ref9) {
                            var _ref10 = $ef593e4916349da0$var$_slicedToArray(_ref9, 1), method = _ref10[0];
                            return method === key;
                        }) || [], _ref8 = $ef593e4916349da0$var$_slicedToArray(_ref7, 2), value = _ref8[1];
                        return value;
                    });
                    var _map4 = $ef593e4916349da0$var$_slicedToArray(_map3, 2);
                    queuedUserToken = _map4[0];
                    queuedInitParams = _map4[1];
                }
                initialParameters = $ef593e4916349da0$var$getInitialParameters(instantSearchInstance);
                // We don't want to force clickAnalytics when the insights is enabled from the search response.
                // This means we don't enable insights for indices that don't opt in
                if (!$$automatic) helper.overrideStateWithoutTriggeringChangeEvent($ef593e4916349da0$var$_objectSpread($ef593e4916349da0$var$_objectSpread({}, helper.state), {}, {
                    clickAnalytics: true
                }));
                if (!$$internal) instantSearchInstance.scheduleSearch();
                var setUserTokenToSearch = function setUserTokenToSearch(userToken) {
                    var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var normalizedUserToken = $ef593e4916349da0$var$normalizeUserToken(userToken);
                    if (!normalizedUserToken) return;
                    var existingToken = helper.state.userToken;
                    function applyToken() {
                        helper.overrideStateWithoutTriggeringChangeEvent($ef593e4916349da0$var$_objectSpread($ef593e4916349da0$var$_objectSpread({}, helper.state), {}, {
                            userToken: normalizedUserToken
                        }));
                        if (existingToken && existingToken !== userToken) instantSearchInstance.scheduleSearch();
                    }
                    // Delay the token application to the next render cycle
                    if (!immediate) setTimeout(applyToken, 0);
                    else applyToken();
                };
                function setUserToken(token) {
                    setUserTokenToSearch(token, true);
                    insightsClient("setUserToken", token);
                }
                var anonymousUserToken = undefined;
                var anonymousTokenFromInsights = (0, $48acce04fdc682d2$export$61f1c6e9cd2ed687)();
                if (anonymousTokenFromInsights) // When `aa('init', { ... })` is called, it creates an anonymous user token in cookie.
                // We can set it as userToken on instantsearch and insights. If it's not set as an insights
                // userToken before a sendEvent, insights automatically generates a new anonymous token,
                // causing a state change and an unnecessary query on instantsearch.
                anonymousUserToken = anonymousTokenFromInsights;
                else {
                    var token = "anonymous-".concat((0, $96e77c48f8f7b2e8$export$5dbf9a24b655dde4)());
                    anonymousUserToken = token;
                }
                var userTokenFromInit;
                // With SSR, the token could be be set on the state. We make sure
                // that insights is in sync with that token since, there is no
                // insights lib on the server.
                var tokenFromSearchParameters = initialParameters.userToken;
                // When the first query is sent, the token is possibly not yet set by
                // the insights onChange callbacks (if insights isn't yet loaded).
                // It is explicitly being set here so that the first query has the
                // initial tokens set and ensure a second query isn't automatically
                // made when the onChange callback actually changes the state.
                if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.userToken) userTokenFromInit = insightsInitParams.userToken;
                if (userTokenFromInit) setUserToken(userTokenFromInit);
                else if (tokenFromSearchParameters) setUserToken(tokenFromSearchParameters);
                else if (userTokenBeforeInit) setUserToken(userTokenBeforeInit);
                else if (queuedUserToken) setUserToken(queuedUserToken);
                else if (anonymousUserToken) {
                    var _queuedInitParams;
                    setUserToken(anonymousUserToken);
                    if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.useCookie || (_queuedInitParams = queuedInitParams) !== null && _queuedInitParams !== void 0 && _queuedInitParams.useCookie) {
                        var _queuedInitParams2;
                        $ef593e4916349da0$var$saveTokenAsCookie(anonymousUserToken, (insightsInitParams === null || insightsInitParams === void 0 ? void 0 : insightsInitParams.cookieDuration) || ((_queuedInitParams2 = queuedInitParams) === null || _queuedInitParams2 === void 0 ? void 0 : _queuedInitParams2.cookieDuration));
                    }
                }
                // This updates userToken which is set explicitly by `aa('setUserToken', userToken)`
                insightsClient("onUserTokenChange", function(token) {
                    return setUserTokenToSearch(token, true);
                }, {
                    immediate: true
                });
                var insightsClientWithLocalCredentials = insightsClient;
                if ($ef593e4916349da0$var$isModernInsightsClient(insightsClient)) insightsClientWithLocalCredentials = function insightsClientWithLocalCredentials(method, payload) {
                    var extraParams = {
                        headers: {
                            "X-Algolia-Application-Id": appId,
                            "X-Algolia-API-Key": apiKey
                        }
                    };
                    // @ts-ignore we are calling this only when we know that the client actually is correct
                    return insightsClient(method, payload, extraParams);
                };
                var viewedObjectIDs = new Set();
                var lastQueryId;
                instantSearchInstance.mainHelper.derivedHelpers[0].on("result", function(_ref11) {
                    var results = _ref11.results;
                    if (results && (!results.queryID || results.queryID !== lastQueryId)) {
                        lastQueryId = results.queryID;
                        viewedObjectIDs.clear();
                    }
                });
                instantSearchInstance.sendEventToInsights = function(event) {
                    if (onEvent) onEvent(event, insightsClientWithLocalCredentials);
                    else if (event.insightsMethod) {
                        if (event.insightsMethod === "viewedObjectIDs") {
                            var _payload = event.payload;
                            var difference = _payload.objectIDs.filter(function(objectID) {
                                return !viewedObjectIDs.has(objectID);
                            });
                            if (difference.length === 0) return;
                            difference.forEach(function(objectID) {
                                return viewedObjectIDs.add(objectID);
                            });
                            _payload.objectIDs = difference;
                        }
                        // Source is used to differentiate events sent by instantsearch from those sent manually.
                        event.payload.algoliaSource = [
                            "instantsearch"
                        ];
                        if ($$automatic) event.payload.algoliaSource.push("instantsearch-automatic");
                        if (event.eventModifier === "internal") event.payload.algoliaSource.push("instantsearch-internal");
                        insightsClientWithLocalCredentials(event.insightsMethod, event.payload);
                    }
                };
            },
            unsubscribe: function unsubscribe() {
                insightsClient("onUserTokenChange", undefined);
                instantSearchInstance.sendEventToInsights = (0, $8fe091dcd40a4798$export$8793edee2d425525);
                if (helper && initialParameters) {
                    helper.overrideStateWithoutTriggeringChangeEvent($ef593e4916349da0$var$_objectSpread($ef593e4916349da0$var$_objectSpread({}, helper.state), initialParameters));
                    instantSearchInstance.scheduleSearch();
                }
            }
        };
    };
}
function $ef593e4916349da0$var$getInitialParameters(instantSearchInstance) {
    var _instantSearchInstanc, _instantSearchInstanc2;
    // in SSR, the initial state we use in this domain is set on the main index
    var stateFromInitialResults = ((_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : (_instantSearchInstanc2 = _instantSearchInstanc[instantSearchInstance.indexName]) === null || _instantSearchInstanc2 === void 0 ? void 0 : _instantSearchInstanc2.state) || {};
    var stateFromHelper = instantSearchInstance.mainHelper.state;
    return {
        userToken: stateFromInitialResults.userToken || stateFromHelper.userToken,
        clickAnalytics: stateFromInitialResults.clickAnalytics || stateFromHelper.clickAnalytics
    };
}
function $ef593e4916349da0$var$saveTokenAsCookie(token, cookieDuration) {
    var MONTH = 2592000000;
    var d = new Date();
    d.setTime(d.getTime() + (cookieDuration || MONTH * 6));
    var expires = "expires=".concat(d.toUTCString());
    document.cookie = "_ALGOLIA=".concat(token, ";").concat(expires, ";path=/");
}
/**
 * Determines if a given insights `client` supports the optional call to `init`
 * and the ability to set credentials via extra parameters when sending events.
 */ function $ef593e4916349da0$var$isModernInsightsClient(client) {
    var _split$map = (client.version || "").split(".").map(Number), _split$map2 = $ef593e4916349da0$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/naming-convention */ var v3 = major >= 3;
    var v2_6 = major === 2 && minor >= 6;
    var v1_10 = major === 1 && minor >= 10;
    /* eslint-enable @typescript-eslint/naming-convention */ return v3 || v2_6 || v1_10;
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $ef593e4916349da0$var$normalizeUserToken(userToken) {
    if (!userToken) return undefined;
    return typeof userToken === "number" ? userToken.toString() : userToken;
}


function $a4ab2cc197ff2f9a$export$dbf1227de6c1fbc6(instantSearchInstance, parent, uiState) {
    var helper = parent.getHelper();
    return {
        uiState: uiState,
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        state: helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        scopedResults: [],
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}
function $a4ab2cc197ff2f9a$export$c3ba97e79c76dd38(instantSearchInstance, parent, widget) {
    var results = parent.getResultsForWidget(widget);
    var helper = parent.getHelper();
    return {
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        results: results,
        scopedResults: parent.getScopedResults(),
        state: results && "_state" in results ? results._state : helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}


function $81e7405c0b8d0125$var$extractWidgetPayload(widgets, instantSearchInstance, payload) {
    var initOptions = (0, $a4ab2cc197ff2f9a$export$dbf1227de6c1fbc6)(instantSearchInstance, instantSearchInstance.mainIndex, instantSearchInstance._initialUiState);
    widgets.forEach(function(widget) {
        var widgetParams = {};
        if (widget.getWidgetRenderState) {
            var renderState = widget.getWidgetRenderState(initOptions);
            if (renderState && renderState.widgetParams) // casting, as we just earlier checked widgetParams exists, and thus an object
            widgetParams = renderState.widgetParams;
        }
        // since we destructure in all widgets, the parameters with defaults are set to "undefined"
        var params = Object.keys(widgetParams).filter(function(key) {
            return widgetParams[key] !== undefined;
        });
        payload.widgets.push({
            type: widget.$$type,
            widgetType: widget.$$widgetType,
            params: params
        });
        if (widget.$$type === "ais.index") $81e7405c0b8d0125$var$extractWidgetPayload(widget.getWidgets(), instantSearchInstance, payload);
    });
}
function $81e7405c0b8d0125$export$4b4254890acf93e7() {
    return (0, $7ba35a00e1b6937e$export$39f19eed34acd2f1)(function(_ref) {
        var _window$navigator, _window$navigator$use;
        var window = _ref.window;
        return ((_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.indexOf("Algolia Crawler")) > -1;
    }, {
        fallback: function fallback() {
            return false;
        }
    });
}
function $81e7405c0b8d0125$export$8ee9d2447935ed96() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$$$internal = _ref2.$$internal, $$internal = _ref2$$$internal === void 0 ? false : _ref2$$$internal;
    return function(_ref3) {
        var instantSearchInstance = _ref3.instantSearchInstance;
        var payload = {
            widgets: []
        };
        var payloadContainer = document.createElement("meta");
        var refNode = document.querySelector("head");
        payloadContainer.name = "instantsearch:widgets";
        return {
            $$type: "ais.metadata",
            $$internal: $$internal,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                // using setTimeout here to delay extraction until widgets have been added in a tick (e.g. Vue)
                setTimeout(function() {
                    var client = instantSearchInstance.client;
                    payload.ua = client.transporter && client.transporter.userAgent ? client.transporter.userAgent.value : client._ua;
                    $81e7405c0b8d0125$var$extractWidgetPayload(instantSearchInstance.mainIndex.getWidgets(), instantSearchInstance, payload);
                    instantSearchInstance.middleware.forEach(function(middleware) {
                        return payload.widgets.push({
                            middleware: true,
                            type: middleware.instance.$$type,
                            internal: middleware.instance.$$internal
                        });
                    });
                    payloadContainer.content = JSON.stringify(payload);
                    refNode.appendChild(payloadContainer);
                }, 0);
            },
            started: function started() {},
            unsubscribe: function unsubscribe() {
                payloadContainer.remove();
            }
        };
    };
}


var $106919725d4b1c2f$exports = {};
"use strict";
var $3950a8d75f202598$exports = {};
"use strict";
var $ff42011a37ee1cce$exports = {};
"use strict";
var $6a0ba6a1159254b6$exports = {};
"use strict";
var $6a0ba6a1159254b6$var$replace = String.prototype.replace;
var $6a0ba6a1159254b6$var$percentTwenties = /%20/g;
var $6a0ba6a1159254b6$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$6a0ba6a1159254b6$exports = {
    "default": $6a0ba6a1159254b6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $6a0ba6a1159254b6$var$replace.call(value, $6a0ba6a1159254b6$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $6a0ba6a1159254b6$var$Format.RFC1738,
    RFC3986: $6a0ba6a1159254b6$var$Format.RFC3986
};


var $ff42011a37ee1cce$var$has = Object.prototype.hasOwnProperty;
var $ff42011a37ee1cce$var$isArray = Array.isArray;
var $ff42011a37ee1cce$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $ff42011a37ee1cce$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($ff42011a37ee1cce$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $ff42011a37ee1cce$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $ff42011a37ee1cce$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($ff42011a37ee1cce$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$ff42011a37ee1cce$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($ff42011a37ee1cce$var$isArray(target) && !$ff42011a37ee1cce$var$isArray(source)) mergeTarget = $ff42011a37ee1cce$var$arrayToObject(target, options);
    if ($ff42011a37ee1cce$var$isArray(target) && $ff42011a37ee1cce$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($ff42011a37ee1cce$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($ff42011a37ee1cce$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $ff42011a37ee1cce$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $ff42011a37ee1cce$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $ff42011a37ee1cce$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $6a0ba6a1159254b6$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $ff42011a37ee1cce$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($ff42011a37ee1cce$var$hexTable[0xC0 | c >> 6] + $ff42011a37ee1cce$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($ff42011a37ee1cce$var$hexTable[0xE0 | c >> 12] + $ff42011a37ee1cce$var$hexTable[0x80 | c >> 6 & 0x3F] + $ff42011a37ee1cce$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $ff42011a37ee1cce$var$hexTable[0xF0 | c >> 18] + $ff42011a37ee1cce$var$hexTable[0x80 | c >> 12 & 0x3F] + $ff42011a37ee1cce$var$hexTable[0x80 | c >> 6 & 0x3F] + $ff42011a37ee1cce$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $ff42011a37ee1cce$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $ff42011a37ee1cce$var$compactQueue(queue);
    return value;
};
var $ff42011a37ee1cce$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $ff42011a37ee1cce$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $ff42011a37ee1cce$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $ff42011a37ee1cce$var$maybeMap = function maybeMap(val, fn) {
    if ($ff42011a37ee1cce$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$ff42011a37ee1cce$exports = {
    arrayToObject: $ff42011a37ee1cce$var$arrayToObject,
    assign: $ff42011a37ee1cce$var$assign,
    combine: $ff42011a37ee1cce$var$combine,
    compact: $ff42011a37ee1cce$var$compact,
    decode: $ff42011a37ee1cce$var$decode,
    encode: $ff42011a37ee1cce$var$encode,
    isBuffer: $ff42011a37ee1cce$var$isBuffer,
    isRegExp: $ff42011a37ee1cce$var$isRegExp,
    maybeMap: $ff42011a37ee1cce$var$maybeMap,
    merge: $ff42011a37ee1cce$var$merge
};



var $3950a8d75f202598$var$has = Object.prototype.hasOwnProperty;
var $3950a8d75f202598$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $3950a8d75f202598$var$isArray = Array.isArray;
var $3950a8d75f202598$var$split = String.prototype.split;
var $3950a8d75f202598$var$push = Array.prototype.push;
var $3950a8d75f202598$var$pushToArray = function(arr, valueOrArray) {
    $3950a8d75f202598$var$push.apply(arr, $3950a8d75f202598$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $3950a8d75f202598$var$toISO = Date.prototype.toISOString;
var $3950a8d75f202598$var$defaultFormat = $6a0ba6a1159254b6$exports.default;
var $3950a8d75f202598$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $ff42011a37ee1cce$exports.encode,
    encodeValuesOnly: false,
    format: $3950a8d75f202598$var$defaultFormat,
    formatter: $6a0ba6a1159254b6$exports.formatters[$3950a8d75f202598$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $3950a8d75f202598$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $3950a8d75f202598$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $3950a8d75f202598$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset) {
    var obj = object;
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $3950a8d75f202598$var$isArray(obj)) obj = $ff42011a37ee1cce$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $3950a8d75f202598$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($3950a8d75f202598$var$isNonNullishPrimitive(obj) || $ff42011a37ee1cce$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $3950a8d75f202598$var$defaults.encoder, charset, "key", format);
            if (generateArrayPrefix === "comma" && encodeValuesOnly) {
                var valuesArray = $3950a8d75f202598$var$split.call(String(obj), ",");
                var valuesJoined = "";
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], $3950a8d75f202598$var$defaults.encoder, charset, "value", format));
                return [
                    formatter(keyValue) + "=" + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $3950a8d75f202598$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $3950a8d75f202598$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if ($3950a8d75f202598$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $3950a8d75f202598$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
        $3950a8d75f202598$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset));
    }
    return values;
};
var $3950a8d75f202598$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $3950a8d75f202598$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $3950a8d75f202598$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $6a0ba6a1159254b6$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$3950a8d75f202598$var$has.call($6a0ba6a1159254b6$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $6a0ba6a1159254b6$exports.formatters[format];
    var filter = $3950a8d75f202598$var$defaults.filter;
    if (typeof opts.filter === "function" || $3950a8d75f202598$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $3950a8d75f202598$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $3950a8d75f202598$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $3950a8d75f202598$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $3950a8d75f202598$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $3950a8d75f202598$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $3950a8d75f202598$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $3950a8d75f202598$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $3950a8d75f202598$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $3950a8d75f202598$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $3950a8d75f202598$var$defaults.strictNullHandling
    };
};
$3950a8d75f202598$exports = function(object, opts) {
    var obj = object;
    var options = $3950a8d75f202598$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($3950a8d75f202598$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $3950a8d75f202598$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $3950a8d75f202598$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $3950a8d75f202598$var$pushToArray(keys, $3950a8d75f202598$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $7edd08c1ac78ff3f$exports = {};
"use strict";

var $7edd08c1ac78ff3f$var$has = Object.prototype.hasOwnProperty;
var $7edd08c1ac78ff3f$var$isArray = Array.isArray;
var $7edd08c1ac78ff3f$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $ff42011a37ee1cce$exports.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $7edd08c1ac78ff3f$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $7edd08c1ac78ff3f$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $7edd08c1ac78ff3f$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $7edd08c1ac78ff3f$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $7edd08c1ac78ff3f$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $7edd08c1ac78ff3f$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $7edd08c1ac78ff3f$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $7edd08c1ac78ff3f$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $7edd08c1ac78ff3f$var$defaults.decoder, charset, "key");
            val = $ff42011a37ee1cce$exports.maybeMap($7edd08c1ac78ff3f$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $7edd08c1ac78ff3f$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $7edd08c1ac78ff3f$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $7edd08c1ac78ff3f$var$isArray(val) ? [
            val
        ] : val;
        if ($7edd08c1ac78ff3f$var$has.call(obj, key)) obj[key] = $ff42011a37ee1cce$exports.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $7edd08c1ac78ff3f$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $7edd08c1ac78ff3f$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $7edd08c1ac78ff3f$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $7edd08c1ac78ff3f$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $7edd08c1ac78ff3f$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $7edd08c1ac78ff3f$var$parseObject(keys, val, options, valuesParsed);
};
var $7edd08c1ac78ff3f$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $7edd08c1ac78ff3f$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $7edd08c1ac78ff3f$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $7edd08c1ac78ff3f$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $7edd08c1ac78ff3f$var$defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $7edd08c1ac78ff3f$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $7edd08c1ac78ff3f$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $7edd08c1ac78ff3f$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $7edd08c1ac78ff3f$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $ff42011a37ee1cce$exports.isRegExp(opts.delimiter) ? opts.delimiter : $7edd08c1ac78ff3f$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $7edd08c1ac78ff3f$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $7edd08c1ac78ff3f$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $7edd08c1ac78ff3f$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $7edd08c1ac78ff3f$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $7edd08c1ac78ff3f$var$defaults.strictNullHandling
    };
};
$7edd08c1ac78ff3f$exports = function(str, opts) {
    var options = $7edd08c1ac78ff3f$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $7edd08c1ac78ff3f$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $7edd08c1ac78ff3f$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $ff42011a37ee1cce$exports.merge(obj, newObj, options);
    }
    return $ff42011a37ee1cce$exports.compact(obj);
};



$106919725d4b1c2f$exports = {
    formats: $6a0ba6a1159254b6$exports,
    parse: $7edd08c1ac78ff3f$exports,
    stringify: $3950a8d75f202598$exports
};



function $6b158fab41365317$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6b158fab41365317$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6b158fab41365317$var$_typeof(o);
}
function $6b158fab41365317$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6b158fab41365317$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6b158fab41365317$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6b158fab41365317$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6b158fab41365317$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6b158fab41365317$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6b158fab41365317$var$_defineProperty(obj, key, value) {
    key = $6b158fab41365317$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6b158fab41365317$var$_toPropertyKey(t) {
    var i = $6b158fab41365317$var$_toPrimitive(t, "string");
    return "symbol" == $6b158fab41365317$var$_typeof(i) ? i : String(i);
}
function $6b158fab41365317$var$_toPrimitive(t, r) {
    if ("object" != $6b158fab41365317$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6b158fab41365317$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6b158fab41365317$var$setWindowTitle = function setWindowTitle(title) {
    if (title) // This function is only executed on browsers so we can disable this check.
    // eslint-disable-next-line no-restricted-globals
    window.document.title = title;
};
var $6b158fab41365317$var$BrowserHistory = /*#__PURE__*/ function() {
    /**
   * Initializes a new storage provider that syncs the search state to the URL
   * using web APIs (`window.location.pushState` and `onpopstate` event).
   */ function BrowserHistory(_ref) {
        var _this = this;
        var windowTitle = _ref.windowTitle, _ref$writeDelay = _ref.writeDelay, writeDelay = _ref$writeDelay === void 0 ? 400 : _ref$writeDelay, createURL = _ref.createURL, parseURL = _ref.parseURL, getLocation = _ref.getLocation, start = _ref.start, dispose = _ref.dispose, push = _ref.push, cleanUrlOnDispose = _ref.cleanUrlOnDispose;
        $6b158fab41365317$var$_classCallCheck(this, BrowserHistory);
        $6b158fab41365317$var$_defineProperty(this, "$$type", "ais.browser");
        /**
     * Transforms a UI state into a title for the page.
     */ $6b158fab41365317$var$_defineProperty(this, "windowTitle", void 0);
        /**
     * Time in milliseconds before performing a write in the history.
     * It prevents from adding too many entries in the history and
     * makes the back button more usable.
     *
     * @default 400
     */ $6b158fab41365317$var$_defineProperty(this, "writeDelay", void 0);
        /**
     * Creates a full URL based on the route state.
     * The storage adaptor maps all syncable keys to the query string of the URL.
     */ $6b158fab41365317$var$_defineProperty(this, "_createURL", void 0);
        /**
     * Parses the URL into a route state.
     * It should be symmetrical to `createURL`.
     */ $6b158fab41365317$var$_defineProperty(this, "parseURL", void 0);
        /**
     * Returns the location to store in the history.
     * @default () => window.location
     */ $6b158fab41365317$var$_defineProperty(this, "getLocation", void 0);
        $6b158fab41365317$var$_defineProperty(this, "writeTimer", void 0);
        $6b158fab41365317$var$_defineProperty(this, "_onPopState", void 0);
        /**
     * Indicates if last action was back/forward in the browser.
     */ $6b158fab41365317$var$_defineProperty(this, "inPopState", false);
        /**
     * Indicates whether the history router is disposed or not.
     */ $6b158fab41365317$var$_defineProperty(this, "isDisposed", false);
        /**
     * Indicates the window.history.length before the last call to
     * window.history.pushState (called in `write`).
     * It allows to determine if a `pushState` has been triggered elsewhere,
     * and thus to prevent the `write` method from calling `pushState`.
     */ $6b158fab41365317$var$_defineProperty(this, "latestAcknowledgedHistory", 0);
        $6b158fab41365317$var$_defineProperty(this, "_start", void 0);
        $6b158fab41365317$var$_defineProperty(this, "_dispose", void 0);
        $6b158fab41365317$var$_defineProperty(this, "_push", void 0);
        $6b158fab41365317$var$_defineProperty(this, "_cleanUrlOnDispose", void 0);
        this.windowTitle = windowTitle;
        this.writeTimer = undefined;
        this.writeDelay = writeDelay;
        this._createURL = createURL;
        this.parseURL = parseURL;
        this.getLocation = getLocation;
        this._start = start;
        this._dispose = dispose;
        this._push = push;
        this._cleanUrlOnDispose = typeof cleanUrlOnDispose === "undefined" ? true : cleanUrlOnDispose;
        (0, $7ba35a00e1b6937e$export$39f19eed34acd2f1)(function(_ref2) {
            var window1 = _ref2.window;
            var title = _this.windowTitle && _this.windowTitle(_this.read());
            $6b158fab41365317$var$setWindowTitle(title);
            _this.latestAcknowledgedHistory = window1.history.length;
        });
    }
    /**
   * Reads the URL and returns a syncable UI search state.
   */ $6b158fab41365317$var$_createClass(BrowserHistory, [
        {
            key: "read",
            value: function read() {
                return this.parseURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($106919725d4b1c2f$exports))),
                    location: this.getLocation()
                });
            }
        },
        {
            key: "write",
            value: function write(routeState) {
                var _this2 = this;
                (0, $7ba35a00e1b6937e$export$39f19eed34acd2f1)(function(_ref3) {
                    var window1 = _ref3.window;
                    var url = _this2.createURL(routeState);
                    var title = _this2.windowTitle && _this2.windowTitle(routeState);
                    if (_this2.writeTimer) clearTimeout(_this2.writeTimer);
                    _this2.writeTimer = setTimeout(function() {
                        $6b158fab41365317$var$setWindowTitle(title);
                        if (_this2.shouldWrite(url)) {
                            if (_this2._push) _this2._push(url);
                            else window1.history.pushState(routeState, title || "", url);
                            _this2.latestAcknowledgedHistory = window1.history.length;
                        }
                        _this2.inPopState = false;
                        _this2.writeTimer = undefined;
                    }, _this2.writeDelay);
                });
            }
        },
        {
            key: "onUpdate",
            value: function onUpdate(callback) {
                var _this3 = this;
                if (this._start) this._start(function() {
                    callback(_this3.read());
                });
                this._onPopState = function() {
                    if (_this3.writeTimer) {
                        clearTimeout(_this3.writeTimer);
                        _this3.writeTimer = undefined;
                    }
                    _this3.inPopState = true;
                    // We always read the state from the URL because the state of the history
                    // can be incorect in some cases (e.g. using React Router).
                    callback(_this3.read());
                };
                (0, $7ba35a00e1b6937e$export$39f19eed34acd2f1)(function(_ref4) {
                    var window1 = _ref4.window;
                    window1.addEventListener("popstate", _this3._onPopState);
                });
            }
        },
        {
            key: "createURL",
            value: function createURL(routeState) {
                var url = this._createURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($106919725d4b1c2f$exports))),
                    routeState: routeState,
                    location: this.getLocation()
                });
                var e;
                return url;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this4 = this;
                if (this._dispose) this._dispose();
                this.isDisposed = true;
                (0, $7ba35a00e1b6937e$export$39f19eed34acd2f1)(function(_ref5) {
                    var window1 = _ref5.window;
                    if (_this4._onPopState) window1.removeEventListener("popstate", _this4._onPopState);
                });
                if (this.writeTimer) clearTimeout(this.writeTimer);
                if (this._cleanUrlOnDispose) this.write({});
            }
        },
        {
            key: "start",
            value: function start() {
                this.isDisposed = false;
            }
        },
        {
            key: "shouldWrite",
            value: function shouldWrite(url) {
                var _this5 = this;
                return (0, $7ba35a00e1b6937e$export$39f19eed34acd2f1)(function(_ref6) {
                    var window1 = _ref6.window;
                    // When disposed and the cleanUrlOnDispose is set to false, we do not want to write the URL.
                    if (_this5.isDisposed && !_this5._cleanUrlOnDispose) return false;
                    // We do want to `pushState` if:
                    // - the router is not disposed, IS.js needs to update the URL
                    // OR
                    // - the last write was from InstantSearch.js
                    // (unlike a SPA, where it would have last written)
                    var lastPushWasByISAfterDispose = !(_this5.isDisposed && _this5.latestAcknowledgedHistory !== window1.history.length);
                    return(// When the last state change was through popstate, the IS.js state changes,
                    // but that should not write the URL.
                    !_this5.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
                    lastPushWasByISAfterDispose && // When the URL is the same as the current one, we do not want to write it.
                    url !== window1.location.href);
                });
            }
        }
    ]);
    return BrowserHistory;
}();
function $6b158fab41365317$export$2e2bcd8739ae039() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$createURL = _ref7.createURL, createURL = _ref7$createURL === void 0 ? function(_ref8) {
        var qsModule = _ref8.qsModule, routeState = _ref8.routeState, location = _ref8.location;
        var protocol = location.protocol, hostname = location.hostname, _location$port = location.port, port = _location$port === void 0 ? "" : _location$port, pathname = location.pathname, hash = location.hash;
        var queryString = qsModule.stringify(routeState);
        var portWithPrefix = port === "" ? "" : ":".concat(port);
        // IE <= 11 has no proper `location.origin` so we cannot rely on it.
        if (!queryString) return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname).concat(hash);
        return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "?").concat(queryString).concat(hash);
    } : _ref7$createURL, _ref7$parseURL = _ref7.parseURL, parseURL = _ref7$parseURL === void 0 ? function(_ref9) {
        var qsModule = _ref9.qsModule, location = _ref9.location;
        // `qs` by default converts arrays with more than 20 items to an object.
        // We want to avoid this because the data structure manipulated can therefore vary.
        // Setting the limit to `100` seems a good number because the engine's default is 100
        // (it can go up to 1000 but it is very unlikely to select more than 100 items in the UI).
        //
        // Using an `arrayLimit` of `n` allows `n + 1` items.
        //
        // See:
        //   - https://github.com/ljharb/qs#parsing-arrays
        //   - https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/
        return qsModule.parse(location.search.slice(1), {
            arrayLimit: 99
        });
    } : _ref7$parseURL, _ref7$writeDelay = _ref7.writeDelay, writeDelay = _ref7$writeDelay === void 0 ? 400 : _ref7$writeDelay, windowTitle = _ref7.windowTitle, _ref7$getLocation = _ref7.getLocation, getLocation = _ref7$getLocation === void 0 ? function() {
        return (0, $7ba35a00e1b6937e$export$39f19eed34acd2f1)(function(_ref10) {
            var window1 = _ref10.window;
            return window1.location;
        }, {
            fallback: function fallback() {
                throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
            }
        });
    } : _ref7$getLocation, start = _ref7.start, dispose = _ref7.dispose, push = _ref7.push, cleanUrlOnDispose = _ref7.cleanUrlOnDispose;
    return new $6b158fab41365317$var$BrowserHistory({
        createURL: createURL,
        parseURL: parseURL,
        writeDelay: writeDelay,
        windowTitle: windowTitle,
        getLocation: getLocation,
        start: start,
        dispose: dispose,
        push: push,
        cleanUrlOnDispose: cleanUrlOnDispose
    });
}


function $415e713e4a549ddc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $415e713e4a549ddc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $415e713e4a549ddc$var$_typeof(o);
}
var $415e713e4a549ddc$var$_excluded = [
    "configure"
];
function $415e713e4a549ddc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $415e713e4a549ddc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $415e713e4a549ddc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $415e713e4a549ddc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $415e713e4a549ddc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $415e713e4a549ddc$var$_defineProperty(obj, key, value) {
    key = $415e713e4a549ddc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $415e713e4a549ddc$var$_toPropertyKey(t) {
    var i = $415e713e4a549ddc$var$_toPrimitive(t, "string");
    return "symbol" == $415e713e4a549ddc$var$_typeof(i) ? i : String(i);
}
function $415e713e4a549ddc$var$_toPrimitive(t, r) {
    if ("object" != $415e713e4a549ddc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $415e713e4a549ddc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $415e713e4a549ddc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $415e713e4a549ddc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $415e713e4a549ddc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $415e713e4a549ddc$var$getIndexStateWithoutConfigure(uiState) {
    var configure = uiState.configure, trackedUiState = $415e713e4a549ddc$var$_objectWithoutProperties(uiState, $415e713e4a549ddc$var$_excluded);
    return trackedUiState;
}
function $415e713e4a549ddc$export$2e2bcd8739ae039() {
    return {
        $$type: "ais.simple",
        stateToRoute: function stateToRoute(uiState) {
            return Object.keys(uiState).reduce(function(state, indexId) {
                return $415e713e4a549ddc$var$_objectSpread($415e713e4a549ddc$var$_objectSpread({}, state), {}, $415e713e4a549ddc$var$_defineProperty({}, indexId, $415e713e4a549ddc$var$getIndexStateWithoutConfigure(uiState[indexId])));
            }, {});
        },
        routeToState: function routeToState() {
            var routeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return Object.keys(routeState).reduce(function(state, indexId) {
                return $415e713e4a549ddc$var$_objectSpread($415e713e4a549ddc$var$_objectSpread({}, state), {}, $415e713e4a549ddc$var$_defineProperty({}, indexId, $415e713e4a549ddc$var$getIndexStateWithoutConfigure(routeState[indexId])));
            }, {});
        }
    };
}



function $59e02f3065a5727d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $59e02f3065a5727d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $59e02f3065a5727d$var$_typeof(o);
}
function $59e02f3065a5727d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59e02f3065a5727d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59e02f3065a5727d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $59e02f3065a5727d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59e02f3065a5727d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $59e02f3065a5727d$var$_defineProperty(obj, key, value) {
    key = $59e02f3065a5727d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $59e02f3065a5727d$var$_toPropertyKey(t) {
    var i = $59e02f3065a5727d$var$_toPrimitive(t, "string");
    return "symbol" == $59e02f3065a5727d$var$_typeof(i) ? i : String(i);
}
function $59e02f3065a5727d$var$_toPrimitive(t, r) {
    if ("object" != $59e02f3065a5727d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $59e02f3065a5727d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $59e02f3065a5727d$export$1fe5128387816284 = function createRouterMiddleware() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$router = props.router, router = _props$router === void 0 ? (0, $6b158fab41365317$export$2e2bcd8739ae039)() : _props$router, _props$stateMapping = props.stateMapping, stateMapping = _props$stateMapping === void 0 ? (0, $415e713e4a549ddc$export$2e2bcd8739ae039)() : _props$stateMapping, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal;
    return function(_ref) {
        var instantSearchInstance = _ref.instantSearchInstance;
        function topLevelCreateURL(nextState) {
            var previousUiState = // If only the mainIndex is initialized, we don't yet know what other
            // index widgets are used. Therefore we fall back to the initialUiState.
            // We can't indiscriminately use the initialUiState because then we
            // reintroduce state that was changed by the user.
            // When there are no widgets, we are sure the user can't yet have made
            // any changes.
            instantSearchInstance.mainIndex.getWidgets().length === 0 ? instantSearchInstance._initialUiState : instantSearchInstance.mainIndex.getWidgetUiState({});
            var uiState = Object.keys(nextState).reduce(function(acc, indexId) {
                return $59e02f3065a5727d$var$_objectSpread($59e02f3065a5727d$var$_objectSpread({}, acc), {}, $59e02f3065a5727d$var$_defineProperty({}, indexId, nextState[indexId]));
            }, previousUiState);
            var route = stateMapping.stateToRoute(uiState);
            return router.createURL(route);
        }
        // casting to UiState here to keep createURL unaware of custom UiState
        // (as long as it's an object, it's ok)
        instantSearchInstance._createURL = topLevelCreateURL;
        var lastRouteState = undefined;
        var initialUiState = instantSearchInstance._initialUiState;
        return {
            $$type: "ais.router({router:".concat(router.$$type || "__unknown__", ", stateMapping:").concat(stateMapping.$$type || "__unknown__", "})"),
            $$internal: $$internal,
            onStateChange: function onStateChange(_ref2) {
                var uiState = _ref2.uiState;
                var routeState = stateMapping.stateToRoute(uiState);
                if (lastRouteState === undefined || !(0, $33ae9dc431645103$export$248d38f6296296c5)(lastRouteState, routeState)) {
                    router.write(routeState);
                    lastRouteState = routeState;
                }
            },
            subscribe: function subscribe() {
                instantSearchInstance._initialUiState = $59e02f3065a5727d$var$_objectSpread($59e02f3065a5727d$var$_objectSpread({}, initialUiState), stateMapping.routeToState(router.read()));
                router.onUpdate(function(route) {
                    if (instantSearchInstance.mainIndex.getWidgets().length > 0) instantSearchInstance.setUiState(stateMapping.routeToState(route));
                });
            },
            started: function started() {
                var _router$start;
                (_router$start = router.start) === null || _router$start === void 0 || _router$start.call(router);
            },
            unsubscribe: function unsubscribe() {
                router.dispose();
            }
        };
    };
};



function $d9fdb8c21b258358$export$110679b26359d23d(_ref) {
    var name = _ref.name, _ref$connector = _ref.connector, connector = _ref$connector === void 0 ? false : _ref$connector;
    return [
        "https://www.algolia.com/doc/api-reference/widgets/",
        name,
        "/js/",
        connector ? "#connector" : ""
    ].join("");
}
function $d9fdb8c21b258358$export$2fde5bffc340821e() {
    for(var _len = arguments.length, widgets = new Array(_len), _key = 0; _key < _len; _key++)widgets[_key] = arguments[_key];
    var links = widgets.map(function(widget) {
        return $d9fdb8c21b258358$export$110679b26359d23d(widget);
    }).join(", ");
    return function(message) {
        return [
            message,
            "See documentation: ".concat(links)
        ].filter(Boolean).join("\n\n");
    };
}

function $c5421e1e8593cec5$export$a9c9a0d43506297d(widget) {
    return widget.$$type === "ais.index";
}

// We aren't using the native `Array.prototype.findIndex` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `findIndex` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.findIndex` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
function $f956226ab825dd35$export$de3a4d4a0d731119(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
}


function $98a2c07ad87fe2bc$export$f70730c3d1fc524e(array) {
    return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
}


function $fdec58dce645e387$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fdec58dce645e387$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fdec58dce645e387$var$_typeof(o);
}
var $fdec58dce645e387$var$_excluded = [
    "facets",
    "disjunctiveFacets",
    "facetsRefinements",
    "facetsExcludes",
    "disjunctiveFacetsRefinements",
    "numericRefinements",
    "tagRefinements",
    "hierarchicalFacets",
    "hierarchicalFacetsRefinements",
    "ruleContexts"
];
function $fdec58dce645e387$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fdec58dce645e387$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fdec58dce645e387$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fdec58dce645e387$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fdec58dce645e387$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fdec58dce645e387$var$_defineProperty(obj, key, value) {
    key = $fdec58dce645e387$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fdec58dce645e387$var$_toPropertyKey(t) {
    var i = $fdec58dce645e387$var$_toPrimitive(t, "string");
    return "symbol" == $fdec58dce645e387$var$_typeof(i) ? i : String(i);
}
function $fdec58dce645e387$var$_toPrimitive(t, r) {
    if ("object" != $fdec58dce645e387$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fdec58dce645e387$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fdec58dce645e387$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fdec58dce645e387$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fdec58dce645e387$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fdec58dce645e387$var$mergeWithRest = function mergeWithRest(left, right) {
    var facets = right.facets, disjunctiveFacets = right.disjunctiveFacets, facetsRefinements = right.facetsRefinements, facetsExcludes = right.facetsExcludes, disjunctiveFacetsRefinements = right.disjunctiveFacetsRefinements, numericRefinements = right.numericRefinements, tagRefinements = right.tagRefinements, hierarchicalFacets = right.hierarchicalFacets, hierarchicalFacetsRefinements = right.hierarchicalFacetsRefinements, ruleContexts = right.ruleContexts, rest = $fdec58dce645e387$var$_objectWithoutProperties(right, $fdec58dce645e387$var$_excluded);
    return left.setQueryParameters(rest);
};
// Merge facets
var $fdec58dce645e387$var$mergeFacets = function mergeFacets(left, right) {
    return right.facets.reduce(function(_, name) {
        return _.addFacet(name);
    }, left);
};
var $fdec58dce645e387$var$mergeDisjunctiveFacets = function mergeDisjunctiveFacets(left, right) {
    return right.disjunctiveFacets.reduce(function(_, name) {
        return _.addDisjunctiveFacet(name);
    }, left);
};
var $fdec58dce645e387$var$mergeHierarchicalFacets = function mergeHierarchicalFacets(left, right) {
    return left.setQueryParameters({
        hierarchicalFacets: right.hierarchicalFacets.reduce(function(facets, facet) {
            var index = (0, $f956226ab825dd35$export$de3a4d4a0d731119)(facets, function(_) {
                return _.name === facet.name;
            });
            if (index === -1) return facets.concat(facet);
            var nextFacets = facets.slice();
            nextFacets.splice(index, 1, facet);
            return nextFacets;
        }, left.hierarchicalFacets)
    });
};
// Merge facet refinements
var $fdec58dce645e387$var$mergeTagRefinements = function mergeTagRefinements(left, right) {
    return right.tagRefinements.reduce(function(_, value) {
        return _.addTagRefinement(value);
    }, left);
};
var $fdec58dce645e387$var$mergeFacetRefinements = function mergeFacetRefinements(left, right) {
    return left.setQueryParameters({
        facetsRefinements: $fdec58dce645e387$var$_objectSpread($fdec58dce645e387$var$_objectSpread({}, left.facetsRefinements), right.facetsRefinements)
    });
};
var $fdec58dce645e387$var$mergeFacetsExcludes = function mergeFacetsExcludes(left, right) {
    return left.setQueryParameters({
        facetsExcludes: $fdec58dce645e387$var$_objectSpread($fdec58dce645e387$var$_objectSpread({}, left.facetsExcludes), right.facetsExcludes)
    });
};
var $fdec58dce645e387$var$mergeDisjunctiveFacetsRefinements = function mergeDisjunctiveFacetsRefinements(left, right) {
    return left.setQueryParameters({
        disjunctiveFacetsRefinements: $fdec58dce645e387$var$_objectSpread($fdec58dce645e387$var$_objectSpread({}, left.disjunctiveFacetsRefinements), right.disjunctiveFacetsRefinements)
    });
};
var $fdec58dce645e387$var$mergeNumericRefinements = function mergeNumericRefinements(left, right) {
    return left.setQueryParameters({
        numericRefinements: $fdec58dce645e387$var$_objectSpread($fdec58dce645e387$var$_objectSpread({}, left.numericRefinements), right.numericRefinements)
    });
};
var $fdec58dce645e387$var$mergeHierarchicalFacetsRefinements = function mergeHierarchicalFacetsRefinements(left, right) {
    return left.setQueryParameters({
        hierarchicalFacetsRefinements: $fdec58dce645e387$var$_objectSpread($fdec58dce645e387$var$_objectSpread({}, left.hierarchicalFacetsRefinements), right.hierarchicalFacetsRefinements)
    });
};
var $fdec58dce645e387$var$mergeRuleContexts = function mergeRuleContexts(left, right) {
    var ruleContexts = (0, $98a2c07ad87fe2bc$export$f70730c3d1fc524e)([].concat(left.ruleContexts).concat(right.ruleContexts).filter(Boolean));
    if (ruleContexts.length > 0) return left.setQueryParameters({
        ruleContexts: ruleContexts
    });
    return left;
};
var $fdec58dce645e387$export$8049d91f25899769 = function mergeSearchParameters() {
    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++)parameters[_key] = arguments[_key];
    return parameters.reduce(function(left, right) {
        var hierarchicalFacetsRefinementsMerged = $fdec58dce645e387$var$mergeHierarchicalFacetsRefinements(left, right);
        var hierarchicalFacetsMerged = $fdec58dce645e387$var$mergeHierarchicalFacets(hierarchicalFacetsRefinementsMerged, right);
        var tagRefinementsMerged = $fdec58dce645e387$var$mergeTagRefinements(hierarchicalFacetsMerged, right);
        var numericRefinementsMerged = $fdec58dce645e387$var$mergeNumericRefinements(tagRefinementsMerged, right);
        var disjunctiveFacetsRefinementsMerged = $fdec58dce645e387$var$mergeDisjunctiveFacetsRefinements(numericRefinementsMerged, right);
        var facetsExcludesMerged = $fdec58dce645e387$var$mergeFacetsExcludes(disjunctiveFacetsRefinementsMerged, right);
        var facetRefinementsMerged = $fdec58dce645e387$var$mergeFacetRefinements(facetsExcludesMerged, right);
        var disjunctiveFacetsMerged = $fdec58dce645e387$var$mergeDisjunctiveFacets(facetRefinementsMerged, right);
        var ruleContextsMerged = $fdec58dce645e387$var$mergeRuleContexts(disjunctiveFacetsMerged, right);
        var facetsMerged = $fdec58dce645e387$var$mergeFacets(ruleContextsMerged, right);
        return $fdec58dce645e387$var$mergeWithRest(facetsMerged, right);
    });
};

function $16aac0f16a00baed$export$1c33c9881dac6797(current) {
    var parent = current.getParent();
    var states = [
        current.getHelper().state
    ];
    while(parent !== null){
        states = [
            parent.getHelper().state
        ].concat(states);
        parent = parent.getParent();
    }
    return states;
}


var $d99c50f9206be3a1$var$id = 0;
function $d99c50f9206be3a1$export$50b3ac0e47148c0b(widget) {
    if (widget.dependsOn !== "recommend") return;
    widget.$$id = $d99c50f9206be3a1$var$id++;
}
function $d99c50f9206be3a1$export$13e2e3d76152aecf() {
    $d99c50f9206be3a1$var$id = 0;
}


function $96c57abe692e5254$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $96c57abe692e5254$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $96c57abe692e5254$var$_typeof(o);
}
var $96c57abe692e5254$var$_excluded = [
    "initialSearchParameters"
], $96c57abe692e5254$var$_excluded2 = [
    "initialRecommendParameters"
];
function $96c57abe692e5254$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $96c57abe692e5254$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $96c57abe692e5254$var$ownKeys(Object(t), !0).forEach(function(r) {
            $96c57abe692e5254$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $96c57abe692e5254$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $96c57abe692e5254$var$_defineProperty(obj, key, value) {
    key = $96c57abe692e5254$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $96c57abe692e5254$var$_toPropertyKey(t) {
    var i = $96c57abe692e5254$var$_toPrimitive(t, "string");
    return "symbol" == $96c57abe692e5254$var$_typeof(i) ? i : String(i);
}
function $96c57abe692e5254$var$_toPrimitive(t, r) {
    if ("object" != $96c57abe692e5254$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $96c57abe692e5254$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $96c57abe692e5254$var$_toConsumableArray(arr) {
    return $96c57abe692e5254$var$_arrayWithoutHoles(arr) || $96c57abe692e5254$var$_iterableToArray(arr) || $96c57abe692e5254$var$_unsupportedIterableToArray(arr) || $96c57abe692e5254$var$_nonIterableSpread();
}
function $96c57abe692e5254$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $96c57abe692e5254$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $96c57abe692e5254$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $96c57abe692e5254$var$_arrayLikeToArray(o, minLen);
}
function $96c57abe692e5254$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $96c57abe692e5254$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $96c57abe692e5254$var$_arrayLikeToArray(arr);
}
function $96c57abe692e5254$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $96c57abe692e5254$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $96c57abe692e5254$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $96c57abe692e5254$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $96c57abe692e5254$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "index-widget"
});
/**
 * This is the same content as helper._change / setState, but allowing for extra
 * UiState to be synchronized.
 * see: https://github.com/algolia/algoliasearch-helper-js/blob/6b835ffd07742f2d6b314022cce6848f5cfecd4a/src/algoliasearch.helper.js#L1311-L1324
 */ function $96c57abe692e5254$var$privateHelperSetState(helper, _ref) {
    var state = _ref.state, recommendState = _ref.recommendState, isPageReset = _ref.isPageReset, _uiState = _ref._uiState;
    if (state !== helper.state) {
        helper.state = state;
        helper.emit("change", {
            state: helper.state,
            results: helper.lastResults,
            isPageReset: isPageReset,
            _uiState: _uiState
        });
    }
    if (recommendState !== helper.recommendState) helper.recommendState = recommendState;
}
function $96c57abe692e5254$var$getLocalWidgetsUiState(widgets, widgetStateOptions) {
    var initialUiState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return widgets.reduce(function(uiState, widget) {
        if ((0, $c5421e1e8593cec5$export$a9c9a0d43506297d)(widget)) return uiState;
        if (!widget.getWidgetUiState && !widget.getWidgetState) return uiState;
        if (widget.getWidgetUiState) return widget.getWidgetUiState(uiState, widgetStateOptions);
        return widget.getWidgetState(uiState, widgetStateOptions);
    }, initialUiState);
}
function $96c57abe692e5254$var$getLocalWidgetsSearchParameters(widgets, widgetSearchParametersOptions) {
    var initialSearchParameters = widgetSearchParametersOptions.initialSearchParameters, rest = $96c57abe692e5254$var$_objectWithoutProperties(widgetSearchParametersOptions, $96c57abe692e5254$var$_excluded);
    return widgets.reduce(function(state, widget) {
        if (!widget.getWidgetSearchParameters || (0, $c5421e1e8593cec5$export$a9c9a0d43506297d)(widget)) return state;
        if (widget.dependsOn === "search" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return widget.getWidgetSearchParameters(state, rest);
    }, initialSearchParameters);
}
function $96c57abe692e5254$var$getLocalWidgetsRecommendParameters(widgets, widgetRecommendParametersOptions) {
    var initialRecommendParameters = widgetRecommendParametersOptions.initialRecommendParameters, rest = $96c57abe692e5254$var$_objectWithoutProperties(widgetRecommendParametersOptions, $96c57abe692e5254$var$_excluded2);
    return widgets.reduce(function(state, widget) {
        if (!(0, $c5421e1e8593cec5$export$a9c9a0d43506297d)(widget) && widget.dependsOn === "recommend" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return state;
    }, initialRecommendParameters);
}
function $96c57abe692e5254$var$resetPageFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $c5421e1e8593cec5$export$a9c9a0d43506297d));
    if (indexWidgets.length === 0) return;
    indexWidgets.forEach(function(widget) {
        var widgetHelper = widget.getHelper();
        $96c57abe692e5254$var$privateHelperSetState(widgetHelper, {
            state: widgetHelper.state.resetPage(),
            recommendState: widgetHelper.recommendState,
            isPageReset: true
        });
        $96c57abe692e5254$var$resetPageFromWidgets(widget.getWidgets());
    });
}
function $96c57abe692e5254$var$resolveScopedResultsFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $c5421e1e8593cec5$export$a9c9a0d43506297d));
    return indexWidgets.reduce(function(scopedResults, current) {
        return scopedResults.concat.apply(scopedResults, [
            {
                indexId: current.getIndexId(),
                results: current.getResults(),
                helper: current.getHelper()
            }
        ].concat($96c57abe692e5254$var$_toConsumableArray($96c57abe692e5254$var$resolveScopedResultsFromWidgets(current.getWidgets()))));
    }, []);
}
var $96c57abe692e5254$var$index = function index(widgetParams) {
    if (widgetParams === undefined || widgetParams.indexName === undefined) throw new Error($96c57abe692e5254$var$withUsage("The `indexName` option is required."));
    var indexName = widgetParams.indexName, _widgetParams$indexId = widgetParams.indexId, indexId = _widgetParams$indexId === void 0 ? indexName : _widgetParams$indexId;
    var localWidgets = [];
    var localUiState = {};
    var localInstantSearchInstance = null;
    var localParent = null;
    var helper = null;
    var derivedHelper = null;
    var lastValidSearchParameters = null;
    var hasRecommendWidget = false;
    var hasSearchWidget = false;
    return {
        $$type: "ais.index",
        $$widgetType: "ais.index",
        getIndexName: function getIndexName() {
            return indexName;
        },
        getIndexId: function getIndexId() {
            return indexId;
        },
        getHelper: function getHelper() {
            return helper;
        },
        getResults: function getResults() {
            var _derivedHelper;
            if (!((_derivedHelper = derivedHelper) !== null && _derivedHelper !== void 0 && _derivedHelper.lastResults)) return null;
            // To make the UI optimistic, we patch the state to display to the current
            // one instead of the one associated with the latest results.
            // This means user-driven UI changes (e.g., checked checkbox) are reflected
            // immediately instead of waiting for Algolia to respond, regardless of
            // the status of the network request.
            derivedHelper.lastResults._state = helper.state;
            return derivedHelper.lastResults;
        },
        getResultsForWidget: function getResultsForWidget(widget) {
            var _helper;
            if (widget.dependsOn !== "recommend" || (0, $c5421e1e8593cec5$export$a9c9a0d43506297d)(widget) || widget.$$id === undefined) return this.getResults();
            if (!((_helper = helper) !== null && _helper !== void 0 && _helper.lastRecommendResults)) return null;
            return helper.lastRecommendResults[widget.$$id];
        },
        getPreviousState: function getPreviousState() {
            return lastValidSearchParameters;
        },
        getScopedResults: function getScopedResults() {
            var widgetParent = this.getParent();
            var widgetSiblings;
            if (widgetParent) widgetSiblings = widgetParent.getWidgets();
            else if (indexName.length === 0) // The widget is the root but has no index name:
            // we resolve results from its children index widgets
            widgetSiblings = this.getWidgets();
            else // The widget is the root and has an index name:
            // we consider itself as the only sibling
            widgetSiblings = [
                this
            ];
            return $96c57abe692e5254$var$resolveScopedResultsFromWidgets(widgetSiblings);
        },
        getParent: function getParent() {
            return localParent;
        },
        createURL: function createURL(nextState) {
            if (typeof nextState === "function") return localInstantSearchInstance._createURL($96c57abe692e5254$var$_defineProperty({}, indexId, nextState(localUiState)));
            return localInstantSearchInstance._createURL($96c57abe692e5254$var$_defineProperty({}, indexId, $96c57abe692e5254$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: nextState,
                helper: helper
            })));
        },
        getWidgets: function getWidgets() {
            return localWidgets;
        },
        addWidgets: function addWidgets(widgets) {
            var _this = this;
            if (!Array.isArray(widgets)) throw new Error($96c57abe692e5254$var$withUsage("The `addWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.init !== "function" && typeof widget.render !== "function";
            })) throw new Error($96c57abe692e5254$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
            widgets.forEach(function(widget) {
                if ((0, $c5421e1e8593cec5$export$a9c9a0d43506297d)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === "recommend") localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === "recommend") hasRecommendWidget = true;
                else hasSearchWidget = true;
                (0, $d99c50f9206be3a1$export$50b3ac0e47148c0b)(widget);
            });
            localWidgets = localWidgets.concat(widgets);
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                $96c57abe692e5254$var$privateHelperSetState(helper, {
                    state: $96c57abe692e5254$var$getLocalWidgetsSearchParameters(localWidgets, {
                        uiState: localUiState,
                        initialSearchParameters: helper.state
                    }),
                    recommendState: $96c57abe692e5254$var$getLocalWidgetsRecommendParameters(localWidgets, {
                        uiState: localUiState,
                        initialRecommendParameters: helper.recommendState
                    }),
                    _uiState: localUiState
                });
                // We compute the render state before calling `init` in a separate loop
                // to construct the whole render state object that is then passed to
                // `init`.
                widgets.forEach(function(widget) {
                    if (widget.getRenderState) {
                        var renderState = widget.getRenderState(localInstantSearchInstance.renderState[_this.getIndexId()] || {}, (0, $a4ab2cc197ff2f9a$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                        $96c57abe692e5254$var$storeRenderState({
                            renderState: renderState,
                            instantSearchInstance: localInstantSearchInstance,
                            parent: _this
                        });
                    }
                });
                widgets.forEach(function(widget) {
                    if (widget.init) widget.init((0, $a4ab2cc197ff2f9a$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                });
                localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        removeWidgets: function removeWidgets(widgets) {
            var _this2 = this;
            if (!Array.isArray(widgets)) throw new Error($96c57abe692e5254$var$withUsage("The `removeWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.dispose !== "function";
            })) throw new Error($96c57abe692e5254$var$withUsage("The widget definition expects a `dispose` method."));
            localWidgets = localWidgets.filter(function(widget) {
                return widgets.indexOf(widget) === -1;
            });
            localWidgets.forEach(function(widget) {
                if ((0, $c5421e1e8593cec5$export$a9c9a0d43506297d)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === "recommend") localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === "recommend") hasRecommendWidget = true;
                else hasSearchWidget = true;
            });
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                var _widgets$reduce = widgets.reduce(function(states, widget) {
                    // the `dispose` method exists at this point we already assert it
                    var next = widget.dispose({
                        helper: helper,
                        state: states.cleanedSearchState,
                        recommendState: states.cleanedRecommendState,
                        parent: _this2
                    });
                    if (next instanceof (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).RecommendParameters) states.cleanedRecommendState = next;
                    else if (next) states.cleanedSearchState = next;
                    return states;
                }, {
                    cleanedSearchState: helper.state,
                    cleanedRecommendState: helper.recommendState
                }), cleanedSearchState = _widgets$reduce.cleanedSearchState, cleanedRecommendState = _widgets$reduce.cleanedRecommendState;
                var newState = localInstantSearchInstance.future.preserveSharedStateOnUnmount ? $96c57abe692e5254$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: localUiState,
                    initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).SearchParameters({
                        index: this.getIndexName()
                    })
                }) : $96c57abe692e5254$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: $96c57abe692e5254$var$getLocalWidgetsUiState(localWidgets, {
                        searchParameters: cleanedSearchState,
                        helper: helper
                    }),
                    initialSearchParameters: cleanedSearchState
                });
                localUiState = $96c57abe692e5254$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: newState,
                    helper: helper
                });
                helper.setState(newState);
                helper.recommendState = cleanedRecommendState;
                if (localWidgets.length) localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        init: function init(_ref2) {
            var _this3 = this, _instantSearchInstanc;
            var instantSearchInstance = _ref2.instantSearchInstance, parent = _ref2.parent, uiState = _ref2.uiState;
            if (helper !== null) // helper is already initialized, therefore we do not need to set up
            // any listeners
            return;
            localInstantSearchInstance = instantSearchInstance;
            localParent = parent;
            localUiState = uiState[indexId] || {};
            // The `mainHelper` is already defined at this point. The instance is created
            // inside InstantSearch at the `start` method, which occurs before the `init`
            // step.
            var mainHelper = instantSearchInstance.mainHelper;
            var parameters = $96c57abe692e5254$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: localUiState,
                initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).SearchParameters({
                    index: indexName
                })
            });
            var recommendParameters = $96c57abe692e5254$var$getLocalWidgetsRecommendParameters(localWidgets, {
                uiState: localUiState,
                initialRecommendParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).RecommendParameters()
            });
            // This Helper is only used for state management we do not care about the
            // `searchClient`. Only the "main" Helper created at the `InstantSearch`
            // level is aware of the client.
            helper = (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports)))({}, parameters.index, parameters);
            helper.recommendState = recommendParameters;
            // We forward the call to `search` to the "main" instance of the Helper
            // which is responsible for managing the queries (it's the only one that is
            // aware of the `searchClient`).
            helper.search = function() {
                if (instantSearchInstance.onStateChange) {
                    instantSearchInstance.onStateChange({
                        uiState: instantSearchInstance.mainIndex.getWidgetUiState({}),
                        setUiState: function setUiState(nextState) {
                            return instantSearchInstance.setUiState(nextState, false);
                        }
                    });
                    // We don't trigger a search when controlled because it becomes the
                    // responsibility of `setUiState`.
                    return mainHelper;
                }
                return mainHelper.search();
            };
            helper.searchWithoutTriggeringOnStateChange = function() {
                return mainHelper.search();
            };
            // We use the same pattern for the `searchForFacetValues`.
            helper.searchForFacetValues = function(facetName, facetValue, maxFacetHits, userState) {
                var state = helper.state.setQueryParameters(userState);
                return mainHelper.searchForFacetValues(facetName, facetValue, maxFacetHits, state);
            };
            derivedHelper = mainHelper.derive(function() {
                return (0, $fdec58dce645e387$export$8049d91f25899769).apply(void 0, [
                    mainHelper.state
                ].concat($96c57abe692e5254$var$_toConsumableArray((0, $16aac0f16a00baed$export$1c33c9881dac6797)(_this3))));
            }, function() {
                return _this3.getHelper().recommendState;
            });
            var indexInitialResults = (_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : _instantSearchInstanc[this.getIndexId()];
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.results) {
                // We restore the shape of the results provided to the instance to respect
                // the helper's structure.
                var results = new (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).SearchResults(new (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).SearchParameters(indexInitialResults.state), indexInitialResults.results);
                derivedHelper.lastResults = results;
                helper.lastResults = results;
            }
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.recommendResults) {
                var recommendResults = new (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).RecommendResults(new (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).RecommendParameters({
                    params: indexInitialResults.recommendResults.params
                }), indexInitialResults.recommendResults.results);
                derivedHelper.lastRecommendResults = recommendResults;
                helper.lastRecommendResults = recommendResults;
            }
            // Subscribe to the Helper state changes for the page before widgets
            // are initialized. This behavior mimics the original one of the Helper.
            // It makes sense to replicate it at the `init` step. We have another
            // listener on `change` below, once `init` is done.
            helper.on("change", function(_ref3) {
                var isPageReset = _ref3.isPageReset;
                if (isPageReset) $96c57abe692e5254$var$resetPageFromWidgets(localWidgets);
            });
            derivedHelper.on("search", function() {
                // The index does not manage the "staleness" of the search. This is the
                // responsibility of the main instance. It does not make sense to manage
                // it at the index level because it's either: all of them or none of them
                // that are stalled. The queries are performed into a single network request.
                instantSearchInstance.scheduleStalledRender();
            });
            derivedHelper.on("result", function(_ref4) {
                var results = _ref4.results;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastResults, which it used to in pre-federated
                // search behavior.
                helper.lastResults = results;
                lastValidSearchParameters = results === null || results === void 0 ? void 0 : results._state;
            });
            // eslint-disable-next-line no-warning-comments
            // TODO: listen to "result" event when events for Recommend are implemented
            derivedHelper.on("recommend:result", function(_ref5) {
                var recommend = _ref5.recommend;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastRecommendResults.
                helper.lastRecommendResults = recommend.results;
            });
            // We compute the render state before calling `init` in a separate loop
            // to construct the whole render state object that is then passed to
            // `init`.
            localWidgets.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this3.getIndexId()] || {}, (0, $a4ab2cc197ff2f9a$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
                    $96c57abe692e5254$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this3
                    });
                }
            });
            localWidgets.forEach(function(widget) {
                if (widget.init) widget.init((0, $a4ab2cc197ff2f9a$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
            });
            // Subscribe to the Helper state changes for the `uiState` once widgets
            // are initialized. Until the first render, state changes are part of the
            // configuration step. This is mainly for backward compatibility with custom
            // widgets. When the subscription happens before the `init` step, the (static)
            // configuration of the widget is pushed in the URL. That's what we want to avoid.
            // https://github.com/algolia/instantsearch/pull/994/commits/4a672ae3fd78809e213de0368549ef12e9dc9454
            helper.on("change", function(event) {
                var state = event.state;
                var _uiState = event._uiState;
                localUiState = $96c57abe692e5254$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: state,
                    helper: helper
                }, _uiState || {});
                // We don't trigger an internal change when controlled because it
                // becomes the responsibility of `setUiState`.
                if (!instantSearchInstance.onStateChange) instantSearchInstance.onInternalStateChange();
            });
            if (indexInitialResults) // If there are initial results, we're not notified of the next results
            // because we don't trigger an initial search. We therefore need to directly
            // schedule a render that will render the results injected on the helper.
            instantSearchInstance.scheduleRender();
            if (hasRecommendWidget) instantSearchInstance._hasRecommendWidget = true;
            if (hasSearchWidget) instantSearchInstance._hasSearchWidget = true;
        },
        render: function render(_ref6) {
            var _derivedHelper2, _this4 = this;
            var instantSearchInstance = _ref6.instantSearchInstance;
            // we can't attach a listener to the error event of search, as the error
            // then would no longer be thrown for global handlers.
            if (instantSearchInstance.status === "error" && !instantSearchInstance.mainHelper.hasPendingRequests() && lastValidSearchParameters) helper.setState(lastValidSearchParameters);
            // We only render index widgets if there are no results.
            // This makes sure `render` is never called with `results` being `null`.
            var widgetsToRender = this.getResults() || (_derivedHelper2 = derivedHelper) !== null && _derivedHelper2 !== void 0 && _derivedHelper2.lastRecommendResults ? localWidgets : localWidgets.filter((0, $c5421e1e8593cec5$export$a9c9a0d43506297d));
            widgetsToRender = widgetsToRender.filter(function(widget) {
                if (!widget.shouldRender) return true;
                return widget.shouldRender({
                    instantSearchInstance: instantSearchInstance
                });
            });
            widgetsToRender.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this4.getIndexId()] || {}, (0, $a4ab2cc197ff2f9a$export$c3ba97e79c76dd38)(instantSearchInstance, _this4, widget));
                    $96c57abe692e5254$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this4
                    });
                }
            });
            widgetsToRender.forEach(function(widget) {
                // At this point, all the variables used below are set. Both `helper`
                // and `derivedHelper` have been created at the `init` step. The attribute
                // `lastResults` might be `null` though. It's possible that a stalled render
                // happens before the result e.g with a dynamically added index the request might
                // be delayed. The render is triggered for the complete tree but some parts do
                // not have results yet.
                if (widget.render) widget.render((0, $a4ab2cc197ff2f9a$export$c3ba97e79c76dd38)(instantSearchInstance, _this4, widget));
            });
        },
        dispose: function dispose() {
            var _this5 = this, _helper2, _derivedHelper3;
            localWidgets.forEach(function(widget) {
                if (widget.dispose && helper) // The dispose function is always called once the instance is started
                // (it's an effect of `removeWidgets`). The index is initialized and
                // the Helper is available. We don't care about the return value of
                // `dispose` because the index is removed. We can't call `removeWidgets`
                // because we want to keep the widgets on the instance, to allow idempotent
                // operations on `add` & `remove`.
                widget.dispose({
                    helper: helper,
                    state: helper.state,
                    recommendState: helper.recommendState,
                    parent: _this5
                });
            });
            localInstantSearchInstance = null;
            localParent = null;
            (_helper2 = helper) === null || _helper2 === void 0 || _helper2.removeAllListeners();
            helper = null;
            (_derivedHelper3 = derivedHelper) === null || _derivedHelper3 === void 0 || _derivedHelper3.detach();
            derivedHelper = null;
        },
        getWidgetUiState: function getWidgetUiState(uiState) {
            return localWidgets.filter((0, $c5421e1e8593cec5$export$a9c9a0d43506297d)).reduce(function(previousUiState, innerIndex) {
                return innerIndex.getWidgetUiState(previousUiState);
            }, $96c57abe692e5254$var$_objectSpread($96c57abe692e5254$var$_objectSpread({}, uiState), {}, $96c57abe692e5254$var$_defineProperty({}, indexId, $96c57abe692e5254$var$_objectSpread($96c57abe692e5254$var$_objectSpread({}, uiState[indexId]), localUiState))));
        },
        getWidgetState: function getWidgetState(uiState) {
            return this.getWidgetUiState(uiState);
        },
        getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref7) {
            var uiState = _ref7.uiState;
            return $96c57abe692e5254$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: uiState,
                initialSearchParameters: searchParameters
            });
        },
        refreshUiState: function refreshUiState() {
            localUiState = $96c57abe692e5254$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: this.getHelper().state,
                helper: this.getHelper()
            }, localUiState);
        },
        setIndexUiState: function setIndexUiState(indexUiState) {
            var nextIndexUiState = typeof indexUiState === "function" ? indexUiState(localUiState) : indexUiState;
            localInstantSearchInstance.setUiState(function(state) {
                return $96c57abe692e5254$var$_objectSpread($96c57abe692e5254$var$_objectSpread({}, state), {}, $96c57abe692e5254$var$_defineProperty({}, indexId, nextIndexUiState));
            });
        }
    };
};
var $96c57abe692e5254$export$2e2bcd8739ae039 = $96c57abe692e5254$var$index;
function $96c57abe692e5254$var$storeRenderState(_ref8) {
    var renderState = _ref8.renderState, instantSearchInstance = _ref8.instantSearchInstance, parent = _ref8.parent;
    var parentIndexName = parent ? parent.getIndexId() : instantSearchInstance.mainIndex.getIndexId();
    instantSearchInstance.renderState = $96c57abe692e5254$var$_objectSpread($96c57abe692e5254$var$_objectSpread({}, instantSearchInstance.renderState), {}, $96c57abe692e5254$var$_defineProperty({}, parentIndexName, $96c57abe692e5254$var$_objectSpread($96c57abe692e5254$var$_objectSpread({}, instantSearchInstance.renderState[parentIndexName]), renderState)));
}



function $f0f6b35ae64c9b16$export$f5dd818bff069720(value, numberLocale) {
    return value.toLocaleString(numberLocale);
}


function $b4112abb41e3b631$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b4112abb41e3b631$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b4112abb41e3b631$var$_typeof(o);
}
function $b4112abb41e3b631$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4112abb41e3b631$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4112abb41e3b631$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b4112abb41e3b631$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4112abb41e3b631$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b4112abb41e3b631$var$_defineProperty(obj, key, value) {
    key = $b4112abb41e3b631$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b4112abb41e3b631$var$_toPropertyKey(t) {
    var i = $b4112abb41e3b631$var$_toPrimitive(t, "string");
    return "symbol" == $b4112abb41e3b631$var$_typeof(i) ? i : String(i);
}
function $b4112abb41e3b631$var$_toPrimitive(t, r) {
    if ("object" != $b4112abb41e3b631$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b4112abb41e3b631$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b4112abb41e3b631$export$2e2bcd8739ae039(_ref) {
    var numberLocale = _ref.numberLocale;
    return {
        formatNumber: function formatNumber(value, render) {
            return (0, $f0f6b35ae64c9b16$export$f5dd818bff069720)(Number(render(value)), numberLocale);
        },
        highlight: function highlight(options, render) {
            try {
                var highlightOptions = JSON.parse(options);
                return render((0, $a04f80f894e77137$export$2e2bcd8739ae039)($b4112abb41e3b631$var$_objectSpread($b4112abb41e3b631$var$_objectSpread({}, highlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseHighlight: function reverseHighlight(options, render) {
            try {
                var reverseHighlightOptions = JSON.parse(options);
                return render((0, $1c0dfaf5220411d2$export$2e2bcd8739ae039)($b4112abb41e3b631$var$_objectSpread($b4112abb41e3b631$var$_objectSpread({}, reverseHighlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseHighlight helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        snippet: function snippet(options, render) {
            try {
                var snippetOptions = JSON.parse(options);
                return render((0, $9bab6399914ee67a$export$2e2bcd8739ae039)($b4112abb41e3b631$var$_objectSpread($b4112abb41e3b631$var$_objectSpread({}, snippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseSnippet: function reverseSnippet(options, render) {
            try {
                var reverseSnippetOptions = JSON.parse(options);
                return render((0, $3f04f3deb6088df4$export$2e2bcd8739ae039)($b4112abb41e3b631$var$_objectSpread($b4112abb41e3b631$var$_objectSpread({}, reverseSnippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseSnippet helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        insights: function insights(options, render) {
            try {
                var _JSON$parse = JSON.parse(options), method = _JSON$parse.method, payload = _JSON$parse.payload;
                return render((0, $54d2c88a789bd99d$export$2e2bcd8739ae039)(method, $b4112abb41e3b631$var$_objectSpread({
                    objectIDs: [
                        this.objectID
                    ]
                }, payload)));
            } catch (error) {
                throw new Error('\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }');
            }
        }
    };
}


var $85ae0e158bdd4b58$var$nextMicroTask = Promise.resolve();
function $85ae0e158bdd4b58$export$260e5c0943f31606(callback) {
    var progress = null;
    var cancelled = false;
    var fn = function fn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (progress !== null) return;
        progress = $85ae0e158bdd4b58$var$nextMicroTask.then(function() {
            progress = null;
            if (cancelled) {
                cancelled = false;
                return;
            }
            callback.apply(void 0, args);
        });
    };
    fn.wait = function() {
        if (progress === null) throw new Error("The deferred function should be called before calling `wait()`");
        return progress;
    };
    fn.cancel = function() {
        if (progress === null) return;
        cancelled = true;
    };
    return fn;
}

function $0d68108429183d43$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0d68108429183d43$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0d68108429183d43$var$_typeof(o);
}
function $0d68108429183d43$var$_slicedToArray(arr, i) {
    return $0d68108429183d43$var$_arrayWithHoles(arr) || $0d68108429183d43$var$_iterableToArrayLimit(arr, i) || $0d68108429183d43$var$_unsupportedIterableToArray(arr, i) || $0d68108429183d43$var$_nonIterableRest();
}
function $0d68108429183d43$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0d68108429183d43$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0d68108429183d43$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0d68108429183d43$var$_arrayLikeToArray(o, minLen);
}
function $0d68108429183d43$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0d68108429183d43$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0d68108429183d43$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0d68108429183d43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0d68108429183d43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0d68108429183d43$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0d68108429183d43$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0d68108429183d43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0d68108429183d43$var$_defineProperty(obj, key, value) {
    key = $0d68108429183d43$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0d68108429183d43$var$_toPropertyKey(t) {
    var i = $0d68108429183d43$var$_toPrimitive(t, "string");
    return "symbol" == $0d68108429183d43$var$_typeof(i) ? i : String(i);
}
function $0d68108429183d43$var$_toPrimitive(t, r) {
    if ("object" != $0d68108429183d43$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0d68108429183d43$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0d68108429183d43$export$7edf4eca27ca3a19(client, results) {
    if (!results) return;
    // Disable cache hydration on:
    // - Algoliasearch API Client < v4 with cache disabled
    // - Third party clients (detected by the `addAlgoliaAgent` function missing)
    if ((!("transporter" in client) || client._cacheHydrated) && (!client._useCache || typeof client.addAlgoliaAgent !== "function")) return;
    var cachedRequest = [
        Object.keys(results).reduce(function(acc, key) {
            var _results$key = results[key], state = _results$key.state, requestParams = _results$key.requestParams, serverResults = _results$key.results;
            var mappedResults = serverResults && state ? serverResults.map(function(result, idx) {
                return $0d68108429183d43$var$_objectSpread({
                    indexName: state.index || result.index
                }, requestParams !== null && requestParams !== void 0 && requestParams[idx] || result.params ? {
                    params: $0d68108429183d43$var$serializeQueryParameters((requestParams === null || requestParams === void 0 ? void 0 : requestParams[idx]) || $0d68108429183d43$var$deserializeQueryParameters(result.params))
                } : {});
            }) : [];
            return acc.concat(mappedResults);
        }, [])
    ];
    var cachedResults = Object.keys(results).reduce(function(acc, key) {
        var res = results[key].results;
        if (!res) return acc;
        return acc.concat(res);
    }, []);
    // Algoliasearch API Client >= v4
    // To hydrate the client we need to populate the cache with the data from
    // the server (done in `hydrateSearchClientWithMultiIndexRequest` or
    // `hydrateSearchClientWithSingleIndexRequest`). But since there is no way
    // for us to compute the key the same way as `algoliasearch-client` we need
    // to populate it on a custom key and override the `search` method to
    // search on it first.
    if ("transporter" in client && !client._cacheHydrated) {
        client._cacheHydrated = true;
        var baseMethod = client.search.bind(client);
        client.search = function(requests) {
            for(var _len = arguments.length, methodArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)methodArgs[_key - 1] = arguments[_key];
            var requestsWithSerializedParams = Array.isArray(requests) ? // search client
            requests.map(function(request) {
                return $0d68108429183d43$var$_objectSpread($0d68108429183d43$var$_objectSpread({}, request), {}, {
                    params: $0d68108429183d43$var$serializeQueryParameters(request.params)
                });
            }) : // composition client
            $0d68108429183d43$var$serializeQueryParameters(requests.requestBody.params);
            return client.transporter.responsesCache.get({
                method: "search",
                args: [
                    requestsWithSerializedParams
                ].concat(methodArgs)
            }, function() {
                return baseMethod.apply(void 0, [
                    requests
                ].concat(methodArgs));
            });
        };
        client.transporter.responsesCache.set({
            method: "search",
            args: cachedRequest
        }, {
            results: cachedResults
        });
    }
    // Algoliasearch API Client < v4
    // Prior to client v4 we didn't have a proper API to hydrate the client
    // cache from the outside. The following code populates the cache with
    // a single-index result. You can find more information about the
    // computation of the key inside the client (see link below).
    // https://github.com/algolia/algoliasearch-client-javascript/blob/c27e89ff92b2a854ae6f40dc524bffe0f0cbc169/src/AlgoliaSearchCore.js#L232-L240
    if (!("transporter" in client)) {
        var cacheKey = "/1/indexes/*/queries_body_".concat(JSON.stringify({
            requests: cachedRequest
        }));
        client.cache = $0d68108429183d43$var$_objectSpread($0d68108429183d43$var$_objectSpread({}, client.cache), {}, $0d68108429183d43$var$_defineProperty({}, cacheKey, JSON.stringify({
            results: Object.keys(results).map(function(key) {
                return results[key].results;
            })
        })));
    }
}
function $0d68108429183d43$var$deserializeQueryParameters(parameters) {
    return parameters.split("&").reduce(function(acc, parameter) {
        var _parameter$split = parameter.split("="), _parameter$split2 = $0d68108429183d43$var$_slicedToArray(_parameter$split, 2), key = _parameter$split2[0], value = _parameter$split2[1];
        acc[key] = value ? decodeURIComponent(value) : "";
        return acc;
    }, {});
}
// This function is copied from the algoliasearch v4 API Client. If modified,
// consider updating it also in `serializeQueryParameters` from `@algolia/transporter`.
function $0d68108429183d43$var$serializeQueryParameters(parameters) {
    var isObjectOrArray = function isObjectOrArray(value) {
        return Object.prototype.toString.call(value) === "[object Object]" || Object.prototype.toString.call(value) === "[object Array]";
    };
    var encode = function encode(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var i = 0;
        return format.replace(/%s/g, function() {
            return encodeURIComponent(args[i++]);
        });
    };
    return Object.keys(parameters).map(function(key) {
        return encode("%s=%s", key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key]);
    }).join("&");
}

function $9e59c372ed8eee3e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9e59c372ed8eee3e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9e59c372ed8eee3e$var$_typeof(o);
}
function $9e59c372ed8eee3e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e59c372ed8eee3e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e59c372ed8eee3e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9e59c372ed8eee3e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e59c372ed8eee3e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9e59c372ed8eee3e$var$_defineProperty(obj, key, value) {
    key = $9e59c372ed8eee3e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9e59c372ed8eee3e$var$_toPropertyKey(t) {
    var i = $9e59c372ed8eee3e$var$_toPrimitive(t, "string");
    return "symbol" == $9e59c372ed8eee3e$var$_typeof(i) ? i : String(i);
}
function $9e59c372ed8eee3e$var$_toPrimitive(t, r) {
    if ("object" != $9e59c372ed8eee3e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9e59c372ed8eee3e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9e59c372ed8eee3e$export$53ef00b131a96aa6(helper, initialResults) {
    var recommendCache = Object.keys(initialResults).reduce(function(acc, indexName) {
        var initialResult = initialResults[indexName];
        if (initialResult.recommendResults) // @MAJOR: Use `Object.assign` instead of spread operator
        return $9e59c372ed8eee3e$var$_objectSpread($9e59c372ed8eee3e$var$_objectSpread({}, acc), initialResult.recommendResults.results);
        return acc;
    }, {});
    helper._recommendCache = recommendCache;
}



function $0de2cc3ab8bc4407$export$fd5e8f1329b3d5e0(finalUiState, indexWidget) {
    var nextIndexUiState = finalUiState[indexWidget.getIndexId()] || {};
    indexWidget.getHelper().setState(indexWidget.getWidgetSearchParameters(indexWidget.getHelper().state, {
        uiState: nextIndexUiState
    }));
    indexWidget.getWidgets().filter((0, $c5421e1e8593cec5$export$a9c9a0d43506297d)).forEach(function(widget) {
        return $0de2cc3ab8bc4407$export$fd5e8f1329b3d5e0(finalUiState, widget);
    });
}


var $159f73dc06d5d946$export$2e2bcd8739ae039 = "4.78.0";


function $88dd954ff97e2022$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $88dd954ff97e2022$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $88dd954ff97e2022$var$_typeof(o);
}
function $88dd954ff97e2022$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $88dd954ff97e2022$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $88dd954ff97e2022$var$ownKeys(Object(t), !0).forEach(function(r) {
            $88dd954ff97e2022$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $88dd954ff97e2022$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $88dd954ff97e2022$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $88dd954ff97e2022$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $88dd954ff97e2022$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $88dd954ff97e2022$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $88dd954ff97e2022$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $88dd954ff97e2022$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $88dd954ff97e2022$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $88dd954ff97e2022$var$_setPrototypeOf(subClass, superClass);
}
function $88dd954ff97e2022$var$_setPrototypeOf(o, p) {
    $88dd954ff97e2022$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $88dd954ff97e2022$var$_setPrototypeOf(o, p);
}
function $88dd954ff97e2022$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $88dd954ff97e2022$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $88dd954ff97e2022$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $88dd954ff97e2022$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $88dd954ff97e2022$var$_possibleConstructorReturn(this, result);
    };
}
function $88dd954ff97e2022$var$_possibleConstructorReturn(self, call) {
    if (call && ($88dd954ff97e2022$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $88dd954ff97e2022$var$_assertThisInitialized(self);
}
function $88dd954ff97e2022$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $88dd954ff97e2022$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $88dd954ff97e2022$var$_getPrototypeOf(o) {
    $88dd954ff97e2022$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $88dd954ff97e2022$var$_getPrototypeOf(o);
}
function $88dd954ff97e2022$var$_defineProperty(obj, key, value) {
    key = $88dd954ff97e2022$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $88dd954ff97e2022$var$_toPropertyKey(t) {
    var i = $88dd954ff97e2022$var$_toPrimitive(t, "string");
    return "symbol" == $88dd954ff97e2022$var$_typeof(i) ? i : String(i);
}
function $88dd954ff97e2022$var$_toPrimitive(t, r) {
    if ("object" != $88dd954ff97e2022$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $88dd954ff97e2022$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $88dd954ff97e2022$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "instantsearch"
});
function $88dd954ff97e2022$var$defaultCreateURL() {
    return "#";
}
var $88dd954ff97e2022$export$8bd42a83af1ca676 = {
    preserveSharedStateOnUnmount: false,
    persistHierarchicalRootCount: false
};
/**
 * The actual implementation of the InstantSearch. This is
 * created using the `instantsearch` factory function.
 * It emits the 'render' event every time a search is done
 */ var $88dd954ff97e2022$var$InstantSearch = /*#__PURE__*/ function(_EventEmitter) {
    $88dd954ff97e2022$var$_inherits(InstantSearch, _EventEmitter);
    var _super = $88dd954ff97e2022$var$_createSuper(InstantSearch);
    function InstantSearch(options) {
        var _options$future2;
        var _this;
        $88dd954ff97e2022$var$_classCallCheck(this, InstantSearch);
        _this = _super.call(this);
        // prevent `render` event listening from causing a warning
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "client", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "indexName", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "compositionID", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "insightsClient", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "onStateChange", null);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "future", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "helper", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "mainHelper", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "mainIndex", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "started", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "templatesConfig", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "renderState", {});
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "_stalledSearchDelay", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "_searchStalledTimer", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "_initialUiState", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "_initialResults", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "_createURL", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "_searchFunction", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "_mainHelperSearch", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "_hasSearchWidget", false);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "_hasRecommendWidget", false);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "_insights", void 0);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "middleware", []);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "sendEventToInsights", void 0);
        /**
     * The status of the search. Can be "idle", "loading", "stalled", or "error".
     */ $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "status", "idle");
        /**
     * The last returned error from the Search API.
     * The error gets cleared when the next valid search response is rendered.
     */ $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "error", undefined);
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "scheduleSearch", (0, $85ae0e158bdd4b58$export$260e5c0943f31606)(function() {
            if (_this.started) _this.mainHelper.search();
        }));
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "scheduleRender", (0, $85ae0e158bdd4b58$export$260e5c0943f31606)(function() {
            var _this$mainHelper;
            var shouldResetStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (!((_this$mainHelper = _this.mainHelper) !== null && _this$mainHelper !== void 0 && _this$mainHelper.hasPendingRequests())) {
                clearTimeout(_this._searchStalledTimer);
                _this._searchStalledTimer = null;
                if (shouldResetStatus) {
                    _this.status = "idle";
                    _this.error = undefined;
                }
            }
            _this.mainIndex.render({
                instantSearchInstance: $88dd954ff97e2022$var$_assertThisInitialized(_this)
            });
            _this.emit("render");
        }));
        $88dd954ff97e2022$var$_defineProperty($88dd954ff97e2022$var$_assertThisInitialized(_this), "onInternalStateChange", (0, $85ae0e158bdd4b58$export$260e5c0943f31606)(function() {
            var nextUiState = _this.mainIndex.getWidgetUiState({});
            _this.middleware.forEach(function(_ref) {
                var instance = _ref.instance;
                instance.onStateChange({
                    uiState: nextUiState
                });
            });
        }));
        _this.setMaxListeners(100);
        var _options$indexName = options.indexName, indexName = _options$indexName === void 0 ? "" : _options$indexName, compositionID = options.compositionID, numberLocale = options.numberLocale, _options$initialUiSta = options.initialUiState, initialUiState = _options$initialUiSta === void 0 ? {} : _options$initialUiSta, _options$routing = options.routing, routing = _options$routing === void 0 ? null : _options$routing, _options$insights = options.insights, insights = _options$insights === void 0 ? undefined : _options$insights, searchFunction = options.searchFunction, _options$stalledSearc = options.stalledSearchDelay, stalledSearchDelay = _options$stalledSearc === void 0 ? 200 : _options$stalledSearc, _options$searchClient = options.searchClient, searchClient = _options$searchClient === void 0 ? null : _options$searchClient, _options$insightsClie = options.insightsClient, insightsClient = _options$insightsClie === void 0 ? null : _options$insightsClie, _options$onStateChang = options.onStateChange, onStateChange = _options$onStateChang === void 0 ? null : _options$onStateChang, _options$future = options.future, future = _options$future === void 0 ? $88dd954ff97e2022$var$_objectSpread($88dd954ff97e2022$var$_objectSpread({}, $88dd954ff97e2022$export$8bd42a83af1ca676), options.future || {}) : _options$future;
        if (searchClient === null) throw new Error($88dd954ff97e2022$var$withUsage("The `searchClient` option is required."));
        if (typeof searchClient.search !== "function") throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
        if (typeof searchClient.addAlgoliaAgent === "function") searchClient.addAlgoliaAgent("instantsearch.js (".concat((0, $159f73dc06d5d946$export$2e2bcd8739ae039), ")"));
        if (insightsClient && typeof insightsClient !== "function") throw new Error($88dd954ff97e2022$var$withUsage("The `insightsClient` option should be a function."));
        _this.client = searchClient;
        _this.future = future;
        _this.insightsClient = insightsClient;
        _this.indexName = indexName;
        _this.compositionID = compositionID;
        _this.helper = null;
        _this.mainHelper = null;
        _this.mainIndex = (0, $96c57abe692e5254$export$2e2bcd8739ae039)({
            // we use an index widget to render compositions
            // this only works because there's only one composition index allow for now
            indexName: _this.compositionID || _this.indexName
        });
        _this.onStateChange = onStateChange;
        _this.started = false;
        _this.templatesConfig = {
            helpers: (0, $b4112abb41e3b631$export$2e2bcd8739ae039)({
                numberLocale: numberLocale
            }),
            compileOptions: {}
        };
        _this._stalledSearchDelay = stalledSearchDelay;
        _this._searchStalledTimer = null;
        _this._createURL = $88dd954ff97e2022$var$defaultCreateURL;
        _this._initialUiState = initialUiState;
        _this._initialResults = null;
        _this._insights = insights;
        if (searchFunction) _this._searchFunction = searchFunction;
        _this.sendEventToInsights = (0, $8fe091dcd40a4798$export$8793edee2d425525);
        if (routing) {
            var routerOptions = typeof routing === "boolean" ? {} : routing;
            routerOptions.$$internal = true;
            _this.use((0, $59e02f3065a5727d$export$1fe5128387816284)(routerOptions));
        }
        // This is the default Insights middleware,
        // added when `insights` is set to true by the user.
        // Any user-provided middleware will be added later and override this one.
        if (insights) {
            var insightsOptions = typeof insights === "boolean" ? {} : insights;
            insightsOptions.$$internal = true;
            _this.use((0, $ef593e4916349da0$export$91e0bf09562e2c44)(insightsOptions));
        }
        if ((0, $81e7405c0b8d0125$export$4b4254890acf93e7)()) _this.use((0, $81e7405c0b8d0125$export$8ee9d2447935ed96)({
            $$internal: true
        }));
        return _this;
    }
    /**
   * Hooks a middleware into the InstantSearch lifecycle.
   */ $88dd954ff97e2022$var$_createClass(InstantSearch, [
        {
            key: "_isSearchStalled",
            get: /**
     * @deprecated use `status === 'stalled'` instead
     */ function get() {
                return this.status === "stalled";
            }
        },
        {
            key: "use",
            value: function use() {
                var _this2 = this;
                for(var _len = arguments.length, middleware = new Array(_len), _key = 0; _key < _len; _key++)middleware[_key] = arguments[_key];
                var newMiddlewareList = middleware.map(function(fn) {
                    var newMiddleware = $88dd954ff97e2022$var$_objectSpread({
                        $$type: "__unknown__",
                        $$internal: false,
                        subscribe: (0, $8fe091dcd40a4798$export$8793edee2d425525),
                        started: (0, $8fe091dcd40a4798$export$8793edee2d425525),
                        unsubscribe: (0, $8fe091dcd40a4798$export$8793edee2d425525),
                        onStateChange: (0, $8fe091dcd40a4798$export$8793edee2d425525)
                    }, fn({
                        instantSearchInstance: _this2
                    }));
                    _this2.middleware.push({
                        creator: fn,
                        instance: newMiddleware
                    });
                    return newMiddleware;
                });
                // If the instance has already started, we directly subscribe the
                // middleware so they're notified of changes.
                if (this.started) newMiddlewareList.forEach(function(m) {
                    m.subscribe();
                    m.started();
                });
                return this;
            }
        },
        {
            key: "unuse",
            value: function unuse() {
                for(var _len2 = arguments.length, middlewareToUnuse = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)middlewareToUnuse[_key2] = arguments[_key2];
                this.middleware.filter(function(m) {
                    return middlewareToUnuse.includes(m.creator);
                }).forEach(function(m) {
                    return m.instance.unsubscribe();
                });
                this.middleware = this.middleware.filter(function(m) {
                    return !middlewareToUnuse.includes(m.creator);
                });
                return this;
            }
        },
        {
            key: "EXPERIMENTAL_use",
            value: function EXPERIMENTAL_use() {
                return this.use.apply(this, arguments);
            }
        },
        {
            key: "addWidget",
            value: function addWidget(widget) {
                return this.addWidgets([
                    widget
                ]);
            }
        },
        {
            key: "addWidgets",
            value: function addWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($88dd954ff97e2022$var$withUsage("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.init !== "function" && typeof widget.render !== "function";
                })) throw new Error($88dd954ff97e2022$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
                if (this.compositionID && widgets.some((0, $c5421e1e8593cec5$export$a9c9a0d43506297d))) throw new Error($88dd954ff97e2022$var$withUsage("The `index` widget cannot be used with a composition-based InstantSearch implementation."));
                this.mainIndex.addWidgets(widgets);
                return this;
            }
        },
        {
            key: "removeWidget",
            value: function removeWidget(widget) {
                return this.removeWidgets([
                    widget
                ]);
            }
        },
        {
            key: "removeWidgets",
            value: function removeWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($88dd954ff97e2022$var$withUsage("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.dispose !== "function";
                })) throw new Error($88dd954ff97e2022$var$withUsage("The widget definition expects a `dispose` method."));
                this.mainIndex.removeWidgets(widgets);
                return this;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this3 = this;
                if (this.started) throw new Error($88dd954ff97e2022$var$withUsage("The `start` method has already been called once."));
                // This Helper is used for the queries, we don't care about its state. The
                // states are managed at the `index` level. We use this Helper to create
                // DerivedHelper scoped into the `index` widgets.
                // In Vue InstantSearch' hydrate, a main helper gets set before start, so
                // we need to respect this helper as a way to keep all listeners correct.
                var mainHelper = this.mainHelper || (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports)))(this.client, this.indexName, undefined, {
                    persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
                });
                if (this.compositionID) mainHelper.searchForFacetValues = mainHelper.searchForCompositionFacetValues.bind(mainHelper);
                mainHelper.search = function() {
                    _this3.status = "loading";
                    _this3.scheduleRender(false);
                    // This solution allows us to keep the exact same API for the users but
                    // under the hood, we have a different implementation. It should be
                    // completely transparent for the rest of the codebase. Only this module
                    // is impacted.
                    if (_this3._hasSearchWidget) {
                        if (_this3.compositionID) mainHelper.searchWithComposition();
                        else mainHelper.searchOnlyWithDerivedHelpers();
                    }
                    if (_this3._hasRecommendWidget) mainHelper.recommend();
                    return mainHelper;
                };
                if (this._searchFunction) {
                    // this client isn't used to actually search, but required for the helper
                    // to not throw errors
                    var fakeClient = {
                        search: function search() {
                            return new Promise((0, $8fe091dcd40a4798$export$8793edee2d425525));
                        }
                    };
                    this._mainHelperSearch = mainHelper.search.bind(mainHelper);
                    mainHelper.search = function() {
                        var mainIndexHelper = _this3.mainIndex.getHelper();
                        var searchFunctionHelper = (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports)))(fakeClient, mainIndexHelper.state.index, mainIndexHelper.state);
                        searchFunctionHelper.once("search", function(_ref2) {
                            var state = _ref2.state;
                            mainIndexHelper.overrideStateWithoutTriggeringChangeEvent(state);
                            _this3._mainHelperSearch();
                        });
                        // Forward state changes from `searchFunctionHelper` to `mainIndexHelper`
                        searchFunctionHelper.on("change", function(_ref3) {
                            var state = _ref3.state;
                            mainIndexHelper.setState(state);
                        });
                        _this3._searchFunction(searchFunctionHelper);
                        return mainHelper;
                    };
                }
                // Only the "main" Helper emits the `error` event vs the one for `search`
                // and `results` that are also emitted on the derived one.
                mainHelper.on("error", function(_ref4) {
                    var error = _ref4.error;
                    if (!(error instanceof Error)) {
                        // typescript lies here, error is in some cases { name: string, message: string }
                        var err = error;
                        error = Object.keys(err).reduce(function(acc, key) {
                            acc[key] = err[key];
                            return acc;
                        }, new Error(err.message));
                    }
                    // If an error is emitted, it is re-thrown by events. In previous versions
                    // we emitted {error}, which is thrown as:
                    // "Uncaught, unspecified \"error\" event. ([object Object])"
                    // To avoid breaking changes, we make the error available in both
                    // `error` and `error.error`
                    // @MAJOR emit only error
                    error.error = error;
                    _this3.error = error;
                    _this3.status = "error";
                    _this3.scheduleRender(false);
                    // This needs to execute last because it throws the error.
                    _this3.emit("error", error);
                });
                this.mainHelper = mainHelper;
                this.middleware.forEach(function(_ref5) {
                    var instance = _ref5.instance;
                    instance.subscribe();
                });
                this.mainIndex.init({
                    instantSearchInstance: this,
                    parent: null,
                    uiState: this._initialUiState
                });
                if (this._initialResults) {
                    (0, $0d68108429183d43$export$7edf4eca27ca3a19)(this.client, this._initialResults);
                    (0, $9e59c372ed8eee3e$export$53ef00b131a96aa6)(this.mainHelper, this._initialResults);
                    var originalScheduleSearch = this.scheduleSearch;
                    // We don't schedule a first search when initial results are provided
                    // because we already have the results to render. This skips the initial
                    // network request on the browser on `start`.
                    this.scheduleSearch = (0, $85ae0e158bdd4b58$export$260e5c0943f31606)((0, $8fe091dcd40a4798$export$8793edee2d425525));
                    // We also skip the initial network request when widgets are dynamically
                    // added in the first tick (that's the case in all the framework-based flavors).
                    // When we add a widget to `index`, it calls `scheduleSearch`. We can rely
                    // on our `defer` util to restore the original `scheduleSearch` value once
                    // widgets are added to hook back to the regular lifecycle.
                    (0, $85ae0e158bdd4b58$export$260e5c0943f31606)(function() {
                        _this3.scheduleSearch = originalScheduleSearch;
                    })();
                } else if (this.mainIndex.getWidgets().length > 0) this.scheduleSearch();
                // Keep the previous reference for legacy purpose, some pattern use
                // the direct Helper access `search.helper` (e.g multi-index).
                this.helper = this.mainIndex.getHelper();
                // track we started the search if we add more widgets,
                // to init them directly after add
                this.started = true;
                this.middleware.forEach(function(_ref6) {
                    var instance = _ref6.instance;
                    instance.started();
                });
                // This is the automatic Insights middleware,
                // added when `insights` is unset and the initial results possess `queryID`.
                // Any user-provided middleware will be added later and override this one.
                if (typeof this._insights === "undefined") mainHelper.derivedHelpers[0].once("result", function() {
                    var hasAutomaticInsights = _this3.mainIndex.getScopedResults().some(function(_ref7) {
                        var results = _ref7.results;
                        return results === null || results === void 0 ? void 0 : results._automaticInsights;
                    });
                    if (hasAutomaticInsights) _this3.use((0, $ef593e4916349da0$export$91e0bf09562e2c44)({
                        $$internal: true,
                        $$automatic: true
                    }));
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this$mainHelper2;
                this.scheduleSearch.cancel();
                this.scheduleRender.cancel();
                clearTimeout(this._searchStalledTimer);
                this.removeWidgets(this.mainIndex.getWidgets());
                this.mainIndex.dispose();
                // You can not start an instance two times, therefore a disposed instance
                // needs to set started as false otherwise this can not be restarted at a
                // later point.
                this.started = false;
                // The helper needs to be reset to perform the next search from a fresh state.
                // If not reset, it would use the state stored before calling `dispose()`.
                this.removeAllListeners();
                (_this$mainHelper2 = this.mainHelper) === null || _this$mainHelper2 === void 0 || _this$mainHelper2.removeAllListeners();
                this.mainHelper = null;
                this.helper = null;
                this.middleware.forEach(function(_ref8) {
                    var instance = _ref8.instance;
                    instance.unsubscribe();
                });
            }
        },
        {
            key: "scheduleStalledRender",
            value: function scheduleStalledRender() {
                var _this4 = this;
                if (!this._searchStalledTimer) this._searchStalledTimer = setTimeout(function() {
                    _this4.status = "stalled";
                    _this4.scheduleRender();
                }, this._stalledSearchDelay);
            }
        },
        {
            key: "setUiState",
            value: function setUiState(uiState) {
                var _this5 = this;
                var callOnStateChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (!this.mainHelper) throw new Error($88dd954ff97e2022$var$withUsage("The `start` method needs to be called before `setUiState`."));
                // We refresh the index UI state to update the local UI state that the
                // main index passes to the function form of `setUiState`.
                this.mainIndex.refreshUiState();
                var nextUiState = typeof uiState === "function" ? uiState(this.mainIndex.getWidgetUiState({})) : uiState;
                if (this.onStateChange && callOnStateChange) this.onStateChange({
                    uiState: nextUiState,
                    setUiState: function setUiState(finalUiState) {
                        (0, $0de2cc3ab8bc4407$export$fd5e8f1329b3d5e0)(typeof finalUiState === "function" ? finalUiState(nextUiState) : finalUiState, _this5.mainIndex);
                        _this5.scheduleSearch();
                        _this5.onInternalStateChange();
                    }
                });
                else {
                    (0, $0de2cc3ab8bc4407$export$fd5e8f1329b3d5e0)(nextUiState, this.mainIndex);
                    this.scheduleSearch();
                    this.onInternalStateChange();
                }
            }
        },
        {
            key: "getUiState",
            value: function getUiState() {
                if (this.started) // We refresh the index UI state to make sure changes from `refine` are taken in account
                this.mainIndex.refreshUiState();
                return this.mainIndex.getWidgetUiState({});
            }
        },
        {
            key: "createURL",
            value: function createURL() {
                var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.started) throw new Error($88dd954ff97e2022$var$withUsage("The `start` method needs to be called before `createURL`."));
                return this._createURL(nextState);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (!this.mainHelper) throw new Error($88dd954ff97e2022$var$withUsage("The `start` method needs to be called before `refresh`."));
                this.mainHelper.clearCache().search();
            }
        }
    ]);
    return InstantSearch;
}((0, (/*@__PURE__*/$parcel$interopDefault($a1a5fc99466dfdf0$exports))));
var $88dd954ff97e2022$export$2e2bcd8739ae039 = $88dd954ff97e2022$var$InstantSearch;



/**
 * Logs a warning when this function is called, in development environment only.
 */ var $07af83c46f96ca29$export$b680e6b2c82f8c2f = function deprecate(fn, message) {
    return fn;
};
/**
 * Logs a warning
 * This is used to log issues in development environment only.
 */ var $07af83c46f96ca29$export$c106dd0671a0fc2d = (0, $8fe091dcd40a4798$export$8793edee2d425525);
/**
 * Logs a warning if the condition is not met.
 * This is used to log issues in development environment only.
 */ var $07af83c46f96ca29$export$491112666e282270 = (0, $8fe091dcd40a4798$export$8793edee2d425525);




/**
 * InstantSearch is the main component of InstantSearch.js. This object
 * manages the widget and lets you add new ones.
 *
 * Two parameters are required to get you started with InstantSearch.js:
 *  - `indexName`: the main index that you will use for your new search UI
 *  - `searchClient`: the search client to plug to InstantSearch.js
 *
 * The [search client provided by Algolia](algolia.com/doc/api-client/getting-started/what-is-the-api-client/javascript/)
 * needs an `appId` and an `apiKey`. Those parameters can be found in your
 * [Algolia dashboard](https://www.algolia.com/api-keys).
 *
 * If you want to get up and running quickly with InstantSearch.js, have a
 * look at the [getting started](https://www.algolia.com/doc/guides/building-search-ui/getting-started/js/).
 */ var $2b5585e42594a41c$var$instantsearch = function instantsearch(options) {
    return new (0, $88dd954ff97e2022$export$2e2bcd8739ae039)(options);
};
$2b5585e42594a41c$var$instantsearch.version = (0, $159f73dc06d5d946$export$2e2bcd8739ae039);
$2b5585e42594a41c$var$instantsearch.createInfiniteHitsSessionStorageCache = (0, $07af83c46f96ca29$export$b680e6b2c82f8c2f)((0, $1d19869c4e5f6004$export$2e2bcd8739ae039), "import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache'");
$2b5585e42594a41c$var$instantsearch.highlight = (0, $07af83c46f96ca29$export$b680e6b2c82f8c2f)((0, $a04f80f894e77137$export$2e2bcd8739ae039), "import { highlight } from 'instantsearch.js/es/helpers'");
$2b5585e42594a41c$var$instantsearch.reverseHighlight = (0, $07af83c46f96ca29$export$b680e6b2c82f8c2f)((0, $1c0dfaf5220411d2$export$2e2bcd8739ae039), "import { reverseHighlight } from 'instantsearch.js/es/helpers'");
$2b5585e42594a41c$var$instantsearch.snippet = (0, $07af83c46f96ca29$export$b680e6b2c82f8c2f)((0, $9bab6399914ee67a$export$2e2bcd8739ae039), "import { snippet } from 'instantsearch.js/es/helpers'");
$2b5585e42594a41c$var$instantsearch.reverseSnippet = (0, $07af83c46f96ca29$export$b680e6b2c82f8c2f)((0, $3f04f3deb6088df4$export$2e2bcd8739ae039), "import { reverseSnippet } from 'instantsearch.js/es/helpers'");
$2b5585e42594a41c$var$instantsearch.insights = (0, $54d2c88a789bd99d$export$2e2bcd8739ae039);
$2b5585e42594a41c$var$instantsearch.getInsightsAnonymousUserToken = (0, $48acce04fdc682d2$export$2e2bcd8739ae039);
Object.defineProperty($2b5585e42594a41c$var$instantsearch, "widgets", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets'");
    }
});
Object.defineProperty($2b5585e42594a41c$var$instantsearch, "connectors", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors'");
    }
});
Object.defineProperty($2b5585e42594a41c$var$instantsearch, "templates", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.templates\" are not available from the ES build.\n\nTo import the templates:\n\nimport { carousel } from 'instantsearch.js/es/templates'");
    }
});
var $2b5585e42594a41c$export$2e2bcd8739ae039 = $2b5585e42594a41c$var$instantsearch;


function $215e0fa3bda6c298$export$11cc42aebef2ef3a(object) {
    return Object.prototype.toString.call(object).slice(8, -1);
}


function $1575d32251b25e2a$export$adc2a8e09aa583ee(rendering, usage) {
    if (rendering === undefined || typeof rendering !== "function") throw new Error("The render function is not valid (received type ".concat((0, $215e0fa3bda6c298$export$11cc42aebef2ef3a)(rendering), ").\n\n").concat(usage));
}


function $9ac8c4a7dd77473d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9ac8c4a7dd77473d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9ac8c4a7dd77473d$var$_typeof(o);
}
function $9ac8c4a7dd77473d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ac8c4a7dd77473d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ac8c4a7dd77473d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9ac8c4a7dd77473d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ac8c4a7dd77473d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9ac8c4a7dd77473d$var$_defineProperty(obj, key, value) {
    key = $9ac8c4a7dd77473d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9ac8c4a7dd77473d$var$_toPropertyKey(t) {
    var i = $9ac8c4a7dd77473d$var$_toPrimitive(t, "string");
    return "symbol" == $9ac8c4a7dd77473d$var$_typeof(i) ? i : String(i);
}
function $9ac8c4a7dd77473d$var$_toPrimitive(t, r) {
    if ("object" != $9ac8c4a7dd77473d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9ac8c4a7dd77473d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9ac8c4a7dd77473d$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "sort-by",
    connector: true
});
/**
 * The **SortBy** connector provides the logic to build a custom widget that will display a
 * list of indices. With Algolia, this is most commonly used for changing ranking strategy. This allows
 * a user to change how the hits are being sorted.
 */ var $9ac8c4a7dd77473d$var$connectSortBy = function connectSortBy(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8fe091dcd40a4798$export$8793edee2d425525);
    (0, $1575d32251b25e2a$export$adc2a8e09aa583ee)(renderFn, $9ac8c4a7dd77473d$var$withUsage());
    var connectorState = {};
    return function(widgetParams) {
        var _ref = widgetParams || {}, items = _ref.items, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(x) {
            return x;
        } : _ref$transformItems;
        if (!Array.isArray(items)) throw new Error($9ac8c4a7dd77473d$var$withUsage("The `items` option expects an array of objects."));
        return {
            $$type: "ais.sortBy",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                var widgetRenderState = this.getWidgetRenderState(initOptions);
                var currentIndex = widgetRenderState.currentRefinement;
                var isCurrentIndexInItems = (0, $3a145725faa3321d$export$71aa6c912b956294)(items, function(item) {
                    return item.value === currentIndex;
                });
                renderFn($9ac8c4a7dd77473d$var$_objectSpread($9ac8c4a7dd77473d$var$_objectSpread({}, widgetRenderState), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($9ac8c4a7dd77473d$var$_objectSpread($9ac8c4a7dd77473d$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return connectorState.initialIndex ? state.setIndex(connectorState.initialIndex) : state;
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $9ac8c4a7dd77473d$var$_objectSpread($9ac8c4a7dd77473d$var$_objectSpread({}, renderState), {}, {
                    sortBy: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var results = _ref3.results, helper = _ref3.helper, state = _ref3.state, parent = _ref3.parent;
                if (!connectorState.initialIndex && parent) connectorState.initialIndex = parent.getIndexName();
                if (!connectorState.setIndex) connectorState.setIndex = function(indexName) {
                    helper.setIndex(indexName).search();
                };
                var hasNoResults = results ? results.nbHits === 0 : true;
                return {
                    currentRefinement: state.index,
                    options: transformItems(items, {
                        results: results
                    }),
                    refine: connectorState.setIndex,
                    hasNoResults: hasNoResults,
                    canRefine: !hasNoResults && items.length > 0,
                    widgetParams: widgetParams
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var currentIndex = searchParameters.index;
                return $9ac8c4a7dd77473d$var$_objectSpread($9ac8c4a7dd77473d$var$_objectSpread({}, uiState), {}, {
                    sortBy: currentIndex !== connectorState.initialIndex ? currentIndex : undefined
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter("index", uiState.sortBy || connectorState.initialIndex || searchParameters.index);
            }
        };
    };
};
var $9ac8c4a7dd77473d$export$2e2bcd8739ae039 = $9ac8c4a7dd77473d$var$connectSortBy;


function $7b535fe936875edd$var$_toConsumableArray(arr) {
    return $7b535fe936875edd$var$_arrayWithoutHoles(arr) || $7b535fe936875edd$var$_iterableToArray(arr) || $7b535fe936875edd$var$_unsupportedIterableToArray(arr) || $7b535fe936875edd$var$_nonIterableSpread();
}
function $7b535fe936875edd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7b535fe936875edd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7b535fe936875edd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7b535fe936875edd$var$_arrayLikeToArray(o, minLen);
}
function $7b535fe936875edd$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $7b535fe936875edd$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $7b535fe936875edd$var$_arrayLikeToArray(arr);
}
function $7b535fe936875edd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7b535fe936875edd$export$d02631cccf789723(_ref) {
    var _ref$start = _ref.start, start = _ref$start === void 0 ? 0 : _ref$start, end = _ref.end, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step;
    // We can't divide by 0 so we re-assign the step to 1 if it happens.
    var limitStep = step === 0 ? 1 : step;
    // In some cases the array to create has a decimal length.
    // We therefore need to round the value.
    // Example:
    //   { start: 1, end: 5000, step: 500 }
    //   => Array length = (5000 - 1) / 500 = 9.998
    var arrayLength = Math.round((end - start) / limitStep);
    return $7b535fe936875edd$var$_toConsumableArray(Array(arrayLength)).map(function(_, current) {
        return start + current * limitStep;
    });
}


function $46d797c5326634ac$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $46d797c5326634ac$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $46d797c5326634ac$var$_typeof(o);
}
function $46d797c5326634ac$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $46d797c5326634ac$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $46d797c5326634ac$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $46d797c5326634ac$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $46d797c5326634ac$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $46d797c5326634ac$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $46d797c5326634ac$var$_defineProperty(obj, key, value) {
    key = $46d797c5326634ac$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $46d797c5326634ac$var$_toPropertyKey(t) {
    var i = $46d797c5326634ac$var$_toPrimitive(t, "string");
    return "symbol" == $46d797c5326634ac$var$_typeof(i) ? i : String(i);
}
function $46d797c5326634ac$var$_toPrimitive(t, r) {
    if ("object" != $46d797c5326634ac$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $46d797c5326634ac$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $46d797c5326634ac$var$Paginator = /*#__PURE__*/ function() {
    function Paginator(params) {
        $46d797c5326634ac$var$_classCallCheck(this, Paginator);
        $46d797c5326634ac$var$_defineProperty(this, "currentPage", void 0);
        $46d797c5326634ac$var$_defineProperty(this, "total", void 0);
        $46d797c5326634ac$var$_defineProperty(this, "padding", void 0);
        this.currentPage = params.currentPage;
        this.total = params.total;
        this.padding = params.padding;
    }
    $46d797c5326634ac$var$_createClass(Paginator, [
        {
            key: "pages",
            value: function pages() {
                var total = this.total, currentPage = this.currentPage, padding = this.padding;
                if (total === 0) return [
                    0
                ];
                var totalDisplayedPages = this.nbPagesDisplayed(padding, total);
                if (totalDisplayedPages === total) return (0, $7b535fe936875edd$export$d02631cccf789723)({
                    end: total
                });
                var paddingLeft = this.calculatePaddingLeft(currentPage, padding, total, totalDisplayedPages);
                var paddingRight = totalDisplayedPages - paddingLeft;
                var first = currentPage - paddingLeft;
                var last = currentPage + paddingRight;
                return (0, $7b535fe936875edd$export$d02631cccf789723)({
                    start: first,
                    end: last
                });
            }
        },
        {
            key: "nbPagesDisplayed",
            value: function nbPagesDisplayed(padding, total) {
                return Math.min(2 * padding + 1, total);
            }
        },
        {
            key: "calculatePaddingLeft",
            value: function calculatePaddingLeft(current, padding, total, totalDisplayedPages) {
                if (current <= padding) return current;
                if (current >= total - padding) return totalDisplayedPages - (total - current);
                return padding;
            }
        },
        {
            key: "isLastPage",
            value: function isLastPage() {
                return this.currentPage >= this.total - 1;
            }
        },
        {
            key: "isFirstPage",
            value: function isFirstPage() {
                return this.currentPage <= 0;
            }
        }
    ]);
    return Paginator;
}();
var $46d797c5326634ac$export$2e2bcd8739ae039 = $46d797c5326634ac$var$Paginator;


function $3c3032902dc84f8e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3c3032902dc84f8e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3c3032902dc84f8e$var$_typeof(o);
}
function $3c3032902dc84f8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c3032902dc84f8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c3032902dc84f8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3c3032902dc84f8e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c3032902dc84f8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3c3032902dc84f8e$var$_defineProperty(obj, key, value) {
    key = $3c3032902dc84f8e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3c3032902dc84f8e$var$_toPropertyKey(t) {
    var i = $3c3032902dc84f8e$var$_toPrimitive(t, "string");
    return "symbol" == $3c3032902dc84f8e$var$_typeof(i) ? i : String(i);
}
function $3c3032902dc84f8e$var$_toPrimitive(t, r) {
    if ("object" != $3c3032902dc84f8e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3c3032902dc84f8e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3c3032902dc84f8e$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "pagination",
    connector: true
});
/**
 * **Pagination** connector provides the logic to build a widget that will let the user
 * choose the current page of the results.
 *
 * When using the pagination with Algolia, you should be aware that the engine won't provide you pages
 * beyond the 1000th hits by default. You can find more information on the [Algolia documentation](https://www.algolia.com/doc/guides/searching/pagination/#pagination-limitations).
 */ var $3c3032902dc84f8e$var$connectPagination = function connectPagination(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8fe091dcd40a4798$export$8793edee2d425525);
    (0, $1575d32251b25e2a$export$adc2a8e09aa583ee)(renderFn, $3c3032902dc84f8e$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, totalPages = _ref.totalPages, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? 3 : _ref$padding;
        var pager = new (0, $46d797c5326634ac$export$2e2bcd8739ae039)({
            currentPage: 0,
            total: 0,
            padding: padding
        });
        var connectorState = {};
        function getMaxPage(_ref2) {
            var nbPages = _ref2.nbPages;
            return totalPages !== undefined ? Math.min(totalPages, nbPages) : nbPages;
        }
        return {
            $$type: "ais.pagination",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($3c3032902dc84f8e$var$_objectSpread($3c3032902dc84f8e$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($3c3032902dc84f8e$var$_objectSpread($3c3032902dc84f8e$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                return state.setQueryParameter("page", undefined);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var page = searchParameters.page || 0;
                if (!page) return uiState;
                return $3c3032902dc84f8e$var$_objectSpread($3c3032902dc84f8e$var$_objectSpread({}, uiState), {}, {
                    page: page + 1
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                var page = uiState.page ? uiState.page - 1 : 0;
                return searchParameters.setQueryParameter("page", page);
            },
            getWidgetRenderState: function getWidgetRenderState(_ref6) {
                var results = _ref6.results, helper = _ref6.helper, state = _ref6.state, createURL = _ref6.createURL;
                if (!connectorState.refine) connectorState.refine = function(page) {
                    helper.setPage(page);
                    helper.search();
                };
                if (!connectorState.createURL) connectorState.createURL = function(page) {
                    return createURL(function(uiState) {
                        return $3c3032902dc84f8e$var$_objectSpread($3c3032902dc84f8e$var$_objectSpread({}, uiState), {}, {
                            page: page + 1
                        });
                    });
                };
                var page = state.page || 0;
                var nbPages = getMaxPage(results || {
                    nbPages: 0
                });
                pager.currentPage = page;
                pager.total = nbPages;
                return {
                    createURL: connectorState.createURL,
                    refine: connectorState.refine,
                    canRefine: nbPages > 1,
                    currentRefinement: page,
                    nbHits: (results === null || results === void 0 ? void 0 : results.nbHits) || 0,
                    nbPages: nbPages,
                    pages: results ? pager.pages() : [],
                    isFirstPage: pager.isFirstPage(),
                    isLastPage: pager.isLastPage(),
                    widgetParams: widgetParams
                };
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $3c3032902dc84f8e$var$_objectSpread($3c3032902dc84f8e$var$_objectSpread({}, renderState), {}, {
                    pagination: this.getWidgetRenderState(renderOptions)
                });
            }
        };
    };
};
var $3c3032902dc84f8e$export$2e2bcd8739ae039 = $3c3032902dc84f8e$var$connectPagination;




function $729cd43df9235464$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $729cd43df9235464$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $729cd43df9235464$var$_typeof(o);
}
function $729cd43df9235464$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $729cd43df9235464$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $729cd43df9235464$var$ownKeys(Object(t), !0).forEach(function(r) {
            $729cd43df9235464$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $729cd43df9235464$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $729cd43df9235464$var$_defineProperty(obj, key, value) {
    key = $729cd43df9235464$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $729cd43df9235464$var$_toPropertyKey(t) {
    var i = $729cd43df9235464$var$_toPrimitive(t, "string");
    return "symbol" == $729cd43df9235464$var$_typeof(i) ? i : String(i);
}
function $729cd43df9235464$var$_toPrimitive(t, r) {
    if ("object" != $729cd43df9235464$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $729cd43df9235464$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * Refine the given search parameters.
 */ var $729cd43df9235464$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "configure",
    connector: true
});
function $729cd43df9235464$var$getInitialSearchParameters(state, widgetParams) {
    // We leverage the helper internals to remove the `widgetParams` from
    // the state. The function `setQueryParameters` omits the values that
    // are `undefined` on the next state.
    return state.setQueryParameters(Object.keys(widgetParams.searchParameters).reduce(function(acc, key) {
        return $729cd43df9235464$var$_objectSpread($729cd43df9235464$var$_objectSpread({}, acc), {}, $729cd43df9235464$var$_defineProperty({}, key, undefined));
    }, {}));
}
var $729cd43df9235464$var$connectConfigure = function connectConfigure() {
    var renderFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $8fe091dcd40a4798$export$8793edee2d425525);
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8fe091dcd40a4798$export$8793edee2d425525);
    return function(widgetParams) {
        if (!widgetParams || !(0, $98634d9e355ebef6$export$53b83ca8eaab0383)(widgetParams.searchParameters)) throw new Error($729cd43df9235464$var$withUsage("The `searchParameters` option expects an object."));
        var connectorState = {};
        function refine(helper) {
            return function(searchParameters) {
                // Merge new `searchParameters` with the ones set from other widgets
                var actualState = $729cd43df9235464$var$getInitialSearchParameters(helper.state, widgetParams);
                var nextSearchParameters = (0, $fdec58dce645e387$export$8049d91f25899769)(actualState, new (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).SearchParameters(searchParameters));
                // Update original `widgetParams.searchParameters` to the new refined one
                widgetParams.searchParameters = searchParameters;
                // Trigger a search with the resolved search parameters
                helper.setState(nextSearchParameters).search();
            };
        }
        return {
            $$type: "ais.configure",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($729cd43df9235464$var$_objectSpread($729cd43df9235464$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($729cd43df9235464$var$_objectSpread($729cd43df9235464$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref) {
                var state = _ref.state;
                unmountFn();
                return $729cd43df9235464$var$getInitialSearchParameters(state, widgetParams);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                var _renderState$configur;
                var widgetRenderState = this.getWidgetRenderState(renderOptions);
                return $729cd43df9235464$var$_objectSpread($729cd43df9235464$var$_objectSpread({}, renderState), {}, {
                    configure: $729cd43df9235464$var$_objectSpread($729cd43df9235464$var$_objectSpread({}, widgetRenderState), {}, {
                        widgetParams: $729cd43df9235464$var$_objectSpread($729cd43df9235464$var$_objectSpread({}, widgetRenderState.widgetParams), {}, {
                            searchParameters: (0, $fdec58dce645e387$export$8049d91f25899769)(new (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).SearchParameters((_renderState$configur = renderState.configure) === null || _renderState$configur === void 0 ? void 0 : _renderState$configur.widgetParams.searchParameters), new (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).SearchParameters(widgetRenderState.widgetParams.searchParameters)).getQueryParams()
                        })
                    })
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var helper = _ref2.helper;
                if (!connectorState.refine) connectorState.refine = refine(helper);
                return {
                    refine: connectorState.refine,
                    widgetParams: widgetParams
                };
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref3) {
                var uiState = _ref3.uiState;
                return (0, $fdec58dce645e387$export$8049d91f25899769)(state, new (0, (/*@__PURE__*/$parcel$interopDefault($0fe43ba187e86394$exports))).SearchParameters($729cd43df9235464$var$_objectSpread($729cd43df9235464$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)));
            },
            getWidgetUiState: function getWidgetUiState(uiState) {
                return $729cd43df9235464$var$_objectSpread($729cd43df9235464$var$_objectSpread({}, uiState), {}, {
                    configure: $729cd43df9235464$var$_objectSpread($729cd43df9235464$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)
                });
            }
        };
    };
};
var $729cd43df9235464$export$2e2bcd8739ae039 = $729cd43df9235464$var$connectConfigure;



function $ffa7e0591390fe97$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ffa7e0591390fe97$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ffa7e0591390fe97$var$_typeof(o);
}
function $ffa7e0591390fe97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ffa7e0591390fe97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ffa7e0591390fe97$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ffa7e0591390fe97$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ffa7e0591390fe97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ffa7e0591390fe97$var$_defineProperty(obj, key, value) {
    key = $ffa7e0591390fe97$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ffa7e0591390fe97$var$_toPropertyKey(t) {
    var i = $ffa7e0591390fe97$var$_toPrimitive(t, "string");
    return "symbol" == $ffa7e0591390fe97$var$_typeof(i) ? i : String(i);
}
function $ffa7e0591390fe97$var$_toPrimitive(t, r) {
    if ("object" != $ffa7e0591390fe97$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ffa7e0591390fe97$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * A list of [search parameters](https://www.algolia.com/doc/api-reference/search-api-parameters/)
 * to enable when the widget mounts.
 */ var $ffa7e0591390fe97$var$configure = function configure(widgetParams) {
    // This is a renderless widget that falls back to the connector's
    // noop render and unmount functions.
    var makeWidget = (0, $729cd43df9235464$export$2e2bcd8739ae039)((0, $8fe091dcd40a4798$export$8793edee2d425525));
    return $ffa7e0591390fe97$var$_objectSpread($ffa7e0591390fe97$var$_objectSpread({}, makeWidget({
        searchParameters: widgetParams
    })), {}, {
        $$widgetType: "ais.configure"
    });
};
var $ffa7e0591390fe97$export$2e2bcd8739ae039 = $ffa7e0591390fe97$var$configure;

function $ec2c038c8c5a38bf$export$a274e22fb40f762e() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.reduce(function(acc, className) {
        if (Array.isArray(className)) return acc.concat(className);
        return acc.concat([
            className
        ]);
    }, []).filter(Boolean).join(" ");
}


var $64f0190ec946a978$var$n, $64f0190ec946a978$export$41c562ebe57d11e2, $64f0190ec946a978$var$u, $64f0190ec946a978$export$a8257692ac88316c, $64f0190ec946a978$var$i, $64f0190ec946a978$var$o, $64f0190ec946a978$var$r, $64f0190ec946a978$var$f, $64f0190ec946a978$var$e, $64f0190ec946a978$var$c, $64f0190ec946a978$var$s, $64f0190ec946a978$var$a, $64f0190ec946a978$var$h = {}, $64f0190ec946a978$var$p = [], $64f0190ec946a978$var$v = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $64f0190ec946a978$var$y = Array.isArray;
function $64f0190ec946a978$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $64f0190ec946a978$var$w(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $64f0190ec946a978$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $64f0190ec946a978$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $64f0190ec946a978$var$g(l, f, i, o, null);
}
function $64f0190ec946a978$var$g(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$64f0190ec946a978$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $64f0190ec946a978$export$41c562ebe57d11e2.vnode && $64f0190ec946a978$export$41c562ebe57d11e2.vnode(f), f;
}
function $64f0190ec946a978$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $64f0190ec946a978$export$ffb0004e005737fa(n) {
    return n.children;
}
function $64f0190ec946a978$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $64f0190ec946a978$var$x(n, l) {
    if (null == l) return n.__ ? $64f0190ec946a978$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $64f0190ec946a978$var$x(n) : null;
}
function $64f0190ec946a978$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $64f0190ec946a978$var$C(n);
    }
}
function $64f0190ec946a978$var$M(n) {
    (!n.__d && (n.__d = !0) && $64f0190ec946a978$var$i.push(n) && !$64f0190ec946a978$var$P.__r++ || $64f0190ec946a978$var$o !== $64f0190ec946a978$export$41c562ebe57d11e2.debounceRendering) && (($64f0190ec946a978$var$o = $64f0190ec946a978$export$41c562ebe57d11e2.debounceRendering) || $64f0190ec946a978$var$r)($64f0190ec946a978$var$P);
}
function $64f0190ec946a978$var$P() {
    var n, u, t, o, r, e, c, s;
    for($64f0190ec946a978$var$i.sort($64f0190ec946a978$var$f); n = $64f0190ec946a978$var$i.shift();)n.__d && (u = $64f0190ec946a978$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $64f0190ec946a978$var$d({}, r)).__v = r.__v + 1, $64f0190ec946a978$export$41c562ebe57d11e2.vnode && $64f0190ec946a978$export$41c562ebe57d11e2.vnode(o), $64f0190ec946a978$var$O(t.__P, o, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $64f0190ec946a978$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $64f0190ec946a978$var$j(c, o, s), o.__e != e && $64f0190ec946a978$var$C(o)), $64f0190ec946a978$var$i.length > u && $64f0190ec946a978$var$i.sort($64f0190ec946a978$var$f));
    $64f0190ec946a978$var$P.__r = 0;
}
function $64f0190ec946a978$var$S(n, l, u, t, i, o, r, f, e, c, s) {
    var a, v, y, d, w, _ = t && t.__k || $64f0190ec946a978$var$p, g = l.length;
    for(u.__d = e, $64f0190ec946a978$var$$(u, l, _), e = u.__d, a = 0; a < g; a++)null != (y = u.__k[a]) && "boolean" != typeof y && "function" != typeof y && (v = -1 === y.__i ? $64f0190ec946a978$var$h : _[y.__i] || $64f0190ec946a978$var$h, y.__i = a, $64f0190ec946a978$var$O(n, y, v, i, o, r, f, e, c, s), d = y.__e, y.ref && v.ref != y.ref && (v.ref && $64f0190ec946a978$var$N(v.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 65536 & y.__u || v.__k === y.__k ? e = $64f0190ec946a978$var$I(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = w;
}
function $64f0190ec946a978$var$$(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)r = t + a, null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $64f0190ec946a978$var$g(null, i, null, null, null) : $64f0190ec946a978$var$y(i) ? $64f0190ec946a978$var$g($64f0190ec946a978$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $64f0190ec946a978$var$g(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $64f0190ec946a978$var$L(i, u, r, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f == r - 1 ? a-- : f == r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : f < r && (f == r - a ? a -= f - r : a++), f !== t + a && (i.__u |= 65536))) : (o = u[r]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $64f0190ec946a978$var$x(o)), $64f0190ec946a978$var$V(o, o, !1), u[r] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $64f0190ec946a978$var$x(o)), $64f0190ec946a978$var$V(o, o));
}
function $64f0190ec946a978$var$I(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $64f0190ec946a978$var$I(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $64f0190ec946a978$var$x(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $64f0190ec946a978$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($64f0190ec946a978$var$y(n) ? n.some(function(n) {
        $64f0190ec946a978$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $64f0190ec946a978$var$L(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $64f0190ec946a978$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $64f0190ec946a978$var$v.test(l) ? u : u + "px";
}
function $64f0190ec946a978$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $64f0190ec946a978$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $64f0190ec946a978$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $64f0190ec946a978$var$e, n.addEventListener(l, o ? $64f0190ec946a978$var$s : $64f0190ec946a978$var$c, o)) : n.removeEventListener(l, o ? $64f0190ec946a978$var$s : $64f0190ec946a978$var$c, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $64f0190ec946a978$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $64f0190ec946a978$var$e++;
            else if (u.t < t.u) return;
            return t($64f0190ec946a978$export$41c562ebe57d11e2.event ? $64f0190ec946a978$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $64f0190ec946a978$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, p, v, w, _, g, m, x, C, M, P, $, I, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $64f0190ec946a978$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (m = u.props, x = "prototype" in T && T.prototype.render, C = (a = T.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? g = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(m, M) : (u.__c = h = new $64f0190ec946a978$export$16fa2f45be04daa8(m, M), h.constructor = T, h.render = $64f0190ec946a978$var$q), C && C.sub(h), h.props = m, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $64f0190ec946a978$var$d({}, h.__s)), $64f0190ec946a978$var$d(h.__s, T.getDerivedStateFromProps(m, h.__s))), v = h.props, w = h.state, h.__v = u, p) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && m !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, M) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, M), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, w, _);
            });
        }
        if (h.context = M, h.props = m, h.__P = n, h.__e = !1, $ = $64f0190ec946a978$export$41c562ebe57d11e2.__r, I = 0, x) {
            for(h.state = h.__s, h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $64f0190ec946a978$var$d($64f0190ec946a978$var$d({}, i), h.getChildContext())), x && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, w)), $64f0190ec946a978$var$S(n, $64f0190ec946a978$var$y(L = null != a && a.type === $64f0190ec946a978$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), g && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            for(u.__u |= c ? 160 : 32; e && 8 === e.nodeType && e.nextSibling;)e = e.nextSibling;
            r[r.indexOf(e)] = null, u.__e = e;
        } else u.__e = t.__e, u.__k = t.__k;
        $64f0190ec946a978$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $64f0190ec946a978$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $64f0190ec946a978$export$41c562ebe57d11e2.diffed) && a(u);
}
function $64f0190ec946a978$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$64f0190ec946a978$var$N(t[i], t[++i], t[++i]);
    $64f0190ec946a978$export$41c562ebe57d11e2.__c && $64f0190ec946a978$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $64f0190ec946a978$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $64f0190ec946a978$var$z(l, u, t, i, o, r, f, e, c) {
    var s, a, p, v, d, _, g, m = t.props, k = u.props, b = u.type;
    if ("svg" === b ? o = "http://www.w3.org/2000/svg" : "math" === b ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != r) {
        for(s = 0; s < r.length; s++)if ((d = r[s]) && "setAttribute" in d == !!b && (b ? d.localName === b : 3 === d.nodeType)) {
            l = d, r[s] = null;
            break;
        }
    }
    if (null == l) {
        if (null === b) return document.createTextNode(k);
        l = document.createElementNS(o, b, k.is && k), r = null, e = !1;
    }
    if (null === b) m === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && $64f0190ec946a978$var$n.call(l.childNodes), m = t.props || $64f0190ec946a978$var$h, !e && null != r) for(m = {}, s = 0; s < l.attributes.length; s++)m[(d = l.attributes[s]).name] = d.value;
        for(s in m)if (d = m[s], "children" == s) ;
        else if ("dangerouslySetInnerHTML" == s) p = d;
        else if ("key" !== s && !(s in k)) {
            if ("value" == s && "defaultValue" in k || "checked" == s && "defaultChecked" in k) continue;
            $64f0190ec946a978$var$A(l, s, null, d, o);
        }
        for(s in k)d = k[s], "children" == s ? v = d : "dangerouslySetInnerHTML" == s ? a = d : "value" == s ? _ = d : "checked" == s ? g = d : "key" === s || e && "function" != typeof d || m[s] === d || $64f0190ec946a978$var$A(l, s, d, m[s], o);
        if (a) e || p && (a.__html === p.__html || a.__html === l.innerHTML) || (l.innerHTML = a.__html), u.__k = [];
        else if (p && (l.innerHTML = ""), $64f0190ec946a978$var$S(l, $64f0190ec946a978$var$y(v) ? v : [
            v
        ], u, t, i, "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : o, r, f, r ? r[0] : t.__k && $64f0190ec946a978$var$x(t, 0), e, c), null != r) for(s = r.length; s--;)null != r[s] && $64f0190ec946a978$var$w(r[s]);
        e || (s = "value", void 0 !== _ && (_ !== l[s] || "progress" === b && !_ || "option" === b && _ !== m[s]) && $64f0190ec946a978$var$A(l, s, _, m[s], o), s = "checked", void 0 !== g && g !== l[s] && $64f0190ec946a978$var$A(l, s, g, m[s], o));
    }
    return l;
}
function $64f0190ec946a978$var$N(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $64f0190ec946a978$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $64f0190ec946a978$var$V(n, u, t) {
    var i, o;
    if ($64f0190ec946a978$export$41c562ebe57d11e2.unmount && $64f0190ec946a978$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $64f0190ec946a978$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $64f0190ec946a978$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $64f0190ec946a978$var$V(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $64f0190ec946a978$var$w(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $64f0190ec946a978$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $64f0190ec946a978$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $64f0190ec946a978$export$41c562ebe57d11e2.__ && $64f0190ec946a978$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $64f0190ec946a978$var$O(t, u = (!o && i || t).__k = $64f0190ec946a978$export$c8a8987d4410bf2d($64f0190ec946a978$export$ffb0004e005737fa, null, [
        u
    ]), r || $64f0190ec946a978$var$h, $64f0190ec946a978$var$h, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $64f0190ec946a978$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $64f0190ec946a978$var$j(f, u, e);
}
function $64f0190ec946a978$export$fa8d919ba61d84db(n, l) {
    $64f0190ec946a978$export$b3890eb0ae9dca99(n, l, $64f0190ec946a978$export$fa8d919ba61d84db);
}
function $64f0190ec946a978$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $64f0190ec946a978$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $64f0190ec946a978$var$n.call(arguments, 2) : t), $64f0190ec946a978$var$g(l.type, e, i || l.key, o || l.ref, null);
}
function $64f0190ec946a978$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $64f0190ec946a978$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $64f0190ec946a978$var$M(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$64f0190ec946a978$var$n = $64f0190ec946a978$var$p.slice, $64f0190ec946a978$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $64f0190ec946a978$var$u = 0, $64f0190ec946a978$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $64f0190ec946a978$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $64f0190ec946a978$var$d({}, this.state), "function" == typeof n && (n = n($64f0190ec946a978$var$d({}, u), this.props)), n && $64f0190ec946a978$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $64f0190ec946a978$var$M(this));
}, $64f0190ec946a978$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $64f0190ec946a978$var$M(this));
}, $64f0190ec946a978$export$16fa2f45be04daa8.prototype.render = $64f0190ec946a978$export$ffb0004e005737fa, $64f0190ec946a978$var$i = [], $64f0190ec946a978$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $64f0190ec946a978$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $64f0190ec946a978$var$P.__r = 0, $64f0190ec946a978$var$e = 0, $64f0190ec946a978$var$c = $64f0190ec946a978$var$F(!1), $64f0190ec946a978$var$s = $64f0190ec946a978$var$F(!0), $64f0190ec946a978$var$a = 0;




function $a5b4777518b58d3c$export$5b1771037ab7c451(event) {
    var isMiddleClick = event.button === 1;
    return isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}





var $16cb5b259a5c5a89$exports = {};
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ // This file is for use with Node.js. See dist/ for browser files.
var $06cff5e082f14831$exports = {};
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ (function(Hogan) {
    // Setup regex  assignments
    // remove whitespace according to Mustache spec
    var rIsWhitespace = /\S/, rQuot = /\"/g, rNewline = /\n/g, rCr = /\r/g, rSlash = /\\/g, rLineSep = /\u2028/, rParagraphSep = /\u2029/;
    Hogan.tags = {
        "#": 1,
        "^": 2,
        "<": 3,
        "$": 4,
        "/": 5,
        "!": 6,
        ">": 7,
        "=": 8,
        "_v": 9,
        "{": 10,
        "&": 11,
        "_t": 12
    };
    Hogan.scan = function scan(text, delimiters) {
        var len = text.length, IN_TEXT = 0, IN_TAG_TYPE = 1, IN_TAG = 2, state = IN_TEXT, tagType = null, tag = null, buf = "", tokens = [], seenTag = false, i = 0, lineStart = 0, otag = "{{", ctag = "}}";
        function addBuf() {
            if (buf.length > 0) {
                tokens.push({
                    tag: "_t",
                    text: new String(buf)
                });
                buf = "";
            }
        }
        function lineIsWhitespace() {
            var isAllWhitespace = true;
            for(var j = lineStart; j < tokens.length; j++){
                isAllWhitespace = Hogan.tags[tokens[j].tag] < Hogan.tags["_v"] || tokens[j].tag == "_t" && tokens[j].text.match(rIsWhitespace) === null;
                if (!isAllWhitespace) return false;
            }
            return isAllWhitespace;
        }
        function filterLine(haveSeenTag, noNewLine) {
            addBuf();
            if (haveSeenTag && lineIsWhitespace()) {
                for(var j = lineStart, next; j < tokens.length; j++)if (tokens[j].text) {
                    if ((next = tokens[j + 1]) && next.tag == ">") // set indent to token value
                    next.indent = tokens[j].text.toString();
                    tokens.splice(j, 1);
                }
            } else if (!noNewLine) tokens.push({
                tag: "\n"
            });
            seenTag = false;
            lineStart = tokens.length;
        }
        function changeDelimiters(text, index) {
            var close = "=" + ctag, closeIndex = text.indexOf(close, index), delimiters = trim(text.substring(text.indexOf("=", index) + 1, closeIndex)).split(" ");
            otag = delimiters[0];
            ctag = delimiters[delimiters.length - 1];
            return closeIndex + close.length - 1;
        }
        if (delimiters) {
            delimiters = delimiters.split(" ");
            otag = delimiters[0];
            ctag = delimiters[1];
        }
        for(i = 0; i < len; i++){
            if (state == IN_TEXT) {
                if (tagChange(otag, text, i)) {
                    --i;
                    addBuf();
                    state = IN_TAG_TYPE;
                } else if (text.charAt(i) == "\n") filterLine(seenTag);
                else buf += text.charAt(i);
            } else if (state == IN_TAG_TYPE) {
                i += otag.length - 1;
                tag = Hogan.tags[text.charAt(i + 1)];
                tagType = tag ? text.charAt(i + 1) : "_v";
                if (tagType == "=") {
                    i = changeDelimiters(text, i);
                    state = IN_TEXT;
                } else {
                    if (tag) i++;
                    state = IN_TAG;
                }
                seenTag = i;
            } else if (tagChange(ctag, text, i)) {
                tokens.push({
                    tag: tagType,
                    n: trim(buf),
                    otag: otag,
                    ctag: ctag,
                    i: tagType == "/" ? seenTag - otag.length : i + ctag.length
                });
                buf = "";
                i += ctag.length - 1;
                state = IN_TEXT;
                if (tagType == "{") {
                    if (ctag == "}}") i++;
                    else cleanTripleStache(tokens[tokens.length - 1]);
                }
            } else buf += text.charAt(i);
        }
        filterLine(seenTag, true);
        return tokens;
    };
    function cleanTripleStache(token) {
        if (token.n.substr(token.n.length - 1) === "}") token.n = token.n.substring(0, token.n.length - 1);
    }
    function trim(s) {
        if (s.trim) return s.trim();
        return s.replace(/^\s*|\s*$/g, "");
    }
    function tagChange(tag, text, index) {
        if (text.charAt(index) != tag.charAt(0)) return false;
        for(var i = 1, l = tag.length; i < l; i++){
            if (text.charAt(index + i) != tag.charAt(i)) return false;
        }
        return true;
    }
    // the tags allowed inside super templates
    var allowedInSuper = {
        "_t": true,
        "\n": true,
        "$": true,
        "/": true
    };
    function buildTree(tokens, kind, stack, customTags) {
        var instructions = [], opener = null, tail = null, token = null;
        tail = stack[stack.length - 1];
        while(tokens.length > 0){
            token = tokens.shift();
            if (tail && tail.tag == "<" && !(token.tag in allowedInSuper)) throw new Error("Illegal content in < super tag.");
            if (Hogan.tags[token.tag] <= Hogan.tags["$"] || isOpener(token, customTags)) {
                stack.push(token);
                token.nodes = buildTree(tokens, token.tag, stack, customTags);
            } else if (token.tag == "/") {
                if (stack.length === 0) throw new Error("Closing tag without opener: /" + token.n);
                opener = stack.pop();
                if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) throw new Error("Nesting error: " + opener.n + " vs. " + token.n);
                opener.end = token.i;
                return instructions;
            } else if (token.tag == "\n") token.last = tokens.length == 0 || tokens[0].tag == "\n";
            instructions.push(token);
        }
        if (stack.length > 0) throw new Error("missing closing tag: " + stack.pop().n);
        return instructions;
    }
    function isOpener(token, tags) {
        for(var i = 0, l = tags.length; i < l; i++)if (tags[i].o == token.n) {
            token.tag = "#";
            return true;
        }
    }
    function isCloser(close, open, tags) {
        for(var i = 0, l = tags.length; i < l; i++){
            if (tags[i].c == close && tags[i].o == open) return true;
        }
    }
    function stringifySubstitutions(obj) {
        var items = [];
        for(var key in obj)items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + "}");
        return "{ " + items.join(",") + " }";
    }
    function stringifyPartials(codeObj) {
        var partials = [];
        for(var key in codeObj.partials)partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
        return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
    }
    Hogan.stringify = function(codeObj, text, options) {
        return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) + "}";
    };
    var serialNo = 0;
    Hogan.generate = function(tree, text, options) {
        serialNo = 0;
        var context = {
            code: "",
            subs: {},
            partials: {}
        };
        Hogan.walk(tree, context);
        if (options.asString) return this.stringify(context, text, options);
        return this.makeTemplate(context, text, options);
    };
    Hogan.wrapMain = function(code) {
        return 'var t=this;t.b(i=i||"");' + code + "return t.fl();";
    };
    Hogan.template = Hogan.Template;
    Hogan.makeTemplate = function(codeObj, text, options) {
        var template = this.makePartials(codeObj);
        template.code = new Function("c", "p", "i", this.wrapMain(codeObj.code));
        return new this.template(template, text, this, options);
    };
    Hogan.makePartials = function(codeObj) {
        var key, template = {
            subs: {},
            partials: codeObj.partials,
            name: codeObj.name
        };
        for(key in template.partials)template.partials[key] = this.makePartials(template.partials[key]);
        for(key in codeObj.subs)template.subs[key] = new Function("c", "p", "t", "i", codeObj.subs[key]);
        return template;
    };
    function esc(s) {
        return s.replace(rSlash, "\\\\").replace(rQuot, '\\"').replace(rNewline, "\\n").replace(rCr, "\\r").replace(rLineSep, "\\u2028").replace(rParagraphSep, "\\u2029");
    }
    function chooseMethod(s) {
        return ~s.indexOf(".") ? "d" : "f";
    }
    function createPartial(node, context) {
        var prefix = "<" + (context.prefix || "");
        var sym = prefix + node.n + serialNo++;
        context.partials[sym] = {
            name: node.n,
            partials: {}
        };
        context.code += 't.b(t.rp("' + esc(sym) + '",c,p,"' + (node.indent || "") + '"));';
        return sym;
    }
    Hogan.codegen = {
        "#": function(node, context) {
            context.code += "if(t.s(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' + "c,p,0," + node.i + "," + node.end + ',"' + node.otag + " " + node.ctag + '")){' + "t.rs(c,p," + "function(c,p,t){";
            Hogan.walk(node.nodes, context);
            context.code += "});c.pop();}";
        },
        "^": function(node, context) {
            context.code += "if(!t.s(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
            Hogan.walk(node.nodes, context);
            context.code += "};";
        },
        ">": createPartial,
        "<": function(node, context) {
            var ctx = {
                partials: {},
                code: "",
                subs: {},
                inPartial: true
            };
            Hogan.walk(node.nodes, ctx);
            var template = context.partials[createPartial(node, context)];
            template.subs = ctx.subs;
            template.partials = ctx.partials;
        },
        "$": function(node, context) {
            var ctx = {
                subs: {},
                code: "",
                partials: context.partials,
                prefix: node.n
            };
            Hogan.walk(node.nodes, ctx);
            context.subs[node.n] = ctx.code;
            if (!context.inPartial) context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
        },
        "\n": function(node, context) {
            context.code += write('"\\n"' + (node.last ? "" : " + i"));
        },
        "_v": function(node, context) {
            context.code += "t.b(t.v(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
        },
        "_t": function(node, context) {
            context.code += write('"' + esc(node.text) + '"');
        },
        "{": tripleStache,
        "&": tripleStache
    };
    function tripleStache(node, context) {
        context.code += "t.b(t.t(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    }
    function write(s) {
        return "t.b(" + s + ");";
    }
    Hogan.walk = function(nodelist, context) {
        var func;
        for(var i = 0, l = nodelist.length; i < l; i++){
            func = Hogan.codegen[nodelist[i].tag];
            func && func(nodelist[i], context);
        }
        return context;
    };
    Hogan.parse = function(tokens, text, options) {
        options = options || {};
        return buildTree(tokens, "", [], options.sectionTags || []);
    };
    Hogan.cache = {};
    Hogan.cacheKey = function(text, options) {
        return [
            text,
            !!options.asString,
            !!options.disableLambda,
            options.delimiters,
            !!options.modelGet
        ].join("||");
    };
    Hogan.compile = function(text, options) {
        options = options || {};
        var key = Hogan.cacheKey(text, options);
        var template = this.cache[key];
        if (template) {
            var partials = template.partials;
            for(var name in partials)delete partials[name].instance;
            return template;
        }
        template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
        return this.cache[key] = template;
    };
})($06cff5e082f14831$exports);



$06cff5e082f14831$exports.Template = (parcelRequire("eNIDJ")).Template;
$06cff5e082f14831$exports.template = $06cff5e082f14831$exports.Template;
$16cb5b259a5c5a89$exports = $06cff5e082f14831$exports;



var $8a5b9e7397cf01ca$var$n = function(t, s, r, e) {
    var u;
    s[0] = 0;
    for(var h = 1; h < s.length; h++){
        var p = s[h++], a = s[h] ? (s[0] |= p ? 1 : 2, r[s[h++]]) : s[++h];
        3 === p ? e[0] = a : 4 === p ? e[1] = Object.assign(e[1] || {}, a) : 5 === p ? (e[1] = e[1] || {})[s[++h]] = a : 6 === p ? e[1][s[++h]] += a + "" : p ? (u = t.apply(a, $8a5b9e7397cf01ca$var$n(t, a, r, [
            "",
            null
        ])), e.push(u), a[0] ? s[0] |= 2 : (s[h - 2] = 0, s[h] = u)) : e.push(a);
    }
    return e;
}, $8a5b9e7397cf01ca$var$t = new Map;
function $8a5b9e7397cf01ca$export$2e2bcd8739ae039(s) {
    var r = $8a5b9e7397cf01ca$var$t.get(this);
    return r || (r = new Map, $8a5b9e7397cf01ca$var$t.set(this, r)), (r = $8a5b9e7397cf01ca$var$n(this, r.get(s) || (r.set(s, r = function(n) {
        for(var t, s, r = 1, e = "", u = "", h = [
            0
        ], p = function(n) {
            1 === r && (n || (e = e.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h.push(0, n, e) : 3 === r && (n || e) ? (h.push(3, n, e), r = 2) : 2 === r && "..." === e && n ? h.push(4, n, 0) : 2 === r && e && !n ? h.push(5, 0, !0, e) : r >= 5 && ((e || !n && 5 === r) && (h.push(r, 0, e, s), r = 6), n && (h.push(r, n, 0, s), r = 6)), e = "";
        }, a = 0; a < n.length; a++){
            a && (1 === r && p(), p(a));
            for(var l = 0; l < n[a].length; l++)t = n[a][l], 1 === r ? "<" === t ? (p(), h = [
                h
            ], r = 3) : e += t : 4 === r ? "--" === e && ">" === t ? (r = 1, e = "") : e = t + e[0] : u ? t === u ? u = "" : e += t : '"' === t || "'" === t ? u = t : ">" === t ? (p(), r = 1) : r && ("=" === t ? (r = 5, s = e, e = "") : "/" === t && (r < 5 || ">" === n[a][l + 1]) ? (p(), 3 === r && (h = h[0]), r = h, (h = h[0]).push(2, 0, r), r = 0) : " " === t || "	" === t || "\n" === t || "\r" === t ? (p(), r = 2) : e += t), 3 === r && "!--" === e && (r = 4, h = h[0]);
        }
        return p(), h;
    }(s)), r), arguments, [])).length > 1 ? r : r[0];
}


var $123c645be20e51c8$export$c0bb0b647f701bb5 = (0, $8a5b9e7397cf01ca$export$2e2bcd8739ae039).bind((0, $64f0190ec946a978$export$c8a8987d4410bf2d));





function $4baf0029b6d92e31$export$2e2bcd8739ae039() {
    return $4baf0029b6d92e31$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4baf0029b6d92e31$export$2e2bcd8739ae039.apply(null, arguments);
}


function $5a6017367e649a7f$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $631a36876f8af650$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $5a6017367e649a7f$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $56343c9595325c3f$var$_excluded = [
    "parts",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator",
    "className",
    "classNames"
];
function $56343c9595325c3f$var$createHighlightPartComponent(_ref) {
    var createElement = _ref.createElement;
    return function HighlightPart(_ref2) {
        var classNames = _ref2.classNames, children = _ref2.children, highlightedTagName = _ref2.highlightedTagName, isHighlighted = _ref2.isHighlighted, nonHighlightedTagName = _ref2.nonHighlightedTagName;
        var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
        return createElement(TagName, {
            className: isHighlighted ? classNames.highlighted : classNames.nonHighlighted
        }, children);
    };
}
function $56343c9595325c3f$export$c8682df1c852a966(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var HighlightPart = $56343c9595325c3f$var$createHighlightPartComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Highlight(userProps) {
        var parts = userProps.parts, _userProps$highlighte = userProps.highlightedTagName, highlightedTagName = _userProps$highlighte === void 0 ? "mark" : _userProps$highlighte, _userProps$nonHighlig = userProps.nonHighlightedTagName, nonHighlightedTagName = _userProps$nonHighlig === void 0 ? "span" : _userProps$nonHighlig, _userProps$separator = userProps.separator, separator = _userProps$separator === void 0 ? ", " : _userProps$separator, className = userProps.className, _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, props = (0, $631a36876f8af650$export$2e2bcd8739ae039)(userProps, $56343c9595325c3f$var$_excluded);
        return createElement("span", (0, $4baf0029b6d92e31$export$2e2bcd8739ae039)({}, props, {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)(classNames.root, className)
        }), parts.map(function(part, partIndex) {
            var isLastPart = partIndex === parts.length - 1;
            return createElement(Fragment, {
                key: partIndex
            }, part.map(function(subPart, subPartIndex) {
                return createElement(HighlightPart, {
                    key: subPartIndex,
                    classNames: classNames,
                    highlightedTagName: highlightedTagName,
                    nonHighlightedTagName: nonHighlightedTagName,
                    isHighlighted: subPart.isHighlighted
                }, subPart.value);
            }), !isLastPart && createElement("span", {
                className: classNames.separator
            }, separator));
        }));
    };
}



var $0a0d0c87670b867f$export$57a0c6fc80bec05c = (0, $56343c9595325c3f$export$c8682df1c852a966)({
    createElement: (0, $64f0190ec946a978$export$c8a8987d4410bf2d),
    Fragment: (0, $64f0190ec946a978$export$ffb0004e005737fa)
});


var $83ba963528b82dd2$var$_excluded = [
    "classNames"
];
function $83ba963528b82dd2$var$_extends() {
    $83ba963528b82dd2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $83ba963528b82dd2$var$_extends.apply(this, arguments);
}
function $83ba963528b82dd2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $83ba963528b82dd2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $83ba963528b82dd2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $83ba963528b82dd2$export$39dbc3f558091353(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $83ba963528b82dd2$var$_objectWithoutProperties(_ref, $83ba963528b82dd2$var$_excluded);
    return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $0a0d0c87670b867f$export$57a0c6fc80bec05c), $83ba963528b82dd2$var$_extends({
        classNames: {
            root: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Highlight", classNames.root),
            highlighted: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Highlight-highlighted", classNames.highlighted),
            nonHighlighted: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Highlight-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Highlight-separator", classNames.separator)
        }
    }, props));
}


function $9e153725cea9a63f$export$45b10814cc054894(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}


var $e1617fdf59f86eb2$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
];
function $e1617fdf59f86eb2$var$_extends() {
    $e1617fdf59f86eb2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1617fdf59f86eb2$var$_extends.apply(this, arguments);
}
function $e1617fdf59f86eb2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e1617fdf59f86eb2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e1617fdf59f86eb2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e1617fdf59f86eb2$export$39dbc3f558091353(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $e1617fdf59f86eb2$var$_objectWithoutProperties(_ref, $e1617fdf59f86eb2$var$_excluded);
    var property = (0, $df4ef976d5bdb951$export$d14846335956eefa)(hit._highlightResult, attribute) || [];
    var properties = (0, $9e153725cea9a63f$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $5102b5af87290225$export$e04d28e65b830ebf)((0, $f3dcbb78d3a0cdcf$export$e8bacd2802a88316)(value || ""));
    });
    return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $83ba963528b82dd2$export$39dbc3f558091353), $e1617fdf59f86eb2$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}





var $ed4e776d35a39c78$var$_excluded = [
    "classNames"
];
function $ed4e776d35a39c78$var$_extends() {
    $ed4e776d35a39c78$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ed4e776d35a39c78$var$_extends.apply(this, arguments);
}
function $ed4e776d35a39c78$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ed4e776d35a39c78$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ed4e776d35a39c78$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ed4e776d35a39c78$export$f346643e8570b662(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $ed4e776d35a39c78$var$_objectWithoutProperties(_ref, $ed4e776d35a39c78$var$_excluded);
    return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $0a0d0c87670b867f$export$57a0c6fc80bec05c), $ed4e776d35a39c78$var$_extends({
        classNames: {
            root: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-ReverseHighlight", classNames.root),
            highlighted: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-ReverseHighlight-highlighted", classNames.highlighted),
            nonHighlighted: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-ReverseHighlight-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-ReverseHighlight-separator", classNames.separator)
        }
    }, props));
}



function $6fa947a304157135$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6fa947a304157135$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6fa947a304157135$var$_typeof(o);
}
var $6fa947a304157135$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
], $6fa947a304157135$var$_excluded2 = [
    "isHighlighted"
];
function $6fa947a304157135$var$_extends() {
    $6fa947a304157135$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6fa947a304157135$var$_extends.apply(this, arguments);
}
function $6fa947a304157135$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6fa947a304157135$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6fa947a304157135$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6fa947a304157135$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6fa947a304157135$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6fa947a304157135$var$_defineProperty(obj, key, value) {
    key = $6fa947a304157135$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6fa947a304157135$var$_toPropertyKey(t) {
    var i = $6fa947a304157135$var$_toPrimitive(t, "string");
    return "symbol" == $6fa947a304157135$var$_typeof(i) ? i : String(i);
}
function $6fa947a304157135$var$_toPrimitive(t, r) {
    if ("object" != $6fa947a304157135$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6fa947a304157135$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6fa947a304157135$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6fa947a304157135$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6fa947a304157135$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6fa947a304157135$export$f346643e8570b662(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $6fa947a304157135$var$_objectWithoutProperties(_ref, $6fa947a304157135$var$_excluded);
    var property = (0, $df4ef976d5bdb951$export$d14846335956eefa)(hit._highlightResult, attribute) || [];
    var properties = (0, $9e153725cea9a63f$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $5102b5af87290225$export$e04d28e65b830ebf)((0, $f3dcbb78d3a0cdcf$export$e8bacd2802a88316)(value || "")).map(function(_ref3) {
            var isHighlighted = _ref3.isHighlighted, rest = $6fa947a304157135$var$_objectWithoutProperties(_ref3, $6fa947a304157135$var$_excluded2);
            return $6fa947a304157135$var$_objectSpread($6fa947a304157135$var$_objectSpread({}, rest), {}, {
                isHighlighted: !isHighlighted
            });
        });
    });
    return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $ed4e776d35a39c78$export$f346643e8570b662), $6fa947a304157135$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}





var $0032a86c02897c40$var$_excluded = [
    "classNames"
];
function $0032a86c02897c40$var$_extends() {
    $0032a86c02897c40$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0032a86c02897c40$var$_extends.apply(this, arguments);
}
function $0032a86c02897c40$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0032a86c02897c40$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0032a86c02897c40$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0032a86c02897c40$export$10c56fa12fda26f9(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $0032a86c02897c40$var$_objectWithoutProperties(_ref, $0032a86c02897c40$var$_excluded);
    return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $0a0d0c87670b867f$export$57a0c6fc80bec05c), $0032a86c02897c40$var$_extends({
        classNames: {
            root: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Snippet", classNames.root),
            highlighted: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Snippet-highlighted", classNames.highlighted),
            nonHighlighted: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Snippet-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Snippet-separator", classNames.separator)
        }
    }, props));
}



var $30424aa6e8de9b30$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
];
function $30424aa6e8de9b30$var$_extends() {
    $30424aa6e8de9b30$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $30424aa6e8de9b30$var$_extends.apply(this, arguments);
}
function $30424aa6e8de9b30$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $30424aa6e8de9b30$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $30424aa6e8de9b30$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $30424aa6e8de9b30$export$10c56fa12fda26f9(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $30424aa6e8de9b30$var$_objectWithoutProperties(_ref, $30424aa6e8de9b30$var$_excluded);
    var property = (0, $df4ef976d5bdb951$export$d14846335956eefa)(hit._snippetResult, attribute) || [];
    var properties = (0, $9e153725cea9a63f$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $5102b5af87290225$export$e04d28e65b830ebf)((0, $f3dcbb78d3a0cdcf$export$e8bacd2802a88316)(value || ""));
    });
    return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $0032a86c02897c40$export$10c56fa12fda26f9), $30424aa6e8de9b30$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}





var $f4e591746303458a$var$_excluded = [
    "classNames"
];
function $f4e591746303458a$var$_extends() {
    $f4e591746303458a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f4e591746303458a$var$_extends.apply(this, arguments);
}
function $f4e591746303458a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f4e591746303458a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f4e591746303458a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f4e591746303458a$export$235f9e0721ad46fa(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $f4e591746303458a$var$_objectWithoutProperties(_ref, $f4e591746303458a$var$_excluded);
    return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $0a0d0c87670b867f$export$57a0c6fc80bec05c), $f4e591746303458a$var$_extends({
        classNames: {
            root: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-ReverseSnippet", classNames.root),
            highlighted: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-ReverseSnippet-highlighted", classNames.highlighted),
            nonHighlighted: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-ReverseSnippet-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-ReverseSnippet-separator", classNames.separator)
        }
    }, props));
}



function $3adb071a401526ee$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3adb071a401526ee$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3adb071a401526ee$var$_typeof(o);
}
var $3adb071a401526ee$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
], $3adb071a401526ee$var$_excluded2 = [
    "isHighlighted"
];
function $3adb071a401526ee$var$_extends() {
    $3adb071a401526ee$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3adb071a401526ee$var$_extends.apply(this, arguments);
}
function $3adb071a401526ee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3adb071a401526ee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3adb071a401526ee$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3adb071a401526ee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3adb071a401526ee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3adb071a401526ee$var$_defineProperty(obj, key, value) {
    key = $3adb071a401526ee$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3adb071a401526ee$var$_toPropertyKey(t) {
    var i = $3adb071a401526ee$var$_toPrimitive(t, "string");
    return "symbol" == $3adb071a401526ee$var$_typeof(i) ? i : String(i);
}
function $3adb071a401526ee$var$_toPrimitive(t, r) {
    if ("object" != $3adb071a401526ee$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3adb071a401526ee$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3adb071a401526ee$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3adb071a401526ee$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3adb071a401526ee$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3adb071a401526ee$export$235f9e0721ad46fa(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $3adb071a401526ee$var$_objectWithoutProperties(_ref, $3adb071a401526ee$var$_excluded);
    var property = (0, $df4ef976d5bdb951$export$d14846335956eefa)(hit._snippetResult, attribute) || [];
    var properties = (0, $9e153725cea9a63f$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $5102b5af87290225$export$e04d28e65b830ebf)((0, $f3dcbb78d3a0cdcf$export$e8bacd2802a88316)(value || "")).map(function(_ref3) {
            var isHighlighted = _ref3.isHighlighted, rest = $3adb071a401526ee$var$_objectWithoutProperties(_ref3, $3adb071a401526ee$var$_excluded2);
            return $3adb071a401526ee$var$_objectSpread($3adb071a401526ee$var$_objectSpread({}, rest), {}, {
                isHighlighted: !isHighlighted
            });
        });
    });
    return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $f4e591746303458a$export$235f9e0721ad46fa), $3adb071a401526ee$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}


function $77cddd4b43ef9f4c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $77cddd4b43ef9f4c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $77cddd4b43ef9f4c$var$_typeof(o);
}
function $77cddd4b43ef9f4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77cddd4b43ef9f4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77cddd4b43ef9f4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $77cddd4b43ef9f4c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77cddd4b43ef9f4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $77cddd4b43ef9f4c$var$_defineProperty(obj, key, value) {
    key = $77cddd4b43ef9f4c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $77cddd4b43ef9f4c$var$_toPropertyKey(t) {
    var i = $77cddd4b43ef9f4c$var$_toPrimitive(t, "string");
    return "symbol" == $77cddd4b43ef9f4c$var$_typeof(i) ? i : String(i);
}
function $77cddd4b43ef9f4c$var$_toPrimitive(t, r) {
    if ("object" != $77cddd4b43ef9f4c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $77cddd4b43ef9f4c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// We add all our template helper methods to the template as lambdas. Note
// that lambdas in Mustache are supposed to accept a second argument of
// `render` to get the rendered value, not the literal `{{value}}`. But
// this is currently broken (see https://github.com/twitter/hogan.js/issues/222).
function $77cddd4b43ef9f4c$var$transformHelpersToHogan() {
    var helpers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var compileOptions = arguments.length > 1 ? arguments[1] : undefined;
    var data = arguments.length > 2 ? arguments[2] : undefined;
    return Object.keys(helpers).reduce(function(acc, helperKey) {
        return $77cddd4b43ef9f4c$var$_objectSpread($77cddd4b43ef9f4c$var$_objectSpread({}, acc), {}, $77cddd4b43ef9f4c$var$_defineProperty({}, helperKey, function() {
            var _this = this;
            return function(text) {
                var render = function render(value) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($16cb5b259a5c5a89$exports))).compile(value, compileOptions).render(_this);
                };
                return helpers[helperKey].call(data, text, render);
            };
        }));
    }, {});
}
function $77cddd4b43ef9f4c$export$b5c363744c17aeab(_ref) {
    var templates = _ref.templates, templateKey = _ref.templateKey, compileOptions = _ref.compileOptions, helpers = _ref.helpers, data = _ref.data, bindEvent = _ref.bindEvent, sendEvent = _ref.sendEvent;
    var template = templates[templateKey];
    if (typeof template !== "string" && typeof template !== "function") throw new Error("Template must be 'string' or 'function', was '".concat($77cddd4b43ef9f4c$var$_typeof(template), "' (key: ").concat(templateKey, ")"));
    if (typeof template === "function") {
        // @MAJOR no longer pass bindEvent when string templates are removed
        var params = bindEvent || {};
        params.html = (0, $123c645be20e51c8$export$c0bb0b647f701bb5);
        params.sendEvent = sendEvent;
        params.components = {
            Highlight: (0, $e1617fdf59f86eb2$export$39dbc3f558091353),
            ReverseHighlight: (0, $6fa947a304157135$export$f346643e8570b662),
            Snippet: (0, $30424aa6e8de9b30$export$10c56fa12fda26f9),
            ReverseSnippet: (0, $3adb071a401526ee$export$235f9e0721ad46fa)
        };
        // @MAJOR remove the `as any` when string templates are removed
        // needed because not every template receives sendEvent
        return template(data, params);
    }
    var transformedHelpers = $77cddd4b43ef9f4c$var$transformHelpersToHogan(helpers, compileOptions, data);
    return (0, (/*@__PURE__*/$parcel$interopDefault($16cb5b259a5c5a89$exports))).compile(template, compileOptions).render($77cddd4b43ef9f4c$var$_objectSpread($77cddd4b43ef9f4c$var$_objectSpread({}, data), {}, {
        helpers: transformedHelpers
    })).replace(/[ \n\r\t\f\xA0]+/g, function(spaces) {
        return spaces.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ");
    }).trim();
}



function $9482d9d5173d02ec$var$_extends() {
    $9482d9d5173d02ec$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9482d9d5173d02ec$var$_extends.apply(this, arguments);
}
function $9482d9d5173d02ec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9482d9d5173d02ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9482d9d5173d02ec$var$_typeof(o);
}
function $9482d9d5173d02ec$var$_toConsumableArray(arr) {
    return $9482d9d5173d02ec$var$_arrayWithoutHoles(arr) || $9482d9d5173d02ec$var$_iterableToArray(arr) || $9482d9d5173d02ec$var$_unsupportedIterableToArray(arr) || $9482d9d5173d02ec$var$_nonIterableSpread();
}
function $9482d9d5173d02ec$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9482d9d5173d02ec$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9482d9d5173d02ec$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9482d9d5173d02ec$var$_arrayLikeToArray(o, minLen);
}
function $9482d9d5173d02ec$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9482d9d5173d02ec$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9482d9d5173d02ec$var$_arrayLikeToArray(arr);
}
function $9482d9d5173d02ec$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9482d9d5173d02ec$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9482d9d5173d02ec$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9482d9d5173d02ec$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $9482d9d5173d02ec$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9482d9d5173d02ec$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9482d9d5173d02ec$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9482d9d5173d02ec$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9482d9d5173d02ec$var$_setPrototypeOf(subClass, superClass);
}
function $9482d9d5173d02ec$var$_setPrototypeOf(o, p) {
    $9482d9d5173d02ec$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9482d9d5173d02ec$var$_setPrototypeOf(o, p);
}
function $9482d9d5173d02ec$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9482d9d5173d02ec$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9482d9d5173d02ec$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9482d9d5173d02ec$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9482d9d5173d02ec$var$_possibleConstructorReturn(this, result);
    };
}
function $9482d9d5173d02ec$var$_possibleConstructorReturn(self, call) {
    if (call && ($9482d9d5173d02ec$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9482d9d5173d02ec$var$_assertThisInitialized(self);
}
function $9482d9d5173d02ec$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9482d9d5173d02ec$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9482d9d5173d02ec$var$_getPrototypeOf(o) {
    $9482d9d5173d02ec$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9482d9d5173d02ec$var$_getPrototypeOf(o);
}
function $9482d9d5173d02ec$var$_defineProperty(obj, key, value) {
    key = $9482d9d5173d02ec$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9482d9d5173d02ec$var$_toPropertyKey(t) {
    var i = $9482d9d5173d02ec$var$_toPrimitive(t, "string");
    return "symbol" == $9482d9d5173d02ec$var$_typeof(i) ? i : String(i);
}
function $9482d9d5173d02ec$var$_toPrimitive(t, r) {
    if ("object" != $9482d9d5173d02ec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9482d9d5173d02ec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9482d9d5173d02ec$var$RawHtml = /*#__PURE__*/ function(_Component) {
    $9482d9d5173d02ec$var$_inherits(RawHtml, _Component);
    var _super = $9482d9d5173d02ec$var$_createSuper(RawHtml);
    function RawHtml() {
        var _this;
        $9482d9d5173d02ec$var$_classCallCheck(this, RawHtml);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $9482d9d5173d02ec$var$_defineProperty($9482d9d5173d02ec$var$_assertThisInitialized(_this), "ref", (0, $64f0190ec946a978$export$7d1e3a5e95ceca43)());
        $9482d9d5173d02ec$var$_defineProperty($9482d9d5173d02ec$var$_assertThisInitialized(_this), "nodes", []);
        return _this;
    }
    $9482d9d5173d02ec$var$_createClass(RawHtml, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var fragment = new DocumentFragment();
                var root = document.createElement("div");
                root.innerHTML = this.props.content;
                this.nodes = $9482d9d5173d02ec$var$_toConsumableArray(root.childNodes);
                this.nodes.forEach(function(node) {
                    return fragment.appendChild(node);
                });
                this.ref.current.replaceWith(fragment);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.nodes.forEach(function(node) {
                    if (node instanceof Element) {
                        node.outerHTML = "";
                        return;
                    }
                    node.nodeValue = "";
                });
                // if there is one TextNode first and one TextNode last, the
                // last one's nodeValue will be assigned to the first.
                if (this.nodes[0].nodeValue) this.nodes[0].nodeValue = "";
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("div", {
                    ref: this.ref
                });
            }
        }
    ]);
    return RawHtml;
}((0, $64f0190ec946a978$export$16fa2f45be04daa8));
var $9482d9d5173d02ec$var$defaultProps = {
    data: {},
    rootTagName: "div",
    useCustomCompileOptions: {},
    templates: {},
    templatesConfig: {}
};
// @TODO: Template should be a generic and receive TData to pass to Templates (to avoid TTemplateData to be set as `any`)
var $9482d9d5173d02ec$var$Template = /*#__PURE__*/ function(_Component2) {
    $9482d9d5173d02ec$var$_inherits(Template, _Component2);
    var _super2 = $9482d9d5173d02ec$var$_createSuper(Template);
    function Template() {
        $9482d9d5173d02ec$var$_classCallCheck(this, Template);
        return _super2.apply(this, arguments);
    }
    $9482d9d5173d02ec$var$_createClass(Template, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, $33ae9dc431645103$export$248d38f6296296c5)(this.props.data, nextProps.data) || this.props.templateKey !== nextProps.templateKey || !(0, $33ae9dc431645103$export$248d38f6296296c5)(this.props.rootProps, nextProps.rootProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var nonFunctionTemplates;
                var RootTagName = this.props.rootTagName === "fragment" ? (0, $64f0190ec946a978$export$ffb0004e005737fa) : this.props.rootTagName;
                var useCustomCompileOptions = this.props.useCustomCompileOptions[this.props.templateKey];
                var compileOptions = useCustomCompileOptions ? this.props.templatesConfig.compileOptions : {};
                var content = (0, $77cddd4b43ef9f4c$export$b5c363744c17aeab)({
                    templates: this.props.templates,
                    templateKey: this.props.templateKey,
                    compileOptions: compileOptions,
                    helpers: this.props.templatesConfig.helpers,
                    data: this.props.data,
                    bindEvent: this.props.bindEvent,
                    sendEvent: this.props.sendEvent
                });
                if (content === null) // Adds a noscript to the DOM but virtual DOM is null
                // See http://facebook.github.io/react/docs/component-specs.html#render
                return null;
                if ($9482d9d5173d02ec$var$_typeof(content) === "object") return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)(RootTagName, this.props.rootProps, content);
                // This is to handle Hogan templates with Fragment as rootTagName
                if (RootTagName === (0, $64f0190ec946a978$export$ffb0004e005737fa)) return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)($9482d9d5173d02ec$var$RawHtml, {
                    content: content,
                    key: Math.random()
                });
                return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)(RootTagName, $9482d9d5173d02ec$var$_extends({}, this.props.rootProps, {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                }));
            }
        }
    ]);
    return Template;
}((0, $64f0190ec946a978$export$16fa2f45be04daa8));
$9482d9d5173d02ec$var$_defineProperty($9482d9d5173d02ec$var$Template, "defaultProps", $9482d9d5173d02ec$var$defaultProps);
var $9482d9d5173d02ec$export$2e2bcd8739ae039 = $9482d9d5173d02ec$var$Template;


function $7e86fab6ba5fa5f4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7e86fab6ba5fa5f4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7e86fab6ba5fa5f4$var$_typeof(o);
}
function $7e86fab6ba5fa5f4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7e86fab6ba5fa5f4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7e86fab6ba5fa5f4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7e86fab6ba5fa5f4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7e86fab6ba5fa5f4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7e86fab6ba5fa5f4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7e86fab6ba5fa5f4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7e86fab6ba5fa5f4$var$_setPrototypeOf(subClass, superClass);
}
function $7e86fab6ba5fa5f4$var$_setPrototypeOf(o, p) {
    $7e86fab6ba5fa5f4$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7e86fab6ba5fa5f4$var$_setPrototypeOf(o, p);
}
function $7e86fab6ba5fa5f4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7e86fab6ba5fa5f4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7e86fab6ba5fa5f4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7e86fab6ba5fa5f4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7e86fab6ba5fa5f4$var$_possibleConstructorReturn(this, result);
    };
}
function $7e86fab6ba5fa5f4$var$_possibleConstructorReturn(self, call) {
    if (call && ($7e86fab6ba5fa5f4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7e86fab6ba5fa5f4$var$_assertThisInitialized(self);
}
function $7e86fab6ba5fa5f4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7e86fab6ba5fa5f4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7e86fab6ba5fa5f4$var$_getPrototypeOf(o) {
    $7e86fab6ba5fa5f4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7e86fab6ba5fa5f4$var$_getPrototypeOf(o);
}
function $7e86fab6ba5fa5f4$var$_defineProperty(obj, key, value) {
    key = $7e86fab6ba5fa5f4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7e86fab6ba5fa5f4$var$_toPropertyKey(t) {
    var i = $7e86fab6ba5fa5f4$var$_toPrimitive(t, "string");
    return "symbol" == $7e86fab6ba5fa5f4$var$_typeof(i) ? i : String(i);
}
function $7e86fab6ba5fa5f4$var$_toPrimitive(t, r) {
    if ("object" != $7e86fab6ba5fa5f4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7e86fab6ba5fa5f4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7e86fab6ba5fa5f4$var$defaultProps = {
    query: "",
    showSubmit: true,
    showReset: true,
    showLoadingIndicator: true,
    autofocus: false,
    searchAsYouType: true,
    ignoreCompositionEvents: false,
    isSearchStalled: false,
    disabled: false,
    ariaLabel: "Search",
    onChange: (0, $8fe091dcd40a4798$export$8793edee2d425525),
    onSubmit: (0, $8fe091dcd40a4798$export$8793edee2d425525),
    onReset: (0, $8fe091dcd40a4798$export$8793edee2d425525),
    refine: (0, $8fe091dcd40a4798$export$8793edee2d425525)
};
var $7e86fab6ba5fa5f4$var$SearchBox = /*#__PURE__*/ function(_Component) {
    $7e86fab6ba5fa5f4$var$_inherits(SearchBox, _Component);
    var _super = $7e86fab6ba5fa5f4$var$_createSuper(SearchBox);
    function SearchBox() {
        var _this;
        $7e86fab6ba5fa5f4$var$_classCallCheck(this, SearchBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $7e86fab6ba5fa5f4$var$_defineProperty($7e86fab6ba5fa5f4$var$_assertThisInitialized(_this), "state", {
            query: _this.props.query,
            focused: false
        });
        $7e86fab6ba5fa5f4$var$_defineProperty($7e86fab6ba5fa5f4$var$_assertThisInitialized(_this), "input", (0, $64f0190ec946a978$export$7d1e3a5e95ceca43)());
        $7e86fab6ba5fa5f4$var$_defineProperty($7e86fab6ba5fa5f4$var$_assertThisInitialized(_this), "onInput", function(event) {
            var _this$props = _this.props, searchAsYouType = _this$props.searchAsYouType, refine = _this$props.refine, onChange = _this$props.onChange;
            var query = event.target.value;
            if (!(_this.props.ignoreCompositionEvents && event.isComposing)) {
                if (searchAsYouType) refine(query);
                _this.setState({
                    query: query
                });
                onChange(event);
            }
        });
        $7e86fab6ba5fa5f4$var$_defineProperty($7e86fab6ba5fa5f4$var$_assertThisInitialized(_this), "onSubmit", function(event) {
            var _this$props2 = _this.props, searchAsYouType = _this$props2.searchAsYouType, refine = _this$props2.refine, onSubmit = _this$props2.onSubmit;
            event.preventDefault();
            event.stopPropagation();
            if (_this.input.current) _this.input.current.blur();
            if (!searchAsYouType) refine(_this.state.query);
            onSubmit(event);
            return false;
        });
        $7e86fab6ba5fa5f4$var$_defineProperty($7e86fab6ba5fa5f4$var$_assertThisInitialized(_this), "onReset", function(event) {
            var _this$props3 = _this.props, refine = _this$props3.refine, onReset = _this$props3.onReset;
            var query = "";
            if (_this.input.current) _this.input.current.focus();
            refine(query);
            _this.setState({
                query: query
            });
            onReset(event);
        });
        $7e86fab6ba5fa5f4$var$_defineProperty($7e86fab6ba5fa5f4$var$_assertThisInitialized(_this), "onBlur", function() {
            _this.setState({
                focused: false
            });
        });
        $7e86fab6ba5fa5f4$var$_defineProperty($7e86fab6ba5fa5f4$var$_assertThisInitialized(_this), "onFocus", function() {
            _this.setState({
                focused: true
            });
        });
        return _this;
    }
    $7e86fab6ba5fa5f4$var$_createClass(SearchBox, [
        {
            key: "resetInput",
            value: /**
     * This public method is used in the RefinementList SFFV search box
     * to reset the input state when an item is selected.
     *
     * @see RefinementList#componentWillReceiveProps
     * @return {undefined}
     */ function resetInput() {
                this.setState({
                    query: ""
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                /**
       * when the user is typing, we don't want to replace the query typed
       * by the user (state.query) with the query exposed by the connector (props.query)
       * see: https://github.com/algolia/instantsearch/issues/4141
       */ if (!this.state.focused && nextProps.query !== this.state.query) this.setState({
                    query: nextProps.query
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, cssClasses = _this$props4.cssClasses, placeholder = _this$props4.placeholder, autofocus = _this$props4.autofocus, showSubmit = _this$props4.showSubmit, showReset = _this$props4.showReset, showLoadingIndicator = _this$props4.showLoadingIndicator, templates = _this$props4.templates, isSearchStalled = _this$props4.isSearchStalled, ariaLabel = _this$props4.ariaLabel;
                return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("div", {
                    className: cssClasses.root
                }, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("form", {
                    action: "",
                    role: "search",
                    className: cssClasses.form,
                    noValidate: true,
                    onSubmit: this.onSubmit,
                    onReset: this.onReset
                }, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("input", {
                    ref: this.input,
                    value: this.state.query,
                    disabled: this.props.disabled,
                    className: cssClasses.input,
                    type: "search",
                    placeholder: placeholder,
                    autoFocus: autofocus,
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "off",
                    spellCheck: "false",
                    maxLength: 512,
                    onInput: this.onInput,
                    oncompositionend: this.onInput,
                    onBlur: this.onBlur,
                    onFocus: this.onFocus,
                    "aria-label": ariaLabel
                }), (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $9482d9d5173d02ec$export$2e2bcd8739ae039), {
                    templateKey: "submit",
                    rootTagName: "button",
                    rootProps: {
                        className: cssClasses.submit,
                        type: "submit",
                        title: "Submit the search query",
                        hidden: !showSubmit
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                }), (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $9482d9d5173d02ec$export$2e2bcd8739ae039), {
                    templateKey: "reset",
                    rootTagName: "button",
                    rootProps: {
                        className: cssClasses.reset,
                        type: "reset",
                        title: "Clear the search query",
                        hidden: !(showReset && this.state.query.trim() && !isSearchStalled)
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                }), showLoadingIndicator && (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $9482d9d5173d02ec$export$2e2bcd8739ae039), {
                    templateKey: "loadingIndicator",
                    rootTagName: "span",
                    rootProps: {
                        className: cssClasses.loadingIndicator,
                        hidden: !isSearchStalled
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                })));
            }
        }
    ]);
    return SearchBox;
}((0, $64f0190ec946a978$export$16fa2f45be04daa8));
$7e86fab6ba5fa5f4$var$_defineProperty($7e86fab6ba5fa5f4$var$SearchBox, "defaultProps", $7e86fab6ba5fa5f4$var$defaultProps);
var $7e86fab6ba5fa5f4$export$2e2bcd8739ae039 = $7e86fab6ba5fa5f4$var$SearchBox;





function $a8639478b1684bdf$var$_extends() {
    $a8639478b1684bdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a8639478b1684bdf$var$_extends.apply(this, arguments);
}
function $a8639478b1684bdf$var$RefinementListItem(_ref) {
    var className = _ref.className, handleClick = _ref.handleClick, facetValueToRefine = _ref.facetValueToRefine, isRefined = _ref.isRefined, templateProps = _ref.templateProps, templateKey = _ref.templateKey, templateData = _ref.templateData, subItems = _ref.subItems;
    return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("li", {
        className: className,
        onClick: function onClick(originalEvent) {
            handleClick({
                facetValueToRefine: facetValueToRefine,
                isRefined: isRefined,
                originalEvent: originalEvent
            });
        }
    }, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $9482d9d5173d02ec$export$2e2bcd8739ae039), $a8639478b1684bdf$var$_extends({}, templateProps, {
        templateKey: templateKey,
        data: templateData
    })), subItems);
}
var $a8639478b1684bdf$export$2e2bcd8739ae039 = $a8639478b1684bdf$var$RefinementListItem;


var $1fbc087d9073389b$var$_excluded = [
    "root"
];
function $1fbc087d9073389b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1fbc087d9073389b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1fbc087d9073389b$var$_typeof(o);
}
function $1fbc087d9073389b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fbc087d9073389b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fbc087d9073389b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1fbc087d9073389b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fbc087d9073389b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1fbc087d9073389b$var$_extends() {
    $1fbc087d9073389b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1fbc087d9073389b$var$_extends.apply(this, arguments);
}
function $1fbc087d9073389b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1fbc087d9073389b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1fbc087d9073389b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1fbc087d9073389b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1fbc087d9073389b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1fbc087d9073389b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1fbc087d9073389b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1fbc087d9073389b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1fbc087d9073389b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1fbc087d9073389b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1fbc087d9073389b$var$_setPrototypeOf(subClass, superClass);
}
function $1fbc087d9073389b$var$_setPrototypeOf(o, p) {
    $1fbc087d9073389b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1fbc087d9073389b$var$_setPrototypeOf(o, p);
}
function $1fbc087d9073389b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1fbc087d9073389b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1fbc087d9073389b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1fbc087d9073389b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1fbc087d9073389b$var$_possibleConstructorReturn(this, result);
    };
}
function $1fbc087d9073389b$var$_possibleConstructorReturn(self, call) {
    if (call && ($1fbc087d9073389b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1fbc087d9073389b$var$_assertThisInitialized(self);
}
function $1fbc087d9073389b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1fbc087d9073389b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1fbc087d9073389b$var$_getPrototypeOf(o) {
    $1fbc087d9073389b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1fbc087d9073389b$var$_getPrototypeOf(o);
}
function $1fbc087d9073389b$var$_defineProperty(obj, key, value) {
    key = $1fbc087d9073389b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1fbc087d9073389b$var$_toPropertyKey(t) {
    var i = $1fbc087d9073389b$var$_toPrimitive(t, "string");
    return "symbol" == $1fbc087d9073389b$var$_typeof(i) ? i : String(i);
}
function $1fbc087d9073389b$var$_toPrimitive(t, r) {
    if ("object" != $1fbc087d9073389b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1fbc087d9073389b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// CSS types
var $1fbc087d9073389b$var$defaultProps = {
    cssClasses: {},
    depth: 0
};
function $1fbc087d9073389b$var$isHierarchicalMenuItem(facetValue) {
    return facetValue.data !== undefined;
}
var $1fbc087d9073389b$var$RefinementList = /*#__PURE__*/ function(_Component) {
    $1fbc087d9073389b$var$_inherits(RefinementList, _Component);
    var _super = $1fbc087d9073389b$var$_createSuper(RefinementList);
    function RefinementList() {
        var _this;
        $1fbc087d9073389b$var$_classCallCheck(this, RefinementList);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $1fbc087d9073389b$var$_defineProperty($1fbc087d9073389b$var$_assertThisInitialized(_this), "listRef", (0, $64f0190ec946a978$export$7d1e3a5e95ceca43)());
        $1fbc087d9073389b$var$_defineProperty($1fbc087d9073389b$var$_assertThisInitialized(_this), "searchBox", (0, $64f0190ec946a978$export$7d1e3a5e95ceca43)());
        $1fbc087d9073389b$var$_defineProperty($1fbc087d9073389b$var$_assertThisInitialized(_this), "lastRefinedValue", undefined);
        $1fbc087d9073389b$var$_defineProperty($1fbc087d9073389b$var$_assertThisInitialized(_this), "_generateFacetItem", function(facetValue) {
            var subItems;
            if ($1fbc087d9073389b$var$isHierarchicalMenuItem(facetValue) && Array.isArray(facetValue.data) && facetValue.data.length > 0) {
                var _this$props$cssClasse = _this.props.cssClasses, root = _this$props$cssClasse.root, cssClasses = $1fbc087d9073389b$var$_objectWithoutProperties(_this$props$cssClasse, $1fbc087d9073389b$var$_excluded);
                subItems = (0, $64f0190ec946a978$export$c8a8987d4410bf2d)(RefinementList, $1fbc087d9073389b$var$_extends({}, _this.props, {
                    // We want to keep `root` required for external usage but not for the
                    // sub items.
                    cssClasses: cssClasses,
                    depth: _this.props.depth + 1,
                    facetValues: facetValue.data,
                    showMore: false,
                    className: _this.props.cssClasses.childList
                }));
            }
            var url = _this.props.createURL(facetValue.value);
            var templateData = $1fbc087d9073389b$var$_objectSpread($1fbc087d9073389b$var$_objectSpread({}, facetValue), {}, {
                url: url,
                attribute: _this.props.attribute,
                cssClasses: _this.props.cssClasses,
                isFromSearch: _this.props.isFromSearch
            });
            var key = facetValue.value;
            if (facetValue.isRefined !== undefined) key += "/".concat(facetValue.isRefined);
            if (facetValue.count !== undefined) key += "/".concat(facetValue.count);
            var refinementListItemClassName = (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)(_this.props.cssClasses.item, facetValue.isRefined && _this.props.cssClasses.selectedItem, !facetValue.count && _this.props.cssClasses.disabledItem, Boolean($1fbc087d9073389b$var$isHierarchicalMenuItem(facetValue) && Array.isArray(facetValue.data) && facetValue.data.length > 0) && _this.props.cssClasses.parentItem);
            return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $a8639478b1684bdf$export$2e2bcd8739ae039), {
                templateKey: "item",
                key: key,
                facetValueToRefine: facetValue.value,
                handleClick: _this.handleItemClick,
                isRefined: facetValue.isRefined,
                className: refinementListItemClassName,
                subItems: subItems,
                templateData: templateData,
                templateProps: _this.props.templateProps
            });
        });
        // Click events on DOM tree like LABEL > INPUT will result in two click events
        // instead of one.
        // No matter the framework, see https://www.google.com/search?q=click+label+twice
        //
        // Thus making it hard to distinguish activation from deactivation because both click events
        // are very close. Debounce is a solution but hacky.
        //
        // So the code here checks if the click was done on or in a LABEL. If this LABEL
        // has a checkbox inside, we ignore the first click event because we will get another one.
        //
        // We also check if the click was done inside a link and then e.preventDefault() because we already
        // handle the url
        //
        // Finally, we always stop propagation of the event to avoid multiple levels RefinementLists to fail: click
        // on child would click on parent also
        $1fbc087d9073389b$var$_defineProperty($1fbc087d9073389b$var$_assertThisInitialized(_this), "handleItemClick", function(_ref) {
            var facetValueToRefine = _ref.facetValueToRefine, isRefined = _ref.isRefined, originalEvent = _ref.originalEvent;
            if ((0, $a5b4777518b58d3c$export$5b1771037ab7c451)(originalEvent)) // do not alter the default browser behavior
            // if one special key is down
            return;
            var parent = originalEvent.target;
            if (parent === null || parent.parentNode === null) return;
            if (isRefined && parent.parentNode.querySelector('input[type="radio"]:checked')) // Prevent refinement for being reset if the user clicks on an already checked radio button
            return;
            if (parent.tagName === "INPUT") {
                _this.refine(facetValueToRefine);
                return;
            }
            while(parent !== originalEvent.currentTarget){
                if (parent.tagName === "LABEL" && (parent.querySelector('input[type="checkbox"]') || parent.querySelector('input[type="radio"]'))) return;
                if (parent.tagName === "A" && parent.href) originalEvent.preventDefault();
                parent = parent.parentNode;
            }
            originalEvent.stopPropagation();
            _this.refine(facetValueToRefine);
        });
        return _this;
    }
    $1fbc087d9073389b$var$_createClass(RefinementList, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var areFacetValuesDifferent = !(0, $33ae9dc431645103$export$248d38f6296296c5)(this.props.facetValues, nextProps.facetValues);
                return areFacetValuesDifferent;
            }
        },
        {
            key: "refine",
            value: function refine(facetValueToRefine) {
                this.lastRefinedValue = facetValueToRefine;
                this.props.toggleRefinement(facetValueToRefine);
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (this.searchBox.current && !nextProps.isFromSearch) this.searchBox.current.resetInput();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$listRef$current, _this$listRef$current2, _this$lastRefinedValu;
                (_this$listRef$current = this.listRef.current) === null || _this$listRef$current === void 0 || (_this$listRef$current2 = _this$listRef$current.querySelector('input[value="'.concat((_this$lastRefinedValu = this.lastRefinedValue) === null || _this$lastRefinedValu === void 0 ? void 0 : _this$lastRefinedValu.replace('"', '\\"'), '"]'))) === null || _this$listRef$current2 === void 0 || _this$listRef$current2.focus();
                this.lastRefinedValue = undefined;
            }
        },
        {
            key: "refineFirstValue",
            value: function refineFirstValue() {
                var firstValue = this.props.facetValues && this.props.facetValues[0];
                if (firstValue) {
                    var actualValue = firstValue.value;
                    this.props.toggleRefinement(actualValue);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var showMoreButtonClassName = (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)(this.props.cssClasses.showMore, !(this.props.showMore === true && this.props.canToggleShowMore) && this.props.cssClasses.disabledShowMore);
                var showMoreButton = this.props.showMore === true && (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $9482d9d5173d02ec$export$2e2bcd8739ae039), $1fbc087d9073389b$var$_extends({}, this.props.templateProps, {
                    templateKey: "showMoreText",
                    rootTagName: "button",
                    rootProps: {
                        className: showMoreButtonClassName,
                        disabled: !this.props.canToggleShowMore,
                        onClick: this.props.toggleShowMore
                    },
                    data: {
                        isShowingMore: this.props.isShowingMore
                    }
                }));
                var shouldDisableSearchBox = this.props.searchIsAlwaysActive !== true && !(this.props.isFromSearch || !this.props.hasExhaustiveItems);
                var searchBox = this.props.searchFacetValues && (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("div", {
                    className: this.props.cssClasses.searchBox
                }, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $7e86fab6ba5fa5f4$export$2e2bcd8739ae039), {
                    ref: this.searchBox,
                    placeholder: this.props.searchPlaceholder,
                    disabled: shouldDisableSearchBox,
                    cssClasses: this.props.cssClasses.searchable,
                    templates: this.props.searchBoxTemplateProps.templates,
                    onChange: function onChange(event) {
                        return _this2.props.searchFacetValues(event.target.value);
                    },
                    onReset: function onReset() {
                        return _this2.props.searchFacetValues("");
                    },
                    onSubmit: function onSubmit() {
                        return _this2.refineFirstValue();
                    },
                    searchAsYouType: false,
                    ariaLabel: "Search for filters"
                }));
                var facetValues = this.props.facetValues && this.props.facetValues.length > 0 && (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("ul", {
                    ref: this.listRef,
                    className: this.props.cssClasses.list
                }, this.props.facetValues.map(this._generateFacetItem, this));
                var noResults = this.props.searchFacetValues && this.props.isFromSearch && (!this.props.facetValues || this.props.facetValues.length === 0) && (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $9482d9d5173d02ec$export$2e2bcd8739ae039), $1fbc087d9073389b$var$_extends({}, this.props.templateProps, {
                    templateKey: "searchableNoResults",
                    rootProps: {
                        className: this.props.cssClasses.noResults
                    }
                }));
                var rootClassName = (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)(this.props.cssClasses.root, (!this.props.facetValues || this.props.facetValues.length === 0) && this.props.cssClasses.noRefinementRoot, this.props.className);
                return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("div", {
                    className: rootClassName
                }, this.props.children, searchBox, facetValues, noResults, showMoreButton);
            }
        }
    ]);
    return RefinementList;
}((0, $64f0190ec946a978$export$16fa2f45be04daa8));
$1fbc087d9073389b$var$_defineProperty($1fbc087d9073389b$var$RefinementList, "defaultProps", $1fbc087d9073389b$var$defaultProps);
var $1fbc087d9073389b$export$2e2bcd8739ae039 = $1fbc087d9073389b$var$RefinementList;


function $09af3be0540e93c6$export$12368a7050a31bdd(helper, facet, value) {
    if (helper.state.isHierarchicalFacet(facet)) return helper.state.isHierarchicalFacetRefined(facet, value);
    else if (helper.state.isConjunctiveFacet(facet)) return helper.state.isFacetRefined(facet, value);
    else return helper.state.isDisjunctiveFacetRefined(facet, value);
}


function $850857ccd2c23846$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $850857ccd2c23846$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $850857ccd2c23846$var$ownKeys(Object(t), !0).forEach(function(r) {
            $850857ccd2c23846$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $850857ccd2c23846$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $850857ccd2c23846$var$_defineProperty(obj, key, value) {
    key = $850857ccd2c23846$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $850857ccd2c23846$var$_toPropertyKey(t) {
    var i = $850857ccd2c23846$var$_toPrimitive(t, "string");
    return "symbol" == $850857ccd2c23846$var$_typeof(i) ? i : String(i);
}
function $850857ccd2c23846$var$_toPrimitive(t, r) {
    if ("object" != $850857ccd2c23846$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $850857ccd2c23846$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $850857ccd2c23846$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $850857ccd2c23846$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $850857ccd2c23846$var$_typeof(o);
}
function $850857ccd2c23846$var$_slicedToArray(arr, i) {
    return $850857ccd2c23846$var$_arrayWithHoles(arr) || $850857ccd2c23846$var$_iterableToArrayLimit(arr, i) || $850857ccd2c23846$var$_unsupportedIterableToArray(arr, i) || $850857ccd2c23846$var$_nonIterableRest();
}
function $850857ccd2c23846$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $850857ccd2c23846$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $850857ccd2c23846$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $850857ccd2c23846$var$_arrayLikeToArray(o, minLen);
}
function $850857ccd2c23846$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $850857ccd2c23846$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $850857ccd2c23846$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $850857ccd2c23846$export$75bfa3473d01f29f(_ref) {
    var instantSearchInstance = _ref.instantSearchInstance, helper = _ref.helper, attr = _ref.attribute, widgetType = _ref.widgetType;
    var sendEventForFacet = function sendEventForFacet() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var facetValue = args[1], _args$ = args[2], eventName = _args$ === void 0 ? "Filter Applied" : _args$, _args$2 = args[3], additionalData = _args$2 === void 0 ? {} : _args$2;
        var _args$0$split = args[0].split(":"), _args$0$split2 = $850857ccd2c23846$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
        var attribute = typeof attr === "string" ? attr : attr(facetValue);
        if (args.length === 1 && $850857ccd2c23846$var$_typeof(args[0]) === "object") instantSearchInstance.sendEventToInsights(args[0]);
        else if (eventType === "click" && args.length >= 2 && args.length <= 4) {
            if (!(0, $09af3be0540e93c6$export$12368a7050a31bdd)(helper, attribute, facetValue)) {
                var _helper$lastResults;
                // send event only when the facet is being checked "ON"
                instantSearchInstance.sendEventToInsights({
                    insightsMethod: "clickedFilters",
                    widgetType: widgetType,
                    eventType: eventType,
                    eventModifier: eventModifier,
                    payload: $850857ccd2c23846$var$_objectSpread({
                        eventName: eventName,
                        index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
                        filters: [
                            "".concat(attribute, ":").concat(facetValue)
                        ]
                    }, additionalData),
                    attribute: attribute
                });
            }
        }
    };
    return sendEventForFacet;
}


function $e0a7033d7266c2b4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e0a7033d7266c2b4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e0a7033d7266c2b4$var$_typeof(o);
}
var $e0a7033d7266c2b4$var$_excluded = [
    "name",
    "escapedValue"
], $e0a7033d7266c2b4$var$_excluded2 = [
    "escapedValue",
    "value"
];
function $e0a7033d7266c2b4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e0a7033d7266c2b4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e0a7033d7266c2b4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e0a7033d7266c2b4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e0a7033d7266c2b4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e0a7033d7266c2b4$var$_defineProperty(obj, key, value) {
    key = $e0a7033d7266c2b4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e0a7033d7266c2b4$var$_toPropertyKey(t) {
    var i = $e0a7033d7266c2b4$var$_toPrimitive(t, "string");
    return "symbol" == $e0a7033d7266c2b4$var$_typeof(i) ? i : String(i);
}
function $e0a7033d7266c2b4$var$_toPrimitive(t, r) {
    if ("object" != $e0a7033d7266c2b4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e0a7033d7266c2b4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e0a7033d7266c2b4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e0a7033d7266c2b4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e0a7033d7266c2b4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e0a7033d7266c2b4$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "refinement-list",
    connector: true
});
var $e0a7033d7266c2b4$var$DEFAULT_SORT = [
    "isRefined",
    "count:desc",
    "name:asc"
];
/**
 * **RefinementList** connector provides the logic to build a custom widget that
 * will let the user filter the results based on the values of a specific facet.
 *
 * **Requirement:** the attribute passed as `attribute` must be present in
 * attributesForFaceting of the searched index.
 *
 * This connector provides:
 * - a `refine()` function to select an item.
 * - a `toggleShowMore()` function to display more or less items
 * - a `searchForItems()` function to search within the items.
 */ var $e0a7033d7266c2b4$var$connectRefinementList = function connectRefinementList(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8fe091dcd40a4798$export$8793edee2d425525);
    (0, $1575d32251b25e2a$export$adc2a8e09aa583ee)(renderFn, $e0a7033d7266c2b4$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, attribute = _ref.attribute, _ref$operator = _ref.operator, operator = _ref$operator === void 0 ? "or" : _ref$operator, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref.sortBy, sortBy = _ref$sortBy === void 0 ? $e0a7033d7266c2b4$var$DEFAULT_SORT : _ref$sortBy, _ref$escapeFacetValue = _ref.escapeFacetValues, escapeFacetValues = _ref$escapeFacetValue === void 0 ? true : _ref$escapeFacetValue, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (!attribute) throw new Error($e0a7033d7266c2b4$var$withUsage("The `attribute` option is required."));
        if (!/^(and|or)$/.test(operator)) throw new Error($e0a7033d7266c2b4$var$withUsage('The `operator` must one of: `"and"`, `"or"` (got "'.concat(operator, '").')));
        if (showMore === true && showMoreLimit <= limit) throw new Error($e0a7033d7266c2b4$var$withUsage("`showMoreLimit` should be greater than `limit`."));
        var formatItems = function formatItems(_ref2) {
            var label = _ref2.name, value = _ref2.escapedValue, item = $e0a7033d7266c2b4$var$_objectWithoutProperties(_ref2, $e0a7033d7266c2b4$var$_excluded);
            return $e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, item), {}, {
                value: value,
                label: label,
                highlighted: label
            });
        };
        var lastResultsFromMainSearch;
        var lastItemsFromMainSearch = [];
        var hasExhaustiveItems = true;
        var triggerRefine;
        var sendEvent;
        var isShowingMore = false;
        // Provide the same function to the `renderFn` so that way the user
        // has to only bind it once when `isFirstRendering` for instance
        var toggleShowMore = function toggleShowMore() {};
        function cachedToggleShowMore() {
            toggleShowMore();
        }
        function createToggleShowMore(renderOptions, widget) {
            return function() {
                isShowingMore = !isShowingMore;
                widget.render(renderOptions);
            };
        }
        function getLimit() {
            return isShowingMore ? showMoreLimit : limit;
        }
        var searchForFacetValues = function searchForFacetValues() {
            return function() {};
        };
        var createSearchForFacetValues = function createSearchForFacetValues(helper, widget) {
            return function(renderOptions) {
                return function(query) {
                    var instantSearchInstance = renderOptions.instantSearchInstance, searchResults = renderOptions.results;
                    if (query === "" && lastItemsFromMainSearch) // render with previous data from the helper.
                    renderFn($e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, widget.getWidgetRenderState($e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, renderOptions), {}, {
                        results: lastResultsFromMainSearch
                    }))), {}, {
                        instantSearchInstance: instantSearchInstance
                    }), false);
                    else {
                        var tags = {
                            highlightPreTag: escapeFacetValues ? (0, $c3ab0a6931928f0c$export$1e7338a8952eaf35).highlightPreTag : (0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPreTag,
                            highlightPostTag: escapeFacetValues ? (0, $c3ab0a6931928f0c$export$1e7338a8952eaf35).highlightPostTag : (0, $c3ab0a6931928f0c$export$62e796b7905e8e6b).highlightPostTag
                        };
                        helper.searchForFacetValues(attribute, query, // We cap the `maxFacetHits` value to 100 because the Algolia API
                        // doesn't support a greater number.
                        // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
                        Math.min(getLimit(), 100), tags).then(function(results) {
                            var facetValues = escapeFacetValues ? (0, $c3ab0a6931928f0c$export$9ae2e822836b2e1a)(results.facetHits) : results.facetHits;
                            var normalizedFacetValues = transformItems(facetValues.map(function(_ref3) {
                                var escapedValue = _ref3.escapedValue, value = _ref3.value, item = $e0a7033d7266c2b4$var$_objectWithoutProperties(_ref3, $e0a7033d7266c2b4$var$_excluded2);
                                return $e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, item), {}, {
                                    value: escapedValue,
                                    label: value
                                });
                            }), {
                                results: searchResults
                            });
                            renderFn($e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, widget.getWidgetRenderState($e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, renderOptions), {}, {
                                results: lastResultsFromMainSearch
                            }))), {}, {
                                items: normalizedFacetValues,
                                canToggleShowMore: false,
                                canRefine: true,
                                isFromSearch: true,
                                instantSearchInstance: instantSearchInstance
                            }), false);
                        });
                    }
                };
            };
        };
        return {
            $$type: "ais.refinementList",
            init: function init(initOptions) {
                renderFn($e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                renderFn($e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, renderState), {}, {
                    refinementList: $e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, renderState.refinementList), {}, $e0a7033d7266c2b4$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(renderOptions) {
                var _this = this;
                var results = renderOptions.results, state = renderOptions.state, _createURL = renderOptions.createURL, instantSearchInstance = renderOptions.instantSearchInstance, helper = renderOptions.helper;
                var items = [];
                var facetValues = [];
                if (!sendEvent || !triggerRefine || !searchForFacetValues) {
                    sendEvent = (0, $850857ccd2c23846$export$75bfa3473d01f29f)({
                        instantSearchInstance: instantSearchInstance,
                        helper: helper,
                        attribute: attribute,
                        widgetType: this.$$type
                    });
                    triggerRefine = function triggerRefine(facetValue) {
                        sendEvent("click:internal", facetValue);
                        helper.toggleFacetRefinement(attribute, facetValue).search();
                    };
                    searchForFacetValues = createSearchForFacetValues(helper, this);
                }
                if (results) {
                    var values = results.getFacetValues(attribute, {
                        sortBy: sortBy,
                        facetOrdering: sortBy === $e0a7033d7266c2b4$var$DEFAULT_SORT
                    });
                    facetValues = values && Array.isArray(values) ? values : [];
                    items = transformItems(facetValues.slice(0, getLimit()).map(formatItems), {
                        results: results
                    });
                    var maxValuesPerFacetConfig = state.maxValuesPerFacet;
                    var currentLimit = getLimit();
                    // If the limit is the max number of facet retrieved it is impossible to know
                    // if the facets are exhaustive. The only moment we are sure it is exhaustive
                    // is when it is strictly under the number requested unless we know that another
                    // widget has requested more values (maxValuesPerFacet > getLimit()).
                    // Because this is used for making the search of facets unable or not, it is important
                    // to be conservative here.
                    hasExhaustiveItems = maxValuesPerFacetConfig > currentLimit ? facetValues.length <= currentLimit : facetValues.length < currentLimit;
                    lastResultsFromMainSearch = results;
                    lastItemsFromMainSearch = items;
                    if (renderOptions.results) toggleShowMore = createToggleShowMore(renderOptions, this);
                }
                // Do not mistake searchForFacetValues and searchFacetValues which is the actual search
                // function
                var searchFacetValues = searchForFacetValues && searchForFacetValues(renderOptions);
                var canShowLess = isShowingMore && lastItemsFromMainSearch.length > limit;
                var canShowMore = showMore && !hasExhaustiveItems;
                var canToggleShowMore = canShowLess || canShowMore;
                return {
                    createURL: function createURL(facetValue) {
                        return _createURL(function(uiState) {
                            return _this.getWidgetUiState(uiState, {
                                searchParameters: state.resetPage().toggleFacetRefinement(attribute, facetValue),
                                helper: helper
                            });
                        });
                    },
                    items: items,
                    refine: triggerRefine,
                    searchForItems: searchFacetValues,
                    isFromSearch: false,
                    canRefine: items.length > 0,
                    widgetParams: widgetParams,
                    isShowingMore: isShowingMore,
                    canToggleShowMore: canToggleShowMore,
                    toggleShowMore: cachedToggleShowMore,
                    sendEvent: sendEvent,
                    hasExhaustiveItems: hasExhaustiveItems
                };
            },
            dispose: function dispose(_ref4) {
                var state = _ref4.state;
                unmountFn();
                var withoutMaxValuesPerFacet = state.setQueryParameter("maxValuesPerFacet", undefined);
                if (operator === "and") return withoutMaxValuesPerFacet.removeFacet(attribute);
                return withoutMaxValuesPerFacet.removeDisjunctiveFacet(attribute);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
                var searchParameters = _ref5.searchParameters;
                var values = operator === "or" ? searchParameters.getDisjunctiveRefinements(attribute) : searchParameters.getConjunctiveRefinements(attribute);
                return $e0a7033d7266c2b4$var$removeEmptyRefinementsFromUiState($e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, uiState), {}, {
                    refinementList: $e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, uiState.refinementList), {}, $e0a7033d7266c2b4$var$_defineProperty({}, attribute, values))
                }), attribute);
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
                var uiState = _ref6.uiState;
                var isDisjunctive = operator === "or";
                if (searchParameters.isHierarchicalFacet(attribute)) return searchParameters;
                if (isDisjunctive && searchParameters.isConjunctiveFacet(attribute) || !isDisjunctive && searchParameters.isDisjunctiveFacet(attribute)) return searchParameters;
                var values = uiState.refinementList && uiState.refinementList[attribute];
                var withFacetConfiguration = isDisjunctive ? searchParameters.addDisjunctiveFacet(attribute).removeDisjunctiveFacetRefinement(attribute) : searchParameters.addFacet(attribute).removeFacetRefinement(attribute);
                var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
                var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
                var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter("maxValuesPerFacet", nextMaxValuesPerFacet);
                if (!values) {
                    var key = isDisjunctive ? "disjunctiveFacetsRefinements" : "facetsRefinements";
                    return withMaxValuesPerFacet.setQueryParameters($e0a7033d7266c2b4$var$_defineProperty({}, key, $e0a7033d7266c2b4$var$_objectSpread($e0a7033d7266c2b4$var$_objectSpread({}, withMaxValuesPerFacet[key]), {}, $e0a7033d7266c2b4$var$_defineProperty({}, attribute, []))));
                }
                return values.reduce(function(parameters, value) {
                    return isDisjunctive ? parameters.addDisjunctiveFacetRefinement(attribute, value) : parameters.addFacetRefinement(attribute, value);
                }, withMaxValuesPerFacet);
            }
        };
    };
};
function $e0a7033d7266c2b4$var$removeEmptyRefinementsFromUiState(indexUiState, attribute) {
    if (!indexUiState.refinementList) return indexUiState;
    if (!indexUiState.refinementList[attribute] || indexUiState.refinementList[attribute].length === 0) delete indexUiState.refinementList[attribute];
    if (Object.keys(indexUiState.refinementList).length === 0) delete indexUiState.refinementList;
    return indexUiState;
}
var $e0a7033d7266c2b4$export$2e2bcd8739ae039 = $e0a7033d7266c2b4$var$connectRefinementList;




function $7d91d9d2178182a4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7d91d9d2178182a4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7d91d9d2178182a4$var$_typeof(o);
}
function $7d91d9d2178182a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d91d9d2178182a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d91d9d2178182a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7d91d9d2178182a4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d91d9d2178182a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7d91d9d2178182a4$var$_defineProperty(obj, key, value) {
    key = $7d91d9d2178182a4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d91d9d2178182a4$var$_toPropertyKey(t) {
    var i = $7d91d9d2178182a4$var$_toPrimitive(t, "string");
    return "symbol" == $7d91d9d2178182a4$var$_typeof(i) ? i : String(i);
}
function $7d91d9d2178182a4$var$_toPrimitive(t, r) {
    if ("object" != $7d91d9d2178182a4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7d91d9d2178182a4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7d91d9d2178182a4$var$_toConsumableArray(arr) {
    return $7d91d9d2178182a4$var$_arrayWithoutHoles(arr) || $7d91d9d2178182a4$var$_iterableToArray(arr) || $7d91d9d2178182a4$var$_unsupportedIterableToArray(arr) || $7d91d9d2178182a4$var$_nonIterableSpread();
}
function $7d91d9d2178182a4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7d91d9d2178182a4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7d91d9d2178182a4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7d91d9d2178182a4$var$_arrayLikeToArray(o, minLen);
}
function $7d91d9d2178182a4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $7d91d9d2178182a4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $7d91d9d2178182a4$var$_arrayLikeToArray(arr);
}
function $7d91d9d2178182a4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7d91d9d2178182a4$var$prepareTemplates(// can not use = {} here, since the template could have different constraints
defaultTemplates) {
    var templates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allKeys = (0, $98a2c07ad87fe2bc$export$f70730c3d1fc524e)([].concat($7d91d9d2178182a4$var$_toConsumableArray(Object.keys(defaultTemplates || {})), $7d91d9d2178182a4$var$_toConsumableArray(Object.keys(templates))));
    return allKeys.reduce(function(config, key) {
        var defaultTemplate = defaultTemplates ? defaultTemplates[key] : undefined;
        var customTemplate = templates[key];
        var isCustomTemplate = customTemplate !== undefined && customTemplate !== defaultTemplate;
        config.templates[key] = isCustomTemplate ? customTemplate : defaultTemplate;
        config.useCustomCompileOptions[key] = isCustomTemplate;
        return config;
    }, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        templates: {},
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        useCustomCompileOptions: {}
    });
}
function $7d91d9d2178182a4$export$2938ff6a58d41f25(_ref) {
    var defaultTemplates = _ref.defaultTemplates, templates = _ref.templates, templatesConfig = _ref.templatesConfig;
    var preparedTemplates = $7d91d9d2178182a4$var$prepareTemplates(defaultTemplates, templates);
    return $7d91d9d2178182a4$var$_objectSpread({
        templatesConfig: templatesConfig
    }, preparedTemplates);
}


function $73431e86cbc4cd7e$export$124b2c3e0d3efb2d(object) {
    return object instanceof HTMLElement || Boolean(object) && object.nodeType > 0;
}


function $ca542eeff1679d1c$export$ffb2c7b8d67c359a(selectorOrHTMLElement) {
    var isSelectorString = typeof selectorOrHTMLElement === "string";
    var domElement = isSelectorString ? document.querySelector(selectorOrHTMLElement) : selectorOrHTMLElement;
    if (!(0, $73431e86cbc4cd7e$export$124b2c3e0d3efb2d)(domElement)) {
        var errorMessage = "Container must be `string` or `HTMLElement`.";
        if (isSelectorString) errorMessage += " Unable to find ".concat(selectorOrHTMLElement);
        throw new Error(errorMessage);
    }
    return domElement;
}



var $5e36ca6526df7898$var$_ref2 = (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("path", {
    d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
});
var $5e36ca6526df7898$var$_ref4 = (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("path", {
    d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
});
var $5e36ca6526df7898$var$_ref6 = (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("g", {
    fill: "none",
    "fill-rule": "evenodd"
}, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("g", {
    transform: "translate(1 1)",
    "stroke-width": "2"
}, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("circle", {
    "stroke-opacity": ".5",
    cx: "18",
    cy: "18",
    r: "18"
}), (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
}, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
}))));
var $5e36ca6526df7898$var$defaultTemplate = {
    reset: function reset(_ref) {
        var cssClasses = _ref.cssClasses;
        return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("svg", {
            className: cssClasses.resetIcon,
            viewBox: "0 0 20 20",
            width: "10",
            height: "10",
            "aria-hidden": "true"
        }, $5e36ca6526df7898$var$_ref2);
    },
    submit: function submit(_ref3) {
        var cssClasses = _ref3.cssClasses;
        return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("svg", {
            className: cssClasses.submitIcon,
            width: "10",
            height: "10",
            viewBox: "0 0 40 40",
            "aria-hidden": "true"
        }, $5e36ca6526df7898$var$_ref4);
    },
    loadingIndicator: function loadingIndicator(_ref5) {
        var cssClasses = _ref5.cssClasses;
        /* eslint-disable react/no-unknown-property */ // Preact supports kebab case attributes, and using camel case would
        // require using `preact/compat`.
        // @TODO: reconsider using the `react` ESLint preset
        return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("svg", {
            "aria-label": "Results are loading",
            className: cssClasses.loadingIcon,
            width: "16",
            height: "16",
            viewBox: "0 0 38 38",
            stroke: "#444",
            "aria-hidden": "true"
        }, $5e36ca6526df7898$var$_ref6);
    /* eslint-enable react/no-unknown-property */ }
};
var $5e36ca6526df7898$export$2e2bcd8739ae039 = $5e36ca6526df7898$var$defaultTemplate;





var $e6777bfdd9de8099$var$defaultTemplates = {
    item: function item(_ref) {
        var cssClasses = _ref.cssClasses, count = _ref.count, value = _ref.value, highlighted = _ref.highlighted, isRefined = _ref.isRefined, isFromSearch = _ref.isFromSearch;
        return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("label", {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)(cssClasses.label)
        }, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("input", {
            type: "checkbox",
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)(cssClasses.checkbox),
            value: value,
            defaultChecked: isRefined
        }), (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("span", {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)(cssClasses.labelText),
            dangerouslySetInnerHTML: isFromSearch ? {
                __html: highlighted
            } : undefined
        }, !isFromSearch && highlighted), (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("span", {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)(cssClasses.count)
        }, (0, $f0f6b35ae64c9b16$export$f5dd818bff069720)(count)));
    },
    showMoreText: function showMoreText(_ref2) {
        var isShowingMore = _ref2.isShowingMore;
        return isShowingMore ? "Show less" : "Show more";
    },
    searchableNoResults: function searchableNoResults() {
        return "No results";
    }
};
var $e6777bfdd9de8099$export$2e2bcd8739ae039 = $e6777bfdd9de8099$var$defaultTemplates;


function $3d35788e55c98fba$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3d35788e55c98fba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3d35788e55c98fba$var$_typeof(o);
}
function $3d35788e55c98fba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d35788e55c98fba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d35788e55c98fba$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3d35788e55c98fba$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d35788e55c98fba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3d35788e55c98fba$var$_defineProperty(obj, key, value) {
    key = $3d35788e55c98fba$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3d35788e55c98fba$var$_toPropertyKey(t) {
    var i = $3d35788e55c98fba$var$_toPrimitive(t, "string");
    return "symbol" == $3d35788e55c98fba$var$_typeof(i) ? i : String(i);
}
function $3d35788e55c98fba$var$_toPrimitive(t, r) {
    if ("object" != $3d35788e55c98fba$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3d35788e55c98fba$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3d35788e55c98fba$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "refinement-list"
});
var $3d35788e55c98fba$var$suit = (0, $fb1e243c72be04b6$export$d8556a2a8f973135)("RefinementList");
var $3d35788e55c98fba$var$searchBoxSuit = (0, $fb1e243c72be04b6$export$d8556a2a8f973135)("SearchBox");
var $3d35788e55c98fba$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, templates = _ref.templates, searchBoxTemplates = _ref.searchBoxTemplates, renderState = _ref.renderState, showMore = _ref.showMore, searchable = _ref.searchable, searchablePlaceholder = _ref.searchablePlaceholder, searchableIsAlwaysActive = _ref.searchableIsAlwaysActive;
    return function(_ref2, isFirstRendering) {
        var refine = _ref2.refine, items = _ref2.items, createURL = _ref2.createURL, searchForItems = _ref2.searchForItems, isFromSearch = _ref2.isFromSearch, instantSearchInstance = _ref2.instantSearchInstance, toggleShowMore = _ref2.toggleShowMore, isShowingMore = _ref2.isShowingMore, hasExhaustiveItems = _ref2.hasExhaustiveItems, canToggleShowMore = _ref2.canToggleShowMore;
        if (isFirstRendering) {
            renderState.templateProps = (0, $7d91d9d2178182a4$export$2938ff6a58d41f25)({
                defaultTemplates: (0, $e6777bfdd9de8099$export$2e2bcd8739ae039),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            renderState.searchBoxTemplateProps = (0, $7d91d9d2178182a4$export$2938ff6a58d41f25)({
                defaultTemplates: (0, $5e36ca6526df7898$export$2e2bcd8739ae039),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: searchBoxTemplates
            });
            return;
        }
        (0, $64f0190ec946a978$export$b3890eb0ae9dca99)((0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $1fbc087d9073389b$export$2e2bcd8739ae039), {
            createURL: createURL,
            cssClasses: cssClasses,
            facetValues: items,
            templateProps: renderState.templateProps,
            searchBoxTemplateProps: renderState.searchBoxTemplateProps,
            toggleRefinement: refine,
            searchFacetValues: searchable ? searchForItems : undefined,
            searchPlaceholder: searchablePlaceholder,
            searchIsAlwaysActive: searchableIsAlwaysActive,
            isFromSearch: isFromSearch,
            showMore: showMore && !isFromSearch && items.length > 0,
            toggleShowMore: toggleShowMore,
            isShowingMore: isShowingMore,
            hasExhaustiveItems: hasExhaustiveItems,
            canToggleShowMore: canToggleShowMore
        }), containerNode);
    };
};
/**
 * The refinement list widget is one of the most common widget that you can find
 * in a search UI. With this widget, the user can filter the dataset based on facets.
 *
 * The refinement list displays only the most relevant facets for the current search
 * context. The sort option only affects the facet that are returned by the engine,
 * not which facets are returned.
 *
 * This widget also implements search for facet values, which is a mini search inside the
 * values of the facets. This makes easy to deal with uncommon facet values.
 *
 * @requirements
 *
 * The attribute passed to `attribute` must be declared as an
 * [attribute for faceting](https://www.algolia.com/doc/guides/searching/faceting/#declaring-attributes-for-faceting)
 * in your Algolia settings.
 *
 * If you also want to use search for facet values on this attribute, you need to make it searchable using the [dashboard](https://www.algolia.com/explorer/display/) or using the [API](https://www.algolia.com/doc/guides/searching/faceting/#search-for-facet-values).
 */ var $3d35788e55c98fba$var$refinementList = function refinementList(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, attribute = _ref3.attribute, operator = _ref3.operator, sortBy = _ref3.sortBy, limit = _ref3.limit, showMore = _ref3.showMore, showMoreLimit = _ref3.showMoreLimit, _ref3$searchable = _ref3.searchable, searchable = _ref3$searchable === void 0 ? false : _ref3$searchable, _ref3$searchablePlace = _ref3.searchablePlaceholder, searchablePlaceholder = _ref3$searchablePlace === void 0 ? "Search..." : _ref3$searchablePlace, _ref3$searchableEscap = _ref3.searchableEscapeFacetValues, searchableEscapeFacetValues = _ref3$searchableEscap === void 0 ? true : _ref3$searchableEscap, _ref3$searchableIsAlw = _ref3.searchableIsAlwaysActive, searchableIsAlwaysActive = _ref3$searchableIsAlw === void 0 ? true : _ref3$searchableIsAlw, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$templates = _ref3.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, transformItems = _ref3.transformItems;
    if (!container) throw new Error($3d35788e55c98fba$var$withUsage("The `container` option is required."));
    var escapeFacetValues = searchable ? Boolean(searchableEscapeFacetValues) : false;
    var containerNode = (0, $ca542eeff1679d1c$export$ffb2c7b8d67c359a)(container);
    var cssClasses = {
        root: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit(), userCssClasses.root),
        noRefinementRoot: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            modifierName: "noRefinement"
        }), userCssClasses.noRefinementRoot),
        list: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            descendantName: "list"
        }), userCssClasses.list),
        item: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            descendantName: "item"
        }), userCssClasses.item),
        selectedItem: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            descendantName: "item",
            modifierName: "selected"
        }), userCssClasses.selectedItem),
        searchBox: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            descendantName: "searchBox"
        }), userCssClasses.searchBox),
        label: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            descendantName: "label"
        }), userCssClasses.label),
        checkbox: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            descendantName: "checkbox"
        }), userCssClasses.checkbox),
        labelText: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            descendantName: "labelText"
        }), userCssClasses.labelText),
        count: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            descendantName: "count"
        }), userCssClasses.count),
        noResults: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            descendantName: "noResults"
        }), userCssClasses.noResults),
        showMore: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            descendantName: "showMore"
        }), userCssClasses.showMore),
        disabledShowMore: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$suit({
            descendantName: "showMore",
            modifierName: "disabled"
        }), userCssClasses.disabledShowMore),
        searchable: {
            root: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$searchBoxSuit(), userCssClasses.searchableRoot),
            form: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$searchBoxSuit({
                descendantName: "form"
            }), userCssClasses.searchableForm),
            input: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$searchBoxSuit({
                descendantName: "input"
            }), userCssClasses.searchableInput),
            submit: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$searchBoxSuit({
                descendantName: "submit"
            }), userCssClasses.searchableSubmit),
            submitIcon: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$searchBoxSuit({
                descendantName: "submitIcon"
            }), userCssClasses.searchableSubmitIcon),
            reset: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$searchBoxSuit({
                descendantName: "reset"
            }), userCssClasses.searchableReset),
            resetIcon: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$searchBoxSuit({
                descendantName: "resetIcon"
            }), userCssClasses.searchableResetIcon),
            loadingIndicator: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$searchBoxSuit({
                descendantName: "loadingIndicator"
            }), userCssClasses.searchableLoadingIndicator),
            loadingIcon: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3d35788e55c98fba$var$searchBoxSuit({
                descendantName: "loadingIcon"
            }), userCssClasses.searchableLoadingIcon)
        }
    };
    var specializedRenderer = $3d35788e55c98fba$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        templates: templates,
        searchBoxTemplates: {
            submit: templates.searchableSubmit,
            reset: templates.searchableReset,
            loadingIndicator: templates.searchableLoadingIndicator
        },
        renderState: {},
        searchable: searchable,
        searchablePlaceholder: searchablePlaceholder,
        searchableIsAlwaysActive: searchableIsAlwaysActive,
        showMore: showMore
    });
    var makeWidget = (0, $e0a7033d7266c2b4$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $64f0190ec946a978$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $3d35788e55c98fba$var$_objectSpread($3d35788e55c98fba$var$_objectSpread({}, makeWidget({
        attribute: attribute,
        operator: operator,
        limit: limit,
        showMore: showMore,
        showMoreLimit: showMoreLimit,
        sortBy: sortBy,
        escapeFacetValues: escapeFacetValues,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.refinementList"
    });
};
var $3d35788e55c98fba$export$2e2bcd8739ae039 = $3d35788e55c98fba$var$refinementList;





function $f8d38740e6d46683$export$9a00dee1beb8f576(text) {
    return text.toString().charAt(0).toUpperCase() + text.toString().slice(1);
}


var $f5b7ba589d4e2264$var$createItemKey = function createItemKey(_ref) {
    var attribute = _ref.attribute, value = _ref.value, type = _ref.type, operator = _ref.operator;
    return [
        attribute,
        type,
        value,
        operator
    ].map(function(key) {
        return key;
    }).filter(Boolean).join(":");
};
var $f5b7ba589d4e2264$var$handleClick = function handleClick(callback) {
    return function(event) {
        if ((0, $a5b4777518b58d3c$export$5b1771037ab7c451)(event)) return;
        event.preventDefault();
        callback();
    };
};
var $f5b7ba589d4e2264$var$CurrentRefinements = function CurrentRefinements(_ref2) {
    var items = _ref2.items, cssClasses = _ref2.cssClasses, canRefine = _ref2.canRefine;
    return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("div", {
        className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)(cssClasses.root, !canRefine && cssClasses.noRefinementRoot)
    }, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("ul", {
        className: cssClasses.list
    }, items.map(function(item, index) {
        return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("li", {
            key: "".concat(item.indexName, "-").concat(item.attribute, "-").concat(index),
            className: cssClasses.item
        }, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("span", {
            className: cssClasses.label
        }, (0, $f8d38740e6d46683$export$9a00dee1beb8f576)(item.label), ": "), item.refinements.map(function(refinement) {
            return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("span", {
                key: $f5b7ba589d4e2264$var$createItemKey(refinement),
                className: cssClasses.category
            }, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("span", {
                className: cssClasses.categoryLabel
            }, refinement.attribute === "query" ? (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("q", null, refinement.label) : refinement.label), (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("button", {
                className: cssClasses.delete,
                type: "button",
                onClick: $f5b7ba589d4e2264$var$handleClick(item.refine.bind(null, refinement))
            }, "\u2715"));
        }));
    })));
};
var $f5b7ba589d4e2264$export$2e2bcd8739ae039 = $f5b7ba589d4e2264$var$CurrentRefinements;


function $43f60bb49151d798$export$ad628980c7383a99(value) {
    if (typeof value === "string") return value.replace(/^\\-/, "-");
    return value;
}
function $43f60bb49151d798$export$40415fcf01f0c9e8(value) {
    if (typeof value === "number" && value < 0 || typeof value === "string") return String(value).replace(/^-/, "\\-");
    return value;
}



function $c8f5d9142d801f6d$var$getRefinement(state, type, attribute, name) {
    var resultsFacets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var res = {
        type: type,
        attribute: attribute,
        name: name,
        escapedValue: (0, $43f60bb49151d798$export$40415fcf01f0c9e8)(name)
    };
    var facet = (0, $3a145725faa3321d$export$71aa6c912b956294)(resultsFacets, function(resultsFacet) {
        return resultsFacet.name === attribute;
    });
    var count;
    if (type === "hierarchical") {
        var facetDeclaration = state.getHierarchicalFacetByName(attribute);
        var nameParts = name.split(facetDeclaration.separator);
        var getFacetRefinement = function getFacetRefinement(facetData) {
            return function(refinementKey) {
                return facetData[refinementKey];
            };
        };
        var _loop = function _loop(i) {
            facet = facet && facet.data && (0, $3a145725faa3321d$export$71aa6c912b956294)(Object.keys(facet.data).map(getFacetRefinement(facet.data)), function(refinement) {
                return refinement.name === nameParts[i];
            });
        };
        for(var i = 0; facet !== undefined && i < nameParts.length; ++i)_loop(i);
        count = facet && facet.count;
    } else count = facet && facet.data && facet.data[res.name];
    if (count !== undefined) res.count = count;
    if (facet && facet.exhaustive !== undefined) res.exhaustive = facet.exhaustive;
    return res;
}
function $c8f5d9142d801f6d$export$d9f33760e70a0a(_results, state) {
    var includesQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var results = _results || {};
    var refinements = [];
    var _state$facetsRefineme = state.facetsRefinements, facetsRefinements = _state$facetsRefineme === void 0 ? {} : _state$facetsRefineme, _state$facetsExcludes = state.facetsExcludes, facetsExcludes = _state$facetsExcludes === void 0 ? {} : _state$facetsExcludes, _state$disjunctiveFac = state.disjunctiveFacetsRefinements, disjunctiveFacetsRefinements = _state$disjunctiveFac === void 0 ? {} : _state$disjunctiveFac, _state$hierarchicalFa = state.hierarchicalFacetsRefinements, hierarchicalFacetsRefinements = _state$hierarchicalFa === void 0 ? {} : _state$hierarchicalFa, _state$numericRefinem = state.numericRefinements, numericRefinements = _state$numericRefinem === void 0 ? {} : _state$numericRefinem, _state$tagRefinements = state.tagRefinements, tagRefinements = _state$tagRefinements === void 0 ? [] : _state$tagRefinements;
    Object.keys(facetsRefinements).forEach(function(attribute) {
        var refinementNames = facetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($c8f5d9142d801f6d$var$getRefinement(state, "facet", attribute, refinementName, results.facets));
        });
    });
    Object.keys(facetsExcludes).forEach(function(attribute) {
        var refinementNames = facetsExcludes[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push({
                type: "exclude",
                attribute: attribute,
                name: refinementName,
                exclude: true
            });
        });
    });
    Object.keys(disjunctiveFacetsRefinements).forEach(function(attribute) {
        var refinementNames = disjunctiveFacetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($c8f5d9142d801f6d$var$getRefinement(state, "disjunctive", attribute, // We unescape any disjunctive refined values with `unescapeFacetValue` because
            // they can be escaped on negative numeric values with `escapeFacetValue`.
            (0, $43f60bb49151d798$export$ad628980c7383a99)(refinementName), results.disjunctiveFacets));
        });
    });
    Object.keys(hierarchicalFacetsRefinements).forEach(function(attribute) {
        var refinementNames = hierarchicalFacetsRefinements[attribute];
        refinementNames.forEach(function(refinement) {
            refinements.push($c8f5d9142d801f6d$var$getRefinement(state, "hierarchical", attribute, refinement, results.hierarchicalFacets));
        });
    });
    Object.keys(numericRefinements).forEach(function(attribute) {
        var operators = numericRefinements[attribute];
        Object.keys(operators).forEach(function(operatorOriginal) {
            var operator = operatorOriginal;
            var valueOrValues = operators[operator];
            var refinementNames = Array.isArray(valueOrValues) ? valueOrValues : [
                valueOrValues
            ];
            refinementNames.forEach(function(refinementName) {
                refinements.push({
                    type: "numeric",
                    attribute: attribute,
                    name: "".concat(refinementName),
                    numericValue: refinementName,
                    operator: operator
                });
            });
        });
    });
    tagRefinements.forEach(function(refinementName) {
        refinements.push({
            type: "tag",
            attribute: "_tags",
            name: refinementName
        });
    });
    if (includesQuery && state.query && state.query.trim()) refinements.push({
        attribute: "query",
        type: "query",
        name: state.query,
        query: state.query
    });
    return refinements;
}


function $8bb7e0ad377f70ed$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8bb7e0ad377f70ed$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8bb7e0ad377f70ed$var$_typeof(o);
}
function $8bb7e0ad377f70ed$var$_toConsumableArray(arr) {
    return $8bb7e0ad377f70ed$var$_arrayWithoutHoles(arr) || $8bb7e0ad377f70ed$var$_iterableToArray(arr) || $8bb7e0ad377f70ed$var$_unsupportedIterableToArray(arr) || $8bb7e0ad377f70ed$var$_nonIterableSpread();
}
function $8bb7e0ad377f70ed$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8bb7e0ad377f70ed$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8bb7e0ad377f70ed$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8bb7e0ad377f70ed$var$_arrayLikeToArray(o, minLen);
}
function $8bb7e0ad377f70ed$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8bb7e0ad377f70ed$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8bb7e0ad377f70ed$var$_arrayLikeToArray(arr);
}
function $8bb7e0ad377f70ed$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8bb7e0ad377f70ed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8bb7e0ad377f70ed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8bb7e0ad377f70ed$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8bb7e0ad377f70ed$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8bb7e0ad377f70ed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8bb7e0ad377f70ed$var$_defineProperty(obj, key, value) {
    key = $8bb7e0ad377f70ed$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8bb7e0ad377f70ed$var$_toPropertyKey(t) {
    var i = $8bb7e0ad377f70ed$var$_toPrimitive(t, "string");
    return "symbol" == $8bb7e0ad377f70ed$var$_typeof(i) ? i : String(i);
}
function $8bb7e0ad377f70ed$var$_toPrimitive(t, r) {
    if ("object" != $8bb7e0ad377f70ed$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8bb7e0ad377f70ed$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8bb7e0ad377f70ed$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "current-refinements",
    connector: true
});
var $8bb7e0ad377f70ed$var$connectCurrentRefinements = function connectCurrentRefinements(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8fe091dcd40a4798$export$8793edee2d425525);
    (0, $1575d32251b25e2a$export$adc2a8e09aa583ee)(renderFn, $8bb7e0ad377f70ed$var$withUsage());
    return function(widgetParams) {
        if ((widgetParams || {}).includedAttributes && (widgetParams || {}).excludedAttributes) throw new Error($8bb7e0ad377f70ed$var$withUsage("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
        var _ref = widgetParams || {}, includedAttributes = _ref.includedAttributes, _ref$excludedAttribut = _ref.excludedAttributes, excludedAttributes = _ref$excludedAttribut === void 0 ? [
            "query"
        ] : _ref$excludedAttribut, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        return {
            $$type: "ais.currentRefinements",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($8bb7e0ad377f70ed$var$_objectSpread($8bb7e0ad377f70ed$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($8bb7e0ad377f70ed$var$_objectSpread($8bb7e0ad377f70ed$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $8bb7e0ad377f70ed$var$_objectSpread($8bb7e0ad377f70ed$var$_objectSpread({}, renderState), {}, {
                    currentRefinements: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var results = _ref2.results, scopedResults = _ref2.scopedResults, _createURL = _ref2.createURL, helper = _ref2.helper;
                function getItems() {
                    if (!results) return transformItems($8bb7e0ad377f70ed$var$getRefinementsItems({
                        results: null,
                        helper: helper,
                        indexId: helper.state.index,
                        includedAttributes: includedAttributes,
                        excludedAttributes: excludedAttributes
                    }), {
                        results: results
                    });
                    return scopedResults.reduce(function(accResults, scopedResult) {
                        return accResults.concat(transformItems($8bb7e0ad377f70ed$var$getRefinementsItems({
                            results: scopedResult.results,
                            helper: scopedResult.helper,
                            indexId: scopedResult.indexId,
                            includedAttributes: includedAttributes,
                            excludedAttributes: excludedAttributes
                        }), {
                            results: results
                        }));
                    }, []);
                }
                var items = getItems();
                return {
                    items: items,
                    canRefine: items.length > 0,
                    refine: function refine(refinement) {
                        return $8bb7e0ad377f70ed$var$clearRefinement(helper, refinement);
                    },
                    createURL: function createURL(refinement) {
                        return _createURL($8bb7e0ad377f70ed$var$clearRefinementFromState(helper.state, refinement));
                    },
                    widgetParams: widgetParams
                };
            }
        };
    };
};
function $8bb7e0ad377f70ed$var$getRefinementsItems(_ref3) {
    var results = _ref3.results, helper = _ref3.helper, indexId = _ref3.indexId, includedAttributes = _ref3.includedAttributes, excludedAttributes = _ref3.excludedAttributes;
    var includesQuery = (includedAttributes || []).indexOf("query") !== -1 || (excludedAttributes || []).indexOf("query") === -1;
    var filterFunction = includedAttributes ? function(item) {
        return includedAttributes.indexOf(item.attribute) !== -1;
    } : function(item) {
        return excludedAttributes.indexOf(item.attribute) === -1;
    };
    var items = (0, $c8f5d9142d801f6d$export$d9f33760e70a0a)(results, helper.state, includesQuery).map($8bb7e0ad377f70ed$var$normalizeRefinement).filter(filterFunction);
    return items.reduce(function(allItems, currentItem) {
        return [].concat($8bb7e0ad377f70ed$var$_toConsumableArray(allItems.filter(function(item) {
            return item.attribute !== currentItem.attribute;
        })), [
            {
                indexName: helper.state.index,
                indexId: indexId,
                attribute: currentItem.attribute,
                label: currentItem.attribute,
                refinements: items.filter(function(result) {
                    return result.attribute === currentItem.attribute;
                })// We want to keep the order of refinements except the numeric ones.
                .sort(function(a, b) {
                    return a.type === "numeric" ? a.value - b.value : 0;
                }),
                refine: function refine(refinement) {
                    return $8bb7e0ad377f70ed$var$clearRefinement(helper, refinement);
                }
            }
        ]);
    }, []);
}
function $8bb7e0ad377f70ed$var$clearRefinementFromState(state, refinement) {
    state = state.resetPage();
    switch(refinement.type){
        case "facet":
            return state.removeFacetRefinement(refinement.attribute, String(refinement.value));
        case "disjunctive":
            return state.removeDisjunctiveFacetRefinement(refinement.attribute, String(refinement.value));
        case "hierarchical":
            return state.removeHierarchicalFacetRefinement(refinement.attribute);
        case "exclude":
            return state.removeExcludeRefinement(refinement.attribute, String(refinement.value));
        case "numeric":
            return state.removeNumericRefinement(refinement.attribute, refinement.operator, String(refinement.value));
        case "tag":
            return state.removeTagRefinement(String(refinement.value));
        case "query":
            return state.setQueryParameter("query", "");
        default:
            return state;
    }
}
function $8bb7e0ad377f70ed$var$clearRefinement(helper, refinement) {
    helper.setState($8bb7e0ad377f70ed$var$clearRefinementFromState(helper.state, refinement)).search();
}
function $8bb7e0ad377f70ed$var$getOperatorSymbol(operator) {
    switch(operator){
        case ">=":
            return "\u2265";
        case "<=":
            return "\u2264";
        default:
            return operator;
    }
}
function $8bb7e0ad377f70ed$var$normalizeRefinement(refinement) {
    var value = $8bb7e0ad377f70ed$var$getValue(refinement);
    var label = refinement.operator ? "".concat($8bb7e0ad377f70ed$var$getOperatorSymbol(refinement.operator), " ").concat(refinement.name) : refinement.name;
    var normalizedRefinement = {
        attribute: refinement.attribute,
        type: refinement.type,
        value: value,
        label: label
    };
    if (refinement.operator !== undefined) normalizedRefinement.operator = refinement.operator;
    if (refinement.count !== undefined) normalizedRefinement.count = refinement.count;
    if (refinement.exhaustive !== undefined) normalizedRefinement.exhaustive = refinement.exhaustive;
    return normalizedRefinement;
}
function $8bb7e0ad377f70ed$var$getValue(refinement) {
    if (refinement.type === "numeric") return Number(refinement.name);
    if ("escapedValue" in refinement) return refinement.escapedValue;
    return refinement.name;
}
var $8bb7e0ad377f70ed$export$2e2bcd8739ae039 = $8bb7e0ad377f70ed$var$connectCurrentRefinements;




function $3213562dea075dda$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3213562dea075dda$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3213562dea075dda$var$_typeof(o);
}
function $3213562dea075dda$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3213562dea075dda$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3213562dea075dda$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3213562dea075dda$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3213562dea075dda$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3213562dea075dda$var$_defineProperty(obj, key, value) {
    key = $3213562dea075dda$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3213562dea075dda$var$_toPropertyKey(t) {
    var i = $3213562dea075dda$var$_toPrimitive(t, "string");
    return "symbol" == $3213562dea075dda$var$_typeof(i) ? i : String(i);
}
function $3213562dea075dda$var$_toPrimitive(t, r) {
    if ("object" != $3213562dea075dda$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3213562dea075dda$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3213562dea075dda$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "current-refinements"
});
var $3213562dea075dda$var$suit = (0, $fb1e243c72be04b6$export$d8556a2a8f973135)("CurrentRefinements");
var $3213562dea075dda$var$renderer = function renderer(_ref, isFirstRender) {
    var items = _ref.items, widgetParams = _ref.widgetParams, canRefine = _ref.canRefine;
    if (isFirstRender) return;
    var _ref2 = widgetParams, container = _ref2.container, cssClasses = _ref2.cssClasses;
    (0, $64f0190ec946a978$export$b3890eb0ae9dca99)((0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $f5b7ba589d4e2264$export$2e2bcd8739ae039), {
        cssClasses: cssClasses,
        items: items,
        canRefine: canRefine
    }), container);
};
var $3213562dea075dda$var$currentRefinements = function currentRefinements(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, includedAttributes = _ref3.includedAttributes, excludedAttributes = _ref3.excludedAttributes, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, transformItems = _ref3.transformItems;
    if (!container) throw new Error($3213562dea075dda$var$withUsage("The `container` option is required."));
    var containerNode = (0, $ca542eeff1679d1c$export$ffb2c7b8d67c359a)(container);
    var cssClasses = {
        root: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3213562dea075dda$var$suit(), userCssClasses.root),
        noRefinementRoot: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3213562dea075dda$var$suit({
            modifierName: "noRefinement"
        }), userCssClasses.noRefinementRoot),
        list: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3213562dea075dda$var$suit({
            descendantName: "list"
        }), userCssClasses.list),
        item: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3213562dea075dda$var$suit({
            descendantName: "item"
        }), userCssClasses.item),
        label: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3213562dea075dda$var$suit({
            descendantName: "label"
        }), userCssClasses.label),
        category: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3213562dea075dda$var$suit({
            descendantName: "category"
        }), userCssClasses.category),
        categoryLabel: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3213562dea075dda$var$suit({
            descendantName: "categoryLabel"
        }), userCssClasses.categoryLabel),
        delete: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($3213562dea075dda$var$suit({
            descendantName: "delete"
        }), userCssClasses.delete)
    };
    var makeWidget = (0, $8bb7e0ad377f70ed$export$2e2bcd8739ae039)($3213562dea075dda$var$renderer, function() {
        return (0, $64f0190ec946a978$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $3213562dea075dda$var$_objectSpread($3213562dea075dda$var$_objectSpread({}, makeWidget({
        container: containerNode,
        cssClasses: cssClasses,
        includedAttributes: includedAttributes,
        excludedAttributes: excludedAttributes,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.currentRefinements"
    });
};
var $3213562dea075dda$export$2e2bcd8739ae039 = $3213562dea075dda$var$currentRefinements;






function $f9c4ff64453c6d2c$var$_extends() {
    $f9c4ff64453c6d2c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f9c4ff64453c6d2c$var$_extends.apply(this, arguments);
}
var $f9c4ff64453c6d2c$var$ClearRefinements = function ClearRefinements(_ref) {
    var hasRefinements = _ref.hasRefinements, refine = _ref.refine, cssClasses = _ref.cssClasses, templateProps = _ref.templateProps;
    return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("div", {
        className: cssClasses.root
    }, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $9482d9d5173d02ec$export$2e2bcd8739ae039), $f9c4ff64453c6d2c$var$_extends({}, templateProps, {
        templateKey: "resetLabel",
        rootTagName: "button",
        rootProps: {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)(cssClasses.button, !hasRefinements && cssClasses.disabledButton),
            onClick: refine,
            disabled: !hasRefinements
        },
        data: {
            hasRefinements: hasRefinements
        }
    })));
};
var $f9c4ff64453c6d2c$export$2e2bcd8739ae039 = $f9c4ff64453c6d2c$var$ClearRefinements;


/**
 * Clears the refinements of a SearchParameters object based on rules provided.
 * The included attributes list is applied before the excluded attributes list. If the list
 * is not provided, this list of all the currently refined attributes is used as included attributes.
 * @returns search parameters with refinements cleared
 */ function $fd10452a577c4d5f$export$c8b9db57471d846b(_ref) {
    var helper = _ref.helper, _ref$attributesToClea = _ref.attributesToClear, attributesToClear = _ref$attributesToClea === void 0 ? [] : _ref$attributesToClea;
    var finalState = helper.state.setPage(0);
    finalState = attributesToClear.reduce(function(state, attribute) {
        if (finalState.isNumericRefined(attribute)) return state.removeNumericRefinement(attribute);
        if (finalState.isHierarchicalFacet(attribute)) return state.removeHierarchicalFacetRefinement(attribute);
        if (finalState.isDisjunctiveFacet(attribute)) return state.removeDisjunctiveFacetRefinement(attribute);
        if (finalState.isConjunctiveFacet(attribute)) return state.removeFacetRefinement(attribute);
        return state;
    }, finalState);
    if (attributesToClear.indexOf("query") !== -1) finalState = finalState.setQuery("");
    return finalState;
}


function $724a7ed99e104adc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $724a7ed99e104adc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $724a7ed99e104adc$var$_typeof(o);
}
function $724a7ed99e104adc$var$_toConsumableArray(arr) {
    return $724a7ed99e104adc$var$_arrayWithoutHoles(arr) || $724a7ed99e104adc$var$_iterableToArray(arr) || $724a7ed99e104adc$var$_unsupportedIterableToArray(arr) || $724a7ed99e104adc$var$_nonIterableSpread();
}
function $724a7ed99e104adc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $724a7ed99e104adc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $724a7ed99e104adc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $724a7ed99e104adc$var$_arrayLikeToArray(o, minLen);
}
function $724a7ed99e104adc$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $724a7ed99e104adc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $724a7ed99e104adc$var$_arrayLikeToArray(arr);
}
function $724a7ed99e104adc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $724a7ed99e104adc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $724a7ed99e104adc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $724a7ed99e104adc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $724a7ed99e104adc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $724a7ed99e104adc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $724a7ed99e104adc$var$_defineProperty(obj, key, value) {
    key = $724a7ed99e104adc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $724a7ed99e104adc$var$_toPropertyKey(t) {
    var i = $724a7ed99e104adc$var$_toPrimitive(t, "string");
    return "symbol" == $724a7ed99e104adc$var$_typeof(i) ? i : String(i);
}
function $724a7ed99e104adc$var$_toPrimitive(t, r) {
    if ("object" != $724a7ed99e104adc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $724a7ed99e104adc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $724a7ed99e104adc$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "clear-refinements",
    connector: true
});
var $724a7ed99e104adc$var$connectClearRefinements = function connectClearRefinements(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8fe091dcd40a4798$export$8793edee2d425525);
    (0, $1575d32251b25e2a$export$adc2a8e09aa583ee)(renderFn, $724a7ed99e104adc$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$includedAttribut = _ref.includedAttributes, includedAttributes = _ref$includedAttribut === void 0 ? [] : _ref$includedAttribut, _ref$excludedAttribut = _ref.excludedAttributes, excludedAttributes = _ref$excludedAttribut === void 0 ? [
            "query"
        ] : _ref$excludedAttribut, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (widgetParams && widgetParams.includedAttributes && widgetParams.excludedAttributes) throw new Error($724a7ed99e104adc$var$withUsage("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
        var connectorState = {
            refine: (0, $8fe091dcd40a4798$export$8793edee2d425525),
            createURL: function createURL() {
                return "";
            },
            attributesToClear: []
        };
        var cachedRefine = function cachedRefine() {
            return connectorState.refine();
        };
        var cachedCreateURL = function cachedCreateURL() {
            return connectorState.createURL();
        };
        return {
            $$type: "ais.clearRefinements",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($724a7ed99e104adc$var$_objectSpread($724a7ed99e104adc$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($724a7ed99e104adc$var$_objectSpread($724a7ed99e104adc$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $724a7ed99e104adc$var$_objectSpread($724a7ed99e104adc$var$_objectSpread({}, renderState), {}, {
                    clearRefinements: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var createURL = _ref2.createURL, scopedResults = _ref2.scopedResults, results = _ref2.results;
                connectorState.attributesToClear = scopedResults.reduce(function(attributesToClear, scopedResult) {
                    return attributesToClear.concat($724a7ed99e104adc$var$getAttributesToClear({
                        scopedResult: scopedResult,
                        includedAttributes: includedAttributes,
                        excludedAttributes: excludedAttributes,
                        transformItems: transformItems,
                        results: results
                    }));
                }, []);
                connectorState.refine = function() {
                    connectorState.attributesToClear.forEach(function(_ref3) {
                        var indexHelper = _ref3.helper, items = _ref3.items;
                        indexHelper.setState((0, $fd10452a577c4d5f$export$c8b9db57471d846b)({
                            helper: indexHelper,
                            attributesToClear: items
                        })).search();
                    });
                };
                connectorState.createURL = function() {
                    return createURL((0, $fdec58dce645e387$export$8049d91f25899769).apply(void 0, $724a7ed99e104adc$var$_toConsumableArray(connectorState.attributesToClear.map(function(_ref4) {
                        var indexHelper = _ref4.helper, items = _ref4.items;
                        return (0, $fd10452a577c4d5f$export$c8b9db57471d846b)({
                            helper: indexHelper,
                            attributesToClear: items
                        });
                    }))));
                };
                var canRefine = connectorState.attributesToClear.some(function(attributeToClear) {
                    return attributeToClear.items.length > 0;
                });
                return {
                    canRefine: canRefine,
                    hasRefinements: canRefine,
                    refine: cachedRefine,
                    createURL: cachedCreateURL,
                    widgetParams: widgetParams
                };
            }
        };
    };
};
function $724a7ed99e104adc$var$getAttributesToClear(_ref5) {
    var scopedResult = _ref5.scopedResult, includedAttributes = _ref5.includedAttributes, excludedAttributes = _ref5.excludedAttributes, transformItems = _ref5.transformItems, results = _ref5.results;
    var includesQuery = includedAttributes.indexOf("query") !== -1 || excludedAttributes.indexOf("query") === -1;
    return {
        helper: scopedResult.helper,
        items: transformItems((0, $98a2c07ad87fe2bc$export$f70730c3d1fc524e)((0, $c8f5d9142d801f6d$export$d9f33760e70a0a)(scopedResult.results, scopedResult.helper.state, includesQuery).map(function(refinement) {
            return refinement.attribute;
        }).filter(function(attribute) {
            return(// If the array is empty (default case), we keep all the attributes
            includedAttributes.length === 0 || // Otherwise, only add the specified attributes
            includedAttributes.indexOf(attribute) !== -1);
        }).filter(function(attribute) {
            return(// If the query is included, we ignore the default `excludedAttributes = ['query']`
            attribute === "query" && includesQuery || // Otherwise, ignore the excluded attributes
            excludedAttributes.indexOf(attribute) === -1);
        })), {
            results: results
        })
    };
}
var $724a7ed99e104adc$export$2e2bcd8739ae039 = $724a7ed99e104adc$var$connectClearRefinements;





var $8b0dad2b51a58a02$var$defaultTemplates = {
    resetLabel: function resetLabel() {
        return "Clear refinements";
    }
};
var $8b0dad2b51a58a02$export$2e2bcd8739ae039 = $8b0dad2b51a58a02$var$defaultTemplates;


function $f93b06120d1ef027$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f93b06120d1ef027$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f93b06120d1ef027$var$_typeof(o);
}
function $f93b06120d1ef027$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f93b06120d1ef027$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f93b06120d1ef027$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f93b06120d1ef027$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f93b06120d1ef027$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f93b06120d1ef027$var$_defineProperty(obj, key, value) {
    key = $f93b06120d1ef027$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f93b06120d1ef027$var$_toPropertyKey(t) {
    var i = $f93b06120d1ef027$var$_toPrimitive(t, "string");
    return "symbol" == $f93b06120d1ef027$var$_typeof(i) ? i : String(i);
}
function $f93b06120d1ef027$var$_toPrimitive(t, r) {
    if ("object" != $f93b06120d1ef027$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f93b06120d1ef027$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f93b06120d1ef027$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "clear-refinements"
});
var $f93b06120d1ef027$var$suit = (0, $fb1e243c72be04b6$export$d8556a2a8f973135)("ClearRefinements");
var $f93b06120d1ef027$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, renderState = _ref.renderState, templates = _ref.templates;
    return function(_ref2, isFirstRendering) {
        var refine = _ref2.refine, canRefine = _ref2.canRefine, instantSearchInstance = _ref2.instantSearchInstance;
        if (isFirstRendering) {
            renderState.templateProps = (0, $7d91d9d2178182a4$export$2938ff6a58d41f25)({
                defaultTemplates: (0, $8b0dad2b51a58a02$export$2e2bcd8739ae039),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        (0, $64f0190ec946a978$export$b3890eb0ae9dca99)((0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $f9c4ff64453c6d2c$export$2e2bcd8739ae039), {
            refine: refine,
            cssClasses: cssClasses,
            hasRefinements: canRefine,
            templateProps: renderState.templateProps
        }), containerNode);
    };
};
var $f93b06120d1ef027$var$clearRefinements = function clearRefinements(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, _ref3$templates = _ref3.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, includedAttributes = _ref3.includedAttributes, excludedAttributes = _ref3.excludedAttributes, transformItems = _ref3.transformItems, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses;
    if (!container) throw new Error($f93b06120d1ef027$var$withUsage("The `container` option is required."));
    var containerNode = (0, $ca542eeff1679d1c$export$ffb2c7b8d67c359a)(container);
    var cssClasses = {
        root: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($f93b06120d1ef027$var$suit(), userCssClasses.root),
        button: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($f93b06120d1ef027$var$suit({
            descendantName: "button"
        }), userCssClasses.button),
        disabledButton: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)($f93b06120d1ef027$var$suit({
            descendantName: "button",
            modifierName: "disabled"
        }), userCssClasses.disabledButton)
    };
    var specializedRenderer = $f93b06120d1ef027$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        renderState: {},
        templates: templates
    });
    var makeWidget = (0, $724a7ed99e104adc$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $64f0190ec946a978$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $f93b06120d1ef027$var$_objectSpread($f93b06120d1ef027$var$_objectSpread({}, makeWidget({
        includedAttributes: includedAttributes,
        excludedAttributes: excludedAttributes,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.clearRefinements"
    });
};
var $f93b06120d1ef027$export$2e2bcd8739ae039 = $f93b06120d1ef027$var$clearRefinements;




var $bdf2c3f121125e0e$var$_excluded = [
    "classNames",
    "hits",
    "itemComponent",
    "sendEvent",
    "emptyComponent",
    "banner",
    "bannerComponent"
];
// Should be imported from a shared package in the future
function $bdf2c3f121125e0e$var$createDefaultBannerComponent(_ref) {
    var createElement = _ref.createElement;
    return function DefaultBanner(_ref2) {
        var classNames = _ref2.classNames, banner = _ref2.banner;
        if (!banner.image.urls[0].url) return null;
        return createElement("aside", {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Hits-banner", classNames.bannerRoot)
        }, banner.link ? createElement("a", {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Hits-banner-link", classNames.bannerLink),
            href: banner.link.url,
            target: banner.link.target
        }, createElement("img", {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Hits-banner-image", classNames.bannerImage),
            src: banner.image.urls[0].url,
            alt: banner.image.title
        })) : createElement("img", {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Hits-banner-image", classNames.bannerImage),
            src: banner.image.urls[0].url,
            alt: banner.image.title
        }));
    };
}
function $bdf2c3f121125e0e$export$abc871145e3e685(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var DefaultBannerComponent = $bdf2c3f121125e0e$var$createDefaultBannerComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Hits(userProps) {
        var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, hits = userProps.hits, ItemComponent = userProps.itemComponent, sendEvent = userProps.sendEvent, EmptyComponent = userProps.emptyComponent, banner = userProps.banner, BannerComponent = userProps.bannerComponent, props = (0, $631a36876f8af650$export$2e2bcd8739ae039)(userProps, $bdf2c3f121125e0e$var$_excluded);
        return createElement("div", (0, $4baf0029b6d92e31$export$2e2bcd8739ae039)({}, props, {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Hits", classNames.root, hits.length === 0 && (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Hits--empty", classNames.emptyRoot), props.className)
        }), banner && (BannerComponent ? createElement(BannerComponent, {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Hits-banner", classNames.bannerRoot),
            banner: banner
        }) : createElement(DefaultBannerComponent, {
            classNames: classNames,
            banner: banner
        })), hits.length === 0 && EmptyComponent ? createElement(EmptyComponent, null) : createElement("ol", {
            className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Hits-list", classNames.list)
        }, hits.map(function(hit, index) {
            return createElement(ItemComponent, {
                key: hit.objectID,
                hit: hit,
                index: index,
                className: (0, $ec2c038c8c5a38bf$export$a274e22fb40f762e)("ais-Hits-item", classNames.item),
                onClick: function onClick() {
                    sendEvent("click:internal", hit, "Hit Clicked");
                },
                onAuxClick: function onAuxClick() {
                    sendEvent("click:internal", hit, "Hit Clicked");
                }
            });
        })));
    };
}





function $e69ac9f55db60a1c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e69ac9f55db60a1c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e69ac9f55db60a1c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e69ac9f55db60a1c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e69ac9f55db60a1c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e69ac9f55db60a1c$var$_defineProperty(obj, key, value) {
    key = $e69ac9f55db60a1c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e69ac9f55db60a1c$var$_toPropertyKey(t) {
    var i = $e69ac9f55db60a1c$var$_toPrimitive(t, "string");
    return "symbol" == $e69ac9f55db60a1c$var$_typeof(i) ? i : String(i);
}
function $e69ac9f55db60a1c$var$_toPrimitive(t, r) {
    if ("object" != $e69ac9f55db60a1c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e69ac9f55db60a1c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e69ac9f55db60a1c$var$_slicedToArray(arr, i) {
    return $e69ac9f55db60a1c$var$_arrayWithHoles(arr) || $e69ac9f55db60a1c$var$_iterableToArrayLimit(arr, i) || $e69ac9f55db60a1c$var$_unsupportedIterableToArray(arr, i) || $e69ac9f55db60a1c$var$_nonIterableRest();
}
function $e69ac9f55db60a1c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e69ac9f55db60a1c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e69ac9f55db60a1c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e69ac9f55db60a1c$var$_arrayLikeToArray(o, minLen);
}
function $e69ac9f55db60a1c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e69ac9f55db60a1c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e69ac9f55db60a1c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e69ac9f55db60a1c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e69ac9f55db60a1c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e69ac9f55db60a1c$var$_typeof(o);
}
function $e69ac9f55db60a1c$var$chunk(arr) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < Math.ceil(arr.length / chunkSize); i++)chunks.push(arr.slice(i * chunkSize, (i + 1) * chunkSize));
    return chunks;
}
function $e69ac9f55db60a1c$export$2f82a8f6391c6db9(_ref) {
    var helper = _ref.helper, widgetType = _ref.widgetType, methodName = _ref.methodName, args = _ref.args, instantSearchInstance = _ref.instantSearchInstance;
    // when there's only one argument, that means it's custom
    if (args.length === 1 && $e69ac9f55db60a1c$var$_typeof(args[0]) === "object") return [
        args[0]
    ];
    var _args$0$split = args[0].split(":"), _args$0$split2 = $e69ac9f55db60a1c$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
    var hits = args[1];
    var eventName = args[2];
    var additionalData = args[3] || {};
    if (!hits) return [];
    if ((eventType === "click" || eventType === "conversion") && !eventName) return [];
    var hitsArray = Array.isArray(hits) ? hits : [
        hits
    ];
    if (hitsArray.length === 0) return [];
    var queryID = hitsArray[0].__queryID;
    var hitsChunks = $e69ac9f55db60a1c$var$chunk(hitsArray);
    var objectIDsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.objectID;
        });
    });
    var positionsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.__position;
        });
    });
    if (eventType === "view") {
        if (instantSearchInstance.status !== "idle") return [];
        return hitsChunks.map(function(batch, i) {
            var _helper$lastResults;
            return {
                insightsMethod: "viewedObjectIDs",
                widgetType: widgetType,
                eventType: eventType,
                payload: $e69ac9f55db60a1c$var$_objectSpread({
                    eventName: eventName || "Hits Viewed",
                    index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
                    objectIDs: objectIDsByChunk[i]
                }, additionalData),
                hits: batch,
                eventModifier: eventModifier
            };
        });
    } else if (eventType === "click") return hitsChunks.map(function(batch, i) {
        var _helper$lastResults2;
        return {
            insightsMethod: "clickedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $e69ac9f55db60a1c$var$_objectSpread({
                eventName: eventName || "Hit Clicked",
                index: ((_helper$lastResults2 = helper.lastResults) === null || _helper$lastResults2 === void 0 ? void 0 : _helper$lastResults2.index) || helper.state.index,
                queryID: queryID,
                objectIDs: objectIDsByChunk[i],
                positions: positionsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else if (eventType === "conversion") return hitsChunks.map(function(batch, i) {
        var _helper$lastResults3;
        return {
            insightsMethod: "convertedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $e69ac9f55db60a1c$var$_objectSpread({
                eventName: eventName || "Hit Converted",
                index: ((_helper$lastResults3 = helper.lastResults) === null || _helper$lastResults3 === void 0 ? void 0 : _helper$lastResults3.index) || helper.state.index,
                queryID: queryID,
                objectIDs: objectIDsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else return [];
}
function $e69ac9f55db60a1c$export$4139f3a7130239e3(_ref2) {
    var instantSearchInstance = _ref2.instantSearchInstance, helper = _ref2.helper, widgetType = _ref2.widgetType;
    var sentEvents = {};
    var timer = undefined;
    var sendEventForHits = function sendEventForHits() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var payloads = $e69ac9f55db60a1c$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            helper: helper,
            methodName: "sendEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        payloads.forEach(function(payload) {
            if (payload.eventType === "click" && payload.eventModifier === "internal" && sentEvents[payload.eventType]) return;
            sentEvents[payload.eventType] = true;
            instantSearchInstance.sendEventToInsights(payload);
        });
        clearTimeout(timer);
        timer = setTimeout(function() {
            sentEvents = {};
        }, 0);
    };
    return sendEventForHits;
}
function $e69ac9f55db60a1c$export$5a3d9973824d9b76(_ref3) {
    var helper = _ref3.helper, widgetType = _ref3.widgetType, instantSearchInstance = _ref3.instantSearchInstance;
    var bindEventForHits = function bindEventForHits() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var payloads = $e69ac9f55db60a1c$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            helper: helper,
            methodName: "bindEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        return payloads.length ? "data-insights-event=".concat((0, $e554eb5b66e10834$export$44b4521aa38272f2)(payloads)) : "";
    };
    return bindEventForHits;
}

function $d85ae0599889bde2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d85ae0599889bde2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d85ae0599889bde2$var$_typeof(o);
}
function $d85ae0599889bde2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d85ae0599889bde2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d85ae0599889bde2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d85ae0599889bde2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d85ae0599889bde2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d85ae0599889bde2$var$_defineProperty(obj, key, value) {
    key = $d85ae0599889bde2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d85ae0599889bde2$var$_toPropertyKey(t) {
    var i = $d85ae0599889bde2$var$_toPrimitive(t, "string");
    return "symbol" == $d85ae0599889bde2$var$_typeof(i) ? i : String(i);
}
function $d85ae0599889bde2$var$_toPrimitive(t, r) {
    if ("object" != $d85ae0599889bde2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d85ae0599889bde2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d85ae0599889bde2$export$33d742d8ee5a4609(hits, page, hitsPerPage) {
    return hits.map(function(hit, idx) {
        return $d85ae0599889bde2$var$_objectSpread($d85ae0599889bde2$var$_objectSpread({}, hit), {}, {
            __position: hitsPerPage * page + idx + 1
        });
    });
}

function $f3c203a76f1035d7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f3c203a76f1035d7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f3c203a76f1035d7$var$_typeof(o);
}
function $f3c203a76f1035d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f3c203a76f1035d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f3c203a76f1035d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f3c203a76f1035d7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f3c203a76f1035d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f3c203a76f1035d7$var$_defineProperty(obj, key, value) {
    key = $f3c203a76f1035d7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f3c203a76f1035d7$var$_toPropertyKey(t) {
    var i = $f3c203a76f1035d7$var$_toPrimitive(t, "string");
    return "symbol" == $f3c203a76f1035d7$var$_typeof(i) ? i : String(i);
}
function $f3c203a76f1035d7$var$_toPrimitive(t, r) {
    if ("object" != $f3c203a76f1035d7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f3c203a76f1035d7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f3c203a76f1035d7$export$b8f834386ea30952(hits, queryID) {
    if (!queryID) return hits;
    return hits.map(function(hit) {
        return $f3c203a76f1035d7$var$_objectSpread($f3c203a76f1035d7$var$_objectSpread({}, hit), {}, {
            __queryID: queryID
        });
    });
}


function $0e84a78cd0520eb3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0e84a78cd0520eb3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0e84a78cd0520eb3$var$_typeof(o);
}
function $0e84a78cd0520eb3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e84a78cd0520eb3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e84a78cd0520eb3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0e84a78cd0520eb3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e84a78cd0520eb3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0e84a78cd0520eb3$var$_defineProperty(obj, key, value) {
    key = $0e84a78cd0520eb3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0e84a78cd0520eb3$var$_toPropertyKey(t) {
    var i = $0e84a78cd0520eb3$var$_toPrimitive(t, "string");
    return "symbol" == $0e84a78cd0520eb3$var$_typeof(i) ? i : String(i);
}
function $0e84a78cd0520eb3$var$_toPrimitive(t, r) {
    if ("object" != $0e84a78cd0520eb3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0e84a78cd0520eb3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0e84a78cd0520eb3$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "hits",
    connector: true
});
var $0e84a78cd0520eb3$export$2e2bcd8739ae039 = function connectHits(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8fe091dcd40a4798$export$8793edee2d425525);
    (0, $1575d32251b25e2a$export$adc2a8e09aa583ee)(renderFn, $0e84a78cd0520eb3$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$escapeHTML = _ref.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        var sendEvent;
        var bindEvent;
        return {
            $$type: "ais.hits",
            init: function init(initOptions) {
                renderFn($0e84a78cd0520eb3$var$_objectSpread($0e84a78cd0520eb3$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var renderState = this.getWidgetRenderState(renderOptions);
                renderFn($0e84a78cd0520eb3$var$_objectSpread($0e84a78cd0520eb3$var$_objectSpread({}, renderState), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
                renderState.sendEvent("view:internal", renderState.items);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $0e84a78cd0520eb3$var$_objectSpread($0e84a78cd0520eb3$var$_objectSpread({}, renderState), {}, {
                    hits: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var _results$renderingCon, _results$renderingCon2, _results$renderingCon3;
                var results = _ref2.results, helper = _ref2.helper, instantSearchInstance = _ref2.instantSearchInstance;
                if (!sendEvent) sendEvent = (0, $e69ac9f55db60a1c$export$4139f3a7130239e3)({
                    instantSearchInstance: instantSearchInstance,
                    helper: helper,
                    widgetType: this.$$type
                });
                if (!bindEvent) bindEvent = (0, $e69ac9f55db60a1c$export$5a3d9973824d9b76)({
                    helper: helper,
                    widgetType: this.$$type,
                    instantSearchInstance: instantSearchInstance
                });
                if (!results) return {
                    hits: [],
                    items: [],
                    results: undefined,
                    banner: undefined,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
                if (escapeHTML && results.hits.length > 0) results.hits = (0, $c3ab0a6931928f0c$export$9adb036445aab889)(results.hits);
                var hitsWithAbsolutePosition = (0, $d85ae0599889bde2$export$33d742d8ee5a4609)(results.hits, results.page, results.hitsPerPage);
                var hitsWithAbsolutePositionAndQueryID = (0, $f3c203a76f1035d7$export$b8f834386ea30952)(hitsWithAbsolutePosition, results.queryID);
                var items = transformItems(hitsWithAbsolutePositionAndQueryID, {
                    results: results
                });
                var banner = (_results$renderingCon = results.renderingContent) === null || _results$renderingCon === void 0 ? void 0 : (_results$renderingCon2 = _results$renderingCon.widgets) === null || _results$renderingCon2 === void 0 ? void 0 : (_results$renderingCon3 = _results$renderingCon2.banners) === null || _results$renderingCon3 === void 0 ? void 0 : _results$renderingCon3[0];
                return {
                    hits: items,
                    items: items,
                    results: results,
                    banner: banner,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                if (!escapeHTML) return state;
                return state.setQueryParameters(Object.keys((0, $c3ab0a6931928f0c$export$1e7338a8952eaf35)).reduce(function(acc, key) {
                    return $0e84a78cd0520eb3$var$_objectSpread($0e84a78cd0520eb3$var$_objectSpread({}, acc), {}, $0e84a78cd0520eb3$var$_defineProperty({}, key, undefined));
                }, {}));
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _uiState) {
                if (!escapeHTML) return state;
                // @MAJOR: set this globally, not in the Hits widget to allow Hits to be conditionally used
                return state.setQueryParameters((0, $c3ab0a6931928f0c$export$1e7338a8952eaf35));
            }
        };
    };
};



function $0c83df9943e283bb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0c83df9943e283bb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0c83df9943e283bb$var$_typeof(o);
}
function $0c83df9943e283bb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c83df9943e283bb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c83df9943e283bb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0c83df9943e283bb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c83df9943e283bb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0c83df9943e283bb$var$_defineProperty(obj, key, value) {
    key = $0c83df9943e283bb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0c83df9943e283bb$var$_toPropertyKey(t) {
    var i = $0c83df9943e283bb$var$_toPrimitive(t, "string");
    return "symbol" == $0c83df9943e283bb$var$_typeof(i) ? i : String(i);
}
function $0c83df9943e283bb$var$_toPrimitive(t, r) {
    if ("object" != $0c83df9943e283bb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0c83df9943e283bb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0c83df9943e283bb$var$getSelectedHits = function getSelectedHits(hits, selectedObjectIDs) {
    return selectedObjectIDs.map(function(objectID) {
        var hit = (0, $3a145725faa3321d$export$71aa6c912b956294)(hits, function(h) {
            return h.objectID === objectID;
        });
        if (typeof hit === "undefined") throw new Error('Could not find objectID "'.concat(objectID, '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'));
        return hit;
    });
};
var $0c83df9943e283bb$var$getQueryID = function getQueryID(selectedHits) {
    var queryIDs = (0, $98a2c07ad87fe2bc$export$f70730c3d1fc524e)(selectedHits.map(function(hit) {
        return hit.__queryID;
    }));
    if (queryIDs.length > 1) throw new Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
    var queryID = queryIDs[0];
    if (typeof queryID !== "string") throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
    return queryID;
};
var $0c83df9943e283bb$var$getPositions = function getPositions(selectedHits) {
    return selectedHits.map(function(hit) {
        return hit.__position;
    });
};
var $0c83df9943e283bb$export$24bd91850d68b36c = function inferPayload(_ref) {
    var method = _ref.method, results = _ref.results, hits = _ref.hits, objectIDs = _ref.objectIDs;
    var index = results.index;
    var selectedHits = $0c83df9943e283bb$var$getSelectedHits(hits, objectIDs);
    var queryID = $0c83df9943e283bb$var$getQueryID(selectedHits);
    switch(method){
        case "clickedObjectIDsAfterSearch":
            var positions = $0c83df9943e283bb$var$getPositions(selectedHits);
            return {
                index: index,
                queryID: queryID,
                objectIDs: objectIDs,
                positions: positions
            };
        case "convertedObjectIDsAfterSearch":
            return {
                index: index,
                queryID: queryID,
                objectIDs: objectIDs
            };
        default:
            throw new Error('Unsupported method passed to insights: "'.concat(method, '".'));
    }
};
var $0c83df9943e283bb$var$wrapInsightsClient = function wrapInsightsClient(aa, results, hits) {
    return function(method) {
        for(var _len = arguments.length, payloads = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)payloads[_key - 1] = arguments[_key];
        var payload = payloads[0];
        if (!aa) {
            var withInstantSearchUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
                name: "instantsearch"
            });
            throw new Error(withInstantSearchUsage("The `insightsClient` option has not been provided to `instantsearch`."));
        }
        if (!Array.isArray(payload.objectIDs)) throw new TypeError("Expected `objectIDs` to be an array.");
        var inferredPayload = $0c83df9943e283bb$export$24bd91850d68b36c({
            method: method,
            results: results,
            hits: hits,
            objectIDs: payload.objectIDs
        });
        aa(method, $0c83df9943e283bb$var$_objectSpread($0c83df9943e283bb$var$_objectSpread({}, inferredPayload), payload));
    };
};
function $0c83df9943e283bb$export$2e2bcd8739ae039(connector) {
    return function(renderFn, unmountFn) {
        return connector(function(renderOptions, isFirstRender) {
            var results = renderOptions.results, hits = renderOptions.hits, instantSearchInstance = renderOptions.instantSearchInstance;
            if (results && hits && instantSearchInstance) {
                var insights = $0c83df9943e283bb$var$wrapInsightsClient(instantSearchInstance.insightsClient, results, hits);
                return renderFn($0c83df9943e283bb$var$_objectSpread($0c83df9943e283bb$var$_objectSpread({}, renderOptions), {}, {
                    insights: insights
                }), isFirstRender);
            }
            return renderFn(renderOptions, isFirstRender);
        }, unmountFn);
    };
}





var $5344fc192cd461e0$export$71d036cfbce90975 = function createInsightsEventHandler(_ref) {
    var insights = _ref.insights, sendEvent = _ref.sendEvent;
    return function(event) {
        // new way, e.g. bindEvent("click", hit, "Hit clicked")
        var insightsThroughSendEvent = $5344fc192cd461e0$var$findInsightsTarget(event.target, event.currentTarget, function(element) {
            return element.hasAttribute("data-insights-event");
        });
        if (insightsThroughSendEvent) {
            var payload = $5344fc192cd461e0$var$parseInsightsEvent(insightsThroughSendEvent);
            payload.forEach(function(single) {
                return sendEvent(single);
            });
        }
        // old way, e.g. instantsearch.insights("clickedObjectIDsAfterSearch", { .. })
        var insightsThroughFunction = $5344fc192cd461e0$var$findInsightsTarget(event.target, event.currentTarget, function(element) {
            return element.hasAttribute("data-insights-method") && element.hasAttribute("data-insights-payload");
        });
        if (insightsThroughFunction) {
            var _readDataAttributes = (0, $54d2c88a789bd99d$export$cbcfede36ce7ab2e)(insightsThroughFunction), method = _readDataAttributes.method, _payload = _readDataAttributes.payload;
            insights(method, _payload);
        }
    };
};
function $5344fc192cd461e0$var$findInsightsTarget(startElement, endElement, validator) {
    var element = startElement;
    while(element && !validator(element)){
        if (element === endElement) return null;
        element = element.parentElement;
    }
    return element;
}
function $5344fc192cd461e0$var$parseInsightsEvent(element) {
    var serializedPayload = element.getAttribute("data-insights-event");
    if (typeof serializedPayload !== "string") throw new Error("The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.");
    try {
        return (0, $e554eb5b66e10834$export$706ea24b0964bee9)(serializedPayload);
    } catch (error) {
        throw new Error("The insights middleware was unable to parse `data-insights-event`.");
    }
}
function $5344fc192cd461e0$export$2e2bcd8739ae039(BaseComponent) {
    return function WithInsightsListener(props) {
        var handleClick = $5344fc192cd461e0$export$71d036cfbce90975(props);
        return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)("div", {
            onClick: handleClick
        }, (0, $64f0190ec946a978$export$c8a8987d4410bf2d)(BaseComponent, props));
    };
}




/**
 * Creates a new object with the same keys as the original object, but without the excluded keys.
 * @param source original object
 * @param excluded keys to remove from the original object
 * @returns the new object
 */ function $4d0cd02659db8bd6$export$30a06c8d3562193f(source, excluded) {
    if (source === null || source === undefined) return source;
    return Object.keys(source).reduce(function(target, key) {
        if (excluded.indexOf(key) >= 0) return target;
        var validKey = key;
        target[validKey] = source[validKey];
        return target;
    }, {});
}


// false positive lint error
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
var $9b8560ae02aca0a4$var$defaultTemplates = {
    empty: function empty() {
        return "No results";
    },
    item: function item(data) {
        return JSON.stringify((0, $4d0cd02659db8bd6$export$30a06c8d3562193f)(data, [
            "__hitIndex"
        ]), null, 2);
    }
};
var $9b8560ae02aca0a4$export$2e2bcd8739ae039 = $9b8560ae02aca0a4$var$defaultTemplates;


function $b8f91a19038542f6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b8f91a19038542f6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f91a19038542f6$var$_typeof(o);
}
var $b8f91a19038542f6$var$_excluded = [
    "hit",
    "index"
];
function $b8f91a19038542f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b8f91a19038542f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b8f91a19038542f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b8f91a19038542f6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b8f91a19038542f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b8f91a19038542f6$var$_defineProperty(obj, key, value) {
    key = $b8f91a19038542f6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b8f91a19038542f6$var$_toPropertyKey(t) {
    var i = $b8f91a19038542f6$var$_toPrimitive(t, "string");
    return "symbol" == $b8f91a19038542f6$var$_typeof(i) ? i : String(i);
}
function $b8f91a19038542f6$var$_toPrimitive(t, r) {
    if ("object" != $b8f91a19038542f6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b8f91a19038542f6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b8f91a19038542f6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b8f91a19038542f6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b8f91a19038542f6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b8f91a19038542f6$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $b8f91a19038542f6$var$_extends() {
    $b8f91a19038542f6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8f91a19038542f6$var$_extends.apply(this, arguments);
}
var $b8f91a19038542f6$var$withUsage = (0, $d9fdb8c21b258358$export$2fde5bffc340821e)({
    name: "hits"
});
var $b8f91a19038542f6$var$Hits = (0, $bdf2c3f121125e0e$export$abc871145e3e685)({
    createElement: (0, $64f0190ec946a978$export$c8a8987d4410bf2d),
    Fragment: (0, $64f0190ec946a978$export$ffb0004e005737fa)
});
var $b8f91a19038542f6$var$renderer = function renderer(_ref) {
    var renderState = _ref.renderState, cssClasses = _ref.cssClasses, containerNode = _ref.containerNode, templates = _ref.templates;
    return function(_ref2, isFirstRendering) {
        var items = _ref2.items, results = _ref2.results, instantSearchInstance = _ref2.instantSearchInstance, insights = _ref2.insights, bindEvent = _ref2.bindEvent, sendEvent = _ref2.sendEvent, banner = _ref2.banner;
        if (isFirstRendering) {
            renderState.templateProps = (0, $7d91d9d2178182a4$export$2938ff6a58d41f25)({
                defaultTemplates: (0, $9b8560ae02aca0a4$export$2e2bcd8739ae039),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        var handleInsightsClick = (0, $5344fc192cd461e0$export$71d036cfbce90975)({
            insights: insights,
            sendEvent: sendEvent
        });
        var emptyComponent = function emptyComponent(_ref3) {
            var rootProps = $b8f91a19038542f6$var$_extends({}, ($b8f91a19038542f6$var$_objectDestructuringEmpty(_ref3), _ref3));
            return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $9482d9d5173d02ec$export$2e2bcd8739ae039), $b8f91a19038542f6$var$_extends({}, renderState.templateProps, {
                rootProps: rootProps,
                templateKey: "empty",
                data: results,
                rootTagName: "fragment"
            }));
        };
        // @MAJOR: Move default hit component back to the UI library
        // once flavour specificities are erased
        var itemComponent = function itemComponent(_ref4) {
            var hit = _ref4.hit, index = _ref4.index, rootProps = $b8f91a19038542f6$var$_objectWithoutProperties(_ref4, $b8f91a19038542f6$var$_excluded);
            return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $9482d9d5173d02ec$export$2e2bcd8739ae039), $b8f91a19038542f6$var$_extends({}, renderState.templateProps, {
                templateKey: "item",
                rootTagName: "li",
                rootProps: $b8f91a19038542f6$var$_objectSpread($b8f91a19038542f6$var$_objectSpread({}, rootProps), {}, {
                    onClick: function onClick(event) {
                        handleInsightsClick(event);
                        rootProps.onClick();
                    },
                    onAuxClick: function onAuxClick(event) {
                        handleInsightsClick(event);
                        rootProps.onAuxClick();
                    }
                }),
                data: $b8f91a19038542f6$var$_objectSpread($b8f91a19038542f6$var$_objectSpread({}, hit), {}, {
                    get __hitIndex () {
                        return index;
                    }
                }),
                bindEvent: bindEvent,
                sendEvent: sendEvent
            }));
        };
        var bannerComponent = function bannerComponent(props) {
            return (0, $64f0190ec946a978$export$c8a8987d4410bf2d)((0, $9482d9d5173d02ec$export$2e2bcd8739ae039), $b8f91a19038542f6$var$_extends({}, renderState.templateProps, {
                templateKey: "banner",
                data: props,
                rootTagName: "fragment"
            }));
        };
        (0, $64f0190ec946a978$export$b3890eb0ae9dca99)((0, $64f0190ec946a978$export$c8a8987d4410bf2d)($b8f91a19038542f6$var$Hits, {
            hits: items,
            itemComponent: itemComponent,
            sendEvent: sendEvent,
            classNames: cssClasses,
            emptyComponent: emptyComponent,
            banner: banner,
            bannerComponent: templates.banner ? bannerComponent : undefined
        }), containerNode);
    };
};
var $b8f91a19038542f6$export$2e2bcd8739ae039 = function hits(widgetParams) {
    var _ref5 = widgetParams || {}, container = _ref5.container, escapeHTML = _ref5.escapeHTML, transformItems = _ref5.transformItems, _ref5$templates = _ref5.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates, _ref5$cssClasses = _ref5.cssClasses, cssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses;
    if (!container) throw new Error($b8f91a19038542f6$var$withUsage("The `container` option is required."));
    var containerNode = (0, $ca542eeff1679d1c$export$ffb2c7b8d67c359a)(container);
    var specializedRenderer = $b8f91a19038542f6$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        renderState: {},
        templates: templates
    });
    var makeWidget = (0, $0c83df9943e283bb$export$2e2bcd8739ae039)((0, $0e84a78cd0520eb3$export$2e2bcd8739ae039))(specializedRenderer, function() {
        return (0, $64f0190ec946a978$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $b8f91a19038542f6$var$_objectSpread($b8f91a19038542f6$var$_objectSpread({}, makeWidget({
        escapeHTML: escapeHTML,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.hits"
    });
};



const $35048af4b05d3593$var$collectionClient = (0, $d359e94bac2b9347$export$e63737c6f074d9d7)("MB13IY345Y", "5a50c24f3e92ae83f808068a942a1f3b");
const $35048af4b05d3593$var$collectionPageEnabled = true;
let $35048af4b05d3593$var$collectionFacetFilter = null;
let $35048af4b05d3593$var$collectionRulesContextValue = null;
let $35048af4b05d3593$var$collectionHandle = null;
let $35048af4b05d3593$var$subCollectionHandle = null;
if ($35048af4b05d3593$var$collectionPageEnabled) {
    let matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    let matches2 = window.location.pathname.match(/\/collections\/([^/]+)\/([^/]+)/i);
    $35048af4b05d3593$var$collectionHandle = Boolean(matches) && matches.length === 2 ? matches[1] : null;
    $35048af4b05d3593$var$subCollectionHandle = Boolean(matches2) && matches2.length === 3 ? matches2[2] : null;
}
// subCollectionHandle.replace('-', '_');
// subCollectionHandle.replace('%20', '_');
let $35048af4b05d3593$var$filterTag = `"${$35048af4b05d3593$var$subCollectionHandle}"`;
const $35048af4b05d3593$var$indexName = "shopify_products";
const $35048af4b05d3593$var$collectionSearch = (0, $2b5585e42594a41c$export$2e2bcd8739ae039)({
    indexName: "shopify_products",
    searchClient: $35048af4b05d3593$var$collectionClient,
    insights: false,
    analytics: false,
    routing: {
        stateMapping: {
            stateToRoute (uiState) {
                const indexUiState = uiState[$35048af4b05d3593$var$indexName];
                return {
                    q: indexUiState.query,
                    type: indexUiState.refinementList && indexUiState.refinementList["meta.filter.type"],
                    flavourGroup: indexUiState.refinementList && indexUiState.refinementList["meta.filter.flavour_group"],
                    flavour: indexUiState.refinementList && indexUiState.refinementList["meta.filter.flavour"],
                    brand: indexUiState.refinementList && indexUiState.refinementList.vendor,
                    size: indexUiState.refinementList && indexUiState.refinementList["meta.filter.size"],
                    strength: indexUiState.refinementList && indexUiState.refinementList["meta.filter.strength"],
                    ratio: indexUiState.refinementList && indexUiState.refinementList["meta.filter.ratio"],
                    wattage: indexUiState.refinementList && indexUiState.refinementList["meta.filter.wattage"],
                    battery: indexUiState.refinementList && indexUiState.refinementList["meta.filter.battery"],
                    resistance: indexUiState.refinementList && indexUiState.refinementList["meta.filter.resistance"],
                    offers: indexUiState.refinementList && indexUiState.refinementList["meta.filter.offer"],
                    page: indexUiState.page
                };
            },
            routeToState (routeState) {
                return {
                    [$35048af4b05d3593$var$indexName]: {
                        query: routeState.q,
                        refinementList: {
                            "meta.filter.type": routeState.type,
                            "meta.filter.flavour_group": routeState.flavourGroup,
                            "meta.filter.flavour": routeState.flavour,
                            vendor: routeState.brand,
                            "meta.filter.size": routeState.size,
                            "meta.filter.strength": routeState.strength,
                            "meta.filter.ratio": routeState.ratio,
                            "meta.filter.wattage": routeState.wattage,
                            "meta.filter.battery": routeState.battery,
                            "meta.filter.resistance": routeState.resistance,
                            "meta.filter.offer": routeState.offers
                        },
                        page: routeState.page
                    }
                };
            }
        }
    }
});
// const index = collectionClient.initIndex("shopify_products");
document.querySelector("#hits")?.classList.remove("loading");
let $35048af4b05d3593$var$acc = document.querySelectorAll(".refine-trigger");
let $35048af4b05d3593$var$macc = document.querySelectorAll(".mobile-refine-trigger");
let $35048af4b05d3593$var$panel = document.querySelectorAll(".refine");
$35048af4b05d3593$var$acc.forEach((i)=>{
    i.addEventListener("click", ()=>{
        let setClasses = !i.classList.contains("active");
        $35048af4b05d3593$var$setClass($35048af4b05d3593$var$acc, "active", "remove");
        $35048af4b05d3593$var$setClass($35048af4b05d3593$var$panel, "show", "remove");
        if (setClasses) {
            i.classList.toggle("active");
            let ref = i.nextElementSibling;
            if (ref) ref.classList.toggle("show");
        }
    });
});
const $35048af4b05d3593$var$setClass = (els, className, fnName)=>{
    for(let i = 0; i < els.length; i++)els[i].classList[fnName](className);
};
const $35048af4b05d3593$var$selectors = {
    body: document.querySelector("body"),
    mobileMenuToggle: document.querySelector("#mobile-menu-toggle"),
    menuClose: document.querySelector("#menu-close"),
    menuApply: document.querySelector("#mobile-apply"),
    mobileFilterMenu: document.querySelector(".mobile-filter-menu"),
    mobileFilterBackdrop: document.querySelector(".mobile-filter-backdrop")
};
if ($35048af4b05d3593$var$selectors.mobileMenuToggle !== null) $35048af4b05d3593$var$selectors.mobileMenuToggle.addEventListener("click", ()=>{
    // document.location.href = '#top';
    $35048af4b05d3593$var$selectors.body.classList.add("blocked");
    $35048af4b05d3593$var$selectors.mobileFilterMenu.classList.toggle("active");
    $35048af4b05d3593$var$selectors.mobileFilterBackdrop.classList.toggle("active");
});
if ($35048af4b05d3593$var$selectors.mobileMenuToggle !== null) $35048af4b05d3593$var$selectors.menuClose.addEventListener("click", ()=>{
    // document.location.href = '#mobile-sorter';
    $35048af4b05d3593$var$selectors.body.classList.remove("blocked");
    $35048af4b05d3593$var$selectors.mobileFilterMenu.classList.remove("active");
    $35048af4b05d3593$var$selectors.mobileFilterBackdrop.classList.remove("active");
});
if ($35048af4b05d3593$var$selectors.menuApply !== null) $35048af4b05d3593$var$selectors.menuApply.addEventListener("click", ()=>{
    $35048af4b05d3593$var$selectors.body.classList.remove("blocked");
    $35048af4b05d3593$var$selectors.mobileFilterMenu.classList.remove("active");
    $35048af4b05d3593$var$selectors.mobileFilterBackdrop.classList.remove("active");
    document.querySelector("#collection-mobile-toolbar").scrollIntoView(true);
});
const $35048af4b05d3593$var$determineProductCard = (data)=>{
    let productURL = `/products/${data.handle}`;
    let promo_img = document.querySelector("#hits").getAttribute("data-promo-source");
    let promo_url = document.querySelector("#hits").getAttribute("data-promo-url");
    let promo_span = document.querySelector("#hits").getAttribute("data-promo-span");
    let promo_start = document.querySelector("#hits").getAttribute("data-string-pos");
    let promo_title = document.querySelector("#hits").getAttribute("data-promo-title");
    let promo_desc = document.querySelector("#hits").getAttribute("data-promo-text");
    let promo_cta = document.querySelector("#hits").getAttribute("data-promo-cta");
    let promo_t_colour = document.querySelector("#hits").getAttribute("data-title-colour");
    let promo_colour = document.querySelector("#hits").getAttribute("data-text-colour");
    let promo_colour_start = document.querySelector("#hits").getAttribute("data-bg-colour-start");
    let promo_colour_end = document.querySelector("#hits").getAttribute("data-bg-colour-end");
    const hasMultiBuy = ()=>{
        let all = data.tags.toString();
        if (isOutOfStockHelper()) return "";
        else {
            if (all && all.includes("Item_pro_Buy") || all.includes("Item_pro1_Buy")) return `<div class="card-product__badge card-product__multiOffer multi-buy">Multi Buy</div>`;
            else return ``;
        }
    };
    const isBundle = ()=>{
        let all = data.tags.toString();
        if (all.includes("Bundle")) return `<div class="card-product__badge card-product__multiOffer bundle-offer">Bundle Offer</div>`;
        else return ``;
    };
    const isEarly = ()=>{
        let all = data.tags.toString();
        if (all.includes("Early Bird")) return `<div class="card-product__badge card-product__multiOffer earlybird">Early Bird22</div>`;
        else return ``;
    };
    const isBundleWeek = ()=>{
        let all = data.tags.toString();
        if (all.includes("BundleWeek")) return `<div class="card-product__badge card-product__multiOffer bundle-of-week">Bundle of the Week</div>`;
        else return ``;
    };
    const isQuitKit = ()=>{
        let all = data.tags.toString();
        if (all.includes("Quit Kit")) return `<div class="card-product__badge card-product__multiOffer quit-kit">Quit Kit of the Week</div>`;
        else return ``;
    };
    const isNew = ()=>{
        let all = data.collections.toString();
        if (all.includes("new")) return `<div class="card-product__badge card-product__newHighlight">New in</div>`;
        else return ``;
    };
    const isSale = ()=>{
        let all = data.collections.toString();
        if (all.includes("sale")) return `<div class="card-product__badge card-product__saleHighlight">Sale</div>`;
        else return ``;
    };
    const hasFlavour = ()=>{
        // console.log(data);
        if (data.named_tags.Profile) {
            if (typeof data.named_tags.Profile == "string") return data.named_tags.Profile;
        } else return "";
    };
    const isDisposable = ()=>{
        let all = data.collections.toString();
        if (all.includes("disposable-vape-kits")) return true;
        else return false;
    };
    const disposableCount = ()=>{
        let all = data.tags;
        let c = "";
        all.filter((t, i)=>{
            if (t.includes("Profile_")) {
                c = t.replace("Profile_", "");
                return t.replace("Profile_", "");
            } else return "";
        });
        return c;
    };
    const isOutOfStockHelper = ()=>{
        if (data.variants_inventory_count == 0) return true;
        else return "";
    };
    const isOutOfStock = ()=>{
        if (data.variants_inventory_count <= 0) return `<div class="card-product__oos">Out Of Stock</div>`;
        else return "";
    };
    const getMultibuyOffer = ()=>{
        let tags = data.tags.toString();
        let _items = window?.multibuyOffer?.tags;
        // console.log(_items);
        if (isOutOfStockHelper()) return "";
        else if (data.collections) {
            let found = false;
            let content;
            for(let i = 0; i < _items.length; i++)if (tags.includes(_items[i].tag)) {
                found = true;
                content = _items[i].return;
                break;
            }
            if (found) return content;
            else return ``;
        }
    };
    const getRelevantBadge = ()=>{
        let tags = data.tags.toString();
        let _items = window?.relevantBadges?.tags;
        if (isOutOfStockHelper()) return "";
        else if (data.collections) {
            let found = false;
            let content;
            for(let i = 0; i < _items.length; i++)if (tags.includes(_items[i].tag)) {
                found = true;
                content = _items[i].return;
                break;
            }
            if (found) return content;
            else return ``;
        }
    };
    const isOnSale = ()=>{
        if (!data.compare_at_price) return false;
        else return true;
    };
    const areAllVariantsDiscounted = ()=>{
        if (data.compare_at_price != 0 && data.variants_min_price == data.variants_max_price) return true;
        else return false;
    };
    const determinePrice = ()=>{
        let originalPrice;
        if (!data.compare_at_price) originalPrice = data.price;
        else originalPrice = data.compare_at_price;
        if (data.price == 0) return "TBC";
        if (isOnSale()) {
            if (areAllVariantsDiscounted()) return `<span class="pre-sale-price"> Was \xa3${originalPrice}</span> <span class="sale-price">Now \xa3${data.variants_min_price.toFixed(2)}</span>`;
            else return data.variants_count > 1 ? `From \xa3${data.variants_min_price.toFixed(2)}` : `\xa3${data.price.toFixed(2)}`;
        } else return data.variants_count > 1 && data.variants_min_price != data.variants_max_price ? `From \xa3${data.variants_min_price}` : `\xa3${data.price.toFixed(2)}`;
    };
    setClickedObject = (id)=>{
        localStorage.setItem("clickedObjectID", id);
    };
    if (data.isPromo == "true") return `
          <div id="promo-card-1" class="card-product promo-card card-carousel-js swiper-slide ${promo_span == "true" && "span-two"} start-pos-${promo_start}" data-handle="promo-only">
          <a style="background: linear-gradient(99deg,${promo_colour_start}, ${promo_colour_end});" class="card-product__wrapper-link" href="${promo_url}"></a>
            <div class="collection-breaker-inner">
              <h3 style="color: ${promo_t_colour}" class="breaker-title">${promo_title}</h3>
              <p style="color: ${promo_colour}" class="breaker-desc">${promo_desc}</p>
              <a href="${promo_url}"><button class="breaker-cta button button--primary button--primary--alternate">${promo_cta}</button></a>
            </div>
            <div class="card-product__imagewrap">
             <img src="${promo_img}" />
            </div>
          </div>
        `;
    else return `
          <div id="card-${data.id}" data-objectID="${data.objectID}" class="card-product card-carousel-js swiper-slide" data-handle="${data.handle}" onClick="setClickedObject(${data.objectID})">
          <a class="card-product__wrapper-link" href="/products/${data.handle}" title="${data.title}"></a>
            <div class="card-product__imagewrap">
              <img
                class="card-product__thumb ${isOutOfStockHelper() ? "greyed" : ""}"
                srcset="${data.product_image}&amp;width=165 100w,${data.product_image}&amp;width=165 165w,${data.product_image}&amp;width=360 360w,${data.product_image}&amp;width=533 533w,${data.product_image} 600w"
                sizes="(min-width: px) -50px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"
                src="${data.product_image}"
                alt="${data.title}"
                width="230"
                height="100%"
                loading="${data.__position <= 10 ? "eager" : "lazy"}"
                />
            </div>
              ${getRelevantBadge()}
              ${isNew()}
              ${isSale()}
              ${getMultibuyOffer()}
            <div class="card-product__wrapper">
              <h3 class="card-product__heading">${data.title}</h3>
              ${isDisposable() ? `<div class="card-product__flavour">${disposableCount()}</div>` : `<div class="card-product__flavour">${hasFlavour()}</div>`}
              <div class="card-product__price ${isOutOfStockHelper() ? "greyed" : ""}">
                ${determinePrice() == "\xa3null" ? `\xa3${data.price.toFixed(2)}` : determinePrice()}
              </div>
            </div>
          </div>
        `;
};
const $35048af4b05d3593$var$applyMobileFilters = (d)=>{};
const $35048af4b05d3593$var$determineShowMore = (d)=>{
// console.log(d);
};
// ensure the collection results are in sync with the collection handle, and returns no duplicate variants
// compare the second 'sub collection' handle and if there is one, use that as a filter by tags within this collection
let $35048af4b05d3593$var$uri = $35048af4b05d3593$var$filterTag.replaceAll("%20", " ");
let $35048af4b05d3593$var$q = $35048af4b05d3593$var$uri.replaceAll("-", " ");
// encodeURIComponent(uri).replace(/%20/g, '-');
// uri.replaceAll(' ', '-');
// console.log(uri);
// let currentURL = window.location.pathname;
// const pattern = new URLPattern({pathname: '/collections/:main/:sub'});
// const result = pattern.exec({pathname: currentURL});
// // result.pathname.groups.sub.replace('-', ' ');
// // let q = result.pathname.groups.sub.replaceAll('-', ' ');
function $35048af4b05d3593$var$getCookie(cookieName) {
    let cookie = {};
    document.cookie.split(";").forEach(function(el) {
        let [key, value] = el.split("=");
        cookie[key.trim()] = value;
    });
    return cookie[cookieName];
}
let $35048af4b05d3593$var$isPromoCard = document.querySelector("#hits")?.getAttribute("data-promo");
let $35048af4b05d3593$var$promoPos = document.querySelector("#hits").getAttribute("data-promo-position");
let $35048af4b05d3593$var$pp = document.querySelector("#hits")?.getAttribute("data-per-page");
let $35048af4b05d3593$var$isSpan = document.querySelector("#hits")?.getAttribute("data-promo-span");
// let refc = document.querySelector('#current-filters .');
const $35048af4b05d3593$var$determineHitsPerPage = ()=>{
    if ($35048af4b05d3593$var$isPromoCard == "true") {
        if ($35048af4b05d3593$var$isSpan == "true") return parseInt($35048af4b05d3593$var$pp) - 2;
        else return parseInt($35048af4b05d3593$var$pp) - 1;
    } else return parseInt($35048af4b05d3593$var$pp);
};
// add the refinements
$35048af4b05d3593$var$collectionSearch.addWidgets([
    (0, $ffa7e0591390fe97$export$2e2bcd8739ae039)({
        filters: $35048af4b05d3593$var$subCollectionHandle ? `collections:${$35048af4b05d3593$var$collectionHandle} AND tags:${$35048af4b05d3593$var$q}` : `collections:${$35048af4b05d3593$var$collectionHandle}`,
        facetingAfterDistinct: true,
        maxValuesPerFacet: 1000,
        enablePersonalization: true,
        userToken: $35048af4b05d3593$var$getCookie("_ALGOLIA"),
        hitsPerPage: $35048af4b05d3593$var$determineHitsPerPage()
    })
]);
$35048af4b05d3593$var$collectionSearch.addWidgets([
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#refine-type",
        attribute: "meta.filter.type",
        limit: 10,
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            root: "group-list"
        }
    }),
    (0, $3213562dea075dda$export$2e2bcd8739ae039)({
        container: "#current-filters",
        transformItems (items) {
            items.map((i)=>{
                switch(i.label){
                    case "meta.filter.type":
                        i.label = "Type";
                        break;
                    case "meta.filter.flavour_group":
                        i.label = "Flavour Group";
                        break;
                    case "meta.filter.flavour":
                        i.label = "Flavour";
                        break;
                    case "vendor":
                        i.label = "Brand";
                        break;
                    case "meta.filter.size":
                        i.label = "Size";
                        break;
                    case "meta.filter.strength":
                        i.label = "Strength";
                        break;
                    case "meta.filter.ratio":
                        i.label = "PG/VG Ratio";
                        break;
                    case "meta.filter.wattage":
                        i.label = "Wattage";
                        break;
                    case "meta.filter.battery":
                        i.label = "Battery";
                        break;
                    case "meta.filter.resistance":
                        i.label = "Resistance";
                        break;
                    case "meta.filter.offer":
                        i.label = "Offers";
                        break;
                    case "price":
                        i.label = "Price";
                        break;
                    default:
                        break;
                }
            });
            return items;
        }
    }),
    (0, $f93b06120d1ef027$export$2e2bcd8739ae039)({
        container: "#clear-filters",
        templates: {
            resetLabel: "Clear All"
        }
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#mobile-refine-type",
        attribute: "meta.filter.type",
        limit: 10,
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            root: "group-list"
        }
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#refine-flavourGroup",
        attribute: "meta.filter.flavour_group",
        limit: 10,
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            root: "group-list"
        }
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#mobile-refine-flavourGroup",
        attribute: "meta.filter.flavour_group",
        limit: 10,
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            root: "group-list"
        }
    }),
    (0, $f93b06120d1ef027$export$2e2bcd8739ae039)({
        container: "#mobile-clear",
        templates: {
            resetLabel: "Clear"
        }
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#refine-flavour",
        attribute: "meta.filter.flavour",
        limit: 10,
        showMore: true,
        showMoreLimit: 100,
        transformItems (items) {
            if (items.length > 10) document.querySelector("#refine-flavour").classList.add("opened");
            else document.querySelector("#refine-flavour").classList.remove("opened");
            return items;
        },
        cssClasses: {
            root: "flavour-list"
        }
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#mobile-refine-flavour",
        attribute: "meta.filter.flavour",
        limit: 10,
        showMore: true,
        showMoreLimit: 100,
        cssClasses: {
            root: "flavour-list"
        }
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#refine-brand",
        attribute: "vendor",
        limit: 10,
        showMore: true,
        showMoreLimit: 100,
        transformItems (items) {
            if (items.length > 10) document.querySelector("#refine-brand").classList.add("opened");
            else document.querySelector("#refine-brand").classList.remove("opened");
            return items;
        }
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#mobile-refine-brand",
        attribute: "vendor",
        limit: 10,
        showMore: true,
        showMoreLimit: 100
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#refine-size",
        attribute: "meta.filter.size",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#mobile-refine-size",
        attribute: "meta.filter.size",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#refine-nic",
        attribute: "meta.filter.strength",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#mobile-refine-nic",
        attribute: "meta.filter.strength",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#refine-ratio",
        attribute: "meta.filter.ratio",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#mobile-refine-ratio",
        attribute: "meta.filter.ratio",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#refine-wattage",
        attribute: "meta.filter.wattage",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#mobile-refine-wattage",
        attribute: "meta.filter.wattage",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#refine-battery",
        attribute: "meta.filter.battery",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#mobile-refine-battery",
        attribute: "meta.filter.battery",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#refine-resistance",
        attribute: "meta.filter.resistance",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#mobile-refine-resistance",
        attribute: "meta.filter.resistance",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#refine-offers",
        attribute: "meta.filter.offer",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    }),
    (0, $3d35788e55c98fba$export$2e2bcd8739ae039)({
        container: "#mobile-refine-offers",
        attribute: "meta.filter.offer",
        limit: 10,
        showMore: true,
        showMoreLimit: 40
    })
]);
const $35048af4b05d3593$var$renderSortBy = (renderOptions, isFirstRender)=>{
    const { options: options, currentRefinement: currentRefinement, hasNoResults: hasNoResults, refine: refine, widgetParams: widgetParams } = renderOptions;
    if (isFirstRender) {
        const select = document.createElement("div");
        // select.setAttribute("size", 10);
        select.setAttribute("class", "select-sortby");
        select.addEventListener("click", (event)=>{
            // console.log(event);
            refine(event.target.id);
        });
        widgetParams.container.appendChild(select);
    }
    const select = widgetParams.container.querySelector("div");
    select.disabled = hasNoResults;
    select.innerHTML = `
      ${options.map((option)=>`
            <span
              class="sort-option"
              id="${option.value}"
              ${option.value === currentRefinement ? "selected" : ""}
            >
              ${option.label}
            </span>
          `).join("")}
    `;
};
// Create the custom widget
const $35048af4b05d3593$var$customSortBy = (0, $9ac8c4a7dd77473d$export$2e2bcd8739ae039)($35048af4b05d3593$var$renderSortBy);
const $35048af4b05d3593$var$renderMobileSortBy = (renderOptions, isFirstRender)=>{
    const { options: options, currentRefinement: currentRefinement, hasNoResults: hasNoResults, refine: refine, widgetParams: widgetParams } = renderOptions;
    if (isFirstRender) {
        const select = document.createElement("div");
        // select.setAttribute("size", 10);
        select.setAttribute("class", "select-sortby");
        select.addEventListener("click", (event)=>{
            // console.log(event);
            refine(event.target.id);
        });
        widgetParams.container.appendChild(select);
    }
    const select = widgetParams.container.querySelector("div");
    select.disabled = hasNoResults;
    select.innerHTML = `
      ${options.map((option)=>`
            <span
              class="sort-option"
              id="${option.value}"
              ${option.value === currentRefinement ? "selected" : ""}
            >
              ${option.label}
            </span>
          `).join("")}
    `;
};
// Create the custom widget
const $35048af4b05d3593$var$customMobileSortBy = (0, $9ac8c4a7dd77473d$export$2e2bcd8739ae039)($35048af4b05d3593$var$renderMobileSortBy);
$35048af4b05d3593$var$collectionSearch.addWidgets([
    $35048af4b05d3593$var$customSortBy({
        container: document.querySelector("#sort-by"),
        items: [
            {
                label: "Featured",
                value: "shopify_products"
            },
            {
                label: "Best Selling",
                value: "shopify_products_recently_ordered_count_desc"
            },
            {
                label: "Price ascending",
                value: "shopify_products_price_asc"
            },
            {
                label: "Price descending",
                value: "shopify_products_price_desc"
            },
            {
                label: "Title ascending",
                value: "shopify_products_title_asc"
            },
            {
                label: "Title descending",
                value: "shopify_products_title_desc"
            },
            {
                label: "Created ascending",
                value: "shopify_products_published_at_asc"
            },
            {
                label: "Created descending",
                value: "shopify_products_published_at_desc"
            }
        ]
    })
]);
$35048af4b05d3593$var$collectionSearch.addWidgets([
    $35048af4b05d3593$var$customMobileSortBy({
        container: document.querySelector("#mobile-sort-by"),
        items: [
            {
                label: "Featured",
                value: "shopify_products"
            },
            {
                label: "Best Selling",
                value: "shopify_products_recently_ordered_count_desc"
            },
            {
                label: "Price ascending",
                value: "shopify_products_price_asc"
            },
            {
                label: "Price descending",
                value: "shopify_products_price_desc"
            },
            {
                label: "Title ascending",
                value: "shopify_products_title_asc"
            },
            {
                label: "Title descending",
                value: "shopify_products_title_desc"
            },
            {
                label: "Created ascending",
                value: "shopify_products_published_at_asc"
            },
            {
                label: "Created descending",
                value: "shopify_products_published_at_desc"
            }
        ]
    })
]);
function $35048af4b05d3593$var$middleware({ instantSearchInstance: instantSearchInstance }) {
    return {
        onStateChange ({ uiState: uiState }) {
            // console.log('middleware: ', uiState.shopify_products);
            if (uiState.shopify_products.refinementList) {
                if (document.querySelector("#promo-card-1")) document.querySelector("#promo-card-1").style.display = "none";
            } else if (document.querySelector("#promo-card-1")) document.querySelector("#promo-card-1").style.display = "block";
        // Do something with `uiState` whenever the state changes.
        },
        subscribe () {},
        unsubscribe () {}
    };
}
$35048af4b05d3593$var$collectionSearch.addWidgets([
    (0, $b8f91a19038542f6$export$2e2bcd8739ae039)({
        container: "#hits",
        transformItems (items) {
            let promoData = {
                title: "Promo Card",
                updated_at: "2023-03-27T14:24:40.000Z",
                isPromo: "true",
                __position: parseInt($35048af4b05d3593$var$promoPos)
            };
            if ($35048af4b05d3593$var$isPromoCard == "true") items.splice(parseInt($35048af4b05d3593$var$promoPos) - 1, 0, promoData);
            return items;
        },
        templates: {
            empty: "Loading...",
            item: (data)=>{
                return $35048af4b05d3593$var$determineProductCard(data);
            }
        },
        cssClasses: {
            root: "hits-results-list",
            list: "results-grid"
        }
    })
]);
// Create the render function
const $35048af4b05d3593$var$renderPagination = (renderOptions, isFirstRender)=>{
    const { pages: pages, currentRefinement: currentRefinement, nbPages: nbPages, isFirstPage: isFirstPage, isLastPage: isLastPage, refine: refine, createURL: createURL, widgetParams: widgetParams } = renderOptions;
    const container = document.querySelector("#pagination");
    container.innerHTML = `
    <ul class="ais-Pagination-list">
      ${!isFirstPage ? `
            <li class="ais-Pagination-item ais-Pagination-item--page">
              <a
                href="https://www.vapesuperstore.co.uk${window.location.pathname}"
                data-value="${0}"
                rel="prev"
              >
                <
              </a>
            </li>
            <li class="ais-Pagination-item ais-Pagination-item--page">
              <a
                href="${currentRefinement == 1 ? `https://www.vapesuperstore.co.uk${window.location.pathname}` : createURL(currentRefinement - 1)}"
                data-value="${currentRefinement - 1}"
                rel="prev"
              >
                Previous
              </a>
            </li>
            ` : ""}
      ${pages.map((page)=>{
        let current = currentRefinement;
        let direction;
        if (page + 1 > current) direction = "next";
        else direction = "prev";
        return `
        <li class="ais-Pagination-item ais-Pagination-item--page ${currentRefinement === page ? " ais-Pagination-item--selected" : ""}">
          <a
            href="${page == 0 ? `https://www.vapesuperstore.co.uk${window.location.pathname}` : createURL(page)}"
            data-value="${page}"
            style="font-weight: ${currentRefinement === page ? "bold" : "inherit"}"
            ${page != current ? `rel="${direction}"` : ""}
          >
            ${page + 1}
          </a>
        </li>
      `;
    }).join("")}
        ${!isLastPage ? `
              <li class="ais-Pagination-item ais-Pagination-item--page">
                <a
                  href="${createURL(currentRefinement + 1)}"
                  data-value="${currentRefinement + 1}"
                  rel="next"
                >
                  Next
                </a>
              </li>
              <li class="ais-Pagination-item ais-Pagination-item--page">
                <a
                  href="${createURL(nbPages - 1)}"
                  data-value="${nbPages - 1}"
                  rel="next"
                >
                  >
                </a>
              </li>
              ` : ""}
    </ul>
  `;
    // on pagination change
    [
        ...container.querySelectorAll("a")
    ].forEach((element)=>{
        element.addEventListener("click", (event)=>{
            event.preventDefault();
            console.log("paginate changed");
            document.querySelector("#paginate-trigger").scrollIntoView();
            refine(event.currentTarget.dataset.value);
            let promo_span = document.querySelector("#hits").getAttribute("data-promo-span");
            const generatePromoCard = ()=>{
                let promo_img = document.querySelector("#hits").getAttribute("data-promo-source");
                let promo_url = document.querySelector("#hits").getAttribute("data-promo-url");
                let promo_span = document.querySelector("#hits").getAttribute("data-promo-span");
                let promo_start = document.querySelector("#hits").getAttribute("data-string-pos");
                let promo_title = document.querySelector("#hits").getAttribute("data-promo-title");
                let promo_desc = document.querySelector("#hits").getAttribute("data-promo-text");
                let promo_cta = document.querySelector("#hits").getAttribute("data-promo-cta");
                let promo_t_colour = document.querySelector("#hits").getAttribute("data-title-colour");
                let promo_colour = document.querySelector("#hits").getAttribute("data-text-colour");
                let promo_colour_start = document.querySelector("#hits").getAttribute("data-bg-colour-start");
                let promo_colour_end = document.querySelector("#hits").getAttribute("data-bg-colour-end");
                return `
        <div id="promo-card-1" class="card-product promo-card card-carousel-js swiper-slide ${promo_span == "true" && "span-two"} start-pos-${promo_start}" data-handle="promo-only">
          <a style="background: linear-gradient(99deg,${promo_colour_start}, ${promo_colour_end});" class="card-product__wrapper-link" href="${promo_url}"></a>
            <div class="collection-breaker-inner">
              <h3 style="color: ${promo_t_colour}" class="breaker-title">${promo_title}</h3>
              <p style="color: ${promo_colour}" class="breaker-desc">${promo_desc}</p>
              <a href="${promo_url}"><button class="breaker-cta button button--primary button--primary--alternate">${promo_cta}</button></a>
            </div>
            <div class="card-product__imagewrap">
              <img src="${promo_img}" />
            </div>
          </div>
      `;
            };
            if ($35048af4b05d3593$var$isPromoCard == "true") setTimeout(()=>{
                document.querySelector("#promo-card-1").style.display = "none";
                // grab all the current hits. then turn them to an array from a node list
                const els = document.querySelectorAll(".card-product");
                const all = Array.from(els);
                let promoData = {
                    title: "Promo Card",
                    updated_at: "2023-03-27T14:24:40.000Z",
                    isPromo: "true",
                    __position: parseInt($35048af4b05d3593$var$promoPos)
                };
                document.querySelector(`#${all[$35048af4b05d3593$var$promoPos - 1].id}`).parentElement.insertAdjacentHTML("beforebegin", generatePromoCard());
                if (promo_span == "true") {
                    document.querySelector(".promo-card").parentElement.classList.add("span-two");
                    document.querySelector(".promo-card").parentElement.classList.add(`start-pos-`);
                }
            }, 100);
        });
    });
};
// Create the custom widget
const $35048af4b05d3593$var$customPagination = (0, $3c3032902dc84f8e$export$2e2bcd8739ae039)($35048af4b05d3593$var$renderPagination);
// Instantiate the custom widget
$35048af4b05d3593$var$collectionSearch.addWidgets([
    $35048af4b05d3593$var$customPagination({
        container: document.querySelector("#pagination"),
        totalPages: 200
    })
]);
//  remove / block any empty facets from filters
$35048af4b05d3593$var$collectionSearch.on("render", ()=>{
    document.querySelectorAll(".ais-RefinementList").forEach((f)=>{
        let facetCount = f.querySelector(".ais-RefinementList-list");
        if (f.childElementCount == 0 || facetCount != null && facetCount.childElementCount == 1) {
            let parent = f.parentNode.previousElementSibling;
            parent.classList.add("blocked");
            parent.parentNode.classList.add("blocked");
        } else {
            let parent = f.parentNode.previousElementSibling;
            parent.classList.remove("blocked");
            parent.parentNode.classList.remove("blocked");
        }
    });
    const cards = document.querySelectorAll(".card-product");
    cards.forEach((item)=>{
        const handle = item.dataset.handle;
        // getShopifyProduct(item, handle);
        $35048af4b05d3593$var$getReviewInfo(item, handle);
    });
    let promo_span = document.querySelector("#hits").getAttribute("data-promo-span");
    let promo_start = document.querySelector("#hits").getAttribute("data-string-pos");
    if (promo_span == "true") {
        document.querySelector(".promo-card").parentElement.classList.add("span-two");
        document.querySelector(".promo-card").parentElement.classList.add("promo-breaker");
        document.querySelector(".promo-card").parentElement.classList.add(`start-pos-${promo_start}`);
    }
    const regeneratePromoCard = ()=>{
        let promo_img = document.querySelector("#hits").getAttribute("data-promo-source");
        let promo_url = document.querySelector("#hits").getAttribute("data-promo-url");
        let promo_span = document.querySelector("#hits").getAttribute("data-promo-span");
        let promo_start = document.querySelector("#hits").getAttribute("data-string-pos");
        let promo_title = document.querySelector("#hits").getAttribute("data-promo-title");
        let promo_desc = document.querySelector("#hits").getAttribute("data-promo-text");
        let promo_cta = document.querySelector("#hits").getAttribute("data-promo-cta");
        let promo_t_colour = document.querySelector("#hits").getAttribute("data-title-colour");
        let promo_colour = document.querySelector("#hits").getAttribute("data-text-colour");
        let promo_colour_start = document.querySelector("#hits").getAttribute("data-bg-colour-start");
        let promo_colour_end = document.querySelector("#hits").getAttribute("data-bg-colour-end");
        return `
    <div id="promo-card-1" class="card-product promo-card card-carousel-js swiper-slide ${promo_span == "true" && "span-two"} start-pos-${promo_start}" data-handle="promo-only">
      <a style="background: linear-gradient(99deg,${promo_colour_start}, ${promo_colour_end});" class="card-product__wrapper-link" href="${promo_url}"></a>
        <div class="collection-breaker-inner">
          <h3 style="color: ${promo_t_colour}" class="breaker-title">${promo_title}</h3>
          <p style="color: ${promo_colour}" class="breaker-desc">${promo_desc}</p>
          <a href="${promo_url}"><button class="breaker-cta button button--primary button--primary--alternate">${promo_cta}</button></a>
        </div>
        <div class="card-product__imagewrap">
          <img src="${promo_img}" alt="promotion card" loading="lazy" />
        </div>
      </div>
  `;
    };
// let refl = document.querySelector('#current-filters .ais-CurrentRefinements-list').innerHTML.length;
// if(refl != 0){
//   document.querySelector('.promo-breaker').style.display = "none";
// } else {
//   document.querySelector('.promo-breaker').style.display = "block";
//   setTimeout(()=>{
//     // grab all the current hits. then turn them to an array from a node list
//     const els = document.querySelectorAll(".card-product");
//     const all = Array.from(els);
//     let promoData = {
//       "title": "Promo Card",
//       "updated_at": "2023-03-27T14:24:40.000Z",
//       "isPromo": "true",
//       "__position": parseInt(promoPos)
//     }
//     document.querySelector(`#${all[promoPos - 1].id}`).parentElement.insertAdjacentHTML('beforebegin', regeneratePromoCard())
//     if(promo_span == "true" ){
//       document.querySelector('.promo-card').parentElement.classList.add('span-two');
//       document.querySelector('.promo-card').parentElement.classList.add(`start-pos-`);
//     }
//   },100)
// }
// console.log(cards);
});
$35048af4b05d3593$var$collectionSearch.use($35048af4b05d3593$var$middleware);
$35048af4b05d3593$var$collectionSearch.start();
async function $35048af4b05d3593$var$getReviewInfo(card, handle) {
    if (!handle) return;
    const wrapper = card.querySelector(".card-product__image-wrapper") || card;
    if (wrapper.querySelector(".card-product__rating")) return;
    const shopifyProductUrl = `/products/${handle}?section_id=product-extras-reviews`;
    try {
        const response = await fetch(shopifyProductUrl);
        const res = await response.text();
        let p = new DOMParser();
        let doc = p.parseFromString(res, "text/html");
        let template = doc.querySelector(".tp-stars-rating > div");
        if (!template) return;
        template.classList.add("card-product__rating");
        wrapper.appendChild(template);
    } catch (error) {
        console.error("Error:", error);
    }
}
async function $35048af4b05d3593$var$getShopifyProduct(card, handle) {
    if (handle == undefined || null) return;
    else {
        // Compose json url test
        const shopifyProductUrl = `/products/${handle}?section_id=product-extras`;
        try {
            const response = await fetch(shopifyProductUrl);
            const res = await response.text();
            let p = new DOMParser();
            let doc = p.parseFromString(res, "text/html");
            let template = doc.querySelector(".quick-view__container");
            let stocker = doc.querySelector(".card-product__oos");
            const insertion = card.querySelector(".card-product__imagewrap");
            const wrapper = card.querySelector(".card-product__wrapper");
            const hasColour = wrapper.querySelector(".card-product__colours img");
            if (!hasColour) wrapper.appendChild(template);
            if (stocker != null) {
                if (!card.querySelector(".card-product__oos")) insertion.appendChild(stocker);
                if (card.querySelector(".card-product__oos")?.innerHTML.length != 0 || null) card.querySelector(".card-product__thumb ").classList.add("greyed");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }
}

})();
//# sourceMappingURL=collection.js.map
